const psionPowersObj = {
  Bioluminescence: {
    name: "Bioluminescence",
    discipline: "Psychometabolism",
    level: "Cryptic 0, gambler 0, psion/wilder 0",
    display: "Visual",
    manifestingTime: "",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "A 30-ft.-radius patch of natural fungus or similar simple plant-life",
    duration: "One hour; see text",
    savingThrow: "Fortitude negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "Psionic focus or 1",
    description: `Manifestation Time: 1 standard action

A glowing ball of dim light fades into perceptibility around the caverns nearby, revealing the tiny natural plants living there, but never fades away. To manifest this power, you must target an area of existing small-scale plant life (no more complex than simple grasses). The chemistry of any of these plants within the area of your power is altered so the plants naturally emit dim light. This alteration is fueled by a symbiotic link between you and the plant life, which continue to produce light as long as you remain within range and one hour thereafter. If you return within range of glowing plants before they extinguish, they relink to you automatically and resume feeding harmlessly on your excess mental energy.

The illumination emitted by these plants is non-psionic in nature, raising the ambient lighting level of the area naturally, which may prevail in circumstances where magic or psionic illumination and darkness powers have cancelled one another out.

Mythic Bioluminescence

You can optionally cause the affected plants to emit normal light instead of merely dim light. Additionally, the alteration to the plants is a permanent genetic trait that is passed on to future generations, causing the plants to emit light any time a sentient (Intelligence 3 or higher) creature is within 30 feet. This change cannot be dispelled.

Augmented (3rd): By expending two uses of mythic power you may target a single large plant such as a tree, which will thereafter shed light in a 30-ft. radius around it. Seeds and cuttings taken from this tree pass on its ability though saplings may only emit light in a 5-ft. radius, which expands as the newly planted tree grows to adulthood.`
  },
  Blinding_Flash: {
    name: "Blinding Flash",
    discipline: "Psychokinesis [Light]",
    level: "Gambler 0, psion/wilder 0, psychic warrior 0, sighted seeker 1, voyager 0",
    display: "Visual",
    manifestingTime: "1 swift action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round",
    savingThrow: "Fortitude Negates",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `You create a blinding flash of light to momentarily distract an opponent. The target of this power must make a Fortitude save or be dazzled for one round.

Augment: You may augment this power in one or both of the following ways:

• For every additional power point you spend, the power's duration increases by one round.

• If you spend 4 additional power points, the target is blinded instead of dazzled.

In addition, for every 2 power points spent to achieve either of these effects, increase the save DC by 1.`
  },
  Conceal_Thoughts: {
    name: "Conceal Thoughts",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 0, dread 0, gambler 0, gifted blade 1, highlord 0, marksman 0, psion/wilder 0, psychic warrior 0, tactician 0, voyager 0",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One willing creature",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "Psionic focus or 1",
    description: `You protect the subject's thoughts from analysis. While the duration lasts, the subject gains a +10 circumstance bonus on Bluff checks against those attempting to discern its true intentions with Sense Motive. It also gains a +4 bonus on its saving throw against any power or spell used to read its mind (such as read thoughts or mind probe ).

Librarian Note: Prior to Ultimate Psionics, this was both a psionic talent and a 1st-level psionic power. They are essentially the same power, with the only difference being that it was a 1st-level power for psions and psychic warriors. As such, they are both on the same page.`
  },
  Create_Sound: {
    name: "Create Sound",
    discipline: "Metacreativity (Creation) [Sonic]",
    level: "Cryptic 0, dread 0, gambler 0, psion/wilder 0",
    display: "Auditory; see text",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Psionic focus or 1",
    description: `Effect: Sounds; see text

You create a volume of sound that rises, recedes, approaches, or remains at a fixed place. You choose what type of sound the power creates when manifesting it and cannot thereafter change its basic character.

The volume of sound created, however, depends on your level. You can produce as much noise as four normal humans per manifester level (maximum twenty humans). Thus, talking, singing, shouting, walking, marching, or running sounds can be created. The noise produced can be virtually any type of sound within the volume limit. A horde of rats running and squeaking is about the same volume as eight humans running and shouting. A roaring lion is equal to the noise from sixteen humans, while a roaring dire lion is equal to the noise from twenty humans.

If you wish to create a specific message, up to twenty-five words can be created, and those words repeat over and over until the duration expires or the power is dismissed. If you attempt to exactly duplicate the voice of a specific individual or an inherently terrifying sound (such as a dragon's roar), you must succeed on a Bluff check with a +2 circumstance bonus opposed by the listener's Sense Motive check to avoid arousing suspicion.

Create sound can be used to bring sounds into existence that you later manipulate by manifesting control sound .

Librarian Note: This had a 1st-level power version in Psionics Unleashed, however the only difference is that it was a 1st-level psion/wilder power.`
  },
  Crystal_Light: {
    name: "Crystal Light",
    discipline: "Psychokinesis [Light]",
    level: "Gambler 0, psion/wilder 0",
    display: "Visual and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One crystalline creature or object",
    area: "",
    duration: "1 min./level (D) or Instantaneous; see text",
    savingThrow: "Will negates (object) or Fortitude negates; see text",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `Upon manifesting this power, you cause one crystalline creature or object (glass, crystal, gem, psicrystal, astral construct, etc.) to glow in one of two ways. You can cause it to glow with a steady light equivalent to a torch, in which case the duration lasts up to 1 minute per manifester level. Alternately, you can cause it to flash brightly once, causing one creature of your choice in that square or immediately adjacent to be dazzled for 1 minute unless it makes a successful Fortitude save. Crystalline creatures or objects which are targeted to glow are allowed a Will save to negate the power completely; if such is also the target of a dazzling flash, the creature being dazzled is also allowed a Fortitude save to avoid being dazzled.`
  },
  Detect_Akasha: {
    name: "Detect Akasha",
    discipline: "Clairsentience",
    level: "All 0",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "cone-shaped emanation",
    duration: "concentration, up to 1min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "psionic focus or 1",
    description: `

You can detect the presence of akasha and essence. The amount of information revealed to you depends on how long you study a particular area or subject.

• 1st Round: Presence or absence of veils and creatures with the akashic subtype in the area.

• 2nd Round: Number of creatures who have veils shaped in the area, and the number of creatures with the akashic subtype in the area.

• 3rd Round: The number of veils each creature in the area has shaped, and an estimation of the number of points of essence each creature in the area possesses (see below). You can also make a Knowledge (arcana) check to identify the effects of each veil you detect using this ability with a +5 bonus.

Essence Estimation: After concentrating on this spell for three rounds you can estimate the essence each creature in the area possess, as per the chart below:

The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.

Detect akasha can be made permanent with the incarnate power. It requires a minimum manifester level of 9 and costs 2,500 gp.`
  },
  Detect_Psionics: {
    name: "Detect Psionics",
    discipline: "Clairsentience",
    level: "Cryptic 0, dread 0, gambler 0, gifted blade 1, highlord 0, marksman 0, psion/wilder 0, psychic warrior 0, sighted seeker 1, tactician 0, vitalist 0, voyager 0",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped emanation centered on you",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Psionic focus or 1",
    description: `You detect psionic auras. A psionic aura is given off by any active or permanent power, or during the use of any psionic feat. Characters who have levels in a psionic class, creatures with the psionic subtype, and creatures with the Wild Talent feat possess psionic auras. The amount of information revealed by the manifestation of this power depends on how long you study a particular area or subject.

1st Round: Presence or absence of psionic auras.

2nd Round: Number of different psionic auras and the strength of the most potent aura.

3rd Round: The strength and location of each aura. If the items or creatures bearing the auras are in line of sight, you can make Knowledge (psionics) checks to determine the discipline involved in each aura. (Make one check per aura; DC 15 + power level, or 15 + one-half manifester level for an effect that is not created by a power, such as that of a psionic item.) If the aura emanates from a psionic item, you can attempt to identify its properties (see Spellcraft).

Psionically charged locations, multiple disciplines, or strong local psionic emanations may confuse or conceal weaker auras.

Aura Strength: A psionic aura's strength depends on a functioning power's level or an item's manifester level. If an aura falls into more than one category, detect psionics indicates the stronger of the two. Detection of an overwhelming aura (see the accompanying table) dazes you for 1 round and the power ends.

* For creatures without a manifester level, use the creature's CR or hit die, whichever is lower.

Lingering Aura: A psionic aura lingers after its original source dissipates (in the case of a power) or is destroyed (in the case of a psionic item). If detect psionics is manifested and directed at such a location, the power indicates an aura of dim (even weaker than a faint aura). How long the aura lingers at this dim level depends on its original strength:

Each round, you can turn to detect psionics in a new area. You can tell the difference between magical and psionic auras. The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.

Augment: If you spend 2 additional power points, the duration changes to 3 rounds/level (D) (no concentration required) and it also gives you a +10 enhancement bonus on Spellcraft checks made to identify the properties and command words of magic items in your possession. This power does not allow you to identify artifacts.

Librarian Note : In Psionics Unleashed, this power is instead a 1st-level power for psions, wilders, and psychic warriors. In addition, it also does not have the duration change augment effect (but keeps the +10 Spellcraft effect). Otherwise, it is functionally the same power.`
  },
  Distract: {
    name: "Distract",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 0, dread 0, gambler 0, gifted blade 1, marksman 0, psion/wilder 0, psychic warrior 0, tactician 0",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `You cause your subject's mind to wander, distracting her. Subjects under the effect of distract make all Perception and Sense Motive checks at a -4 penalty.

Librarian Note : This is a 1st-level power for psions, wilders, and psychic warriors in Psionics Unleashed. Otherwise, it is the same.`
  },
  Ectoplasmic_Trinket: {
    name: "Ectoplasmic Trinket",
    discipline: "Metacreativity (Creation)",
    level: "Cryptic 0, gambler 0, marksman 0, psion/wilder 0, psychic warrior 0",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "1 minute/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Psionic focus or 1",
    description: `Effect: Unattended, nonpsionic, nonmagical object of nonliving matter, up to 1 cu. ft.

You shape raw ectoplasm into a nonmagical, unattended object of nonliving matter. The item created cannot exceed 1 cubic foot in volume or 1 gp in value. You must succeed on an appropriate Craft skill check to make a complex item. Coins and other objects of rare and precious materials (such as adamantine, cold iron, silver, etc.) cannot be created. Objects created in this manner may be used as tools, but have 1 hp and 0 hardness; they are too fragile to be used as weapons except for arrows, bolts, bullets, darts, and shuriken (manifesting this power will create up to three of such at once). Attempting to use any created object as a material component for spells causes the spell to fail.`
  },
  Empathy: {
    name: "Empathy",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 0, dread 0, gambler 0, psion/wilder 0",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft.-radius spread centered on you",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Psionic focus or 1",
    description: `You detect the surface emotions of any creature you can see that is in the power's area. You can sense basic needs,drives, and emotions. Thirst, hunger, fear, fatigue, pain, rage, hatred, uncertainty, curiosity, friendliness, and many other kinds of sensations and moods can all be perceived.

You gain a +2 insight bonus on any Bluff, Diplomacy, Intimidate, or Sense Motive checks that you make in the round when you cease concentrating on this power.

Augment: You can augment this power in one or both of the following ways.

• For every additional power point you spend, this power's range and the radius of its area increases by 5 feet.

• If you spend 2 additional power points, this power's maximum duration increases to 1 hour/level and you need only concentrate to gain the benefit of the power.

Librarian Note : In Psionics Unleashed, this is a 1st-level psion/wilder power. It is otherwise identical.`
  },
  Energy_Splash: {
    name: "Energy Splash",
    discipline: "Psychokinesis [see text];",
    level: "Gambler 0, psion/wilder 0",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `Effect: Ray

You create a ray of your active energy type (cold, electricity, fire, or sonic) that shoots forth from your fingertip and strikes a target within range, dealing damage if you succeed on a ranged touch attack with the ray.

• Cold: A ray of this energy type deals 2 points of damage. Alternately, the manifester can choose to deal no damage but instead chill up to 1 pound of non-living material (such as cooling a drink).

• Electricity: A ray of this energy type deals 1 point of damage. Manifesting a ray of this energy type provides a +3 bonus on your attack roll if the target is wearing metal armor and a +2 bonus on manifester level checks for the purpose of overcoming power resistance. Alternately, the manifester can choose to deal no damage but instead cause a relatively harmless static shock. This shock is painful enough to wake someone sleeping, but is not painful to interrupt concentration or spellcasting.

• Fire: A ray of this energy type deals 2 points of damage. Alternately, the manifester can choose to deal no damage but instead light a readily flammable object such as a lantern or torch, or warm up to 1 pound of nonliving material (such as heating food).

• Sonic: A ray of this energy type deals 1 point of damage and ignores an object's hardness. Alternately, the manifester can choose to deal no damage but instead cause a loud bang at the target location (DC 10 Perception check to hear it).

This power's subtype is the same as the type of energy you manifest.`
  },
  Far_Hand: {
    name: "Far Hand",
    discipline: "Clairsentience (Scrying)",
    level: "Seer 5, voyager 5",
    display: "Auditory, mental, and visual",
    manifestingTime: "1 standard action",
    range: "See text",
    target: "A nonmagical, unattended object weighing up to 5 lb.",
    area: "See text",
    duration: "Up to 1 min./level; see text (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `Far Hand[]

You can mentally lift and move an object at will from a distance. As a move action, you can propel the object as far as 15 feet in any direction, though the power ends if the distance between you and the object exceeds the power's range.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's range increases by 5 feet.

• For every additional power point you spend, the weight limit of the target increases by 2 pounds.

Librarian Note : The Psionics Unleashed version lists this power as a 1st-level psion/wilder power. Otherwise, it is identical.

Clairtangent Hand[]

You can emulate a far hand effect at any distance while simultaneously emulating clairvoyant sense to target your far hand; see the appropriate power descriptions. Clairtangent hand 's duration is up to 1 minute per level when used with a far hand effect.

Augment: If you spend 8 additional power points, you can emulate clairvoyant sense in conjunction with either telekinetic force or telekinetic maneuver , but this power's duration expires as soon as any of the noted telekinetic powers deals damage.

Mythic Clairtangent Hand[]

When you scry into a naturally darkened area, increase the distance you can see by 5 feet times your mythic tier. You may also see half this distance within magical darkness, as long as the darkness was created by an effect of 3rd level or lower. You can scry into an area that is warded against scrying by a non-mythic effect by succeeding on a manifester level check with a bonus equal to your mythic tier against a DC of 11 plus the manifester level of the ward against scrying.

The weight limit of the object you can affect is doubled.`
  },
  Float: {
    name: "Float",
    discipline: "Psychoportation",
    level: "Cryptic 0, gambler 0, gifted blade 1, highlord 0, marksman 0, psion/wilder 0, psychic warrior 0",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Psionic focus or 1",
    description: `You mentally support yourself in water or similar liquid.

You can swim at a speed of 5 feet using the power alone, or, if you already have a swim speed, this power boosts your swim speed by 5 feet.

Augment: For every additional power point you spend, your swim speed and bonus to swim speed increases by +5 feet.

Librarian Note : In Psionics Unleashed, this is a 1st-level power for psions, wilders, and psychic warriors. In addition, the base version states 10 feet, and the augment is every two additional power points for a +10 feet increase. Otherwise, they are the same power.`
  },
  Fortify_Lesser: {
    name: "Fortify, Lesser",
    discipline: "Psychometabolism [network]",
    level: "Cryptic 0, dread 0, gambler 0, guardian 0, psion/wilder 0, psychic warrior 0, tactician 0",
    display: "Mental",
    manifestingTime: "One standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One minute",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Psionic focus or 1",
    description: `You imbue yourself with psionic energy that protects you from harm, granting yourself a +1 resistance bonus on saves.`
  },
  Judge: {
    name: "Judge",
    discipline: "Telepathy",
    level: "Psion/wilder 0, sighted seeker 0, voyager 0",
    display: "None",
    manifestingTime: "One swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One Sense Motive check this round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You gain temporary, intuitive insight into piercing lies. Your Sense Motive check gains a +2 insight bonus.

Augment: For each 2 additional power points you spend, you can increase your Sense Motive check by +1.`
  },
  Missive: {
    name: "Missive",
    discipline: "Telepathy [Mind-Affecting, Language-Dependent]",
    level: "Cryptic 0, dread 0, gambler 0, psion/wilder 0, tactician 0, vitalist 0, voyager 0",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `Effect: Mental message delivered to subject

You send a telepathic message of up to ten words to any living creature within range. Missive is strictly a one-way exchange from you to the subject. If you do not share a common language, the subject “hears” meaningless mental syllables.

Augment: For every 2 additional power points you spend, this power's range increases by 5 feet.

Librarian Note : In Psionics Unleashed, this is a 1st-level power for psions and wilders. Otherwise, it is identical.`
  },
  My_Light: {
    name: "My Light",
    discipline: "Psychokinesis [Light]",
    level: "Cryptic 0, dread 0, gambler 0, gifted blade 1, highlord 0, marksman 0, psion/wilder 0, psychic warrior 0",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Psionic focus or 1",
    description: `Effect: 40-ft. cone of light emanating from you

Your eyes beam forth a 40-foot cone of light; for the first 20 feet, you shed normal light in such area, and you increase the light level for the other 20 feet by one step, up to normal light (darkness becomes dim light, and dim light becomes normal light). In an area of normal or bright light, this power can be manifested but it has no effect, until you enter into an area with a lower light level.

If my light is used in conjunction with elfsight , the cone of light extends out to 80 feet instead of 40 feet.

If my light is used in conjunction with control ligh t, the cone of light extends out to 60 feet instead of 20 feet.

Augment: You can augment this power in one of the following ways.

• If you spend 2 additional power points, you can manifest this power as a swift action.

• If you expend your psionic focus when manifesting this power, the cost of the power is reduced by 1 (to a minimum of 0).

Librarian Note : In Psionics Unleashed, this is a 1st-level power for psions, wilders, and psychic warriors. Otherwise, it is identical.`
  },
  Psionic_Repair: {
    name: "Psionic Repair",
    discipline: "metacreativity",
    level: "Cryptic 0, gambler 0, psion/wilder 0, voyager 0",
    display: "Material, Olfactory",
    manifestingTime: "10 minutes",
    range: "10 ft.",
    target: "one object of up to 1 lb./level",
    area: "",
    duration: "instantaneous",
    savingThrow: "Will negates (harmless, object)",
    powerResistance: "Yes (harmless, object)",
    powerPoints: "Psionic focus or 1",
    description: `This power repairs damaged objects, restoring 1d4 hit points to the object. If the object has the broken condition, this condition is removed if the object is restored to at least half its original hit points. All of the pieces of an object must be present for this power to function. Magic items can be repaired by this power, but you must have a manifester level equal to or higher than that of the object. Magic items that are destroyed (at 0 hit points or less) can be repaired with this power, but this power does not restore their magic abilities. This power does not affect creatures (including constructs). This power has no effect on objects that have been warped or otherwise transmuted, but it can still repair damage done to such items.`
  },
  Sense_Poison: {
    name: "Sense Poison",
    discipline: "Clairsentience",
    level: "Highlord 0, psion/wilder 0, psychic warrior 0, vitalist 0",
    display: "Material, Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Psionic focus or 1",
    description: `Target or Area: One creature, one object, or a 5-ft. cube

You determine whether a creature, object, or area has been poisoned or is poisonous. You can determine the exact type of poison with a DC 20 Wisdom check. A character with the Craft (alchemy) skill may try a DC 20 Craft (alchemy) check if the Wisdom check fails, or may try the Craft (alchemy) check prior to the Wisdom check. The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.`
  },
  Telekinetic_Punch: {
    name: "Telekinetic Punch",
    discipline: "Psychokinesis [Force]",
    level: "Cryptic 0, dread 0, gambler 0, marksman 0, psion/wilder 0, psychic warrior 0",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature or unattended object",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (object)",
    powerResistance: "Yes (object)",
    powerPoints: "Psionic focus or 1",
    description: `You can mentally punch a creature or object from a distance. This power deals 1 point of force damage; creatures and objects in their possession are allowed a Will save to negate the effect. You cannot push anything into another square using this power.`
  },
  Telepathic_Lash: {
    name: "Telepathic Lash",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Dread 0, gambler 0, psion/wilder 0, tactician 0, voyager 0",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One humanoid creature that has 4 HD or less",
    area: "",
    duration: "1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `Your mind lashes out, overwhelming your target with raging emotions, flooding their mind with memories and impulses they are hard pressed to control, rendering them unable to take any actions. Humanoids of 5 or more HD are not affected. The target is dazed; a dazed subject is not stunned, so attackers get no special advantage against it. After a creature has been dazed by this power, it is immune to the effects of this power for 1 minute.

Augment: This power can be augmented in one or more of the following ways.

• For every additional power point you spend, this power can affect a target that has Hit Dice equal to 4 + the additional points.

• For every additional power point you spend, increase the duration of the effect by 1 round. If you spend 6 additional power points in this fashion, the target is instead stunned for 1 round.

Additionally, for every two additional power points spent on either of the above options, this power's save DC increases by 1.

Librarian Note : In Psionics Unleashed, this is a 1st-level power for psions and wilders. Otherwise, it is identical.`
  },
  Unearthly_Terror: {
    name: "Unearthly Terror",
    discipline: "Telepathy [Fear, Mind-Affecting, Network]",
    level: "Dread 0, gambler 0, highlord 0, psion/wilder 0, tactician 0",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates or Will partial (see text)",
    powerResistance: "Yes",
    powerPoints: "Psionic focus or 1",
    description: `You form a mental bond between yourself and an enemy, and use that bond to bombard their mind with horrifying images and incite fear. Targets of this power who fail their saving throws are shaken for the duration of the power.

Augment: You may augment this power in one or more of the following ways.

• If you spend 4 additional power points, creatures that fail their save become frightened for the duration and those that succeed are considered shaken.

• If you spend 8 additional power points, creatures that fail their saves become panicked for the duration, and those that succeed are shaken.

• For every 2 additional power points you spend (including those spent on the above augment options) increase the save DC by 1.`
  },
  Vim: {
    name: "Vim",
    discipline: "Psychometabolism",
    level: "Cryptic 0, dread 0, gambler 0, psion/wilder 0, psychic warrior 0, vitalist 0",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Psionic focus or 1",
    description: `You suffuse yourself with power, gaining 1 temporary hit point. This temporary hit point overlaps (does not stack) with temporary hit points from any source, including previous manifestations of this power.`
  },
  Accelerant: {
    name: "Accelerant",
    discipline: "Metacreativity",
    level: "Cryptic 1, dread 1, psion/wilder 1",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "See text",
    powerResistance: "No",
    powerPoints: "1",
    description: `Effect: Ray

The stench of oils wafts around you, then the target of your ire finds themselves doused in a sticky flammable jelly that reeks of fiery doom. When you manifest accelerant , one creature or object becomes coated by a layer of fluid that they cannot easily remove. The target may immerse their entire body in a solvent to remove the oily slick, but ordinary water does not dissolve the fuel you have created.

Once so coated, the target is vulnerable to any source of flame, psionic or mundane. Mere contact with fire ignites the gel, forcing the subject to make a Reflex save to avoid catching on fire. On a failed saving throw, the target takes 1d6 points of fire damage. Each round thereafter, the target must make another Reflex save at the same DC to extinguish the flames, with failure resulting in an additional 1d6 points of fire damage. The target of this power may automatically extinguish (but not remove) the burning jelly by jumping into enough water to douse themselves. If insufficient water is available, the target may roll on the ground or smother the fire with cloaks or similar to make another save with a +4 bonus. This fire does not cause clothes or equipment to burn.

The flammable jelly remains present even when not burning and can be reignited by fresh exposure to a fire source. Once the duration of this power expires, the fuel vanishes. If the target is on fire when accelerant ends, they remain burning until they succeed at putting the fire out.

Augment: For every additional two power points you spend, the damage dealt by this power increases by 1d6 and the saving throw DC increases by 1.

Mythic Accelerant

The damage dice increase to 1d10s and the target gains the death throes monster special ability. If the subject of mythic accelerant is killed while on fire due to this power, they explode in a blinding flash of fire that deals 10 points of fire damage per damage die to anything within 10 feet per damage die (Reflex DC equal to this power's halves). The subject does not need to die due to burning to trigger this explosion. If the subject dies while having temporarily extinguished the flames, they do not explode.

Augmented (6th): Creatures that fail their Reflex save to take half damage from a death throes explosion become covered in mythic accelerant as if originally targeted. This does not extend the duration of this power but such creatures are considered to automatically have been exposed to fire and start taking burning damage on their turns. The death throes special property is inherited by these creatures, possibly allowing a cascading series of explosions for the duration of this power.`
  },
  Animus_Overload: {
    name: "Animus Overload",
    discipline: "Metacreativity",
    level: "Gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, tactician 1",
    display: "Auditory, Material, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude partial",
    powerResistance: "No",
    powerPoints: "1",
    description: `This power allows the manifester to cause the power of the already-unstable animus within a target to lose containment and become explosive within the target's body. When manifesting this power, the manifester makes a touch attack against the target and he may cause 1d4 points of animus in the target to erupt within them (consuming the point of animus), causing 5 points of damage per animus point consumed with this ability. Th target of this ability may make a Fortitude save to negate the damage while they release the dangerous animus from their body, but the animus targeted by this power is consumed. If the target does not possess animus, this power has no effct.

Augment: If you spend an additional 2 power points points, you may alter the range of this power to close range (25 feet + 5 feet per two manifester levels) and make the attack as a ranged touch attack.

If you spend an additional 2 power points, you may consume and explode an additional 1d4 points of animus within the target.`
  },
  Astral_Traveler: {
    name: "Astral Traveler",
    discipline: "Psychoportation",
    level: "Gambler 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "None",
    manifestingTime: "1 hour",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "See text",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "1",
    description: `This power allows you or a creature you touch to participate in an astral caravan created through use of the astral caravan power. While participating in a journey allowed by the astral caravan power, you must hold the hand of both your fellow passenger ahead of you (or the caravan leader) and your fellow passenger behind you (unless you happen to be the last in the hand-linked line). If you or any one of your fellow passengers breaks the hand-to-hand link for 2 consecutive rounds, the impetus through the Astral Plane provided by astral caravan fails. See the astral caravan power for more information.

All those who are part of the caravan who are capable of performing purely mental actions, such as manifesting a power, may do so while maintaining hand-to-hand contact with their fellow travelers. When astral travelers begin their journey, each one is connected to the Material Plane by an insubstantial silvery cord. Very few weapons exist that can damage a silvery cord.

The last creature in the line of those making up the caravan is sometimes referred to as the rear guard, because he or she has one hand free and can use it to wield a weapon without relinquishing his or her grip on the next traveler in line. The weightless, subjective environment of the Astral Plane allows the caravan to flex and bend as necessary to bring the rear guard's weapon to bear.`
  },
  Attraction: {
    name: "Attraction",
    discipline: "Telepathy (Charm) [Mind-Affecting]",
    level: "Gambler 1, psion/wilder 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You plant a compelling attraction in the mind of the subject. The attraction can be toward a particular person or an object. The subject will take reasonable steps to meet, get close to, attend, or find the object of its implanted attraction. For the purpose of this power, “reasonable” means that, while attracted, the subject doesn't suffer from blind obsession. He will act on this attraction only when not engaged in combat. The subject won't perform obviously suicidal actions. He can still recognize danger but will not flee unless the threat is immediate. If you make the subject feel an attraction to yourself, you can't command him indiscriminately, although he will be willing to listen to you (even if he disagrees). This power grants you a +4 bonus on any interaction checks you make involving the subject (such as Bluff, Diplomacy, Intimidate, and Sense Motive).

Augment: For every 2 additional power points you spend, this power's save DC increases by 1 and the bonus on interaction checks increases by 1.

Attraction (Mythic)[]

The duration of the effect increases to one day. Add your mythic tier to the bonus on interaction checks you make involving the subject.

Augmented: If you expend one use of mythic power, you may target one additional creature per tier.`
  },
  Autorecall: {
    name: "Autorecall",
    discipline: "Psychoportation",
    level: "Psion/wilder 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "Your psicrystal",
    area: "",
    duration: "1 hour/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You bind yourself to your psicrystal, allowing you to recall the psicrystal to your side with but a thought. As a free action, while the power is in effect and within range, you can recall your psicrystal, instantly teleporting it to your side. When you do, the power ends.

Augment: If you expend your psionic focus when manifesting this power, your psicrystal can trigger the recall as an immediate action.`
  },
  Bolt: {
    name: "Bolt",
    discipline: "Metacreativity (Creation)",
    level: "Marksman 1, psion/wilder 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "1 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `Effect: A normal bolt, arrow, or sling bullet

You create 2d4 ectoplasmic crossbow bolts, arrows, or sling bullets, appropriate to your size, which dissipate into their constituent ectoplasmic particles when the duration ends or after being fired. Ammunition you create has a +1 enhancement bonus on attack rolls and damage rolls.

Augment: For every 3 additional power points you spend, this power improves the ammunition's enhancement bonus on attack rolls and damage rolls by 1 and creates an additional 1d4 pieces of appropriate ammunition.

Mythic Bolt[]

Double the number of bolts, arrows, or sling bullets created by the power. Add half your tier to the enhancement bonus.

Augmented (3rd): If you expend one use of mythic power, you can choose weapon special abilities to use on the bolts, arrows, or sling bullets, but reduce the enhancement bonus by the cost of the weapon special ability. The bolts, arrows, or sling bullets must have a minimum +1 enhancement bonus in order to select weapon special abilities. You may not select the bane weapon special ability.`
  },
  Broker: {
    name: "Broker",
    discipline: "Psychometabolism",
    level: "Psion/wilder 1",
    display: "None",
    manifestingTime: "",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One Diplomacy check within 1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Manifestation Time: One swift action

You gain temporary, intuitive insight into dealing equitably with others. Your next Diplomacy check gains a +2 insight bonus.

Augment: For each 2 additional power points you spend, the insight bonus to Diplomacy increases by +1.

Mythic Broker[]

The duration increases to one minute per level. Add your tier to the insight bonus gained.

Augmented (3rd): If you expend one use of mythic power, you can try to use Diplomacy to influence attitude even during combat.`
  },
  Call_to_Mind_Lanis_s: {
    name: "Call to Mind, Lanis's",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 1, highlord 1, psion/wilder 1, sighted seeker 1, tactician 1, voyager 1",
    display: "Mental",
    manifestingTime: "1 minute",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `By meditating on a subject, you can recall natural memories and knowledge otherwise inaccessible to you.

On a failed Knowledge check, you can manifest this power to gain a new check with a +4 competence bonus. If successful, you instantly recall what was previously buried in your subconscious.

Augment: For every 2 additional power points you spend, the competence bonus increases by +1.`
  },
  Catfall: {
    name: "Catfall",
    discipline: "Psychoportation",
    level: "Gambler 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Until landing or 1 round/ level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You recover instantly from a fall and can absorb some damage from falling. You land on your feet no matter how far you fall, and you take damage as if the fall were 50 feet shorter than it actually is. This power affects you and anything you carry or hold (up to your maximum load). You can manifest this power with an instant thought, quickly enough to gain the benefit of the power while you fall. You can manifest this power even when it isn't your turn.

Augment: For every additional power point you spend, this power reduces your damage as if the fall were an additional 50 feet shorter.

Mythic Catfall[]

You can share the effects of the power with one creature per manifester level. All targets must be within 30 feet of you.

Augmented (4th): If you expend two uses of mythic power, you can move up to your movement speed while falling to choose where you land.`
  },
  Circumstance_Shield: {
    name: "Circumstance Shield",
    discipline: "Clairsentience",
    level: "Gambler 1, highlord 1, psion/wilder 1, psychic warrior 1, sighted seeker 1, tactician 1, voyager 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One hour/level or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Your shield of insight alerts you to potential dangers and supercharges your reaction time. You gain a +1 insight bonus on your Initiative checks for the duration of the effect. As as an immediate action, even if you are caught flatfooted (an exception to the rule that you cannot normally take immediate actions while flat-footed), you may add this bonus to a single Reflex save as a resistance bonus; doing so ends the effect.

Augment: For every 5 additional power points you spend, the insight bonus increases by +1.

Mythic Circumstance Shield[]

You add your tier to the insight bonus gained from this effect.

Augmented: If you expend one use of mythic power, you add the bonus to your Reflex saves without ending the effect.`
  },
  Control_Flames_Izam_s: {
    name: "Control Flames, Izam's",
    discipline: "Psychokinesis [Fire]",
    level: "Gambler 1, psion/wilder 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "One nonmagical fire source; see text",
    duration: "Concentration, up to 1 min./level",
    savingThrow: "See text",
    powerResistance: "No",
    powerPoints: "1",
    description: `You pyrokinetically control the intensity or movements of one fire source. A nonmagical fire source can be controlled if it is equal to or smaller than the maximum size of fire you can control according to your manifester level, as noted on the accompanying table. You can freely switch control between fire sources, or change the nature of your control, while you maintain concentration, but only one specified change (keeping a fire burning, animating it, or altering its size) can be made to one fire source in a round. When your control over a fire source lapses, that fire immediately returns to its original state (or goes out if it has no fuel or has been moved away from its original location). With this power, you can artificially keep a fire burning that would normally expire for lack of fuel; even dousing a controlled flame with water does not put it out (though completely submerging the flame would). Normally, a creature at risk of catching on fire can avoid this fate by making a DC 15 Reflex saving throw, with success indicating that the fire has gone out. If the fire is one that has been kept burning by the use of control flames, then the DC of the Reflex save needed to put out the flames increases to 25.

This power also enables you to make a fire move as if it were a living creature. You can animate only a naturally burning fire; if you attempt to animate one that has been increased or decreased in size by your augmentation of this power, the fire immediately returns to its original size. An animated fire moves at a speed of 30 feet. A fire that moves away from its fuel or its original location dies as soon as your control over it lapses.

An animated fire can enter any square, even if a creature already occupies it. If an animated fire enters a square occupied by a creature, that creature can make a Reflex save to get out of the way (DC 11 + the number of dice of damage the fire does + your key ability modifier). A successful Reflex save moves the creature to the nearest unoccupied square. The flames deal the indicated damage to any creature that is either on fire or surrounded by the flames (in the fire's space); see the accompanying table).

At the start of your turn, the animated fire deals damage to any creature in its space, and the creature catches on fire unless it makes a Reflex save (DC as noted above). A victim on fire takes 1d6 points of damage each round. Additional rounds in the same space as the animated fire occupies mean additional chances of ignition. The damage from multiple normal fires stacks, but the victim gets a saving throw each round to negate each fire. It is possible to switch control from the animated fire (causing it to disappear) to intensify flames that are already burning (thus denying the foe Reflex saves after the first).

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, you can increase the size of a fire you want to control by one step, up to the maximum size of fire you can control according to your manifester level.

• For every 2 additional power points you spend, you can decrease the size of a fire you want to control by one step. You can reduce a Tiny or smaller fire to nothing, extinguishing it.

Mythic Izam's Control Flames[]

You can concentrate to maintain the power as a move action instead of as a standard action. You may control a fire one size larger than normal (a 1st level manifester controlling a torch, a 3rd level manifester controlling a small campfire, and so on.) You add your tier to the maximum damage per round dealt by a fire you control.

Augmented (5th): If you expend two uses of mythic power, you can control two fires, each of up to your normal maximum fire size.`
  },
  Control_Light: {
    name: "Control Light",
    discipline: "Psychokinesis [Light]",
    level: "Gambler 1, psion/wilder 1",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "Nine 10-ft. cubes + three 10-ft. cubes/level (S)",
    duration: "Concentration, up to 1 min./level, or 1 round; see text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `By manipulating the ambient light level, you can decrease or increase the illumination of an area. The change in illumination can be gradual (taking as long as 1 minute) or sudden (occurring immediately when you manifest this power). You can alter the level of illumination from its original level at any time during the power's duration.

Decrease: You can decrease the light level of an area by one step (from bright light to normal light, from normal light to dim light, or from dim light to darkness. Creatures with darkvision can see in an area of dim light or darkness without penalty. You cannot create supernatural dark.

Increase: You can increase the light level of an area by one step (from darkness to dim light, from dim light to normal light, or from normal light to bright light).

Burst Increase: You can use this power to increase the light level of an area by two steps (from darkness to normal light, or from dim light to bright light), but in such a case the power's duration is only 1 round.

This power cannot stack with itself, even when manifested by another psionic creature, if manifested into the same area. If multiple manifestations of the control light power overlaps in an area, the light level is decreased or increased by only one step (or two steps in case of the Burst Increase manifestation).

Mythic Control Light[]

If using control light to decrease light, the illumination level in the area drops to darkness regardless of the existing lighting conditions. Non- mythic powers and effects can't increase the light level in the area. Creatures  with darkvision  and the power to see in darkness have difficulty seeing through this darkness, and can see as well as a human can in dim light. Creatures in the area of darkness take a -2 penalty on saves against fear.

If using control light to increase light, the illumination level in the area increases to at least normal light regardless of the existing lighting conditions. Creatures that take penalties in bright light double those penalties while in the area of bright light produced by this spell. All other creatures in the area of bright light gain a +2 circumstance bonus on Perception checks and saves to resist fear.

Augmented (3rd): If you expend one use of mythic power, the duration becomes 10 minutes per level.`
  },
  Crystal_Shard: {
    name: "Crystal Shard",
    discipline: "Metacreativity (Creation); Leve l : Gambler 1, psion/wilder 1",
    level: "",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `Effect: Ray

Upon manifesting this power, you propel a razor-sharp crystal shard at your target. You must succeed on a ranged touch attack with the ray to deal damage to a target. The ray deals 1d6 points of piercing damage.

Augment: You can augment this power in one of the following ways.

• For every additional power point you spend, this power's damage increases by 1d6 points.

• If you expend your psionic focus when manifesting this power, the cost of the power is reduced by 1 (to a minimum of 0), but the damage is reduced to 1d3 points of piercing damage and cannot be further augmented.

Mythic Crystal Shard[]

The damage dice increases to d10. If the target struck is adjacent to a wall, it becomes pinned to that wall. If adjacent to more than one wall, it is your choice to which  wall  it  becomes  pinned. The  CMB of the crystal shard is equal to your manifester level plus your key ability modifier plus your tier.

Augmented (3rd): If you expend two uses of mythic power, you may target a number of creatures equal to your tier.`
  },
  Deceleration: {
    name: "Deceleration",
    discipline: "Psychoportation",
    level: "Gambler 1, psion/wilder 1, voyager 1",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One Medium or smaller creature",
    area: "",
    duration: "1 min./level",
    savingThrow: "Reflex negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You warp space around an individual, hindering the subject's ability to move. The subject's speed (in any movement mode it possesses) is halved. A subsequent manifestation of deceleration on the subject does not further decrease its speed.

Augment: For every 2 additional power points you spend, this power can affect a target one size category larger and this power's save DC increases by 1.

Mythic Deceleration[]

The target creature is staggered.

Augmented (3rd): If you expend one use of mythic power, the target creature is denied its Dexterity bonus to AC on a failed save. On a successful save, the target's speed is halved (round down to the next 5-foot increment).`
  },
  Demoralize: {
    name: "Demoralize",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 1, gambler 1, psion/wilder 1",
    display: "Mental and olfactory",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft.-radius spread centered on you",
    duration: "1 min./level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You fill your enemies with self-doubt. Any enemy in the area that fails its save becomes shaken for the duration of the power. Allies and creatures without an Intelligence score are unaffected.

Augment: For every 2 additional power points you spend, this power's range and the radius of its area both increase by 5 feet, and the power's save DC increases by 1.

Mythic Demoralize[]

Creatures who fail their save instead become frightened.

Augmented: If you expend one use of mythic power, creatures who fail their save instead become panicked, and creatures who succeed on their save are shaken.`
  },
  Detect_Compulsion: {
    name: "Detect Compulsion",
    discipline: "Clairsentience",
    level: "Psion/wilder 1, vitalist 1",
    display: "None (see text)",
    manifestingTime: "",
    range: "60 feet",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `Manifestation Time: One swift action

You detect if the target creature is under the effects of a compulsion or charm. Affected creatures appear to have an amber aura, though no one but you sees this visual effect.`
  },
  Disable: {
    name: "Disable",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Gambler 1, psion/wilder 1",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "20 ft.",
    target: "",
    area: "Cone-shaped emanation centered on you",
    duration: "1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You broadcast a mental compulsion that convinces one or more creatures of a combined total of 4 Hit Dice or less that they are disabled. Creatures with the fewest HD are affected first. Among creatures with equal Hit Dice, those who are closest to the power's point of origin are affected first. Hit Dice that are not sufficient to affect a creature are wasted. Creatures that are rendered helpless or are destroyed when they reach 0 hit points cannot be affected.

Creatures affected by this power believe that they have somehow been brought to the brink of unconsciousness and must act accordingly. While it's possible for an important nonplayer character to attempt some sort of “heroic” action, common NPCs and creatures under the effect of this power typically cower or retreat.

Any creature that attempts to take a standard action immediately breaks the compulsion and can act normally. A creature that attempts to heal itself or that receives healing is likewise freed of the compulsion, and if it is not actually wounded, the healing is wasted. A creature that takes damage is also instantly freed of the compulsion (although the damage still counts against its actual current hit points).

Augment: For every 2 additional power points you spend, this power's range increases by 5 feet and its save DC increases by 1.

In addition, for every additional power point you spend to increase the range and the save DC, this power can affect targets that have Hit Dice equal to 4 + the number of additional points.

Mythic Disable[]

The number of hit dice of creatures that can be affected is doubled and you can choose the order in which creatures are affected by the power.

Augmented (8th): If you expend three uses of mythic power, you can cause a single creature within the affected area to actually become disabled, as its body conforms to what its mind believes. If the creature does not make a successful save, its hit points are reduced to -1.`
  },
  Dissipating_Touch: {
    name: "Dissipating Touch",
    discipline: "Psychoportation (Teleportation)",
    level: "Gambler 1, highlord 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature or object touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes (object)",
    powerPoints: "1",
    description: `Your mere touch can disperse the surface material of a foe or object, sending a tiny portion of it far away. This effect is disruptive; thus, your successful melee touch attack deals 1d6 points of damage.

Augment: For every additional power point you spend, this power's damage increases by 1d6 points.

Mythic Dissipating Touch[]

Add your tier to each die of damage dealt with your melee touch attack.

Augmented (7th): If you expend three uses of mythic power, your touch dissipates the entire non-mythic creature, scattering their entire form across the planes, effectively killing them. This effect cannot be used against mythic creatures.`
  },
  D_j_Vu: {
    name: "Déjà Vu",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 1, gambler 1, psion/wilder 1, voyager 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `Your mental impulse forces the subject to repeat the actions it took on its previous turn. If the situation has changed in such a way that the subject can't take the same actions again (if its foe is dead, or the subject has run out of power points, and so on), the subject stands still and takes no actions for 1 round. In any event, the subject can still defend itself, and it retains its Dexterity bonus to AC even if it stands still.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mythic Déjà Vu[]

The duration of the effect increases to two rounds. The targeted creature attempts to retrace its steps, repeating the previous actions rounds on the first round, but taking any move actions back the way it came, and repeating the previous round's action on the next round.

Augment (5th): If you expend two uses of mythic power, the target creature loses its Dexterity bonus for the duration of mythic déjà vu .`
  },
  Ecto_Protection: {
    name: "Ecto Protection",
    discipline: "Metacreativity",
    level: "Psion/wilder 1",
    display: "Visual; see text",
    manifestingTime: "1 standard action; see text",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "An astral construct you manifest",
    area: "",
    duration: "1 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `This power reinforces an astral construct you created by the astral construct power, increasing the DC by 1 on any dispel psionics attempts or a similar effect, and a +1 bonus on its saving throw to resist dismiss ectoplasm. This power can be manifested as a swift action in the same round that you manifest an astral construct, as long as the power points you spend to perform both actions do not exceed your manifester level.

Augment: For every 2 additional power points you spend, the DC for dispel psionics or similar effects increases by 1, and your astral construct's bonus on its saving throw to resist dismiss ectoplasm increases by 1.

Mythic Ecto Protection[]

Increase the bonus gained against dispel effects and dismiss ectoplasm by your tier.

Augmented: If you expend one use of mythic power, if your astral construct is dispelled or fails against a dismiss ectoplasm effect, the construct explodes, dealing 1d6 points of piercing damage for each power point spent on the manifestation to all creatures within a 5 ft. radius of the construct's location.`
  },
  Ectoplasmic_Sheen: {
    name: "Ectoplasmic Sheen",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 1, psion/wilder 1",
    display: "Visual and olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "See power text",
    powerResistance: "No",
    powerPoints: "1",
    description: `Target or Area: One object or a 10-ft. square

You draw forth ectoplasm in an area, causing the surface to become slick. Any creature in the area when the power is manifested must make a successful Reflex save or fall. A creature can walk within or through the area of ectoplasm at half normal speed with a DC 10 Acrobatics check. Failure means it can't move that round (and must then make a Reflex save or fall), while failure by 5 or more means it falls (see the Acrobatics skill for details). Creatures that do not move on their turn do not need to make this check and are not considered flat-footed.

The power can also be used to create a greasy coating on an item. Material objects not in use are always affected by this power, while an object wielded or employed by a creature requires its bearer to make a Reflex saving throw to avoid the effect. If the initial saving throw fails, the creature immediately drops the item. A saving throw must be made in each round that the creature attempts to pick up or use the affected item. A creature wearing affected armor or clothing gains a +10 circumstance bonus on Escape Artist checks and combat maneuver checks made to escape a grapple, and to their CMD to avoid being grappled.

Augment: If you spend 6 additional power points, each target that fails a Reflex save to remain standing and falls must first make a Strength check (with the same DC as the Reflex save) to stand.

In addition, for every two additional power points you spend augmenting this power, the power's save DC increases by 1.

Mythic Ectoplasmic Sheen[]

If you manifest ectoplasmic sheen on an area, add your tier to the Acrobatics DC to move within or through the area. If you manifest it on a creature's armor or clothing, add your tier to its Escape Artist checks and combat maneuver checks attempted to escape a grapple and to its CMD to avoid being grappled.

Augmented: You can expend two uses of mythic power to make the affected area flammable. It ignites from any fire at least the size of a candle flame. If an affected area is ignited, any creature in the area on your turn takes 1d3 points of fire damage and might catch on fire. If an affected creature is ignited, it takes 2d6 points of fire damage, and might catch on fire; add your tier to the save DC.`
  },
  Empty_Mind: {
    name: "Empty Mind",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You empty your mind of all transitory and distracting thoughts, improving your self-control. You gain a +2 bonus on all Will saves until your next action.

Augment: For every 2 additional power points you spend, the bonus on your Will saves increases by 1.

Mythic Empty Mind[]

Increase the bonus on Will saves by 50% (round down).

Augmented (3rd): If you expend one use of mythic power, you can manifest this power after already having rolled a Will saving throw to reroll.`
  },
  Energy_Dagger: {
    name: "Energy Dagger",
    discipline: "Psychokinesis [see text]",
    level: "Highlord 1, psion/wilder 1, psychic warrior 1",
    display: "Visual, Material",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "1 minute/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Effect: One dagger

You focus your mental energy into the form of a dagger wreathed in psionic energy. This dagger deals damage like a normal dagger for your size and has an additional effect depending on your active energy type. If the dagger leaves your hand, it disappears at the end of the round.

• Cold: +1 point of cold damage and anyone damaged by this takes a -1 penalty to saves against cold effects.

• Fire: +1d4 fire damage.

• Electricity: +1 point of electricity damage and a +3 bonus to attacks against enemies in metal armor.

• Sonic: -1 point of damage and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, the dagger becomes a +1 weapon.

• If you spend 4 additional power points, it becomes a +1 weapon with the corresponding energy enhancement (flaming, frost, shocking, thundering) in addition to its energy bonus.

• If you spend 6 additional power points, it becomes a +1 weapon with the corresponding energy enhancement (flaming burst, icy burst, shocking burst, keen thundering).`
  },
  Energy_Ray: {
    name: "Energy Ray",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 1, psion/wilder 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `Effect: Ray

You create a ray of energy of your active energy type (cold, electricity, fire, or sonic) that shoots forth from your fingertip and strikes a target within range, dealing 1d6 points of damage, if you succeed on a ranged touch attack with the ray.

• Cold: A ray of this energy type deals +1 point of damage per die.

• Electricity: Manifesting a ray of this energy type provides a +3 bonus on your attack roll if the target is wearing metal armor and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A ray of this energy type deals +1 point of damage per die.

• Sonic: A ray of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6).

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Ray[]

The damage die type is increased to 1d8 and bypasses the first 10 points of resistance.

Augmented (3rd): The power bypasses all energy resistance, but does not bypass immunities.`
  },
  Energy_Touch: {
    name: "Energy Touch",
    discipline: "Psychokinesis",
    level: "Highlord 1, psion/wilder1, psychic warrior 1",
    display: "Visual, Auditory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One target per level",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You charge your touch with your active energy type, dealing 1d6 points of energy damage on a successful melee touch attack. You can use this melee touch attack up to one time per manifester level.

• Cold: A touch of this energy type deals +1 point of damage per die.

• Electricity: You gain a +3 bonus on your attack roll if the target is wearing metal armor and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A touch of this energy type deals +1 point of damage per die.

• Sonic: A touch of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: This power can be augmented in one or more of the following ways.

• 1. For every 2 power points you spend, this power deals +1d6 energy damage.

• 2. If you spend 2 additional power points, each energy type gains a secondary effect as follows: Cold: The target must make a Fortitude save or become staggered for 1 round. Electricity: The target must make a Will save or become shaken for 1 round. Fire: The target must make a Reflex save or catch on fie and take 1d6 of extra fire damage. Sonic: The target must make a Fortitude save or become sickened for 1 round.`
  },
  Entangling_Debris: {
    name: "Entangling Debris",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 1, highlord 1, psion/wilder 1, tactician 1",
    display: "Material, Visual",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "Matter in a 40-ft.-radius spread",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "Reflex partial; see text",
    powerResistance: "No",
    powerPoints: "1",
    description: `You use telekinetic force to manipulate matter in the affected area, including wood, metal, grasses, bushes, and even trees, to entwine creatures in the affected area or those that enter the area, causing them to become entangled. The individual pieces of matter affected must weigh less than 25 lbs each and either cannot be permanently affixed or must be able to sufficiently reach creatures within the area. Affected creatures can break free and move half their normal speed by using a full-round action to make a DC 20 Strength check or a DC 20 Escape Artist check. A creature that succeeds on a Reflex save is not entangled but can still move at only half speed through the area. Each round you concentrate, you may once again direct the debris to attempt to entangle all creatures that have avoided or escaped entanglement.

Augment: This power may be augmented in one or more of the following ways.

• For each additional 2 power points spent, this power can affect an area 5 ft. larger in radius.

• By spending an additional 4 power points, this power causes 2d6 points of damage per round to creatures that failed their Reflex save.

In addition, for every 2 additional power points you spend to achieve any of these effects, this power's save DC increases by 1.`
  },
  Entangling_Ectoplasm: {
    name: "Entangling Ectoplasm",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 1, highlord 1, psion/wilder 1, tactician 1",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One Medium or smaller creature",
    area: "",
    duration: "5 rounds",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You draw forth a glob of ectoplasmic goo from the Astral Plane and immediately throw it as a ranged touch attack at any creature in range. On a successful hit, the subject is covered in goo and becomes entangled. The goo evaporates at the end of the power's duration. Entangled creatures can attempt to break free as a move action, making a Strength or Escape Artist check. The DC for this check is equal to 11 + the manifester's key ability modifier.

Augment: For every 2 additional power points you spend, this power can affect a target one size category larger and the DC to break free increases by 1.

Mythic Entangling Ectoplasm[]

The duration of the effect increases to one minute. Add your tier to the DC to break free from the goo.

Augmented (5th): If you expend two uses of mythic power, the save DC increases by 1 each round the struck creature does not successfully break free. In addition, if the struck creature makes a successful check to break free, it must make another successful check to break free before the end of the next round or the ectoplasmic goo regenerates around it.`
  },
  Environment_Shield: {
    name: "Environment Shield",
    discipline: "psychometabolism [network]",
    level: "cryptic 1, dread 1, gambler 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 1, psionic formulist 1, psychic warrior 1, tactician 1, vitalist 1, voyager 1",
    display: "visual",
    manifestingTime: "1 standard action",
    range: "touch",
    target: "creature touched",
    area: "",
    duration: "24 hours",
    savingThrow: "Fortitude negates (harmless)",
    powerResistance: "yes (harmless)",
    powerPoints: "1",
    description: `You insulate the target against their surroundings. A creature protected by this power suffers no harm from being in a hot or cold environment. It can exist comfortably in conditions between -50 and 140 degrees Fahrenheit (-45 and 60 degrees Celsius) without having to make Fortitude saves. The creature's equipment is likewise protected.

Unaugmented, this power doesn't provide any protection from fire or cold damage, nor does it protect against other environmental hazards such as smoke, lack of air, and so forth.

Augment: This power can be augmented in following ways

• If you spend 6 additonal power points, the target gains the ability to breathe freely, even underwater or in a vacuum, and becomes immune to harmful gases and vapors, including radiation, inhaled diseases and poisons and spells like cloudkill. In addition, the creature is protected from extremes of pressure. This power does not provide the ability to see in conditions of poor visibility (such as in smoke or fog), nor the ability to move or act normally in conditions that impede movement (such as underwater).

• If you spend 10 additional power points, the target gains the ability to exist comfortably at any temperature, becoming immune to heat and cold and thus becoming immune to both fire and cold damage.`
  },
  Essence_Defilement: {
    name: "Essence Defilement",
    discipline: "Psychometabolism",
    level: "All 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `

Your successful melee touch attack defiles your target's essence, burning 1 point of essence and then granting the target 1 point of temporary essence for the duration of this spell. This essence is defiled by your psionic energy, blighting the affected creature's body and soul. The affected creature takes a penalty to their Strength score (to a minimum of 1), and a penalty to their natural armor (to a minimum of 0) equal to the defiled temporary essence they possess. At the beginning of each of their turns, they take a number of points of damage equal to the defiled essence. This damage ignores any damage reduction or resistance the target might possess.

Augment: For every 2 additional power points you spend, you burn an additional 1 point of essence and grant 1 additional point of temporary defiled essence.`
  },
  Essence_Infusion: {
    name: "Essence Infusion",
    discipline: "Psychometabolism",
    level: "All 1",
    display: "Olfactory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "1 minute",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `

Your touch infuses a creature with essence. Choose one of the creature's essence receptacles; it is invested with 1 temporary point of essence. The chosen essence receptactle's essence capacity increases by 1.

Augment: This power can be augmented in the following ways:

• For every 2 additional power points you spend, increase the duration of this power by 1 minute

• For every 2 additional power points you spend, increase the temporary essence by 1. This does not further increase the receptacle's essence capacity.`
  },
  False_Veil: {
    name: "False Veil",
    discipline: "Metacreativity",
    level: "Dread 1, highlord 1, psion/wilder 1, tactician 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "no",
    powerPoints: "1",
    description: `You draw upon the proto-magics of akasha to weave an extremely minor veil on the target. This veil doesn't do anything in particular, but can be formed on any open chakra and can look like whatever the caster desires (including other appropriate veils). It can be readily identified as a veil as normal, but noticing that it isn't a fully operational one takes an appropriate Knowledge check (DC 25). This veil can be invested with essence by the person it is formed on, just like any other. Essence invested this way makes the veil appear more solid, with much more dramatic energies swirling, sparking, or showering from it. This increases the DC to identify that it is not functional by +2 per point of essence invested. It cannot be bound.

Augment: For every 2 additional power points you spend, increase the range of this power by one category (touch to close, close to medium, and medium to long).`
  },
  Find_the_Host: {
    name: "Find the Host",
    discipline: "Athanatism",
    level: "Psion/wilder 1, vitalist 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "Circle, centered on you, with a radius of 400 ft. + 40 ft./level",
    duration: "1 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You sense the direction of the nearest dead, mostly intact body. This power is blocked by even a thin sheet of lead. Undead creatures cannot be found by this power. Magical or psionic attempts to conceal the body fool this power.

Augment: You may spend an additional 6 power points to find the dead body of a specific creature, instead of just the closest dead body.`
  },
  Force_Screen: {
    name: "Force Screen",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 1, gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You create an invisible mobile disk of force that hovers in front of you. The force screen provides a +4 shield bonus to Armor Class (which applies against incorporeal touch attacks, since the force screen is a force effect). Since it hovers in front of you, the effect has no armor check penalty associated with it.

Augment: For every 4 additional power points you spend, the shield bonus to Armor Class improves by 1.

Mythic Force Screen[]

Half of the shield bonus (rounded down) from the power also applies against ranged touch attacks.

Augmented: If you expend two uses of mythic power, the effect can also gain one shield special ability with a +1 bonus cost, such as arrow catching .`
  },
  Fortify: {
    name: "Fortify",
    discipline: "Psychometabolism",
    level: "Cryptic 1, gambler 1, gifted blade 1, psion/wilder 1, psychic warrior 1",
    display: "Mental",
    manifestingTime: "One standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One minute/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You imbue yourself with psionic energy that protects you from harm, granting yourself a +2 resistance bonus on saves.

Augment: For every 2 additional power points you spend, you gain an additional +1 resistance bonus on saves.

Mythic Fortify[]

The resistance bonus gained from the power also applies to AC as a deflection bonus. Once during the power's duration, you can roll a saving throw twice and take the higher result, or force a creature attacking you to roll the attack roll twice and take the worse result. You must decide to use this ability before the first roll is attempted.

Augmented (2nd): If you expend one use of mythic power, you may reroll a number of times equal to your mythic tier.`
  },
  Foxhole: {
    name: "Foxhole",
    discipline: "Psychokinesis",
    level: "Gambler 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1",
    display: "Material, Olfactory",
    manifestingTime: "1 standard action",
    range: "20 ft.",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Effect: Four 5-ft. squares of loose earth, sand, snow, or similar unworked terrain (S)

A quick burst of psychokinetic force rearranges the land nearby you, providing an emergency source of cover. By pushing the terrain away from a central point and piling it at the outer edges of the area of effect, you can rapidly create a mundane safe-zone for sudden combat.

This power creates a small burrow three to five feet deep in the land, with a small wall that surrounds it which can provide cover for creatures within.

Multiple manifestations of this power can dig deeper into the ground, providing a quick underground burrow, or can be used to extend an existing burrow into a trench. Foxhole cannot be used to dig through walls or foundations (although it could burrow around them) nor can it rearrange magically treated terrain.

If the area of effect completely contains a creature's space, including the manifester, that creature must make a Reflex save or fall prone in the burrow. If a creature happens to be burrowing in the area of effect and would be exposed by this power, it emerges, prone but unharmed, in the trench.

Augment: You may augment this power in one or more of the following ways:

• For each additional power point spend, you can burrow one 5-ft, cube instead of affecting four 5ft. squares. Only one of these cubes need be in contact with the surface when you start manifesting.

• For each 2 additional power points spend, you can affect substances with an hardness of 2 additional points (such as stone or ice) starting at hardness 0.

• If you spend 2 additional power points you may manifest this power as a swift action.`
  },
  Guide_the_Willing: {
    name: "Guide the Willing",
    discipline: "Athanatism [death]",
    level: "Dread 2, psion/wilder 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One conscious, willing, and living target",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None and Fort negates; see text",
    powerResistance: "No and yes; see text",
    powerPoints: "3 (dread), 1 (psion/wilder)",
    description: `Your powers can grant the final mercy to those suffering. The target dies immediately. Any triggered effects that would normally activate on the target's death do not activate, and the target cannot be raised from the dead by any means. A target killed by this power does not become undead when it dies. If the target is coerced or compelled in any way, this power fails.

Augment: This power may be augmented in one of the following ways.

• You may expend your psionic focus to have only effects of your choice trigger when the target dies.

• By spending an additional 10 power points, the target does not have to be willing or conscious. This power has a range of touch, and the target receives a Fortitude save to resist its effects (as well as power resistance, if applicable).

• By spending an additional 4 power points, the target can be a willing undead creature. The target is completely destroyed, releasing its soul to be raised as normal.

In addition, for every two power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Hammer: {
    name: "Hammer",
    discipline: "Psychometabolism",
    level: "Gambler 1, highlord 1, psion/wilder 1, psychic warrior 1",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `Targets: Creature or creatures touched (see text)

This power charges your touch with the force of a sledgehammer. Your melee touch attack deals 1d8 points of damage. This damage is not increased or decreased by your Strength modifier.

Augment: You can augment this power in the following ways:

• For every additional power point you spend, you can use this melee touch attack one additional time.

• For every additional 2 power points you spend, the damage increases by 1d8 damage.

Mythic Hammer[]

Add your tier to the damage dealt by your melee touch attack. You may choose to have the damage modified by your Strength modifier.`
  },
  Hide_Psicrystal: {
    name: "Hide Psicrystal",
    discipline: "Psychometabolism",
    level: "Psion/wilder 1",
    display: "Visual",
    manifestingTime: "1 round",
    range: "Personal",
    target: "",
    area: "",
    duration: "24 hours or until discharged",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You merge your biokinetic aura with that of your psicrystal, allowing your psicrystal to merge into your body. For the duration of the power, the psicrystal cannot be targeted in any way and cannot use any of its powers, but still gives you the benefits of having it close, such as Alertness. It cannot be detected in any way, but the effect can still be detected. The psicrystal can be discharged as a standard action.`
  },
  Inertial_Armor: {
    name: "Inertial Armor",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 1, gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "Visual; see text",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Your mind generates a tangible field of force that provides a +4 armor bonus to Armor Class. Unlike mundane armor, inertial armor entails no armor check penalty or speed reduction. Because inertial armor is composed of psychokinetic force, incorporeal creatures can't bypass it the way they do normal armor.

Your inertial armor can be invisible or can appear as a colored glow, at your option.

The armor bonus provided by inertial armor does not stack with the armor bonus provided by regular armor.

Augment: For every 2 additional power points you spend, the armor bonus to Armor Class increases by 1.

Mythic Inertial Armor[]

The armor bonus is increased by 50% (rounded down). There is a 50% chance that any critical hit or sneak attack made against the target is negated and treated as a normal hit, as if the target were wearing moderate fortification armor.`
  },
  Inevitable_Strike_Roshan_s: {
    name: "Inevitable Strike, Roshan's",
    discipline: "Clairsentience",
    level: "Cryptic 1, gambler 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1, tactician 1, voyager 1",
    display: "Visual",
    manifestingTime: "1 swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "See text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You gain temporary, intuitive insight into the immediate future during your next attack. Your next single attack roll (if it is made before the end of the next round) gains a +5 insight bonus. Additionally, you are not affected by the miss chance that applies to attackers trying to strike a concealed target.

Augment: This power may be augmented in one or both of the following ways.

• You can increase the manifesting time to 1 standard action and increase the insight bonus to +20.

• For every additional power point spent, the insight bonus increases by 2, but the total bonus may not exceed +25.

Mythic Roshan's Inevitable Strike[]

The affected attack bypasses all damage reduction.

Augmented (2nd): If you expend two uses of mythic power and are manifesting the power as a standard action, you gain a +10 insight bonus on your second attack that round and a +5 insight bonus on your third attack that round. The second and third attacks can be on your turn or on another creature's turn before your next turn (such as when you attempt an attack of opportunity). This option may only be used when manifesting the power as a standard action.`
  },
  Involuntary_Bodily_Function: {
    name: "Involuntary Bodily Function",
    discipline: "Psychometabolism",
    level: "Psion/wilder 1, vitalist 1",
    display: "Olfactory, Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "one living creature",
    area: "",
    duration: "1 min/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You trigger a number of involuntary bodily functions in a living target, making them sickened unless they succeed on a Fortitude save.

Augment: You can augment this power in any of the following ways

• If you spend 3 additional power points, the target instead becomes nauseated on a failed save, and falls prone unless they make a successful Reflex save.

• If you spend 2 additional power points, you can designate one target per manifester level instead of just one.`
  },
  Know_Direction_and_Location: {
    name: "Know Direction and Location",
    discipline: "Clairsentience",
    level: "Cryptic 1, highlord 1, psion/wilder 1, sighted seeker 2, tactician 1, voyager 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 1, highlord 1, psion/wilder 1, sighted seeker 3, tactician 1, voyager 1",
    description: `You generally know where you are. This power is useful to characters that end up at unfamiliar destinations after teleporting, using a gate, or traveling to or from other planes of existence. The power reveals general information about your location as a feeling or presentiment. The information is usually no more detailed than a summary that locates you according to a prominent local or regional site. Using this power also tells you what direction you are facing.

Using this power prior to making a Knowledge (planes) check with astral caravan grants a +2 bonus on the check.

Augment: If you expend your psionic focus when manifesting this power, the cost of the power is reduced by 1 (to a minimum of 0).

Mythic Know Direction and Location[]

You may choose for the power to reveal the direction to a commonly known location within a number of miles equal to your manifester level plus your mythic tier times 10. This location must be commonly known, such as a city or other settlement or a natural feature such as a mountain or river, with a Knowledge (geography), Knowledge (local), or Knowledge (nature) DC no greater than 10 plus your mythic tier unless you have previously visited that location.`
  },
  Locate_Secret_Doors: {
    name: "Locate Secret Doors",
    discipline: "Clairsentience",
    level: "Cryptic 1, gambler 1, psion/wilder 1, voyager 1",
    display: "Auditory, Mental",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "cone-shaped emanation",
    duration: "concentration, up to 1 min./level (D)",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "1",
    description: `You can detect secret doors, compartments, caches, and so forth. Only passages, doors, or openings that have been specifically constructed to escape detection are detected by this power. The amount of information revealed depends on how long you study a particular area or subject.

1st Round : Presence or absence of secret doors.

2nd Round : Number of secret doors and the location of each. If an aura is outside your line of sight, then you discern its direction but not its exact location.

Each Additional Round : The mechanism or trigger for one particular secret portal closely examined by you. Each round, you can turn to locate secret doors in a new area.

The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.

Mythic Locate Secret Doors[]

When you are not concentrating, the power continues to function in a 10-foot-radius emanation centered on you. In addition, you gain a bonus equal to one-half your mythic tier on Perception checks made to notice traps placed on secret doors that you detect. You can concentrate as a swift action to gain information on the second and subsequent rounds after detecting a secret door.

You can penetrate effects that block divination or clairsentience with a manifester level check with a DC of 11 plus the manifester level of the effect, or through lead sheeting with a DC 20 manifester level check, plus 5 per inch of thickness. You can penetrate 3 feet of wood or dirt, 1 foot of stone, or 1 inch of common metal with a DC 15 manifester level check, plus 5 for each multiple of that thickness. If the substance or effect blocking your detection is not mythic, or if it already allows a manifester level check or saving throw to penetrate its protection, add your mythic tier on your manifester level check or saving throw.`
  },
  Malfunction: {
    name: "Malfunction",
    discipline: "psychokinesis",
    level: "cryptic 1, dread 1, highlord 1, psion/wilder 1, psychic warrior 1, tactician 1",
    display: "mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft + 10 ft./level)",
    target: "One object",
    area: "",
    duration: "instantaneous",
    savingThrow: "Fortitude negates, affects objects, see text",
    powerResistance: "yes",
    powerPoints: "1",
    description: `You disrupt the function of a technological object. On a failed save, the next time the object is used, it is treated as timeworn, and the user must roll on the appropriate glitch table to determine the functionality of the weapon. If the wielder is carrying the targeted object when this power is used, the wielder may use their own fortitude saving throw modifier in place of the weapon's saving throw modifier.

Augment: This power may be augmented in the following ways:

• By spending 4 additional power points, the manifester may choose the glitch that occurs rather than having the glitch be determined by a roll.

• By spending 6 additional power points, you may manifest this power as an immediate action rather than a standard action.

• For every additional power point that you spend that is not part of either of the above augmentations, you may target one additional object within range to be affected by this power.

• By spending 8 additional power points, you may cause the weapon to become permanently timeworn, causing it to glitch every time that it is used. This can be removed with a DC 30 craft (machinery) check.`
  },
  Mark_of_the_Shroud: {
    name: "Mark of the Shroud",
    discipline: "Athanatism",
    level: "Highlord 1, psion/wilder 1, tactician 1, vitalist 1",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One living creature touched per three levels",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `By marking mortal creatures, you gain knowledge of their mortality. You are aware of direction or distance to the creatures and any conditions affecting them: unharmed, wounded, disabled, staggered, unconscious, dying, nauseated, panicked, stunned, poisoned, diseased, confused, or the like. You may also allow the soul to linger in the marked creatures for the duration of this power. This extends the period of time that spells and powers such as raise dead would be effective. Once this power has been manifested upon the subjects, the distance between them and the manifester does not affect the power as long as they are on the same plane. If a subject leaves the plane, or if it dies, the power ceases to function for it.

Augment: This power may be augmented in one of the following ways.

• By spending an additional 2 power points, increase the duration of this power to 1 hour/level.

• By spending an additional 4 power points, increase the duration of this power to 1 day/level.

• For every 2 additional power points you spend, you extend the negative hit point total at which targets die by 1 hit point.

In addition, for every 2 power points you spend augmenting this power, targets gain a +1 bonus on saves against death or negative energy effects.`
  },
  Matter_Agitation: {
    name: "Matter Agitation",
    discipline: "Psychokinesis",
    level: "Gambler 1, psion/wilder 1",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "2 sq. ft. of surface area of an object or creature",
    duration: "Concentration, up to 1 min./level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You can excite the structure of a nonpsionic, nonmagical object, heating it to the point of combustion over time. The agitation grows more intense in the second and third rounds after you manifest the power, as described below.

1st Round: Readily flammable material (paper, dry grass, tinder, torches) ignites. Skin reddens (1 point of damage).

2nd Round: Wood smolders and smokes, metal becomes hot to the touch, skin blisters (1d4 points of damage), hair smolders, paint shrivels, water boils.

3rd and Subsequent Rounds: Wood ignites, metal scorches (1d4 points of damage for those holding metallic objects). Skin burns and hair ignites (1d6 points of damage), lead melts.

Mythic Matter Agitation[]

The area of effect is increased to 4 square feet of surface area of an object or creature. Add your tier to the amount of damage dealt each round. Non-mythic creatures suffer double damage from the effect.

Augmented: If you expend one use of mythic power, you can divide the area of effect between two objects or creatures.`
  },
  Memories_of_Flesh: {
    name: "Memories of Flesh",
    discipline: "Athanatism",
    level: "Psion/wilder 1, vitalist 1",
    display: "Auditory, olfactory, and visual",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One incorporeal creature",
    area: "",
    duration: "One hour",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "1",
    description: `You reward the target with memories of life, letting it feel alive and corporeal for a limited time. It can smell the living world, feel the warmth of the sun, and any number of other purely aesthetic effects, and gains a +1 bonus on all d20 rolls for the duration. You gain a +5 bonus on all Charisma-based skill checks except Intimidate against the target for the duration of this power.

Augment: By spending an additional 6 power points, the target loses any immunity to pain and morale effects that you create. When augmented this way, this power is no longer harmless for the purpose of saves or power resistance.`
  },
  Mind_Palace: {
    name: "Mind Palace",
    discipline: "Clairsentience",
    level: "Cryptic 1, psion/wilder 1, vitalist 1",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `At the sound of a sharp snap, your eyes glaze over as you internalize your thought processes, rummaging amongst the recesses of your mind to reach resources normally inaccessible to your conscious self. For a tiny moment of time, your personal sense of time's passage is distorted, granting the priceless boon of time to think. When you manifest mind palace , you envision a artificial representation of your mind's contents, and you search within that representation for shards of knowledge that might be applicable to the problem immediately before you. The amount of hidden useful knowledge to be gained is unpredictable. You gain a 1d4 bonus to the next attack roll, saving throw, skill check, ability check, manifester level check or similar check you make before the start of your next turn.

Augment: For every additional two power points you spend, bonus granted by this power increases by 1d4.

Mythic Mind Palace

The bonus dice for mythic mind palace are increased to 1d8.`
  },
  Mind_Thrust: {
    name: "Mind Thrust",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 1, gambler 1, psion/wilder 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You instantly deliver a massive assault on the thought pathways of any one creature, dealing 1d10 points of damage to it.

Augment: For every additional power point you spend, this power's damage increases by 1d10 points. For each extra 2d10 points of damage, this power's save DC increases by 1.`
  },
  Mindscape_Lens: {
    name: "Mindscape Lens",
    discipline: "Clairsentience",
    level: "Cryptic 1, Dread 1, Psion/Wilder 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 feet + 5 feet/level)",
    target: "One creature",
    area: "",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "1",
    description: `You peer inside the mind of a creature, observing any mindscape that it resides in. You sense anything that they sense inside the mindscape, but cannot alter the mindscape or communicate with the individual inside without the aid of another ability.

Augment

• If you spend 2 additional power points, you can use this ability on a sleeping creature's dreamscape rather than a mindscape.

• If you spend 6 additional power points, you gain the ability to generate an entity that can perceive and interact with the subconscious realm more actively. This functions as the remote viewing power, save that it only works on the creature you are looking into the mindscape of. You cannot use this ability to manifest powers inside a binary mindscape`
  },
  Morbid_Fascination: {
    name: "Morbid Fascination",
    discipline: "Athanatism",
    level: "Cryptic 1, gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You cast your eyes far off into the Ethereal, catching occasional glimpses of its inhabitants. You can see creatures in the Ethereal Plane and pinpoint their locations, but they are treated as having total concealment from you. This link with the Ethereal makes you dangerously curious about the dead and ghosts. While this power is active; you gain a +2 bonus on Diplomacy checks made against followers or advocates of death and ghosts, but suffer a -2 penalty on Will saving throws and Bluff checks against the same.

Augment: By spending an additional 4 power points, you may, as a swift action at any time during the duration of this power, expend your psionic focus to instead treat creatures in the Ethereal Plane as if they had concealment instead of total concealment for one round.`
  },
  Precognition_Defensive: {
    name: "Precognition, Defensive",
    discipline: "Clairsentience",
    level: "Cryptic 1, gifted blade 1, highlord 1, psychic warrior 1, tactician 1, voyager 1",
    display: "Auditory, Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Precognition[]

Precognition allows your mind to glimpse fragments of potential future events—what you see will probably happen if no one takes action to change it. However, your vision is incomplete, and it makes no real sense until the actual events you glimpsed begin to unfold. That's when everything begins to come together, and you can act, if you act swiftly, on the information you previously received when you manifested this power.

In practice, manifesting this power grants you a “precognitive edge.” Normally, you can have only a single precognitive edge at one time. You must use your edge within a period of no more than 10 minutes per level, at which time your preknowledge fades and you lose your edge.

You can use your precognitive edge in a variety of ways. Essentially, the edge translates into a +2 insight bonus that you can apply at any time to either an attack roll, a damage roll, a saving throw, or a skill check. You can elect to apply the bonus to the roll after you determine that your unmodified roll is lower than desired.

Precognition, Defensive[]

Your awareness extends a fraction of a second into the future, allowing you to better evade an opponent's blows.

You gain a +1 insight bonus to AC and on all saving throws. If caught in a situation where your Dexterity bonus isn't applied to your Armor Class, this bonus to AC and saving throws does not apply.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Greater[]

As precognition, except as noted here. You gain a +4 insight bonus instead of a +2 bonus, and the effect is not discharged when used. You may only gain a number of precognitive edges per manifestation equal to your manifester level.

Precognition, Offensive[]

Your awareness extends a fraction of a second into the future, allowing you to better land blows against your opponent. You gain a +1 insight bonus on your attack rolls.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained on your attack rolls increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Tactical[]

Your awareness extends a fraction of a second into the future, allowing you to better perform a particular combat maneuver. Select one type of combat maneuver, such as bull rush or reposition, when you manifest this power. You gain a +2 enhancement bonus to combat maneuver checks of that type for the duration of the effect.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, the enhancement bonus increases by 1.

• For every 3 additional power points you spend, you can select an additional type of combat maneuver.

• If you spend 4 additional power points, using the combat maneuver selected does not provoke attacks of opportunity.

• If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Precognition_Offensive: {
    name: "Precognition, Offensive",
    discipline: "Clairsentience",
    level: "Cryptic 1, gifted blade 1, highlord 1, psychic warrior 1, tactician 1, voyager 1",
    display: "Auditory, Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Precognition[]

Precognition allows your mind to glimpse fragments of potential future events—what you see will probably happen if no one takes action to change it. However, your vision is incomplete, and it makes no real sense until the actual events you glimpsed begin to unfold. That's when everything begins to come together, and you can act, if you act swiftly, on the information you previously received when you manifested this power.

In practice, manifesting this power grants you a “precognitive edge.” Normally, you can have only a single precognitive edge at one time. You must use your edge within a period of no more than 10 minutes per level, at which time your preknowledge fades and you lose your edge.

You can use your precognitive edge in a variety of ways. Essentially, the edge translates into a +2 insight bonus that you can apply at any time to either an attack roll, a damage roll, a saving throw, or a skill check. You can elect to apply the bonus to the roll after you determine that your unmodified roll is lower than desired.

Precognition, Defensive[]

Your awareness extends a fraction of a second into the future, allowing you to better evade an opponent's blows.

You gain a +1 insight bonus to AC and on all saving throws. If caught in a situation where your Dexterity bonus isn't applied to your Armor Class, this bonus to AC and saving throws does not apply.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Greater[]

As precognition, except as noted here. You gain a +4 insight bonus instead of a +2 bonus, and the effect is not discharged when used. You may only gain a number of precognitive edges per manifestation equal to your manifester level.

Precognition, Offensive[]

Your awareness extends a fraction of a second into the future, allowing you to better land blows against your opponent. You gain a +1 insight bonus on your attack rolls.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained on your attack rolls increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Tactical[]

Your awareness extends a fraction of a second into the future, allowing you to better perform a particular combat maneuver. Select one type of combat maneuver, such as bull rush or reposition, when you manifest this power. You gain a +2 enhancement bonus to combat maneuver checks of that type for the duration of the effect.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, the enhancement bonus increases by 1.

• For every 3 additional power points you spend, you can select an additional type of combat maneuver.

• If you spend 4 additional power points, using the combat maneuver selected does not provoke attacks of opportunity.

• If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Prescience_Offensive: {
    name: "Prescience, Offensive",
    discipline: "Clairsentience",
    level: "Cryptic 1, dread 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1, sighted seeker 1, voyager 1",
    display: "Material and visual",
    manifestingTime: "1 standard action; see text",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Your awareness extends a fraction of a second into the future, allowing you to better aim blows against your opponent. You gain a +2 insight bonus on your damage rolls.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus on your damage rolls increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.`
  },
  Prophetic_Song_Euterpe_s: {
    name: "Prophetic Song, Euterpe's",
    discipline: "Clairsentience [mind-affcting, sonic]",
    level: "Highlord 1, psion/wilder 1, tactician 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "60 ft. radius sphere centered on you",
    duration: "Concentration (up to 1 minute/level)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You weave your prophetic power into song, using it to bolster your allies with visions of the future. Allies within the area gain a +1 insight bonus to their attack rolls as long as you concentrate on singing, humming, or otherwise making music (allies within the area of silence or similar effects, or who are deafened, cannot benefit from this bonus). You cannot manifest this power while unable to make music, such as by being within the area of a silence spell.

Augment: You may augment this power in the following ways.

• If you spend 4 additional power points, the insight bonus also applies to skill checks.

• If you spend 8 additional power points, the insight bonus also applies to weapon damage rolls in addition to the above options.

• If you spend 12 additional power points, the insight bonus also applies to AC in addition to the above options.

• If you spend 16 additional power points, the insight bonus also applies to saving throws in addition to the above options.

In addition, the insight bonus granted by this power increases by 1 for every 2 power points spent on the above options.

Surge Augmentation: If you invoke your wild surge while manifesting this power, change its duration to 'concentration plus 3 rounds'.`
  },
  Reject_Essence: {
    name: "Reject Essence",
    discipline: "Psychometabolism",
    level: "all 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft. per level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates, Fortitude half",
    powerResistance: "yes",
    powerPoints: "1",
    description: `

You briefly alter the target's soul, causing it to violently reject its natural essence. The affected creature must make a Will saving throw or take 1 point of essence burn. A successful Will save negates the essence burn. If the creature fails this save, they then take 1d4 points of damage, halved on a successful Fortitude saving throw. This damage is from a pulse of akashic power and bypasses all forms of damage reduction and resistance.

Augment: For every 2 additional power points you spend augmenting this power, the power's saving throw DC increases by 1, you burn an additional point of essence, and the target takes an additional 2d4 points of damage.`
  },
  Restore_Essence: {
    name: "Restore Essence",
    discipline: "Psychometabolism",
    level: "all 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "No",
    powerPoints: "1",
    description: `Casting Time: 1 standard action



Your touch restores 1 point of the creature's burned essence, as if they had meditated to recover it. Burned essence that cannot be recovered via meditation (such as essence burned as part of the psiweaving ability) cannot be restored using this spell.

Augment: Every 1 additional power point you spend on this power restores 1 additional point of burned essence.`
  },
  Sense_Link: {
    name: "Sense Link",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 1, highlord 1, psion/wilder 1, tactician 1, vitalist 1, voyager 1",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One willing creature",
    area: "",
    duration: "Concentration, up to 1min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You perceive what the subject creature perceives using its sight, hearing, taste, or smell. Only one sense is linked, and you cannot switch between senses with the same manifestation.

You make any skill checks involving senses, such as Perception, as the subject, and only within the subject's field of view. You lose your Dexterity bonus to AC while directly sensing what the subject senses.

Once sense link is manifested, the link persists even if the subject moves out of the range of the original manifestation (but the link does not work across planes). You do not control the subject, nor can you communicate with it by means of this power.

The strength of the subject's linked sense could be enhanced by other powers or items, allowing you the same enhanced sense. You are subject to any gaze attack affecting the subject creature (if you linked vision). If you are blinded or deafened, or suffer some other sensory deprivation, the linked creature functions as an independent sensory organ, and provides you the benefit of the linked sense from its perspective while this power's duration lasts.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, you can have the subject perceive one of your senses instead of the other way around.

• If you spend 4 additional power points, you can link to a second sense of the same subject.

• If you spend 2 additional power points, you can target an unwilling creature (Will save negates), but cannot augment this power in any other way. Treat the power as a 2nd level power when determining the save DC.`
  },
  Shroudsight: {
    name: "Shroudsight",
    discipline: "Athanatism",
    level: "Psion/wilder 1, vitalist 1",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped emanation",
    duration: "Concentration",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You attune your eyes to the energies of the dead and the half-living, detecting undead and incorporeal creatures. The amount of information revealed depends on how long you study a particular area.

1st Round : Presence or absence of undead or incorporeal auras.

2nd Round: Number of incorporeal or undead auras in the area and the strength of the strongest incorporeal or undead aura present. If you are of good alignment, and the strongest incorporeal or undead aura's strength is overwhelming (11 HD or greater), and the creature has HD of at least twice your character level, you are stunned for 1 round and the power ends.

3rd Round: The strength and location of each incorporeal or undead aura. If an aura is outside your line of sight, then you discern its direction but not its exact location.

Each round, you can turn to detect incorporeal creatures or undead in a new area. The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.

For the purpose of detecting incorporeal undead, you count as if you had spent three rounds focusing whenever you manifest this power, automatically granting you the maximum amount of information.

Augment: By spending an additional 3 power points, gain a +1 bonus on attack rolls, power save DCs, and skill checks against any creatures that you detected with this power. This bonus lasts for a number of rounds equal to your key manifesting modifier.`
  },
  Shunning_of_the_Material: {
    name: "Shunning of the Material",
    discipline: "Athanatism",
    level: "Psion/wilder 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One object no larger than 2 cubic feet/level",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes; see text",
    powerPoints: "1",
    description: `You send an object into the Ethereal Plane, making it ethereal. While it is ethereal, the object cannot affect or be affected by any force on the Material Plane, except those that can normally interact with the ethereal (such as through ghost touch) . Any creatures inside the object must succeed at a Will save, or be transported along with it. Any creatures transported this way become fully ethereal, not incorporeal until they leave the object - at which time they immediately return to the Material Plane. If the object was part of a larger object, or interacted with another object in a significant way (such as the support beam or keystone for a building, or a single part of a complex weapon), the structure of the other objects that interact with the target is unchanged.

Augment: You may augment this power in one of the following ways.

• By spending an additional 6 power points, you may shift an area instead of an object. You may shift up to 3,000 sq. ft./level with this augmented use of this power. Any creatures inside the area to be transported gain Will saves as described above.

• By spending an additional 4 power points, increase the duration of this power to 1 hour/level.`
  },
  Skate: {
    name: "Skate",
    discipline: "Psychoportation",
    level: "Gambler 1, gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, voyager 1",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Personal or touch; see text",
    target: "You or one willing creature or one unattended object (total weight up to 100 lb./level); see text",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes (harmless, object)",
    powerPoints: "1",
    description: `You, another willing creature, or an unattended object can slide along solid ground as if on smooth ice. If you manifest skate on yourself or another creature, the subject of the power retains equilibrium by mental desire alone, allowing her to gracefully skate along the ground, turn, or stop suddenly as desired. The skater's land speed increases by 15 feet. (This adjustment is treated as an enhancement bonus.) As with any effect that increases speed, this power affects the subject's maximum jumping distance.

The subject can skate up or down any incline or decline she could normally walk upon without mishap, though skating up an incline reduces the subject's speed to normal, while skating down a decline increases her speed by an additional 15 feet. (This adjustment is treated as a circumstance bonus.)

If you manifest skate on an object, treat the object as having only one-tenth of its normal weight for the purpose of dragging it along the ground.

Augment: For every additional power point you spend, you can affect an additional target.`
  },
  Slumber: {
    name: "Slumber",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Dread 1, gambler 1, psion/wilder 1",
    display: "Mental",
    manifestingTime: "1 round",
    range: "Medium (100 feet + 10 feet/level)",
    target: "",
    area: "One or more living creatures in a 10-foot-radius burst",
    duration: "One minute/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You cause a psionic slumber to come upon 4 HD of creatures. Creatures with the fewest HD are affected first. Among creatures with equal HD, those who are closest to the power's point of origin are affected first. HD that are not sufficient to affect a creature are wasted. Sleeping creatures are helpless. Slapping or wounding awakens an affected creature, but normal noise does not. Awakening a creature is a standard action (an application of the aid another action). Slumber does not target unconscious creatures, constructs, or undead creatures.

Augment: For every additional power point you spend, you increase the number of Hit Dice affected by one.

If you instead spend 11 additional power points, you affect every creature within the power's area, regardless of individual or total Hit Dice.`
  },
  Steal_Language: {
    name: "Steal Language",
    discipline: "Telepathy",
    level: "Cryptic 1, psion/wilder 1",
    display: "Olfactory, Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature with at least one language",
    area: "",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You rip knowledge of a language out of the mind of the target and implant it into your own mind. Unless the target succeeds on its saving throw, you add the language to your languages known for the duration of the effect and your target loses access to this language for the duration of the effect.

Augment: This power can be augmented in one or more of the following ways.

• For every additional power point you spend, choose one more language that your target knows that it will lose and you will gain on a failed save.

• If you spend 2 additional power points, the duration extends to 1 hour/level.

• If you spend 4 additional power points, the duration extends to 1 day/level.`
  },
  Sunder_Investment: {
    name: "Sunder Investment",
    discipline: "Psychometabolism",
    level: "All 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft. per 2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fort partial",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `

You briefly sunder the connections between the target's essence and their essence receptacles. The target of this power must make a Fortitude saving throw or have all of their essence uninvested from their essence receptacles. If some of their essence cannot be uninvested (such as if it is bound, or uninvesting their essence from a receptacle requires them to be within a certain range) those points of essence are burned instead. Essence burned in this way is automatically reinvested into those receptacles when it is recovered. If they succeed on this save, all of their essence invested in a single essence receptacle of your choice that you have knowledge of has its essence uninvested instead.

Augment: For every 2 additional power points you spend augmenting this power, the power's saving throw DC increases by 1, and you may choose an additional essence receptacle to uninvest if the target succeeds on its saving throw.`
  },
  Synesthete: {
    name: "Synesthete",
    discipline: "Psychometabolism",
    level: "Gambler 1, gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, vitalist 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You receive one kind of sensory input when a different sense is stimulated. In particular, you can either feel light or feel sound. You can shift your stimulated sense between these two options once per round as a swift action. Your senses continue to work normally as well, unless they are impaired for some reason.

Your face must be uncovered to use this power, because it is the skin of your face that acts as the sensory receiver.

If you are feeling light by absorbing ambient light onto your skin, you have your normal visual abilities (except for darkvision), even if your eyes are closed or you are blinded. If your eyes are working normally, you gain a +4 circumstance bonus on all visual Perception checks. While feeling light, you are immune to gaze attacks.

If you are feeling sound by absorbing sound onto your skin and your ears are working normally, the expanded audio input provides you with a +4 circumstance bonus on Perception checks to listen.

Psionic or magical displacement effects, invisibility effects, illusions, and other similar effects confuse your synesthete senses just as they would your normal senses.

You can also use this power to see sound if you are deafened, or hear light if you are blinded, thus removing all penalties associated with either condition (though you gain no bonuses for using the power in this way if you are not deafened or blinded).`
  },
  Telempathic_Projection: {
    name: "Telempathic Projection",
    discipline: "Telepathy (Charm) [Mind-Affecting]",
    level: "Psion/wilder 1",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You alter the subject's mood, adjusting its attitude toward you by one step in a positive direction. For instance, an unfriendly creature can be made indifferent, or a hostile creature unfriendly. You can grant a +4 bonus on your own (or others') Bluff, Diplomacy, Intimidate, Perform, or Sense Motive checks involving the affected creature.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Temporary_Blindness: {
    name: "Temporary Blindness",
    discipline: "Psychometabolism",
    level: "cryptic 1, dread 1, psion/wilder 1",
    display: "Visual, Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One target",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You temporarily disconnect the body's sight from whatever processes the images in them, causing them to suffer temporary blindness. The target must make a Fortitude save or become blinded. The target can make a new save at the end of each round to remove the blindness.

Augment: This power can be augmented in one or more of the following ways.

• If you spend 2 additional power points, the duration extends to 1 minute per level. The target gets to make a new save every minute instead of every round.

• If you spend 4 additional power points, the duration extends to 1 day per level. The target gets to make a new save every day instead of every round.

• If you spend 4 additional power points, the target does not gain any additional saves if they fail the first.

• If you spend 4 additional power points, you can target one target per manifester level.

• If you spend 6 additional power points, the duration becomes Permanent instead of 1 round/lvl.

In addition, for every 2 power points you spend to augment this power, increase the DC by +1.`
  },
  Transfer_Animus: {
    name: "Transfer Animus",
    discipline: "Psychometabolism (mind-affecting)",
    level: "Gifted blade 1, highlord 1, psion/wilder 1, psychic warrior 1, tactician 1",
    display: "Material, Visual",
    manifestingTime: "1 swift action",
    range: "Touch",
    target: "",
    area: "",
    duration: "1 minute",
    savingThrow: "Will (harmless)",
    powerResistance: "No",
    powerPoints: "1",
    description: `Upon manifesting this power, you are able to transfer your animus to an individual with a touch. To use this power, you must possess an animus pool. The target of this power need not have an animus pool or a method of using it; if they do not, they may not use this animus for any reason, simply becoming harmlessly charged by it. You may transfer two points of animus to a target creature, and this energy lasts for one minute before dissipating harmlessly.

Augment: If you spend an additional 2 power points points, you may alter the range of this power to close range (25 feet + 5 feet per two manifester levels) and the manifester must make a successful ranged touch attack on an unwilling target. If you spend an additional 1 power point, you may transfer an additional two points of animus to the target.`
  },
  Transfer_Energy: {
    name: "Transfer Energy",
    discipline: "psychokinesis",
    level: "cryptic 1, dread 1, gambler 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 1, psionic formulist 1, psychic warrior 1, tactician 1, vitalist 1, voyager 1",
    display: "visual",
    manifestingTime: "1 standard action",
    range: "close (25 feet + 5 feet/level)",
    target: "2 technological objects within range",
    area: "",
    duration: "instantaneous",
    savingThrow: "see text",
    powerResistance: "no",
    powerPoints: "1",
    description: `You move energy between two objects, transferring up to 5 charges between them. You may use this power on an object in the possession of an unwilling creature, but that creature is allowed a will save to negate the effects of this power

Augment: This power can be augmented in the following ways:

• For every additional power point you spend, you may transfer 5 additional charges between the two objects.

• For every 2 additional power points you spend, you may target one additional object with this power. If you are targeting more than 2 objects with this power, you may allocate the charges between them however you wish, such as drawing 2 charges from one and 3 charges from another to move all 5 into a third.

• If you spend 6 additional power points, you may use this power as a swift action`
  },
  Unnatural_Aura: {
    name: "Unnatural Aura",
    discipline: "Athanatism [fear, mind-affecting]",
    level: "Dread 1, psion/wilder 1",
    display: "Olfactory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature touched",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You cause the target to radiate the unnatural chill of the grave, repelling animals. Any animal must succeed on a Will save to willingly approach within 20 feet of the target. If they fail the save and are forced to approach, they are shaken for as long as they remain within 20 feet of the target.

Augment: This power may be augmented in one of the following ways.

• For every additional power point spent, you can target one additional living creature when manifesting this power.

• By spending an additional 4 power points, you may cause any animal that fails the save and is forced to approach to become frightened.

• By spending an additional 6 power points, you may cause any animal that fails the save and is forced to approach to become panicked.

In addition, for every two power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Veil_Magnification: {
    name: "Veil Magnification",
    discipline: "Telepathy (essence, mind affecting)",
    level: "All 1",
    display: "Auditory, Visual",
    manifestingTime: "1 swift action",
    range: "Close (25 ft. + 5 ft. per 2 levels)",
    target: "One creature",
    area: "",
    duration: "See text",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You wrack the target's mind with this power, amplifying the effects of your veils when used against them. The target suffers a -1 penalty against the saving throws of your veils until the beginning of your next turn.

Augment: This power can be augmented in the following ways:

• For every 4 additional power points you spend, the duration of this power increases by 1 round.

• By spending 6 additional power points, the penalties of this power apply to saving throws against all veils, not just your own.

Essence: For each point of essence burned as part of manifesting this power, the penalty to saving throws against your veils worsens by -1.`
  },
  Veil_Restoration: {
    name: "Veil Restoration",
    discipline: "Clairsentience",
    level: "All 1",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "No",
    powerPoints: "1",
    description: `

Your touch restores one of the creature's suppressed veils, immediately causing it to reform around them. Choose one of the creature's veils that have been suppressed for a set duration. That veil is immediately restored, as if the duration of the suppression had ended. If other abilities are tied to that veil being suppressed (such as the psiweaver's psiweaving ability) those abilities are resolved as normal for the veil's suppression ending.

Augment: For every 2 additional power points you spend, you may choose and restore an additional veil with this power.`
  },
  Vigor: {
    name: "Psionic Vigor",
    discipline: "Psychometabolism",
    level: "Cryptic 1, gambler 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 1, psychic warrior 1, vitalist 1",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You suffuse yourself with power, gaining 5 temporary hit points. Using this power again when an earlier manifestation has not expired merely replaces the older temporary hit points (if any remain) with the newer ones.

Augment: For every additional power point you spend, the number of temporary hit points you gain increases by 5.`
  },
  Ward_the_Mind: {
    name: "Ward the Mind",
    discipline: "Athanatism",
    level: "Highlord 1, psion/wilder 1, tactician 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature touched",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "1",
    description: `This power wards the mind and soul of the living from the predations of the undead. The target is immune to future possession and possession-like effects such as magic jar - if the target is already possessed, this power does not remove that effect. They also gain a +2 deflection bonus to AC and a +2 resistance bonus on saves, but only against attacks made or effects created by incorporeal creatures.

Augment: This power may be augmented in one of the following ways.

• For every additional power point spent, you can target an additional creature when you manifest this power.

• For every 2 additional power points spent, you increase the bonuses granted by this power by 1.

• By spending an additional 4 power points, this power affects a 10-ft.-radius emanation from the target. Summoned incorporeal creatures cannot enter the area of this power.

In addition, if you spend at least 4 power points augmenting this power, increase the duration of this power to 10 minutes/level.`
  },
  Accelerate_Body: {
    name: "Accelerate Body",
    discipline: "Psychometabolism",
    level: "Cryptic 2, psion/wilder 2, vitalist 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You accelerate the body of the touched target and you can choose to affect only detrimental effects, only positive effects or all effects.

Detrimental: Every poison, disease, ongoing spell effect with a negative effect over time triggers once more as if at least one day had passed (reducing onset time, triggering more saves against diseases or poisons, but only one and so on). A successful saving throw does not count toward ending the affliction, and this extra save does not change the timing of the next save against the affliction. The target can make a Fortitude save to negate this effect.

Positive: The target heals physical ability damage as if they had rested for a day, gain a new save against any ongoing effects or spells that give new saves after a day and heal their hit dice in hit point damage. No save.

All: Both of the above effects trigger at the same time. The target gains no save.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, the range changes from Touch to Close (25 ft. + 5 ft./2 levels).

• For every 2 additional power points you spend, the effects trigger as if another day had passed.

• For every 2 additional power points you spend, you can affect another target with this power.`
  },
  Apathetic_Aura: {
    name: "Apathetic Aura",
    discipline: "telepathy (compulsion) [mind-affecting]",
    level: "Cryptic 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "20 ft.",
    target: "",
    area: "20 ft. radius centered on you",
    duration: "",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Duration 1: round/level

You emit an aura that causes creatures to be uninterested in you or those accompanying you. The affected creatures are aware of your presence, but simply find your presence unworthy of their attention. Creatures accompanying you must be within 10 feet of you to be similarly ignored. Any action that would directly harm the affected creature allows it to make an additional save against this power with a +4 circumstance bonus to negate this effect.

Augment: If you spend an additional 4 power points, the duration becomes 10 minutes/level.`
  },
  Arcanix_Spellsieve: {
    name: "Arcanix Spellsieve",
    discipline: "Psychokinesis or clairsentience",
    level: "Highlord 2, psion/wilder 2, tactician 2, vitalist 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 min/level",
    savingThrow: "None (harmless)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You interweave your mind and power with that of another creature, allowing you to either empower their spells or to draw power from the spells they cast. Whenever the target casts a spell, you can augment that spell as an immediate action. For every 2 power points you spend augmenting it, increase the effective caster level of that spell by 1. For every 3 power points you spend augmenting it, increase its effective spell level by 1. Both of these uses stack with each other, but you cannot spend more than your manifester level on a single augment. (For example, if you spend 6 power points to augment a spell, the caster level increases by 3 and the spell level by 2).

The other use of this power allows you to siphon some of the power of a spell into your own power reserves. As an immediate action when the target casts a spell, you regain 1 power point for every 2 spell levels of the spell they cast. This use of the power immediately ends the effect.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, the duration increases to 10 minutes / level.

• For every 2 power points you spend, you can choose another target for this power.

• If you spend 2 additional power points, you can augment the spells of your target as a free action.`
  },
  Bastion: {
    name: "Bastion",
    discipline: "Psychometabolism",
    level: "Psion/wilder 2, vitalist 2",
    display: "Mental",
    manifestingTime: "",
    range: "Touch",
    target: "Creature touched; see text",
    area: "",
    duration: "1 min./level",
    savingThrow: "Fortitude negates (harmless); Power",
    powerResistance: "",
    powerPoints: "3",
    description: `Manifestation Time: 1 standard action

Resistance: Yes (harmless)

A fluttering of your eyelashes reveals your concentration as you expend extraordinary effort restructuring the biological makeup of your ally, granting them extra ability. When you manifest this power upon an ally with the ability to form an astral suit, they gain an extra customization point which they can spend on their turn as a free action. When this power expires, the customization invested is removed automatically.

Augment: For every four additional power points you spend, the recipient is granted an additional customization point.

Mythic Bastion

You may use mythic bastion offensively against an enemy aegis. When you manifest this power, you attempt to suppress a number of customization points invested in their astral suit. Treat this similarly to a targeted dispel psionics check. The enemy aegis uses their aegis level as their manifester level. If you are successful, you remove as many customization points from the target's pool as you would normally grant an ally aegis. Your opponent may choose which customizations their suit sheds for the duration of this power and once this power ends, those customizations return to full potency immediately.`
  },
  Bestow_Power: {
    name: "Bestow Power",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Psion/wilder 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "20 ft.",
    target: "One psionic creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You link your mind with another psionic creature's mind, creating a brief conduit through which mental energy can be shared. When you manifest this power, the subject gains up to 2 power points. You can transfer only as many power points to a subject as it has manifester levels.

Because of the intimate nature of this power, it cannot be fabricated into a psionic item—only power points generated by a psionic creature in the moment can be shared using bestow power .

Special: The power point cost of this power cannot be reduced below the number of power points transferred. All points transferred must be deducted from the manifester's pool of power points; sources such as wild surge cannot pay for this effect. This power is not subject to the effects of affinity field .

Augment: For every 3 additional power points you spend, the subject gains 2 additional power points.`
  },
  Biofeedback: {
    name: "Biofeedback",
    discipline: "Psychometabolism",
    level: "Dread 1, gambler 2, gifted blade 1, highlord 1, psion/wilder 2, psychic warrior 1, vitalist 1",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Dread 1, gifted blade 1, highlord 1, psion/wilder 3, psychic warrior 1, vitalist 1",
    description: `You can toughen your body against wounds, lessening their impact. For the duration of this power, you gain damage reduction 2/-.

Augment: For every 3 additional power points you spend, your damage reduction increases by 1.

Biofeedback (Mythic)[]

Add your tier to the amount of damage reduction received.

Augmented (5th): You can expend two uses of mythic power to have the damage reduction also apply to damage from powers and other effects that deal hit point damage.`
  },
  Blackest_Shade: {
    name: "Blackest Shade",
    discipline: "Athanatism",
    level: "Highlord 2, psion/wilder 2, tactician 2",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One shadow touched",
    area: "",
    duration: "1 minute/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `By imbuing a shadow with psychic energy, you create a free-willed and friendly spirit. You create a harmless shadow spirit to serve your needs. This spirit is treated as a shadow, except that it cannot attack or take hostile actions and has a friendly disposition towards you. You may use it to scout, but it cannot venture more than 50 feet from you without vanishing, and it cannot speak (though it can communicate through mime or shadow puppetry). The shadow will generally follow your commands, unless you command it to do something obviously self-destructive. It also suffers a -2 penalty on saves against any athanatism powers that you manifest on it.

Augment: By spending an additional 6 power points, increase the duration of this power to 1 hour/level.`
  },
  Bloodfountain: {
    name: "Bloodfountain",
    discipline: "Psychometabolism",
    level: "Dread 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "One round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Manifestation Time: 1 standard action

Your press your fingers against the pliant flesh of your enemy and through this contact tap into its bloodstream, overloading its capacity. When you manifest this power, your target's blood pressure (or similar life-giving fluid) increases to the point that vessels begin to burst. A creature affected by bloodfountain begins to leak their precious fluids out of eyes, ears, or other openings. Such a creature bleeds 2 hit points of damage at the start of its turn each round. This bleed damage functions as normal, requiring a DC 15 Heal check or magical healing to stop.

Augment: For every two additional power points you spend, the bleed damage increases by one each round and the DC also increases by one.

Mythic Bloodfountain

Every round that a creature takes damage from mythic bloodfountain , it also takes one point of Constitution damage unless it succeeds at an additional Fortitude saving throw. Succeeding at this saving throw does not end the power early.`
  },
  Body_Equilibrium: {
    name: "Body Equilibrium",
    discipline: "Psychometabolism",
    level: "Cryptic 2, gambler 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 2, psychic warrior 2, vitalist 2, voyager 2",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You can adjust your body's equilibrium to correspond with any solid or liquid that you stand on. Thus, you can walk on water, quicksand, or even a spider's web without sinking or breaking through (this effect does not confer any resistance to particularly sticky webs). You can move at your normal speed, but you cannot run (x4 speed) on a non-firm surface without sinking or breaking through.

If you fall from any height while using this power, damage from the impact is halved.

Mythic Body Equilibrium[]

You can run on unfirm surfaces without sinking or breaking through and you add your tier to Acrobatics checks.`
  },
  Body_Slam: {
    name: "Body Slam",
    discipline: "Psychokinesis",
    level: "Dread 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "Two creatures adjacent to one another",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Reflex half",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `A giant band of yellow light surrounds your foes then snaps out of existence as they smash against one another. When you manifest this power, you select two creatures that are beside each other and push them violently together, dealing 1d6 points of bludgeoning damage to each. Both of your targets may make a Reflex save to attempt to reduce the damage taken by half.

Augment: This power may be augmented in one of the following ways.

• For every additional power point you spend, the damage dealt to each creature increases by 1d6. Also, for every extra 2d6 damage, the DC of this power increases by 1.

• By spending an additional two power points, targets that fail their Reflex saves are knocked prone in addition to taking damage.

Mythic Body Slam

You may use this power on as many creatures as you have mythic tiers. The effected creatures must all be adjacent to at least one other targeted creature, allowing you to use mythic body slam on targets who are lined up, or in formation.`
  },
  Breach: {
    name: "Breach",
    discipline: "Psychoportation",
    level: "Cryptic 2, gambler 2, psion/wilder 2, voyager 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One door, box, or chest with an area of up to 10 sq. ft./level",
    area: "",
    duration: "Instantaneous; see text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You psionically open stuck, barred, or locked doors, as well as those subject to hold portal or arcane lock . When you complete the manifestation of this power, make a manifester level check against the DC of the lock with a +10 bonus. If successful, you open up to two means of closure. This power opens secret doors, as well as locked or trick-opening boxes or chests. This also loosens welds, shackles, or chains (provided they serve to hold something shut). If used to open an arcane locked door, the power does not remove the arcane lock but simply suspends its functioning for 10 minutes. In all other cases, the door does not relock itself or become stuck again on its own. This does not raise barred gates or similar impediments (such as a portcullis), nor does it affect ropes, vines, and the like. The effect is limited by the area. Each manifestation can undo as many as two means of preventing access.

Mythic Breach[]

The power unlocks up to three means of closure instead of two. The power automatically opens locks of simple or average quality, without requiring a manifester level check to do so. If used on a door locked with psionic lock , you can attempt a free dispel check against it as if using a targeted dispel psionics , adding your tier to the check.

Augmented (3rd): You can expend two uses of mythic power to target one locked item per tier, unlocking up to four means of closure on each, allowing a free dispel against a psionic lock on each, and automatically opening locks of up to good quality (no manifester level check needed).

If the door has a trap that triggers when opened, you become aware of the trap and its general nature, and the door is unlocked but doesn't automatically open.

The power can raise a barred gate, portcullis, or similar impediment, but each one counts as two locked doors.`
  },
  Breath_of_Thanatos: {
    name: "Breath of Thanatos",
    discipline: "",
    level: "",
    display: "Olfactory and visual",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "Cone-shaped burst",
    duration: "1 round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "1 (dread), 3 (psion/wilder)",
    description: `scipline: ine: Athanatism; Level : Dread 1, psion/wilder 2

You exhale the chill of the grave onto your foes. Any creature that fails its save suffers a -2 penalty to saving throws against death effects and cannot be stabilized if brought below 0 hit points.

Augment: This power may be augmented in one of the following ways.

• For every 2 additional power points you spend, increase the save DC of this power by 1.

• By spending an additional 4 power points, you may deal negative energy damage equal to your manifester level to a target that fails its save.

For every 2 power points that you spend augmenting this power, increase the saving throw penalty by 1.`
  },
  Cleanse_Body: {
    name: "Cleanse Body",
    discipline: "Psychometabolism (Healing)",
    level: "Psion/wilder 2, vitalist 2",
    display: "Mental and visual",
    manifestingTime: "3 rounds",
    range: "Touch",
    target: "Living creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `You dispel any psionic effects reducing one of the subject's ability scores or cure 1d4 points of temporary ability damage to one of the subject's ability scores. You also eliminate any fatigue suffered by the character, and improves an exhausted condition to fatigued. You do not restore permanent ability drain.

Mythic Cleanse Body[]

The amount of temporary ability damage cured is doubled and any fatigue or exhaustion is removed.

Augmented: If you expend one use of mythic power, mythic cleanse body also removes the sickened and exhausted conditions.`
  },
  Cloud_Mind: {
    name: "Cloud Mind",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 2, gambler 2, gifted blade 2, marksman 2, psion/wilder 2, voyager 2",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You make yourself completely undetectable to the subject by erasing all awareness of your presence from its mind. This power has the following effects.

First, you are invisible and inaudible to the creature. It cannot even detect your presence by means of blindsense, blindsight, scent, or tremorsense. It cannot pinpoint your location by any means.

Second, the subject remains unaware of your actions, provided you do not make any attacks or cause any obvious or directly threatening changes in the subject's environment. If you attack the subject creature, the effect ends.

If you take an action that creates a sustained and obvious change in the subject's environment—for example, attacking a creature aside from the subject or moving a large or attended object the subject can see—the subject immediately gains a new saving throw against the power. An ally of the subject creature that is able to see or perceive you can use a move action to warn the subject and thereby grant it a new saving throw.

Augment: This power may be augmented in one or both of the following ways.

• If you spend 6 additional power points, you may manifest this power as an immediate action.

• For every 2 additional power points you spend, this power can affect one additional creature.

• If you spend 8 additional power points, this power effects one creature per manifester level.

In addition, for every 2 power points spent on any of the above options, the power's save DC increases by 1.

Mythic Cloud Mind[]

Mythic cloud mind affects a number of creatures equal to your tier. Targets that succeed on the save instead suffer a 20% miss chance against you for the duration of the effect.

Augmented: If you expend one use of mythic power, the effect does not break when you attack a creature.`
  },
  Clutching_the_Shroud: {
    name: "Clutching the Shroud",
    discipline: "Athanatism",
    level: "Cryptic 2, psion/wilder 2",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You bridge the gap between life and death, counting temporarily as one of the undead. You detect as an undead creature (such as with detect undead , but not with magic that reveals your true form) and are treated as undead for the purposes of channeled energy, cure spells, and inflict spells, but not for other effects that specifically target or react differently to undead.

Augment: You may spend an additional 2 power points to gain a +2 bonus on saves against mind-affecting effects, disease, poison, sleep, and stunning.`
  },
  Concealing_Amorpha: {
    name: "Concealing Amorpha",
    discipline: "Metacreativity (Creation)",
    level: "Cryptic 3, gifted blade 3, highlord 3, marksman 3, psychic warrior 3, shaper 3, voyager 3",
    display: "Material; see text",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Concealing Amorpha[]

Effect: Quasi-real amorphous film centered on you

You weave a quasi-real membrane around yourself. You remain visible within the translucent, amorphous enclosure. This distortion grants you concealment (opponents have a 20% miss chance), thanks to the rippling membrane encasing your form. You can pick up or drop objects, easily reaching through the film. Anything you hold is enveloped by the amorpha. Likewise, you can engage in melee, make ranged attacks, and manifest powers without hindrance.

Augment: If you spend 4 additional power points, the membrane can spread and affect one creature adjacent to you. If the creature moves away from you, it loses the protection.

Concealing Amorpha, Greater[]

As concealing amorpha , except the quasi-real membrane so distorts your image and actual position that you gain total concealment (opponents have a 50% miss chance), but for a shorter period of time.

Mythic Concealing Amorpha[]

When a melee attack misses because of this power, there is a 50% chance that the weapon is coated in the membrane and deals only nonlethal damage unless the wielder spends  a  standard  action cleaning  off the membrane. Add your tier to Stealth checks while under the effect of mythic concealing amorpha .

Augmented: If you expend one use of mythic power, the amorpha absorbs damage from effects that deal damage of cold, fire, electricity, force, or sonic damage. When used  in  this  way,  you  reduce all damage of those energy types by your tier for one round and you shorten the duration of the effect by an additional round.

Mythic Greater Concealing Amorpha[]

When a melee attack misses because of this power, there is a 50% chance that the weapon is coated in the membrane and deals only nonlethal damage unless the wielder spends a standard action cleaning off the membrane.

Augmented: If you expend one use of mythic power, the duration of the effect is one minute per level.`
  },
  Concussion_Blast: {
    name: "Concussion Blast",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature or object",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `A subject you select is pummeled with telekinetic force for 1d6 points of force damage. You can choose to instead have the power deal an equal amount of nonlethal damage. Concussion blast always affects a subject within range that you can see, even if the subject is in melee or has cover or concealment (you cannot use this power against creatures with total cover or total concealment).

Nonmagical, unattended objects (including doors, walls, locks, and so on) may also be damaged by this power.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's damage increases by 1d6 points.

• For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Mythic Concussion Blast[]

Increase the damage dealt by the power by 50% (round down) and you may make a free bull rush maneuver attempt against affected creatures, using your manifester level, key ability modifier, and mythic tier to determine your CMB.

Augmented (3rd): If you expend one use of mythic power, affected creatures are dazed for one round unless they succeed on a Fortitude save, in  which case they are instead deafened for one round.`
  },
  Control: {
    name: "Control",
    discipline: "Psychokinesis, psychometabolism or telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous or 1 round (see text)",
    savingThrow: "Fortitude OR Will (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You reach out with your mind and seize control of another creature's body - either through manipulating their body, using direct force on their limbs, or by hijacking their mind. Regardless, if the target fails their save (Fortitude if this is a psychometabolism or psychokinesis power, Will if this is a telepathy power), you can have them do one of the following actions immediately:

• Move up to their speed (this movement provokes attacks of opportunity)

• Make a single attack with a held weapon or a natural attack

• Prohibit movement for one round

• Prohibit attacks with one held weapon or one natural attack for one round

Augment: This power may be augmented in one or more of the following ways.

• For every 2 additional power points you spend, you can choose another target.

• If you spend 2 additional power points, the range becomes Medium (100 ft. + 10ft./lvl).

• For every 2 power points spent on the above augments, increase the save DC by 1.`
  },
  Control_Sound: {
    name: "Control Sound",
    discipline: "Psychokinesis [Sonic]: Level: Cryptic 2, Gambler 2, Psion/Wilder 2, Thug 2",
    level: "",
    display: "Auditory; see text",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One sound or mixture of related sounds",
    area: "",
    duration: "Concentration, up to 1 min./level; see text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You shape and alter existing sounds. You can target one sound, such as a person speaking or singing, or a group of related sounds, such as the patter of many raindrops or the tramp of soldiers passing by. A sound as quiet as a snapping finger can be controlled. You can substitute any sound you have heard for the target sound. If you attempt to exactly duplicate the voice of a specific individual, or an inherently terrifying sound (such as a dragon's roar), you must succeed on a Bluff check with a +5 circumstance bonus opposed by the intended listener's Sense Motive check to avoid arousing suspicion.

You can entirely muffle a noise or magnify a sound to such loudness that it drowns out all other conversation in the immediate area. In this way, you can provide yourself or any with a +4 circumstance bonus on Stealth and audio-based Perception checks.

Alternatively, you can use up the power in an instant. You do this by modulating a sound into a one-time destructive impetus that shatters nonmagical/nonpsionic, unattended objects of crystal, glass, ceramics, or porcelain (vials, bottles, flasks, jugs, mirrors, and so forth) in the area.

Mythic Control Sound[]

Add your tier to any Bluff check, Stealth check, or audio-based Perception check while using the power. You can make a 5 foot square completely silent, negating all sound from that square or entering that square. Among other things, this means any creature in that square cannot speak, nor hear, nor perform any action requiring speaking or verbal components.

Augmented (3rd): If you expend one use of mythic power, you can cause  a  number of  creatures  equal to your tier in range to be deafened for a number of rounds equal to your tier. A successful Fortitude save negates the effect.`
  },
  Dead_Hand: {
    name: "Dead Hand",
    discipline: "Athanatism",
    level: "Cryptic 2, highlord 2, marksman 2, psion/wilder 2, psychic warrior 2",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `Saving Throws: Will negates; see text; Power Resistance: Yes

You bind a bit of the Ethereal Plane into your hand. You can interact with the Ethereal Plane as if one of your hands was also ethereal, but you cannot use that hand to manipulate the Material Plane. This means you cannot wield a two-handed weapon, and any shield, weapon, or item held in the ethereal hand can only affect the Ethereal Plane. If the item you are holding has the ghost touch special property, you can hold and wield it as normal. Any item dropped from the ethereal hand returns to the Material Plane at the end of your turn.

If you grapple a creature while this power is active, you may attempt to shunt it partially into the Ethereal Plane. If it fails a Will save, it counts as both ethereal and material and is shaken by the horrific sights it sees in the spirit realms. This lasts as long as you are grappling it or until this power expires, whichever happens first.

Augment: By spending 3 additional power points, you may manifest this power on one other hand. This hand may belong to you, or to another willing target. If both of your hands are ethereal, you may wield items and weapons as normal (albeit ethereally). If you use this augmented power on an ethereal creature, they instead gain one material hand.`
  },
  Defy_Gravity: {
    name: "Defy Gravity",
    discipline: "Psychoportation",
    level: "Cryptic 2, gambler 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 2, psychic warrior 2, voyager 2",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal or close (25 ft. + 5 ft./2 levels)",
    target: "You or one willing creature or one object (total weight up to 100 lb./level); see text",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes (harmless, object)",
    powerPoints: "3",
    description: `You gain the ability move yourself, another creature, or an object up and down as you wish. A creature must be willing to be affected, and an object must be unattended or possessed by a willing creature. You can mentally direct the recipient to move up or down as much as 20 feet each round; doing so is a move action. You cannot move the recipient horizontally, but the recipient could clamber along the face of a cliff, for example, or push against a ceiling to move laterally (generally at half its base land speed).

An affected creature that attacks with a melee or ranged weapon finds itself increasingly unstable; the first attack has a -1 penalty on attack rolls, the second -2, and so on, to a maximum penalty of -5. A full round spent stabilizing allows the creature to begin again at -1.

Special: When a manifester other than a nomad manifests this power, the target is the manifester (not a willing creature or an object).

Mythic Defy Gravity[]

Instead of affecting one creature, you can affect a number of targets up to your manifester level, but the total weight supported can be no more than 100 pounds per manifester level. You can spend a move action to mentally direct all targets, but you must move all of them identically.

Augmented (8th): If you expend 10 uses of mythic power, you permanently levitate a 5-foot cube of rock, which you can move 20 feet vertically or horizontally as a move action.

If you have created multiple cubes and they are physically touching each other, you can direct them all as a single move action (as if they were one object), even if some of them are out of range. Each levitating cube can support approximately 1,000 pounds of weight, allowing you to use it as a portion of the foundation for a bridge, floating castle, or similar construction project.`
  },
  Detect_Hostile_Intent: {
    name: "Detect Hostile Intent",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 2, gambler 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 2, psychic warrior 2, tactician 2, voyager 2",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft.-radius emanation centered on you",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `While the duration of this power lasts, you become aware of the presence of any creatures with hostile intent within 30 feet of you, and their direction from you (but not their specific location). The power detects active aggression, as opposed to vigilance. In addition, while this power is active you cannot be surprised or caught flatfooted by creatures that are susceptible to mind-affecting powers.

While under the effect of this power, you can make Sense Motive checks as a free action against anyone within 30 feet of you.

The power can penetrate barriers, but 3 feet of stone, 3 inches of common metal, 1 inch of lead, or 6 feet of wood or dirt blocks it.

Mythic Detect Hostile Intent[]

The range of the effect, both detecting hostility and making Sense Motive checks, extends to 60 feet.

Augmented (3rd): If you expend one use of mythic power, you can pinpoint the location of hostile creatures detected using this power.`
  },
  Dirt_Nap: {
    name: "Dirt Nap",
    discipline: "Metacreativity",
    level: "Cryptic 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One touched surface of dirt of stone",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `With a wrenching moan, an extradimensional space opens at your feet, resembling a freshly excavated grave. This grave generally appears as a 5-ft. by 10-ft. rectangle but its interior is always adequate for those who inhabit it. Creatures in the extradimensional space are hidden, beyond the reach of powers (including clairsentience powers), unless those powers work across planes. The space holds as many as eight creatures (of any size).

The interface between this extradimensional space and the material plane is semi-solid and can support covering materials such as spread straw or a sleeping bag. The interface can support up to 20 pounds of material. Such items can be placed from within the space by reaching up then gently retracting your hands, leaving the items above what you now see as your ceiling.

Powers cannot be manifested across the extradimensional interface, nor can area effects cross it. Those in the extradimensional space can see out of it as usual but those outside see only an empty grave plot. Anything inside the extradimensional space is ejected when the power ends. Only one creature at a time can cross through the interface.

Augment: For every two additional power points you spend, this power can shelter an additional creature.

Mythic Dirt Nap

The duration of this power changes to Permanent.

Augmented (3rd): By expending a use of mythic power, you can manifest a power from inside the extradimensional space to outside. Doing so weakens the interface material, allowing those outside of the space to see inside (but not to manifest powers against those inside).`
  },
  Ectoplasmic_Charged_Armor: {
    name: "Ectoplasmic Charged Armor",
    discipline: "Metacreativity",
    level: "Cryptic 2, highlord 2, psion/wilder 2, psychic warrior 2",
    display: "Olfactory, Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You cover yourself with charged ectoplasm that reacts to any physical attacks by transforming the kinetic energy into volatile crystal shards. Any creature striking you with its body, natural weapon, or a handheld weapon takes 2d6 points of piercing damage. Each time the power discharges, the number of dice is halved, down to a minimum of 1d6.

Augment: This power can be augmented in one or more of the following ways.

• For every 2 additional power points you spend, increase the base damage by +2d6.

• If you spend 2 additional power points, each discharge only removes 1d6 from the next damage, instead of halving it.

• If you spend 2 additional power points, you also gain 3 temporary hit points per die of base damage.`
  },
  Ectoplasmic_Obelisk: {
    name: "Ectoplasmic Obelisk",
    discipline: "Metacreativity",
    level: "Cryptic 2, highlord 2, psion/wilder 2, tactician 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `Effect: Temporarily real statue up to 5-ft. square

Expanding from a mid-air spec of colorful ectoplasm, a massive statue forms in space where you designate it, blocking travel and sight. When you manifest this power, you must specify an unoccupied square, which then becomes filled by a simple ectoplasmic statue of your design. This statue impedes movement as would one of the same size carved out of stone. An ectoplasmic obelisk has hardness 10 and 30 hit points. The created obelisk is newly created and thus has not yet made any impression in the floor below it, so it may be possible to push it one square with a DC 15 Strength check.

Augment: You may augment this power in one or more of the following ways.

• For every additional power point you spend on this power, the hardness of the obelisk is increased by 1 and its hit points increase by 2. Additionally, the weight of the obelisk increases, adding 1 to the Strength DC required to push it.

• By spending an additional 6 power points, you may make an ectoplasmic obelisk up to one 10-ft. square in size.

• By spending an additional 10 power points, the duration of this power becomes Permanent.

Mythic Ectoplasmic Obelisk

You may move through any mythic ectoplasmic obelisk you create, though you cannot end your turn in the same square as one. Also, the 10-point augment that changes the duration of this power now optionally changes to Instantaneous, preventing it from being dispelled.`
  },
  Ego_Whip: {
    name: "Ego Whip",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. +10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will half; see text",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Your rapid mental lashings assault the ego of your enemy, debilitating its confidence. The target takes 1d4 points of Charisma damage, or half that amount (minimum 1 point) on a successful save. A target that fails its save is also dazed for 1 round.

Augment: For every 4 additional power points you spend, this power's Charisma damage increases by 1d4 points and its save DC increases by 2.

Mythic Ego Whip[]

When manifesting mythic ego whip , you can choose to either extend the duration of the daze effect by a number of rounds equal to your mythic tier or to add half your tier to the Charisma damage.

Augmented (5th): If you expend two uses of mythic power, you can cause mythic ego whip to become a burst effect with 15 foot radius anywhere within range. You are immune to your own use of mythic ego whip .`
  },
  Elfsight: {
    name: "Elfsight",
    discipline: "Psychometabolism",
    level: "Cryptic 1, gifted blade 1, highlord 1, marksman 1, psion/wilder 2, psychic warrior 1, vitalist 1",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Psion/wilder 3, psychic warrior 1",
    description: `You gain low-light vision (as an elf) for the duration of the power, as well as a +2 bonus on vision-based Perception checks.

If elfsight is used in conjunction with my light , the cone of light extends out to 80 feet instead of 40 feet.`
  },
  Empathic_Condition_Relief: {
    name: "Empathic Condition Relief",
    discipline: "Psychometabolism (Healing)",
    level: "Psion/wilder 2, vitalist 2",
    display: "Olfactory",
    manifestingTime: "",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `Manifestation Time: One standard action

You cleanse the subject's body of unhealthy influences and relieve 1d2+1 rounds' worth of debilitating conditions - dazed, confused, nauseated, shaken, and/or stunned. The subject gains instant relief if she is dazed, confused, nauseated, shaken, and/or stunned. If the duration of the debilitating condition is longer than the relief provided by this power, the subject can either, at your choice, remain affected by the debilitating condition, but for a reduced time, or gain 1d2+1 rounds unaffected by the condition. So, if the subject is dazed for 10 rounds, using this power can either grant them 1d2+1 rounds not being dazed or shorten that period by 1d2+1 rounds. You could manifest this power again to relieve the additional rounds of the specified debilitating conditions.

Augment: This power can be augmented in one or more of the following ways.

• For every 2 additional power points you spend, the number of rounds of relief extends by 1.

• If you spend 8 additional power points, you can restore a petrified creature back to its normal state, although the subject must make a successful DC 15 Fortitude save to survive the process. Any petrified creature, regardless of size, can be restored.`
  },
  Empowering_Arcanix_Aura: {
    name: "Empowering Arcanix Aura",
    discipline: "Psychokinesis OR clairsentience (Network)",
    level: "Highlord 2, psion/wilder 2, tactician 2, vitalist 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "",
    area: "",
    duration: "1 round/level",
    savingThrow: "none (harmless)",
    powerResistance: "No",
    powerPoints: "3",
    description: `When you manifest this power, choose either divine, arcane or psychic spells as the vibration your aura is aligned with. Whenever you are the target of a spell of this kind, you gain a +2 bonus to saves against it. If you successfully save against the effect, you siphon off the energies from it to empower yourself. If you manifested this as a psychokinesis power, you gain 1 temporary hit point per spell level of the spell you saved against, and if you manifested this as a clairsentience power, you gain a +1 insight bonus to your next d20 roll for every 3 spell levels. If the spell doesn't require a save, or is harmless, you gain half this bonus. These bonuses stack with themselves and lasts while the aura is in effect.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, the duration increases to 1 minute / level.

• If you spend 4 additional power points, the duration increases to 10 minutes / level.`
  },
  Energy_Adaptation_Specified: {
    name: "Energy Adaptation, Specified",
    discipline: "Psychometabolism [see text]",
    level: "Psion/wilder 7, vitalist 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal and close (25 ft. + 5 ft./2 levels); see text",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `Energy Adaptation[]

Your body assimilates some of the effect of an energy attack and converts it to harmless light. You gain resistance 10 against any attack that deals acid, cold, electricity, fire, or sonic damage.

When you absorb damage, you can choose to radiate visible light that illuminates a 60-foot radius for a number of rounds equal to the points of damage you successfully resisted, or merely dissipate the energy without giving off a visual display.

The energy resistance provided by this power increases to 20 points at 7th manifester level and to a maximum of 30 points at 11th level.

The power protects your equipment as well.

The resistance provided by this power does not stack with other forms of energy resistance.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Energy Adaptation, Specified[]

As energy adaptation, except the type of energy to which you gain resistance when this power is manifested is your active energy type.

This power's subtype is the same as the type of damage it protects against.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Energy Conversion[]

Effect: Ray; see text

As energy adaptation , except that instead of radiating away energy as light, you store up the energy and can later discharge it as a ray. To discharge a ray requires a standard action. You can choose to fire any number of rays during the power's duration. The ray you fire must be of one of the energy types you have stored (if you have stored more than one type, you can choose what kind of energy to use for each ray). If a ray successfully strikes its target (requiring a ranged touch attack), the target takes damage equal to the amount of energy damage of that type you have stored, up to a maximum of three times your manifester level. As long as this power remains in effect, you can continue to absorb energy damage and fire additional rays using the stored damage. Damage you fire in rays is subtracted from the damage you have absorbed, so you may not fire off rays if you have depleted the energy you have absorbed.

This power's subtype is the same as the type of energy you discharge in a ray; thus, its subtype can change during the course of the power's duration.

Mythic Energy Adaptation[]

You gain a +6 bonus to saves against effects that deal acid, cold, electricity, fire, or sonic damage.

Augmented (5th): If you expend two uses of mythic power, you gain immunity against effects that deal acid, cold, electricity, fire, or sonic damage.

Mythic Specified Energy Adaptation[]

You gain a +4 bonus on saves against effects that deal damage of the selected energy type. Once each round as a free action, you can choose one adjacent ally to gain energy resistance 5 against the chosen energy type for 1 round. This increases to energy resistance 10 at manifester level 7 and energy resistance 15 at manifester level 11.

Mythic Energy Conversion[]

You may fire rays as if making an attack with a ranged weapon, allowing the use of iterative attacks for a high base attack bonus. If firing multiple rays in a single round, the rays can target the same creature or different creatures, as long as both all targets are in range.

Augmented (5th): If you expend two uses of mythic power, the amount of damage you can retain increases to 10 times your manifester level, and you can fire rays of two different energy types. Such rays deal damage based upon the amount and type of energy chosen when firing the ray.`
  },
  Energy_Push: {
    name: "Energy Push",
    discipline: "Psychokinetic [see text]",
    level: "Gambler 2, psion/wilder 2",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Effect: Ray

You project a solid blast of energy of your active energy type (cold, electricity, fire, or sonic) at a target, dealing it 2d6 points of damage. In addition, if a subject of up to one size category larger than you fails a Strength check (DC equal to the save DC of this power), the driving force of the energy blast pushes it back 5 feet plus another 5 feet for every 5 points of damage it takes. If a wall or other solid object prevents the subject from being pushed back, the subject instead slams into the object and takes an extra 2d6 points of damage from the impact (no save). The movement caused by energy push does not provoke attacks of opportunity.

• Cold: A blast of this energy type deals +1 point of damage per die (damage from impact remains at 2d6 points). The saving throw to reduce damage from a cold push is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a blast of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A blast of this energy type deals +1 point of damage per die (damage from impact remains at 2d6 points).

• Sonic: A blast of this energy type deals -1 point of damage per die (damage from impact remains at 2d6 points) and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every 2 additional power points you spend, this power's damage increases by one die (d6) and its save DC increases by 1. The damage increase applies to both the initial blast and any damage from impact with an object.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Push[]

Add half your tier to the save DC of effect (minimum +1) and increase the damage of both the blast of energy and slamming into an object to 3d6.

Augmented: If you expend one use of mythic power, creatures that fail their save are pushed back and knocked prone.

Augmented (3rd): If you expend one use of mythic power, the blast of energy can launch the target straight up instead of backwards. The target suffers falling damage as normal.`
  },
  Energy_Stun: {
    name: "Energy Stun",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "5-ft.-radius burst",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text;",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You release a powerful stroke of your active energy type (cold, electricity, fire, or sonic) that encircles all creatures in the area, dealing 1d6 points of damage to each of them. In addition, any creature that fails its save for half damage must succeed on a Will save or be stunned for 1 round.

• Cold: A stroke of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold stun is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a stroke of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A stroke of this energy type deals +1 point of damage per die.

• Sonic: A stroke of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For every two additional dice of damage, the power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Stun[]

All targets must succeed on a Will save or be stunned for 1 round, even if they succeeded on the save to reduce damage to half. Add half your tier (minimum 1) to each die of damage dealt.

Augmented: If you expend one use of mythic power, mythic energy stun deals  splash damage  to all creatures within 5 feet of the target. A successful Reflex save halves the splash damage.`
  },
  Epidermal_Fissure: {
    name: "Epidermal Fissure",
    discipline: "Psychometabolism",
    level: "dread 2, highlord 2, psion/wilder 2, psychic warrior 2, tactician 2, vitalist 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You engorge the muscles of your target, shredding their skin and exposing the tissue beneath. The target gains a +4 enhancement bonus to Strength and a +4 enhancement bonus to Intimidate checks. Additionally, the target suffers 2 points of bleed damage at the start of their turns.

Augment: You may augment this power in the following ways:

• If you spend 3 additional power points, the Strength and Intimidate bonuses increase by 2.

• For every 2 additional power points you spend, the bleed damage increases by 2.

• For every 2 additional power points you spend, the target suffers a -2 penalty to their natural armor (this cannot reduce their natural armor below 0).

Additionally, for every 2 power points you spend to achieve the above results, increase this power's save DC by 1.`
  },
  Essence_Theft: {
    name: "Essence Theft",
    discipline: "Psychometabolism (essence)",
    level: "All 2",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "1 minute/level",
    savingThrow: "none",
    powerResistance: "yes",
    powerPoints: "3",
    description: `

Your touch tears away at your target's soul as you painfully steal their essence. A successful melee touch attack deals 3d6 points of damage and grants you 1 temporary point of essence for the duration of this spell. If the target has an essence pool, they take 1 point of essence burn as well.

Augment: For every additional power point spent on this spell, the target takes an additional 1d6 points of damage.

Essence: For each point of essence burned as part of casting this spell you gain 1 additional point of temporary essence for the duration of the spell, and if the touched creature has an essence pool they take an additional point of essence burn.`
  },
  Everyman: {
    name: "Everyman",
    discipline: "Psychometabolism",
    level: "Cryptic 2, highlord 2, psion/wilder 2, psychic warrior 2, sighted seeker 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You subtly shift your features and voice, making you less noticeable and granting you a +10 circumstance bonus to Disguise checks, although you may not attempt to appear as a certain individual or another race.

This is a minor physical transformation, not an illusion, and as such fools touch as well as sight.

You may alter any skin or facial features to be anything normally possible for the race you appear as. Birthmarks, moles, tattoos, piercings, and other distinguishing features are not visible unless you specifically will it. Psionic tattoos may still be tapped while hidden.

At any point during the power's duration, you may concentrate as a standard action to change your appearance again, including to resemble yourself.

Your clothing and gear are not changed.

Augment: You can augment this power in one or more of the following ways.

• If you spend 1 additional power point, you may use this power to disguise yourself as particular individuals.

• If you spend 2 additional power points, you may alter your smell to blend in with creatures using the scent ability or who identify individuals by pheromones or other chemical senses.

Mythic Everyman[]

The bonus to Disguise checks increases to +15. Changing your appearance requires only a move action instead of a standard action.

Augmented (7th): If you expend three uses of mythic power, the duration becomes permanent and your looks are permanently altered to your new appearance.`
  },
  Feat_Leech: {
    name: "Feat Leech",
    discipline: "Clairsentience",
    level: "Dread 2, gifted blade 2, highlord 2, psion/wilder 2, psychic warrior 2, sighted seeker 2, tactician 2, voyager 2",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You can use another's psionic or metapsionic feats for yourself. You make a melee touch attack against a target. If successful, you immediately are familiar with the target's psionic and metapsionic feats, if any, and you can choose two of these feats to “leech”.

While the power lasts, you are treated as if you possessed the stolen feats, despite the fact that you have more feats than normally allowed. During this same period, the target can make no use of the stolen feats. When the power's duration expires, you lose access to the feats, and the target gains immediate use of them. This transfer occurs regardless of the distance between you and the target.

If the duration of feat leech is extended by the use of a metapsionic feat, the target gains a Will saving throw every 10 minutes beyond the normal duration. If this save succeeds, the power's duration ends. If the target is killed before the duration expires, you immediately lose the benefit of the stolen feats.

You cannot steal a feat for which you do not meet the prerequisites, if any. However, you can use a stolen feat as the prerequisite for another stolen feat.

Augment: For every 2 additional power points you spend, you can leech another feat and this power's save DC increases by 1 .

Mythic Feat Leech[]

You can steal any feat, including mythic feats, the target possesses, in addition to psionic or metapsionic feats. If you steal a mythic feat and do not have the prerequisite feat, you must steal both feats to gain the benefit.

Augmented (2nd): If you expend one use of mythic power, you can steal an additional number of feats equal to half your mythic tier.`
  },
  Heartbinding: {
    name: "Heartbinding",
    discipline: "Athanatism",
    level: "Highlord 3, psion/wilder 2, tactician 3, vitalist 2",
    display: "Mental",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One living creature",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "Will negates (harmless); Power",
    powerResistance: "",
    powerPoints: "3 (conduit, vitalist), 5 (highlord, tactician)",
    description: `Resistance: Yes (harmless)

By binding the soul of another to yourself, you form a protective bond. The subject gains a +1 deflection bonus to AC and a +1 resistance bonus on saves. While this power is active, you or the target may choose to gain any morale bonuses granted to the other, just as if you were both targeted. In addition, if you or the target are subjected to an emotion effect that allows a saving throw, one of you may attempt the saving throw, applying the result to both of you. You must decide to use this effect before the save is made.

Augment: By spending an additional 6 power points, you may, as a standard action, end this power to heal the target 3d8 points of damage + 1 point per manifester level (maximum +25). This healing can return a recently dead target to life, as long as its hit points after the healing are at least equal to the hit points at which it would die. If you return a recently dead target to life this way, you suffer damage equal to the amount healed. You must touch the target to trigger this effect, and no more than one round may have passed since their death. This power gains the healing subtype.`
  },
  Id_Insinuation: {
    name: "Id Insinuation",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Dread 2, gambler 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Concentration + 1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Swift tendrils of thought disrupt the unconscious mind of any one creature, sapping its might. As long as the manifester remains concentrating fully on this power, the subject is confused , making it unable to independently determine it will do. Roll on the following table at the beginning of each of the subject's turns to see what the subject does in that round.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1, and the power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Mythic Id Insinuation[]

Roll on the table below instead of the non-mythic version at the start of each subject's turn to see what it does in that round.`
  },
  Inflict_Pain: {
    name: "Inflict Pain",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 2, psion/wilder 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will partial; see text",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You telepathically stab the mind of your foe, causing horrible agony. The subject suffers wracking pain that imposes a -4 penalty on attack rolls, skill checks, and ability checks. If the target makes its save, it takes only a -2 penalty.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1, and the power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Mythic Inflict Pain[]

The penalty also applies to damage rolls, saving throws, and concentration checks.

Augmented: If you expend one use of mythic power, the pain forces a concentration check to cast any spell or manifest any power (DC 15 plus your key ability modifier and your tier).`
  },
  Kinetic_Arsenal: {
    name: "Kinetic Arsenal",
    discipline: "telekinesis",
    level: "highlord 2, marksman 2, psion/wilder 2, psychic warrior 2, tactician 2",
    display: "mental",
    manifestingTime: "1 standard action",
    range: "medium (100 ft. + 10 ft./level)",
    target: "1 weapon",
    area: "",
    duration: "concentration",
    savingThrow: "Reflex negates, see text; Power",
    powerResistance: "",
    powerPoints: "3",
    description: `Resistance: no

On your command, a weapon rises into the air and begins to attack. This weapon may be any weapon that is lying around or that you have in your possession, and as part of manifesting this power you may move the weapon up to 30 feet. You may even use this ability on weapons held or used by other creatures, though such creatures are allowed a reflex save to prevent their weapon from being taken. The weapon targets an opponent you designate, starting with one attack or combat maneuver in the round this power is manifested and continuing each round thereafter on your turn. It uses your base attack bonus plus your manifesting modifier as its attack bonus but cannot make iterative attacks. Any bonuses you have that would apply to that particular type of weapon (such as the weapon focus and whip mastery feats or the weapon training class feature) as well as any enhancement bonus or masterwork bonus that the weapon has apply to attacks or maneuvers made with the affected weapon.

Each round after the first, you can use a move action to redirect the weapon to a new target. If you do not, the weapon continues to attack the previous round's target.

Augment: This power can be augmented in the following ways:

• For every 3 additional power points that you expend, this power may target an additional weapon within range. All of the weapons make attacks and may be moved using the same move action.

• If you spend 6 additional power points, you enable these weapons to make iterative attacks. On any round that the weapon switches targets, it gets only a single attack. Subsequent rounds of attacking that target allow the weapon to make multiple attacks if your base attack bonus would allow it to. Even if the weapon is a ranged weapon, switching targets still is a move action.

• By spending 4 additional power points, you may have any affected weapons use your manifester level in place of your base attack bonus.`
  },
  Lifeless_Tongues: {
    name: "Lifeless Tongues",
    discipline: "Athanatism [language-dependant]",
    level: "Psion/wilder 2",
    display: "Auditory and mental",
    manifestingTime: "10 minutes",
    range: "10 ft.",
    target: "One dead creature",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "3",
    description: `Conduits say that the lips of the dead hold many secrets, known only to the dying and the passed. You summon helpful spirits into a corpse, allowing it to answer your questions. You may ask up to three questions. The corpse's knowledge is limited to what it knew during life, including the languages it spoke. Answers are brief, cryptic, or repetitive, especially if the creature would have opposed you in life.

If the dead creature's alignment was different from yours, the corpse gets a Will save to resist the power as if it were alive. If successful, the corpse can refuse to answer your questions or attempt to deceive you, using Bluff. The soul can only speak about what it knew in life. It cannot answer any questions that pertain to events that occurred after its death.

If the corpse has been subject to either speak with dead or lifeless tongues within the past week, the new power fails. You can manifest this power on a corpse that has been deceased for any amount of time, but the body must be mostly intact to be able to respond. A damaged corpse may be able to give partial answers or partially correct answers, but it must at least have a mouth in order to speak at all. This power does not affect a corpse that has been turned into an undead creature.

Augment: This power may be augmented in one of the following ways.

• For every 2 additional power points spent, you can ask one additional question.

• By spending 4 additional power points, you may target an incorporeal creature with this power. If the incorporeal creature fails its saving throw against this power, it must honestly answer your questions to the best of its ability.

In addition, for every 2 power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Memory_Revelation: {
    name: "Memory Revelation",
    discipline: "Clairsentience (network)",
    level: "Cryptic 2, Dread 2, Highlord 2, Psion/Wilder 2, Tactician 2, Vitalist 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "you and one creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You make contact with the memory of your target and share a single memory of no longer than 1 minute. You can show the target one of your memories, show the target one of its own memories, or view one of the target's memories.

Augment

• For every additional power point you spend, you may share 1 additional minute of memories with the target.

• If you spend 4 additional power points, you may display false memories with this power.

• If you spend 4 additional power points, you can share a memory that emboldens or demoralizes a creature. You may embolden the target (granting a +2 morale bonus on attack rolls, saving throws, and skill checks) or demoralize them (causing them to become shaken). This effect lasts for 1 minute/level. If you spend 4 additional power points, the bonus or penalty from this effect is doubled.

• For every 2 power points you spend augmenting this power (including as part of other augments), you may select and additional target within 15 feet of the original and the save DC increases by 1)`
  },
  Mental_Disruption: {
    name: "Mental Disruption",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 2, gambler 2, psion/wilder 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "10 ft.",
    target: "",
    area: "10-ft.-radius spread centered on you",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You generate a mental wave of confusion that instantly sweeps out from your location. All creatures you designate in the affected area (you can choose certain creatures to be unaffected) must make a Will save or become dazed for 1 round.

Augment: You can augment this power in one or more of the following ways.

• For every 2 additional power points you spend, this power's save DC increases by 1.

• For every 2 additional power points you spend, this power's range and the radius of its area both increase by 5 feet.

• For every 4 additional power points you spend, any creature who fails their save is dazed for an additional round.

Mythic Mental Disruption[]

The area of effect is doubled and creatures that make their saving throw are instead staggered for one round.`
  },
  Mental_Mist: {
    name: "Mental Mist",
    discipline: "Telepathy [mind-affecting]",
    level: "dread 2, highlord 2, psion/wilder2, tactician 2, vitalist 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "20 ft radius",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You reach into the minds of your targets and cloud them, making them think they are deep inside an overwhelming mist or fog. These who fail their Will saves are affected as follows: The mental mist obscures all sight, including darkvision, beyond 5 feet. A creature within 5 feet has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker can't use sight to locate the target).

Augment: This power can be augmented in one or more of the following ways.

• If you spend 4 additional power points, all targets that fail their saves are mentally drained, move at half their normal speed and take a -2 penalty on all attack rolls and melee damage rolls and cannot take a 5-foot-step while inside.

• If you spend 4 additional power points, all targets that failed their Will save also take 1d6 points of damage at the start of your turn, beginning with the turn you manifest the mental mist.

• If you spend 6 additional power points, all targets must make a Fortitude save at the beginning of their turn or be overwhelmed by horrid mental images tearing them apart, taking 1d4 points of Wisdom damage. If they succeed on this save, they take half damage.

• If you expend your psionic focus, you can exclude yourself from all effects while inside the area.`
  },
  Mental_Regression: {
    name: "Mental Regression",
    discipline: "Psychometabolism OR telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "10 min/level",
    savingThrow: "Will or Fortitude negates (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You regress the targets mental faculties, making them dim-witted and coarse, perhaps even reducing them to an animal state. If the target fails its saving throw (Will for telepathy, Fortitude for psychometabolism), it takes a 1d6 penalty to Intelligence, Wisdom and Charisma (this cannot reduce a score below 1). If the target's ability score is reduced to 1, they cannot use any skills related to that ability score, cannot communicate clearly (or at all), cannot understand language, but can still identify friend and foe.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, the range increases to Medium (100 ft. + 10 ft. / level).

• For every 2 additional power points you spent, the penalty increases by 1d6.

• If you spend 2 additional power points, the duration changes to Instantaneous and the penalty can only be removed through the use of psychic surgery, heal, wish, reality revision or a similar power or spell.`
  },
  Mental_Semblance: {
    name: "Mental Semblance",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 2, psion/wilder 2",
    display: "Auditory, Material, Visual",
    manifestingTime: "1 full round action",
    range: "Personal",
    target: "",
    area: "",
    duration: "10 minute/level",
    savingThrow: "Will negates",
    powerResistance: "No",
    powerPoints: "3",
    description: `When manifesting this power, you are capable of duplicating the psionic pattern of an individual you've touched and attempt to duplicate them. This is a mind-affecting ability that causes those who view you to see and hear you as the duplicated individual, granting you a +30 competence bonus on Disguise and Bluff checks to appear and act like the duplicated individual. You may duplicate patterns that are similar to your own; creatures duplicated must be of same type and size or within one step smaller or larger, and must have the same configuration of limbs (if you duplicate someone with a missing limb, observers will see that this limb is missing still). This power only affects the senses of sight and sound, you will still smell the same and creatures with scent may pick up the difference. Individuals who perceive falsehood in your disguise and representation of the duplicated victim may attempt a Will save to disbelieve the power and see through it. However, this does not end the power, only allowing the creature making the save to see through it to what you really are.

Augment: If you spend an additional 2 power points points, the bonus on Bluff and Disguise checks increase by 2 and the DC to disbelieve the disguise increases by 1.`
  },
  Metamorphosis_Minor: {
    name: "Metamorphosis, Minor",
    discipline: "psychometabolism",
    level: "cryptic 1, egoist 1, gambler 2, psion/wilder 2, voyager 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "cryptic 1, egoist 1, psion/wilder 3, voyager 1",
    description: `Metamorphosis, Minor[]

You channel your psionic power, snapping bones and twisting flesh, transforming yourself into a new shape or form. You can take the form of any creature of the same size as yourself, but this is a purely cosmetic change, your abilities, powers or stats do not change beyond the options selected below. This grants you a +10 bonus on Disguise skill checks.

If you choose to imitate an existing person, you gain an additional +2 circumstance bonus to Disguise checks to convince people that you are that person. If you choose to take on an intimidating, horrifying, or otherwise imposing form, you gain a +2 circumstance bonus to Intimidate checks.

In addition, you get one choice from either the Enhancement Menu A or Abilities Menu A.

Enhancement Menu A

• +2 enhancement bonus to Strength

• +2 enhancement bonus to Dexterity

• +2 enhancement bonus to Constitution

• Increase your size by one size category (+2 size bonus to Strength, -2 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by one size category (+2 size bonus to Dexterity, -2 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Increase your base land speed by 10 feet.

Abilities Menu A

• You gain 5 temporary hit points.

• You gain the Cleave feat.

• You gain the Improved Trip feat.

• You gain a +1 natural armor bonus.

• You gain a natural slam/claw/bite (pick one) attack that deals 1d8 damage if Medium (1d10 if Large).

• You gain Resistance 5 against one of these energy types: Cold, Acid, Fire, Electricity.

• You gain a swim speed of 20 feet.

• You gain a climb speed of 20 feet.

• You gain a burrow speed of 15 feet.

Augment: For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A. You may not choose the same option twice.

Metamorphosis[]

As minor metamorphosis , except you instead gain one option from enhancement menu B or one option from abilities menu B. Choices that give similar benefits to those from enhancement menu B or abilities menu B do not stack. For example, you cannot pick to gain two natural attacks from abilities menu B and also to gain a natural attack from abilities menu A to get three attacks.

Enhancement Menu B

• +4 enhancement bonus to Strength

• +4 enhancement bonus to Dexterity

• +4 enhancement bonus to Constitution

• Increase your size by two size categories (+4 size bonus to Strength, -4 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by two size categories (+4 size bonus to Dexterity, -4 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Pick 3 choices from Enhancement Menu A. You may not choose the same option twice.

• Increase your base land speed by 20 feet.

Abilities Menu B

• You gain two natural slam/bite/claw attacks that deal 1d8 damage if Medium (1d10 if Large).

• You gain Fast Healing 2.

• You gain a +3 natural armor bonus.

• You gain 20 temporary hit points.

• You gain the Improved Critical feat with any natural attacks you have.

• You gain damage reduction 5/magic.

• You gain a fly speed of 20 feet (poor).

• You gain a poison attack. When you hit with a natural melee attack, the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You can spit poison as a ranged touch attack (30 feet) as a standard action. If it hits, it deals 3d6 acid damage and the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability score modifier) or take 1 point of Constitution damage.

• You gain a swim speed of 40 feet.

• You gain a climb speed of 40 feet.

• You gain a burrow speed of 30 feet.

• You gain 3 choices from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Metamorphosis, Major[]

As minor metamorphosis, except you instead gain one option from Enhancement Menu C or one option from Abilities Menu C. Choices that give similar benefits to those from Enhancement Menu C or Abilities Menu C do not stack. For example, you cannot pick to gain three natural attacks from Abilities Menu C and also to gain a natural attack from Abilities Menu A to get four attacks.

Enhancement Menu C

• +6 enhancement bonus to Strength

• +6 enhancement bonus to Dexterity

• +6 enhancement bonus to Constitution

• Pick 2 choices from Enhancement Menu B from metamorphosis . You may not choose the same option twice.

• Increase your base land speed by 30 feet.

Abilities Menu C

• You gain the Rend ability. If you hit the same opponent with two natural attacks in one round, you deal additional damage equal to 2d6 + your Strength modifier.

• You gain three natural slam/bite/claw attacks that deal 2d6 damage if Medium (2d8 if Large).

• Your natural attacks extrude poison and acid. When you hit with a natural melee attack, it deals +2d6 acid damage and the target must make a Fortitude save (DC10+ ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You gain Fast Healing 5.

• You gain +6 natural armor bonus.

• You gain 40 temporary hit points.

• You gain a fly speed of 40 feet (good).

• You gain a swim speed of 60 feet.

• You gain a climb speed of 60 feet.

• You gain a burrow speed of 60 feet.

• You gain 2 choices from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Metamorphosis, True[]

As minor metamorphosis, except you gain two menu choices from the Enhancement Menu C and two menu choices from Abilities Menu C from major metamorphosis . As a swift action, you can change your menu choices while the duration of this power is in effect.

While under the effects of this power, you can choose to become one of the following types, with the associated benefits: aberration, dragon, fey, humanoid, magical beast or monstrous humanoid. As a swift action, you can change what type you are while the duration of this power is in effect.

Augment You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Mythic Minor Metamorphosis[]

Add your tier to the bonus to Disguise checks. In addition, you gain one choice from Enhancement Menu A and Abilities Menu A, instead of one choice between the two menus.

Mythic Metamorphosis[]

You gain one choice from Enhancement Menu B and Abilities Menu B, instead of one choice between the two menus.

Mythic Major Metamorphosis[]

You gain one choice from Enhancement Menu C and Abilities Menu C, instead of one choice between the two menus.

Mythic True Metamorphosis[]

You can also choose to become one of the following types, with the associated traits: construct, elemental, or plant.`
  },
  Mindscape_Generation: {
    name: "Mindscape Generation",
    discipline: "Telepathy (mind-affecting)",
    level: "Cryptic 2, Dread 2, Highlord 2, Psion/Wilder 2, Tactician 2, Telepath 1",
    display: "Mental",
    manifestingTime: "1 Standard action",
    range: "medium (100 ft. + 10 ft./level)",
    target: "one creature",
    area: "",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "3, telepath 1",
    description: `Fabricating a pseudo-real space in the linked psyche of you and your target, you create a binary mindscape and initiate a psychic duel with the target.

This mindscape includes only two minds: yours and the target's. This power ends and both minds return to their respective bodies if one of you drops below 0 hit points or if both of you agree to end the psychic duel (a free action that you can perform even if it isn't your turn).

Even if you manifest this power, you must succeed at a Will save to escape your own psychic duel if your opponent doesn't want to allow you to leave. Powers like Mindscape Transcendance can also free you from the mindscape (this power is one of the few spells you can manifest in a binary mindscape). A binary mindscape is clearly a fabrication of the manifester's imagination, and disbelieving the mindscape doesn't alter how the mindscape works.

This power ends at any time that you choose to depart the mindscape, freeing the target as well. Any creature that drops below 0 hit points while inside the mindscape returns to its body. If this happens to you, the power also ends, freeing anyone still inside.

If you create an immersive mindscape with this power, it can be made permanent with an Incarnate power by a manifester of 12th level or higher at a cost of 10,000 gp in crystal foci. You and other creatures aware of a permanent mindscape can come and go using the mindscape door spell or similar powers.

For the purpose of meeting prerequisites, this power is considered to be Create Mindscape, Greater Create Mindscape, and Instigate Psychic Duel.

Augment

• By spending 4 additional power points, you may choose to create an immersive mindscape in place of a binary mindscape. You are allowed to control whether this mindscape is overt or veiled, as well as whether it is harmful or harmless. You may also determine the shape, size, and gravity of the mindscape. You must also create a method of exit from the mindscape when you manifest this power, and that method must be possible to achieve based on the traits of the mindscape, even if it is obscure or difficult. The GM decides whether a method of escape is reasonable. Anything that would be a reasonable method of waking from a dream during deep sleep could allow one to leave a mindscape. If you choose to create a veiled mindscape, the first time another creature interacts with the environment, it can attempt a Will save to disbelieve the effect. Disbelieving a mindscape reveals to that creature that it's within a mindscape and gives it the knowledge needed to leave the mindscape, but doesn't free it from the mindscape.

• By spending 2 additional power points, you may alter the magic traits of a mindscape you create in any way you wish.

• By spending 2 additional power points, you may target up to 1 creature/level with this power, sending them into the mindscape with you. These creatures may not be brought into a binary mindscape.

• By expending psionic focus, you may target a creature to draw into the mindscape without line of sight. However, you must be aware of its presence within range. If you target an area with more than one sentient creature and you have never seen any of the creatures before (for example, if you know a group of soldiers is inside a barracks but you can't see them through the door), the subject of this spell is selected at random. If you have seen firsthand the creature you wish to target (continuing the example, if you spied the sergeant entering the room moments before), You can select it unerringly from among all the creatures.

• For every 2 power points you spend augmenting this power (including as part of other augments), the save DC increases by 1.`
  },
  Missive_Mass: {
    name: "Missive, Mass",
    discipline: "Telepathy [Mind-Affecting, LanguageDependent]",
    level: "Gambler 2, highlord 2, psion/wilder 2, tactician 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `Targets: All creatures in a 400 ft. + 40 ft./level radius centered on you; see text

Effect: Mental message delivered to subjects

You send a telepathic message of up to twenty-five words to all creatures within range. You can include or exclude from this broadcast any creature you can see, as well as any creature that you know or know of. Mass missive is strictly a one-way exchange from you to the subjects. If you do not share a common language, the subjects “hear” meaningless mental syllables.

Augment: For every 2 additional power points you spend, this power's range increases by 40 feet and its save DC increases by 1.`
  },
  Natural_Linguist: {
    name: "Natural Linguist",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 2, psion/wilder 2, voyager 2",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You telepathically charge your speech and hearing, allowing you to understand an additional language when it is spoken, even if it is a racial tongue or a regional dialect, and allowing your speech to be understood in that language. When you manifest this power, choose a language or a creature you want to understand and that you want to understand you. Any other creature that also understands the same language can understand you and you can understand them. This does not enable you to speak with creatures who don't speak. You can make yourself understood as far as your voice carries. This power does not predispose any creature addressed toward you in any way. This power does not enable you to speak with creatures immune to mind-affecting powers.

Augment: For every additional power point you spend, you may understand and be understood in an additional language at the same time while this effect is active.`
  },
  Overpowering_Guilt: {
    name: "Overpowering Guilt",
    discipline: "Telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, psion/wilder 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/lvl",
    savingThrow: "Will (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You viciously pound on the mind of the target, triggering their inner guilt, allowing it to wash over them. This guilt takes on a different aspect for every target, from what they wish they had done, to guilt over what they actually did. Regardless, if they make their save, they take a -1 penalty to all their d20 rolls until the end of the duration. If they fail, they are also staggered during this time.

Augment: This power may be augmented in one or more of the following ways.

• For every 2 additional power points you spend, the penalty increases by 1.

• If you spend an 2 additional power points, this power can target one creature per level.

• If you spend an 2 additional power points, the range increases to Medium (100 ft. + 10 ft./lvl)`
  },
  Psionic_Howl_Melpomene_s: {
    name: "Psionic Howl, Melpomene's",
    discipline: "Psychokinesis [sonic]",
    level: "Psion/Wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30 ft. radius burst centered on you",
    duration: "Instantaneous",
    savingThrow: "Fortitude half",
    powerResistance: "No",
    powerPoints: "3",
    description: `You unleash a blast of charged sonic energy that manifests as a howling shriek. Creatures and objects within the area suffer 3d4 points of sonic damage, which ignores the hardness of objects, and creatures that fail their saves become deafened for 1 round per manifester level as the sound persists in their minds, drowning out all others. The deafened effect is mind-affecting.

Augment: You may augment this power in one or both of the following ways:

• For every additional power point you spend, this power's damage increases by one die (d4). For each 2 extra dice of damage, this power's save DC increases by 1.

• If you spend an additional 4 power points, you may exclude any number of allies and/or objects from the power's effects.

Surge Augmentation: If you invoke your wild surge while manifesting this power, double its range and area.`
  },
  Psionic_Lock: {
    name: "Psionic Lock",
    discipline: "Psychoportation",
    level: "Gambler 2, psion/wilder 2, voyager 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Door, chest, or portal touched, up to 30 sq. ft./level in size",
    area: "",
    duration: "Permanent",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `A psionic lock manifested upon a door, chest, or portal psionically locks it. You can freely pass your own lock without affecting it; otherwise, a door or object secured with psionic lock can be opened only by breaking in or by a successful dispel psionics effect. Add +10 to the normal DC to break open a door or portal affected by this power.`
  },
  Psionic_Recharge: {
    name: "Psionic Recharge",
    discipline: "psychokinesis",
    level: "cryptic 2, dread 2, gambler 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 2, psionic formulist 2, psychic warrior 2, tactician 2, vitalist 2, voyager 2",
    display: "visual",
    manifestingTime: "",
    range: "touch",
    target: "object touched",
    area: "",
    duration: "instantaneous",
    savingThrow: "Fortitude negates (object); Power",
    powerResistance: "",
    powerPoints: "3",
    description: `Manifesting: Time 1 standard action

Resistance: no

Transforming some of your psionic power into electrical energy, you force charges into a technological object in your possession. The object regains 3 charges, to a maximum of the max number of charges the object can normally hold. Charges in excess of this maximum are simply dissipated

Augment: This power can be augmented in the following ways:

• For every additional power point you spend, the object gains one additional charge

• For every 4 additional power points you spend, you may choose an additional item to be recharged by this effect.

• If you expend your psionic focus, you may manifest this power as a swift action.`
  },
  Psychic_Bodyguard: {
    name: "Psychic Bodyguard",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 2, highlord 2, psion/wilder 2, tactician 2, vitalist 2",
    display: "Mental, visual",
    manifestingTime: "1 round",
    range: "Medium (100 feet + 10 feet/level)",
    target: "One willing creature",
    area: "",
    duration: "One hour/level (D) or until discharged; see text",
    savingThrow: "Yes (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `You forge a specialized telepathic connection between yourself and one ally. Whenever the target must make a Will save, you make the save instead as if the effect targeted you. If you fail in the saving throw, your ally suffers the consequences of the effect that forced the Will save and you must make an additional Will save at the same DC or be stunned for one round. The target may willingly fail saves against harmless powers without causing you to be stunned. Once the connection is forged, you can make Will saves for your ally as long as she remains in range. If she strays out of range, the power ends. You may not willingly fail a save when using psychic bodyguard , but you may allow the target to make her own save. The power immediately ends after you have made a successful Will save for the target.

Augment: This power may be augmented in one or more of the following ways.

• For every additional 2 power points spent, the power lasts for one additional successful Will save.

• If you spend 8 additional power points, the power is not discharged after making a successful Will save.`
  },
  Pummelling_Barrage: {
    name: "Pummelling Barrage",
    discipline: "Metacreativity",
    level: "psion/wilder2, cryptic 2",
    display: "Material, Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One or more creatures",
    area: "",
    duration: "",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You pummel the creature with ectoplasm, possibly knocking them out without seriously injuring them. Make a ranged touch attack to deal 3d6 nonlethal damage against a single creature.

Augment: This power can be augmented in one or both of the following ways.

• For every 2 power points you spend, you can make another ranged touch attack.

• If you spend 3 additional power points, the ectoplasm sticks to the target if it hits and deals the same amount of nonlethal damage at the beginning of your next turn.`
  },
  Recall_Agony: {
    name: "Recall Agony",
    discipline: "Clairsentience [Death, Mind-Affecting]",
    level: "Psion/wilder 8",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will partial; see text",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `Recall Agony[]

The fabric of time parts to your will, revealing wounds your foe has received in the past (or has yet to receive). That foe takes 2d6 points of damage as the past (or future) impinges briefly on the present.

Augment: For every additional power point you spend, this power's damage increases by 1d6 points. For each extra 2d6 points of damage, this power's save DC increases by 1.

Recall Death[]

As recall agony , except the wounds revealed by folding the fourth dimension are potentially fatal. If the target fails its Will save, it dies. If the save succeeds, the target instead takes 5d6 points of damage.`
  },
  Selective_Hearing: {
    name: "Selective Hearing",
    discipline: "Psychometabolism",
    level: "Cryptic 2, psion/wilder 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One creature, see text",
    area: "",
    duration: "1 min./level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `With a sudden disturbing throb, your foes ears become exceptionally tuned, their drums refusing to vibrate in response to carefully chosen stimuli. When you manifest this power on a creature that can hear normally, you specify one other creature that it will become unable to hear any longer. Once in place, selective hearing prevents its target from being able to hear the voice of the source creature you have chosen. The source creature does not need to be within range of this power when you manifest it, however you must have heard the source creature's voice in the past.

The target creature can still hear other sounds created by the source creature, allowing for simple communication through such means as banging two items together.

Augment: You can augment this power in one or both of the following ways:

• For every additional three power points you spend, you can choose a second target creature or a second source creature. For instance, this could allow you to have one creature that cannot hear two others, or to have two creatures that cannot hear a single common other. You can augment in both ways at once by spending appropriate power points.

• By spending an additional six power points, all sounds created by the source creature are inaudible to your target.

For every two additional power points spent on either augment, the DC of this power increases by 1.

Mythic Selective Hearing

You can allow your target to hear the source creature as if not under the effects of this power. When so allowing, you can tap into the hearing of your target as long as they are on the same plane as you are, and hear the voice of the source creature you specified. You only hear that voice, not that of your source target or any other sounds.

The duration of mythic selective hearing becomes 1 hour/level and its saving throw becomes a Will save.`
  },
  Shape_the_Shade: {
    name: "Shape the Shade",
    discipline: "Athanatism",
    level: "Cryptic 2, psion/wilder 2",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One willing incorporeal creature touched",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You sculpt an incorporeal creature, making it appear as something else. You may make the creature appear either living or dead, corporeal or incorporeal, and can even effect clothing, armor, weapons, and equipment. This power can make the target seem 1 foot shorter or taller, thin, fat, or in between. It can change the apparent subtype of the target, can add or obscure a minor feature, or make it look like an entirely different sex.

This power does not provide any abilities or mannerisms of the chosen form. If this is used to create a disguise, the target gets a +10 bonus on the Disguise check.

Augment: This power may be augmented in one of the following ways.

• By spending an additional 5 power points, you may choose two points worth of evolutions from the list of evolutions available to summoner's eidolons that you may apply to the target while this power is active.

• By spending an additional 2 power points, you may target a living creature with this power. However, any disguise must be to make them appear dead or as some form of undead.

• By spending an additional 4 power points, you may make the target appear as a different creature type.`
  },
  Share_Pain: {
    name: "Share Pain",
    discipline: "Psychometabolism",
    level: "Gambler 3, highlord 3, psion/wilder 3, tactician 3, vitalist 3",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Share Pain[]

Targets: You and one willing creature, or two willing creatures; see text

This power creates a psychometabolic connection between you and a willing subject so that some of your wounds are transferred to the subject. You take half damage from all attacks that deal hit point damage to you, and the subject takes the remainder. If your hit points are reduced by a lowered Constitution score, that reduction is not shared with the subject because it is not a form of hit point damage. When this power ends, subsequent damage is no longer divided between the subject and you, but damage already shared is not reassigned.

If you and the subject move farther away from each other than close range, the power ends.

You can manifest this power on two willing subjects, one of which you designate to share its damage with the other.

Share Pain, Forced[]

As share pain , except as noted here.

You attempt to force the sharing of your wounds with an unwilling creature for less time. If you are immune to the type of damage dealt, or if you convert lethal damage into nonlethal, the target takes no damage.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Steal_Animus: {
    name: "Steal Animus",
    discipline: "Psychometabolism",
    level: "Gifted blade 2, highlord 2, psion/wilder 2, psychic warrior 2, tactician 2",
    display: "Auditory, Material, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will half",
    powerResistance: "No",
    powerPoints: "3",
    description: `Manifesting this power allows the manifester to steal the unstable animus from a target with a touch. The manifester makes a touch attack against the target and may attempt to steal 1d4 points of animus from the target. A successful Will save by the target halves the loss of animus. If the target does not possess animus, this power has no effect.

Augment: If you spend an additional 2 power points points, you may alter the range of this power to close range (25 feet + 5 feet per two manifester levels) and make the attack as a ranged touch attack.

For every additional 2 power points spent, you may steal an additional 1d4 points of animus from the target.`
  },
  Suppress_Instinct: {
    name: "Suppress Instinct",
    discipline: "Telepathy",
    level: "Cryptic 2, psion/wilder 2, vitalist 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One touched animal",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `Your thoughts gently caress the primitive mind of an animal, reworking its most base urges to enable it to act more calmly than natural. Once under the effect of this power, the subject animal becomes temporarily immune to fear effects. In addition, the animal can now potentially be convinced to perform acts that it would otherwise be unwilling to do, such as run through a sheet of fire or walk along a sharp cliff. This may allow an animal to take advantage of abilities that would normally alarm it, such as if it were subject to a fly spell (though directing it in flight may require Handle Animal checks).

This does not make an animal suicidal, but merely keeps its natural fears from preventing it from acting. You also do not gain any special influence over the animal and must direct it as you would to take any actions it would not normally find distasteful.

Augment: For every two additional power points you spend, you may manifest this power on one additional animal. You do not need to touch each animal at the same time to activate this power but must touch all target animals within the duration of the power.

Mythic Suppress Instinct

This power can now apply to magical beasts and its duration is changed to 1 hour/level.`
  },
  Suppress_Veil: {
    name: "Suppress Veil",
    discipline: "Psychokinesis",
    level: "All 2",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft. per 2 levels)",
    target: "One creature",
    area: "",
    duration: "1 min/level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `

You project a pulse of concentrated essence at a creature in an attempt to suppress one of their veils. Select one veil the target creature has shaped and make a dispel check (1d20 + your manifester level) and compare it against a DC equal to 11 + the veil's veilweaver level. If your check meets or beats this DC, that veil is suppressed it for the duration of this power.

Augment: For every 3 additional power points you spend, you may choose an additional veil to suppress with this power. You make a single dispel check and apply its results to all selected veils.`
  },
  Suspend_Psionics: {
    name: "Suspend Psionics",
    discipline: "Psychokinesis",
    level: "Cryptic 2, highlord 2, psion/wilder 2, tactician 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Concentration up to 1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `The visible auras of magic surrounding you dampen noticeably, signifying some reduction in effect. When you manifest this power, you select one ongoing power in that is currently manifested upon you. While you concentrate, the selected power is suppressed, its benefits cease and its remaining duration stops decreasing. Once you cease concentrating, the power immediately springs back into effect and resumes its normal duration.

You can only specify powers that you have manifested upon yourself and powers you have voluntarily failed your saving throws against; suspend psionics cannot be used upon powers that were placed upon you by enemies.

Mythic Suspend Psionics

You may suspend a number of powers on your person equal to your mythic tier.`
  },
  Sustenance: {
    name: "Sustenance",
    discipline: "Psychometabolism",
    level: "Dread 2, gambler 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 2, psychic warrior 2, tactician 2, vitalist 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You can go without food and water for one day. Each time you manifest this power, your body manufactures sufficient solid and liquid nourishment to satisfy your needs for that time.`
  },
  Swarm_of_Crystals: {
    name: "Swarm of Crystals",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 2, psion/wilder 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "15 ft.",
    target: "",
    area: "Cone-shaped spread",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `Thousands of tiny crystal shards spray forth in an arc from your hand. These razor-like crystals slice everything in their path. Anyone caught in the cone takes 3d4 points of slashing damage.

Augment: For every additional power point you spend, this power's damage increases by 1d4 points.`
  },
  Sympathetic_Drain: {
    name: "Sympathetic Drain",
    discipline: "Psychometabolism",
    level: "Psion/wilder 2, vitalist 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. plus 5 ft. per 2 levels)",
    target: "You and 1 other creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will partial",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You establish a channel between you and a victim, through which you both bleed life force. When you manifest this power, sacrifice any number of hp up to 1/2 your full maximum total (you may not sacrifice temporary hp). Your victim loses an equal amount of hp and must succeed at a Will save or be sickened for 1 round.

Augment: For every 2 additional power points you spend when manifesting this power, the duration of the sickened effect increases by 1 round and its save DC increases by 1.

Surge Augmentation: If you invoke your wild surge when you manifest this power your opponent loses 2 hp for each 1 hp you sacrifice.`
  },
  Thought_Shield: {
    name: "Thought Shield",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 2, gifted blade 2, highlord 2, psion/wilder 2, psychic warrior 2, tactician 2",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You fortify your mind against intrusions, gaining power resistance 13 against all mind-affecting powers.

Augment: For every additional power point you spend, this power's duration increases by 1 round, and the power resistance it provides increases by 1 point.`
  },
  Tormenting_the_Living: {
    name: "Tormenting the Living",
    discipline: "Athanatism [mind-affecting, fear]",
    level: "Psion/wilder 2, vitalist 2",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature touched",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You bind a spirit to a living creature, goading it into tormenting and torturing them. They are constantly harassed by ghostly hallucinations, suffering a -2 penalty on Reflex saves and AC against attacks of opportunity. During your turn, as a swift action, you may expend your psionic focus to empower the spirit, haunting the creature more intensely. It is shaken for a number of rounds equal to your Charisma modifier.

Augment: You may augment this power in one of the following ways.

• By spending an additional 4 power points, any incorporeal creature that attacks the target gains a +2 bonus on attack rolls, damage rolls, and save DCs of powers it manifests or effects it creates.

• By spending an additional 2 power points, increase the duration of this power to 1 day/level.

• By spending an additional 4 power points, increase the duration of this power to 1 week/level.`
  },
  Twitch: {
    name: "Twitch",
    discipline: "Psychometabolism OR telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, psion/wilder 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude OR Will (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `If the target fails its saving throw (Fortitude if this is a psychometabolism power, Will if this is a telepathy power), you can immediately force them to do one of the following as their body spasms:

• Drop something held in one hand

• Take a 5-foot step in any direction (this does not provoke attacks of opportunity)

• Fall prone

If the target succeeds on their save, they take a -1 penalty to their next d20 roll as the focus required to keep their body from twitching distracts them.

Augment: This power may be augmented in one or more of the following ways.

• For every 2 additional power points you spend, you can choose another target.

• If you spend 2 additional power points, the range becomes Medium (100 ft. + 10 ft./lvl).

For every 2 power points spent on the above augments, increase the save DC by 1.`
  },
  Baleful_Mind_Trap_of_Surtr: {
    name: "Baleful Mind Trap of Surtr",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "None; see text",
    powerResistance: "Yes (harmless)",
    powerPoints: "5",
    description: `You set up a trap in your mind against mental intruders. Anyone who attacks you with a telepathy power or mind-affecting effect immediately loses 1d6 power points. This power's effect does not negate the power that is currently being used against you. You can manifest this power instantly, quickly enough to gain its benefit in an emergency. Creatures that do not have power points must make a Fortitude save or be nauseated for 1 round. Manifesting the power is an immediate action. You can use this power even when it is not your turn.

Augment: For every additional power point you spend, this power's duration increases by 1 round.

Librarian Note : In Psionics Unleashed, this power is simply called Mind Trap. It appears to have been renamed to avoid confusion with the later Mind Trap power.

Baleful Mind Trap of Surtr (Mythic)[]

You gain a number of power points equal to those drained by the target, or 1 power point if the target does not have power points. Creatures with power points must also make a save to avoid being nauseated, while creatures without power points are nauseated for two rounds on a failed save.`
  },
  Banshee_s_Hearing: {
    name: "Banshee's Hearing",
    discipline: "Athanatism",
    level: "Dread 2, psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 minutes/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3 (dread), 5 (psion/wilder)",
    description: `Like the spectral undead, you attune your senses to the heartbeats of the living. You gain blindsight with a range of 60 ft. However, any target that does not have a heartbeat (undead, constructs, some aberrations, etc.) is treated as having total concealment from your blindsight. Your normal senses continue to function.

Augment: You may augment this power in one of the following ways.

• You may spend an additional 2 power points to increase the range of your blindsight from this power by 10 feet.

• By spending an additional 4 power points, the duration of this power becomes 1 hour/level.`
  },
  Biokinetic_Endurance: {
    name: "Biokinetic Endurance",
    discipline: "Psychometabolism",
    level: "Highlord 3, psion/wilder 3, psychic warrior 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 minute/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You alter your body's rhythms, defending yourself against crippling attacks and turning your skin (as well as fur, feathers, or scales) a pale gray color. Whenever damage would be dealt to one of your physical ability scores by a source other than you, reduce that damage by 2 points, to a minimum of 0. Once this power has prevented an amount of ability damage equal to your manifester level, it ends immediately.

Augment: For every 2 additional power points you spend, the ability damage reduced by this power, as well as the maximum amount of damage that can be prevented, increases by 1 point.

Surge Augmentation: If you invoke your wild surge while manifesting this power, choose one of the following augmentations:

• The power's range changes to close (25 ft. plus 5 ft. per 2 levels) and its target changes to 'one creature.'

• You gain DR X/—, where X is equal to your wild surge's intensity.`
  },
  Body_Adjustment: {
    name: "Body Adjustment",
    discipline: "Psychometabolism (Healing)",
    level: "Cryptic 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 3, psychic warrior 2, vitalist 2, voyager 2",
    display: "Auditory and material",
    manifestingTime: "1 round",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 3, gifted blade 3, marksman 3, highlord 3, psion/wilder 5, psychic warrior 3, vitalist 3, voyager 3",
    description: `You take control of your body's healing process, curing yourself of 1d12 points of damage. As usual, when regular damage is healed, an equal amount of nonlethal damage is also healed.

Augment: For every 2 additional power points you spend, this power heals an additional 1d12 points of damage.

Mythic Body Adjustment[]

The damage healed by this power is doubled. In addition, for every 2d12 damage healed, this power also cures up to 2 points of ability damage.

Augmented (3rd): If you expend two uses of mythic power, you can manifest mythic body adjustment as an immediate action when you would be reduced to 0 or fewer hit points.`
  },
  Body_Purification: {
    name: "Body Purification",
    discipline: "Psychometabolism (Healing)",
    level: "Cryptic 2, gifted blade 2, highlord 2, marksman 2, psion/wilder 3, psychic warrior 2, vitalist 2",
    display: "Auditory and material",
    manifestingTime: "1 round",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 3, gifted blade 3, marksman 3, highlord 3, psion/wilder 5, psychic warrior 3, vitalist 3",
    description: `You restore up to 2 points of damage to a single ability score. You cannot use body purification to heal ability drain.

Augment: For every additional power point you spend, this power heals 1 additional point of damage to the same ability score.

Mythic Body Purification[]

The power cures all ability damage to a single attribute.

Augmented (3rd): If you expend one use of mythic power, the power cures all ability damage to all attributes.`
  },
  Captivity_Bond: {
    name: "Captivity Bond",
    discipline: "Psychometabolism",
    level: "Dread 2, cryptic 2, highlord 3, marksman 2,psion/wilder 3, tactician 3, vitalist 3",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One living creature",
    area: "",
    duration: "One round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "Dread 3, cryptic 3, highlord 5, marksman 3, psion/wilder 5, tactician 5, vitalist 5",
    description: `A thin film of colored oily liquid engulfs your target then appears to be absorbed into their skin, leaving them tinted to match. For the duration of this power, the altered creature can take only nonlethal damage from any source. If they are suffering from ongoing bleed damage, they will bleed nonlethally. This power only applies to effects that deal hit point damage, and it can only be manifested upon creatures that are not immune to nonlethal damage.

Mythic Captivity Bond

For the duration of this power, if the target creature performs movement away from the manifester, they take nonlethal damage equal to the resulting increase in distance. For example, a creature moving around obstacles may move 15 feet, but only 5 of those feet might be “away” from the manifester, and thus that movement causes 5 points of nonlethal damage. Movement performed by psychoportive means does not cause the target to take damage.`
  },
  Caustic_Retribution: {
    name: "Caustic Retribution",
    discipline: "Psychometabolism [Acid]",
    level: "dread 3, highlord 3, psion/wilder 3, psychic warrior 3, vitalist 3",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You alter a creature's blood into a caustic fluid and adjust their veins and arteries to accommodate it. The target gains acid resistance 10. Additionally, when the target is damaged by a melee attack, its attacker must succeed at a Reflex save or take 3d6 points of acid damage. Attackers using a natural weapon suffer a -4 penalty to their save.

Whenever the target takes damage from a bleed effect, creatures adjacent to the target must succeed at a Reflex save or suffer 3d6 points of acid damage.

Augment: You may augment this power in the following ways:

• For every 2 power points you spend, its damage increases by one die (d6).

• If you spend an additional 4 power points, creatures damaged by this power who fail their saves are also blinded until the beginning of their next turn.`
  },
  Caustic_Transfusion: {
    name: "Caustic Transfusion",
    discipline: "Psychometabolism [Acid]",
    level: "dread 3, psion/wilder 3, vitalist 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature (see text)",
    area: "",
    duration: "Concentration (up to 1 round per level) + 1 round",
    savingThrow: "Fortitude partial (see text)",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You convert large portions of your target's blood to a caustic fluid, wracking them with pain and misery. The target takes 2d6 acid damage at the start of their turn and becomes fatigued until the beginning of their text turn. A successful Fortitude save halves the damage and negates the fatigued condition. If the target is suffering bleed damage at the beginning of its turn, adjacent creatures must succeed at a Reflex save or suffer the damage dealt by this power as well.

Augment: You may augment this power in the following ways:

• For every 2 power points you spend, its damage increases by one die (d6).

• If you spend an additional 4 power points, victims that fail their saving throws also become nauseated for 1 round.

In addition, for every 2 power points spent to achieve either of these results, increase the save DC of this power by 1.`
  },
  Concussive_Onslaught: {
    name: "Concussive Onslaught",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory, Material, Visual",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "30 ft. radius burst",
    duration: "1 round / level",
    savingThrow: "Fortitude half",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You direct wave after wave of concussive kinetic energy at a specific location, pulverizing any and all creatures within the area of effect. All creatures within the area take 3d6 force damage, or half on a successful Fortitude save. The damage continues each round in the same area until the power expires.

Augment: This power may be augmented in one or more of the following ways.

• For every two additional power points spent, the damage done each round increases by 1d6 and the save DC increases by 1.

• By spending an additional 4 power points, you can redirect what area is affected as a standard action that does not provoke attacks of opportunity. The newly chosen area must be within the power's range, even if you have moved beyond the range of the initial area.

Mythic Concussive Onslaught[]

The affected area increases to a 60-foot radius burst. In addition, you can choose to have the power damage any unattended, mundane objects in the affected area.

Augmented: If you expend one use of mythic power, the damage dealt by this power uses d8s instead of d6s.`
  },
  Danger_Sense: {
    name: "Danger Sense",
    discipline: "Clairsentience",
    level: "Cryptic 3, highlord 3, marksman 3, psion/wilder 3, psychic warrior 3, sighted seeker 3, tactician 3, vitalist 3, voyager 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You can sense the presence of danger before your senses would normally allow it. Your intuitive sense alerts you to danger from traps, giving you a +4 insight bonus on Reflex saves to avoid traps and a +4 insight bonus to Armor Class against attacks by traps.

Augment: If you spend 3 additional power points, this power also gives you the uncanny dodge ability; if you spend 6 additional power points, this power gives you the improved uncanny dodge ability as well.

Mythic Danger Sense[]

The insight bonus is increased to +6.

Augmented (3rd): If you expend one use of mythic power, the insight bonus also applies during any surprise round in which you do not get to act.`
  },
  Dismiss_Ectoplasm: {
    name: "Dismiss Ectoplasm",
    discipline: "Metacreativity",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "30-ft.-radius burst",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "5",
    description: `You dismiss creatures, objects, or effects composed of ectoplasm, such as astral constructs or the ectoplasmic cocoon power, or that were formerly composed of ectoplasm, such as items created by metacreativity (creation) powers. An ectoplasmic creature that fails its Will saving throw dissipates into so much constituent ectoplasm, which evaporates immediately.

A creature under the effect of the ectoplasmic form power that fails its saving throw is either destroyed out right or physically shifted to a random location on the Astral Plane (50% chance for either result).

Other ongoing powers that create ectoplasmic objects or effects, such as ectoplasmic cocoon, are dismissed if you succeed on a manifester level check (1d20 + your manifester level, maximum +10) against a DC of 11 + the power's manifester level.`
  },
  Dispel_Psionics: {
    name: "Dispel Psionics",
    discipline: "Psychokinesis",
    level: "Cryptic 3, gambler 3, psion/wilder 3, vitalist 3, voyager 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5",
    description: `Target or Area: One manifester, creature, or object; or 20-ft.-radius burst

You can use dispel psionics to end one ongoing power that has been manifest on a creature or object or to temporarily suppress the psionic abilities of a psionic item. A dispelled power ends as if its duration had expired. Some powers, as detailed in their descriptions, can't be defeated by dispel psionics . Dispel psionics can dispel (but not counter) psi-like effects just as it does powers. The effect of a power with an instantaneous duration can't be dispelled, because the psionic effect is already over before the dispel psionics can take effect.

Targeted Dispel: One object, creature, or power is the target of the dispel psionics power. You make one dispel check (1d20 + your manifester level) and compare that to the power with highest manifester level (DC = 11 + the power's manifester level). If successful, that power ends. If not, compare the same result to the power with the next highest manifester level. Repeat this process until you have dispelled one power affecting the target, or you have failed to dispel every power.

For example, a 7th-level manifester manifests dispel psionics , targeting a creature affected by biofeedback (manifester level 12th) and flight (manifester level 7th). The manifester level check results in a 19. This check is not high enough to end the biofeedback (which would have required a 23 or higher), but it is high enough to end the flight (which only required a 18). Had the dispel check resulted in a 23 or higher, the biofeedback would have been dispelled, leaving the flight intact. Had the dispel check been a 17 or less, no powers would have been affected.

You can also use a targeted dispel to specifically end one power affecting the target or one power affecting an area (such as a wall of fire ). You must name the specific power effect to be targeted in this way. If your manifester level check is equal to or higher than the DC of that power, it ends. No other powers or effects on the target are dispelled if your check is not high enough to end the targeted effect.

If you target an object or creature that is the effect of an ongoing power (such as a monster summoned by summon monster ), you make a dispel check to end the power that conjured the object or creature.

If the object that you target is a psionic item, you make a dispel check against the item's manifester level (DC = 11 + the item's manifester level). If you succeed, all the item's psionic properties are suppressed for 1d4 rounds, after which the item recovers its psionic properties. A suppressed item becomes nonpsionic for the duration of the effect. An interdimensional opening (such as a bag of holding ) is temporarily closed. A psionic item's physical properties are unchanged: A suppressed psionic sword is still a sword (a masterwork sword, in fact). Artifacts and deities are unaffected by mortal psionics such as this. You automatically succeed on your dispel check against any power that you manifest yourself.

Augment: This power may be augmented in one of the following ways.

• If you spend an additional 6 power points, your targeted dispel can dispel one power for every four manifester levels you possess, starting with the highest level powers and proceeding to lower level powers. It also has a chance to dispel any effect that remove curse can remove, even if an unaugmented dispel psionics can't dispel that effect. The DC of this check is equal to the curse's DC.

• If you spend an additional 6 power points, you may choose to make an area dispel instead of a targeted dispel.

Area Dispel: When dispel psionics is used in this way, the power affects everything within a 20-foot-radius burst. Roll one dispel check and apply that check to each creature in the area, as if targeted by dispel psionics . For each object within the area that is the target of one or more powers, apply the dispel check as with creatures. Psionic items are not affected by an area dispel.

For each ongoing area or effect power whose point of origin is within the area of the dispel psionics power, apply the dispel check to dispel the power. For each ongoing power whose area overlaps that of the dispel psionics power, apply the dispel check to end the effect, but only within the overlapping area.

If an object or creature that is the effect of an ongoing power (such as a weapon summoned by call weaponry ) is in the area, apply the dispel check to end the power that conjured that object or creature (returning it whence it came) in addition to attempting to dispel one power targeting the creature or object.

You may choose to automatically succeed on dispel checks against any power that you have manifested.

Mythic Dispel Psionics[]

When used as a targeted dispel, this power can end two effects affecting the target instead of just one. If the targeted dispel successfully dispels at least one effect, you heal 1d4 points of damage for every power level of the dispelled effect. If you dispel two effects, this healing applies only to the highest-level effect dispelled.`
  },
  Disruption: {
    name: "Disruption",
    discipline: "Telepathy [mind-affecting]",
    level: "Cryptic 3, dread 3, highlord 3, psion/wilder 3, tactician 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `The power overwhelms the target's mind and ability to concentrate, making manifesting powers or casting spells extremely hard. The subject must succeed at a concentration check (DC equal to the save DC of this power) in order to cast a spell, manifest a power, use any spell-like ability, use any psi-like ability, or use any spell completion, power completion, power trigger or spell trigger magic items.

While under the effect of this power, if the subject must attempt a concentration check to cast a spell, manifest a power, use a psi-like ability or a spell-like ability for any reason other than the effect of this spell (such as manifesting defensively, being injured while manifesting, and so on), it takes a penalty on that check equal to 1/2 its caster or manifester level.

Augment: This power can be augmented in one or more of the following ways.

• For every 2 additional power points you spend, you can choose another target.

• If you spend 2 additional power points, the range increases to Medium instead of Close.

• If you spend 3 additional power points, the target takes a penalty to all concentration checks equal to your manifesting ability stat, in addition to any other penalties it might suffer.`
  },
  Ectoplasmic_Carpet: {
    name: "Ectoplasmic Carpet",
    discipline: "Metacreativity (Creation)",
    level: "Cryptic 3, highlord 3, psion/wilder 3, tactician 3",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "",
    area: "",
    duration: "1 min./level",
    savingThrow: "See text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Effect: One 5-ft. square of temporarily real carpet

A glossy sheet of soft ectoplasm coheres in space to do your bidding. When you manifest this power, you must choose one of the several modes in which it can operate. Once this choice is made, it cannot be changed for this manifestation.

Flying : In this mode, an ectoplasmic carpet acts as a flying carpet of the same size. Unaugmented, it can carry up to 200 lbs. and has a fly speed of 40 ft. plus the usual overland flight capability.

Restraint: In this mode, an ectoplasmic carpet can wrap itself around a creature's arms, preventing them from being used to wield weapons or perform fine activities using hands. The carpet is treated as a set of masterwork manacles (Escape Artist DC 35 or Strength check DC 28 to escape or break) but also constrains the target's fingers. This imposes an Arcane Spell Failure chance of 20% upon those to whom it may apply. A creature can make a Reflex save to avoid being ensnared by a carpet in this mode. As a move action, you can direct the carpet to a target within range, and as a standard action you can attempt to ensnare a creature. Only one creature can be held at a time and releasing a creature is a free action.

Shield: In this mode, an ectoplasmic carpet acts as a sheet of protective material that you can move around within your space as a free action. This functions as a heavy shield (+2 shield bonus to AC) but only against ranged attacks as it is too insubstantial to interfere with melee attacks. This shield has no armor check penalty or Arcane Spell Failure chance since it is weightless and encumbrance-free.

Tripping: In this mode, an ectoplasmic carpet can be slipped beneath the feet of an opponent then telekinetically pulled out from beneath them. This requires a move action to mentally direct the carpet to slide underneath a target within range, and a standard action to perform a trip attempt. You use your manifester level in place of your base attack bonus and your primary manifesting ability modifier in place of Strength for calculating your CMB for this trip attempt. You cannot trip a creature larger than this carpet.

Augment: This power may be augmented in one or more of the following ways:

• For every additional two power points you spend, the basic flying mode carpet expands one size as per flying carpet . The first augmentation increases the carpet to 5-ft. by 10-ft. and carrying capacity to 400 lbs. The second augmentation increases the carpet to 10-ft. by 10-ft. and carrying capacity to 800 lbs. Each subsequent augmentation increases size by two 5-ft. squares and carrying capacity by 400 lbs. Any carpet augmented to 10-ft. by 10-ft. or larger changes its duration to 1 hour/ level.

• For every additional power point you spend, the DCs for escaping or breaking a restraint carpet increase by 1.

• For every additional three power points you spend, the shield bonus granted by a basic shield carpet increases by 1.

• For every additional four power points you spend, the basic tripping mode carpet becomes one size larger (from a 5-ft. square appropriate to a Medium creature to a 10-ft. square appropriate to a Large creature, then to a 15-ft. square appropriate to a Huge creature and so on). A tripping carpet that is large enough may be used to trip multiple creatures at once if they all fit within its area.

Mythic Ectoplasmic Carpet

A flying mythic ectoplasmic carpet bestows flight upon its riders for a number of rounds equal to your mythic tier when it ends (either as its duration expires or if it is dispelled).

A restraint ectoplasmic carpet causes any creature ensnared within it to be entangled.

A shield ectoplasmic carpet grants its shield bonus to AC against melee attacks as well as ranged attacks.

A tripping ectoplasmic carpet is treated as difficult terrain by those standing upon it. You can leave the carpet underneath your foes by declining to make trip attempts.`
  },
  Empathic_Understanding: {
    name: "Empathic Understanding",
    discipline: "Telepathy",
    level: "Cryptic 3, Dread 3, Highlord 3, Psion/Wilder 3, Tactician 3, Vitalist 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "personal",
    target: "",
    area: "30-foot radius centered on you.",
    duration: "10 minutes/level (D); see text",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "5",
    description: `You establish a field of psychic energy around yourself that facilitates easy communication between individuals, enabling them to understand whatever it is that the others are asserting with perfect accuracy. This enables all creatures to understand whatever it is that others say or attempt to communicate through other language (sign language, for example) with perfect accuracy, even if they would otherwise not know the language. Even if a creature is not otherwise capable of speaking (but still possesses an intelligence score), this power can be used to interpret their feelings and emotions when they attempt to enunciate them (such as a dog barking). This does not reveal a creature's thoughts, so a being with secrets to hide may simply keep silent inside the field to avoid detection. A creature within the area of this power is allowed a Will save to avoid entering into this link and having its words or intentions understood.

Augment

• If you spend 6 additional power points, you automatically determine when any linked creature within the area is lying.

• For every 2 additional power points you spend, the radius of this power increases by 10 feet and the save DC increases by 1.`
  },
  Endorphin_Surge: {
    name: "Endorphin Surge",
    discipline: "Psychometabolism",
    level: "Gifted blade 2, highlord 2, psion/wilder 3, psychic warrior 2, vitalist 3, voyager 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round / level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Gifted blade 3, highlord 3, psion/wilder 5, psychic warrior 3, vitalist 5, voyager 3",
    description: `The glands of your body emit massive quantities of endorphins, augmenting your natural abilities. While this power is active, you are treated as if in a barbarian rage, giving you a +2 morale bonus to your Constitution and Strength, a +1 morale bonus on Will saves, and a -2 penalty to your Armor Class. The effect is otherwise identical with a barbarian's rage except you aren't fatigued at the end of the rage.

Augment: If you spend 6 additional power points, the morale bonus to your Constitution and Strength is increased by 2, and the morale bonus on Will saves is increased by 1.

Mythic Endorphin Surge[]

You can affect one additional creature per mythic tier. In addition, if affected creatures take damage while mythic endorphin surge is in effect, the bonuses provided by this power are doubled.

Augmented: If you expend two uses of mythic power, all affected creatures gain the ferocity special quality and can fight on at 0 or fewer hit points, to a maximum hit point total equal to their Constitution plus your mythic tier.`
  },
  Energy_Bolt_Lanis_s: {
    name: "Energy Bolt, Lanis's",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "120 ft.",
    target: "",
    area: "120-ft. line",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You release a powerful stroke of energy of your active energy type (cold, electricity, fire, or sonic) that deals 5d6 points of damage to every creature or object within the area. The beam begins at your fingertips.

• Cold: A bolt of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold bolt is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a bolt of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A bolt of this energy type deals +1 point of damage per die.

• Sonic: A bolt of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Lanis's Energy Bolt[]

The dice are d8s instead of d6s. Any creature that fails its save is staggered for 1 round.

Augmented (3rd): If you expend two uses of mythic power, you can bend the line of the power once up to 90 degrees. Any creature that fails its save is stunned for 1 round.`
  },
  Energy_Burst: {
    name: "Energy Burst",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "40 ft.",
    target: "",
    area: "40-ft-radius burst centered on you",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You create an explosion of unstable ectoplasmic energy of your active energy type (cold, electricity, fire, or sonic) that deals 5d6 points of damage to every creature or object within the area. The explosion creates almost no pressure. Since this power extends outward from you, you are not affected by the damage.

• Cold: A burst of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold burst is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a burst of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A burst of this energy type deals +1 point of damage per die.

• Sonic: A burst of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Burst[]

The radius of the burst increases to 60 feet.

Augmented: If you expend two uses of mythic power, you can select a number of creatures up to your tier to not be affected by the burst.`
  },
  Energy_Retort: {
    name: "Energy Retort",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 3, psion/wilder 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal and close (25 ft. + 5 ft./2 levels); see text",
    target: "",
    area: "",
    duration: "1 min./level",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Targets: You and creature or object attacking you; see text

You weave a field of potential energy of your active energy type (cold, electricity, fire, or sonic) around your body. The first successful attack made against you in each round during the power's duration prompts a response from the field without any effort on your part. The attack may be physical, the effect of a power, or the effect of a spell (including spell-like, supernatural, and extraordinary abilities). An “ectoburst” discharges from the field, targeting the source of the attack and dealing 4d6 points of damage of the active energy type. To be affected, a target must be within close range, you must have line of sight and line of effect to it, and you must be able to identify the source of the attack. The ectoburst automatically strikes the enemy who successfully attacked you, so long as it meets the above criteria.

• Cold: A field of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold retort is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a field of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A field of this energy type deals +1 point of damage per die.

• Sonic: A field of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's duration increases by 1 minute.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Retort[]

You can choose whether to allow the effect to target a creature that strikes you or save it for a possible attack later in the round. The range of the retort increases to medium (100 feet + 10 feet/level) and you do not need line of sight to the attacker.

Augmented (4th): If you expend two uses of mythic power, all attacks against you are subjected to the effect of mythic energy retort .`
  },
  Energy_Rings: {
    name: "Energy Rings",
    discipline: "Psychokinesis [see text]",
    level: "Psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One Medium or smaller creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You create an immobile cylindrical stack of rings of energy of your active energy type that surrounds your target, threatening to harm them if they move. When initially placed, these rings do no damage, but they discourage your foe from undertaking movement. While surrounded by energy rings , the targeted creature may still take actions within their square as usual, including making ranged or melee attacks, or manifesting powers without hindrance.

In order to escape the energy rings , the target must first succeed at a Strength check to break the rings. The DC for this check is equal to the DC of the power. Attempting to do so requires the target to directly contact the rings, which deals 5d6 points of damage to the creature touching the rings. This power ends if any of the rings are broken.

• Cold: A set of rings of this energy type deals +1 point of damage per die. The saving throw to reduce damage from cold rings is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a set of rings of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A set of rings of this energy type deals +1 point of damage per die.

• Sonic: A bolt of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: You can augment this power in one or both of the following ways:

• For every additional power point you spend, this power's damage increases by one die (d6).

• For every two additional power points you spend, this power can affect a creature one size category larger.

Additionally, for each two power points spent on either augment, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Rings

The damage dice of the power and its augments increase to d10.

Augment (3rd): If you expend two uses of mythic power, you can target one additional creature or unattended object for every three mythic tiers you possess.`
  },
  Energy_Wall: {
    name: "Energy Wall",
    discipline: "Metacreativity (Creation) [see text]",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "An opaque sheet of energy up to 20 ft. long/level or a ring of energy with a radius of up to 5 ft./2 levels; either form 20 ft. high",
    duration: "Concentration + 1 round/ level",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You create an immobile sheet of energy of your active energy type (cold, electricity, fire, or sonic) formed out of unstable ectoplasm. One side of the wall, selected by you, sends forth waves of energy, dealing 2d6 points of damage to creatures and objects within 10 feet and 1d6 points of damage to those beyond 10 feet but within 20 feet. In addition, anyone passing though the energy wall takes 2d6 points of damage +1 point per manifester level (maximum +20).

If you manifest the wall so that it appears where creatures are, each creature takes damage as if passing through the wall.

If you manifest this power in the form of a ring of energy, you choose whether the waves of energy radiate inward or outward from the ring.

• Cold: A sheet of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold wall is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a sheet of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A sheet of this energy type deals +1 point of damage per die.

• Sonic: A sheet of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Wall[]

The wall's damage increases to 2d8 points of damage to creatures within 10 feet, 1d8 points of damage to those past 10 feet but within 20 feet, and 2d8 points of damage + 1 point of damage per manifester level (maximum +20) to any creature passing through it.

Augmented (5th): If you expend two uses of mythic power, you may move the wall 5 feet in any direction as a move action on your turn. Moving the wall into a barrier (such as a stone wall) destroys the part of the wall that overlaps the barrier.`
  },
  Essential_Block: {
    name: "Essential Block",
    discipline: "Telepathy (essence, mind-affecting)",
    level: "All 3",
    display: "Auditory, Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft. per 2 levels)",
    target: "One creature",
    area: "",
    duration: "Concentration (maximum 1 minute)",
    savingThrow: "Will partial",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `

You attempt to place a mental block on the target which prevents them from reinvesting their essence. If the target fails their saving throw, they cannot invest, reinvest, or willingly burn any of their essence for the duration of the power.

On a successful save, choose one of the target's essence receptacles that you have knowledge of; the target cannot invest essence into, out of, or burn essence invested in that receptacle for the duration of the power.

Augment: For every 2 additional power points you spend, you may choose an additional essence receptacle to block if the target succeeds on its saving throw and the maximum duration you can concentrate on this power increases by 1 minute.

For every 2 power points you spend augmenting this power, the power's save DC increases by 1.

Essence: For each point of essence burned as part of manifesting this power, the power persists for 1 additional round after you stop concentrating on it, or if your concentration is broken.`
  },
  Eradicate_Invisibility: {
    name: "Eradicate Invisibility",
    discipline: "Psychokinesis",
    level: "Gambler 3, psion/wilder 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "50 ft.",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Reflex negates",
    powerResistance: "No",
    powerPoints: "5",
    description: `Targets: You and all invisible creatures and objects in a 50-ft.-radius burst centered on you

You radiate a psychokinetic burst that disrupts and negates all types of invisibility (though this power can't negate the effect of cloud mind ). Any creature that fails its save to avoid the effect loses its invisibility.

Creatures that are naturally invisible, such as an invisible stalker, are revealed as a dim outline for 1 round (until the beginning of your next turn) and do not have total concealment during this period.

Augment: For every additional power point you spend, this power's range and the radius of the burst in which it functions both increase by 5 feet. For each 10-foot increase, this power's save DC increases by 1.

Mythic Eradicate Invisibility[]

The area of effect is doubled, and naturally invisible creatures are revealed for a number of rounds equal to your tier.

Augmented (3rd): If you expend one use of mythic power, the duration becomes instantaneous and 1 round per level. Each round on your turn, the mythic eradicate invisibility emits another pulse.`
  },
  Feast_of_the_Dead: {
    name: "Feast of the Dead",
    discipline: "Athanatism",
    level: "Psion/wilder 3",
    display: "Material",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Personal plus one creature/level",
    area: "",
    duration: "1 hour plus 12 hours; see text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5",
    description: `You transform phantasmal remains into a sumptuous, macabre banquet, which you may share with one creature/level. The feast takes 1 hour to consume, and the beneficial effects do not set in until this hour is over. Every creature partaking of the feast gains 1d8 temporary hit points + 1 point per two manifester levels (maximum +10). The meat of the feast grants each target that partakes a +2 morale bonus on saving throws against curses and effects that sicken or nauseate for 12 hours. If the feast is interrupted for any reason, the power is ruined and all effects of the power are negated.

Augment: You may spend an 6 additional power points to grant all who join in the feast a +1 morale bonus on attack rolls. It also increases the granted bonus on saves against curses and effects that sicken or nauseate to +4. In addition, if you expend your psionic focus when manifesting this power, you may provide both of the following benefits to any that partake in the feast: dispel any magical or psionic effects reducing one of the subject's ability scores, cures 1d4 points of temporary ability damage to one of the subject's ability scores, eliminates fatigue, improves an exhausted condition to fatigued, and attempts to remove any curses currently affecting the creature. You must succeed at a manifester level check against the DC of each curse, with success meaning that the curse is removed.`
  },
  Fettering_the_Shade: {
    name: "Fettering the Shade",
    discipline: "Athanatism",
    level: "Psion/wilder 3",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Item touched",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You force spiritual essence into an object you are touching, granting that object the ghost touch property.

Augment: This power may be augmented in one of the following ways.

• You may spend an additional power point to (if the object is a weapon) grant it one of the following: any one of the +1 weapon special abilities suitable for its weapon type, or a +1 bonus on one type of combat maneuver that can normally be used with that weapon type.

• You may spend an additional 2 power points to (if the object is armor or a shield) grant it any one of the +1 armor or shield special abilities suitable for the object.`
  },
  Floral_Alteration: {
    name: "Floral Alteration",
    discipline: "psychometabolism",
    level: "psion/wilder 3, vitalist 3",
    display: "olfactory",
    manifestingTime: "1 standard action",
    range: "see text",
    target: "",
    area: "",
    duration: "instantaneous",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "5",
    description: `Area or Target: see text

Channeling psionic power through an environment, you stimulate or purge plant life in one of a variety of ways.

Clear Growth : This version of the spell causes normal vegetation within long range (400 feet + 40 feet per level) to shrink to about one-third normal size, becoming untangled and less bushy. The affected vegetation is reduced in size and potency, enabling individuals to travel at normal speeds through an otherwise-overgrown area. This version of floral alteration automatically dispels any spells or effects that enhance plants, such as entangle, wall of thorns, or another floral alteration. At your option, the area can be a 100-foot-radius circle, a 150-foot-radius semicircle, or a 200-foot-radius quarter-circle. You may also designate portions of the area that are not affected.

Enrichment : This effect targets plants within a range of a half-mile, raising their potential productivity over the course of the next year to onethird above normal.

Overgrowth : This effect causes normal vegetation (grasses, briars, bushes, creepers, thistles, trees, vines, and so on) within long range (400 feet + 40 feet per caster level) to become thick and overgrown. The plants entwine to form a thicket or jungle that creatures must hack or force a way through. Speed drops to 5 feet, or 10 feet for Large or larger creatures. The area must have brush and trees in it for this spell to take effect. If this spell is cast on an area that is already affected by any spell or effect that enhances plants, such as entangle or wall of thorns, any DC involved with these spells is increased by 4. This bonus is granted for 1 day after the casting of this spell. At your option, the area can be a 100-foot-radius circle, a 150-foot-radius semicircle, or a 200-foot-radius quarter circle. You may designate places within the area that are not affected.

Stunt Growth : This version of the spell targets all normal plants within a range of 1/2 mile, reducing their potential productivity over the course of the following year to half normal.

Augment: This power can be augmented in one of the following ways

• If you spend 6 additional power points, you may use the enrichment and overgrowth effects of this power on terrain that plant life could not normally grow on, making the area hospitable to plant life and causing the soil to become fertile in addition to causing plant growth. The terrain becomes fertile enough to grow basic crops, enough to feed 1 person/level.

• If you spend 10 additional power points, you may use the stunt growth effect to cause an area to become barren, unable to sustain any sort of plant life and slowly killing any plant life that exists upon it.`
  },
  Follow_the_Strands: {
    name: "Follow the Strands",
    discipline: "Athanatism",
    level: "Conduit 2, psion/wilder 3",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Object or ghost touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3 (conduit), 5 (psion/wilder)",
    description: `You become attuned to the link between a ghost and its important possessions. If you target a ghost with this power, you learn what (if any) objects would be considered important to it, as well as their basic whereabouts. If you target an object with this power, you learn the name, alignment, and general location of a ghost that considers it important (if it is connected to a ghost). In the latter case, the ghost receives a Will save to negate the use of this power on its object. If it fails the Will save, it is not aware that anything has occurred. If the object or ghost is located on another plane, you learn which plane it is on in addition to its location. If more than one ghost considers the object equally important, you gain knowledge on a random one.

Augment: You may spend an additional 4 power points to instead gain knowledge on a living person that considers a targeted object important. If more than one living person considers the object equally important, you gain knowledge on a random one.`
  },
  Fracture_Pattern: {
    name: "Fracture Pattern",
    discipline: "Psychometabolism",
    level: "Cryptic 3 , highlord 3, psion/wilder 3, tactician 3, vitalist 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. plus 10 ft. per level)",
    target: "1 creature or object",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You brutally rewrite the pattern of your target, leaving them vulnerable to further attack. If your target fails its saving throw, choose bludgeoning, cold, fire, electricity, piercing, slashing, or sonic damage. Your victim suffers 50% additional damage from sources that deal damage of the chosen type for the duration of this power.

Augment: You may augment this power in one or both of the following ways.

• For every 2 additional power points you spend, your target suffers 1d6 points of untyped damage as their pattern is violently rent by your will.

• For every 4 additional power points you spend, this power affects an additional target within range.

In addition, for every 2 power points spent on either of the above options, the power's save DC is increased by 1.

Surge Augmentation: If you invoke your wild surge when manifesting this power, the damage dealt by its first augment option is of the type chosen when your victim failed their saving throw (and therefore deals 50% more damage).`
  },
  Guarded_Sleep: {
    name: "Guarded Sleep",
    discipline: "Clairsentience",
    level: "Dread 3, psion/wilder 3, sighted seeker 3, vitalist 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One sleeping creature",
    area: "",
    duration: "Until the target wakes",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You create a temporary dreamstate in the mind of a sleeping creature, sheltering it from outside influence while providing it with a pristine resting environment, ideal for recovering mental energies. For the duration of this power, the subject is immune to all mind-affecting effects and may make saving throws normally (it is not automatically considered “willing” as unconscious creatures usually are).

After a guarded sleep of at least 8 hours, a subject's mind is in top condition, and it gains special benefits based upon its particular abilities. If the target could manifest psionic powers, it gains one temporary power point for each manifester level it has (which it can access as if from a cognizance crystal). If the target could cast arcane spells spontaneously, it gains one additional spell slot of his highest level. If the target prepares arcane spells, it may prepare spells in half the usual amount of time. These benefits fade when the target next sleeps. You cannot manifest guarded sleep on yourself unless you are capable of manifesting powers while unconscious`
  },
  Heightened_Vision: {
    name: "Heightened Vision",
    discipline: "Clairsentience",
    level: "Cryptic 2, gifted blade 2, highlord 2, marksman 3, psion/wilder 3, psychic warrior 2, sighted seeker 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 3, gifted blade 3, highlord 3, marksman 5, psion/wilder 5, psychic warrior 3, sighted seeker 3",
    description: `You increase your visual acuity, gaining the ability to see 60 feet even in total darkness. Your increased vision is black and white only but otherwise like normal sight.

Mythic Heightened Vision[]

The range of the darkvision is increased to 120 feet, and this range stacks with any existing darkvision you possess. In addition, you can see through up to 10 feet plus 5 feet per mythic tier of magical darkness.

Augmented (3rd): If you expend two uses of mythic power, the range of the target's mythic heightened vision becomes equal to the target's line of sight.`
  },
  Id_Autopilot: {
    name: "Id Autopilot",
    discipline: "psychokinesis",
    level: "cryptic 3, dread 3, highlord 3, psion/wilder 3, psychic warrior 3, tactician 3, voyager 3",
    display: "auditory",
    manifestingTime: "1 standard action",
    range: "close (25 ft + 5 ft./level)",
    target: "1 vehicle or mech",
    area: "",
    duration: "Concentration",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Extending your consciousness into a vehicle, you command the machine to move automatically without a physical driver. While you concentrate, you may allow the vehicle or mech to make a full round's worth of actions. The mech or vehicle may not make attacks or combat maneuvers but may otherwise perform any other actions that a creature would normally be capable of.

Augment: This power may be augmented in the following ways:

• For every 4 additional power points you spend, you may use this power to control one additional vehicle at the same time.

• By spending 4 additional power points, you may allow a vehicle or mech under your control to make attacks or combat maneuvers.`
  },
  Lift: {
    name: "Lift",
    discipline: "Psychoportation",
    level: "Cryptic 3, psion/wilder 3",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One Medium or smaller creature",
    area: "",
    duration: "Concentration up to 1 round/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `With a mental thrust you fling your foe upwards then suspend them there. When you manifest lift , you cause a target to float unnaturally five feet above the ground. This typically prevents them from moving though creatures which can fly are unaffected by lift . Additionally, a creature that is able to react walls, items, or creatures nearby may be able to push themselves horizontally. This requires deliberate intent, so a target creature kicking or punching an adjacent foe does not float away unexpectedly.

This power is inherently stable and being suspended in midair does not impose any penalty on actions the target creature might undertake excepting movement. Each round at the end of its turn, the target creature makes an additional save at the original DC of this power to terminate its effects.

Mythic Lift

You may manifest mythic lift on one creature per mythic tier you possess, but no two creatures may be more than 15 feet apart from one another.`
  },
  Living_Haunter: {
    name: "Living Haunter",
    discipline: "Athanatism [spirit]",
    level: "Dread 3, psion/wilder 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "100 sq. ft./level (S)",
    duration: "1 round/level (D)",
    savingThrow: "None and Will negates; see text; Power",
    powerResistance: "",
    powerPoints: "5",
    description: `Resistance: No and yes; see text

You haunt an area by binding your soul to it. When you manifest this power, your soul leaves your body - you count as both unconscious and helpless, but you are also immune to mind-affecting effects. While this power is active, you may spend a standard action each turn to do one of the following.

Animate: You may animate a Small or smaller object within the area as the control object power . If you do not maintain this effect as a standard action, this animation ends.

Hallucinations: You create vivid hallucinations, creating the visual illusion of an object, creature, or force, as visualized by you. You may also create sounds, but not coherent speech. You can move the image within the limits of the size of the effect whenever you maintain this effect as a standard action. If you do not maintain this effect as a standard action, this effect ends.

Movement: You may alter the speed of any single creature in the area of this power. If you choose to accelerate them, they gain a +1 bonus on attack rolls, a +1 dodge bonus to AC, an increase in all modes of movement of 30 feet (to a maximum of twice the subject's normal speed using that mode), and an additional attack with a natural or manufactured weapon whenever the subject makes a full attack action, using the subject's full base attack bonus and other applicable modifiers. This effect is not cumulative with similar effects, such as haste or a speed weapon. If you choose to decelerate them, they are staggered, may take only a single move action or standard action each turn, take a -1 penalty on attack rolls, AC, and Reflex saves, and move at half their normal speed. If you do not maintain this effect as a standard action, this effect ends. A creature targeted by this use may attempt a Will save to resist it (power resistance applies).

Augment: You may augment this power in one of the following ways.

• For every additional power point you spend, you may target one additional creature with the movement ability of this power.

• By spending an additional 4 power points, you may include full sound, smell, and thermal elements with the hallucinations ability of this power.

• For every 2 additional power points you spend, you can animate one additional Small object with the animate ability of this power. You may instead animate fewer, larger objects, as per control object.

• By spending an additional 6 power points, increase the duration of this power to 1 min./level.

If you spend at least 6 power points augmenting this power, you may sustain any of its effects as a move action, instead of a standard. This allows you to maintain more than one effect each turn.`
  },
  Malefic_Metamorphosis: {
    name: "Malefic Metamorphosis",
    discipline: "Psychometabolism",
    level: "Psion/Wilder 3, Vitalist 3",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "1 creature",
    area: "",
    duration: "permanent",
    savingThrow: "Fortitude Negates",
    powerResistance: "yes",
    powerPoints: "5",
    description: `While enhancing one's abilities with psychometabolic power is difficult, inhibiting those of an opponent are a technique that many find easier to gain a grasp upon. On a failed Fortitude save, the target creature is affected by one of the following penalties

• A -6 penalty to one ability score

• Size is decreased by up to 2 size categories

• Target loses use of a limb. If this limb is a leg, fin, wing or other method of mobility, the target's speed that uses that limb is halved. If it loses all such limbs, it cannot use that method of movement. If this limb is an arm, the target loses the ability to manipulate anything (including weapons) with that arm. If all arms are disabled in this way, the target cannot apply somatic components to spells.

• The target becomes blind or deaf, as chosen by the manifester.

• The target's natural armor decreases by 3 (minimum 0)

• The target's damage reduction is reduced by 5 (minimum 0)

• Any regeneration or fast healing the target possesses is reduced by 5 (minimum 0). If the target's regeneration cannot be bypassed, it cannot be reduced below 1.

• The target's fly maneuverability is reduced by 2 steps. If it would go below poor, the target loses the ability to fly.

• The target takes a -4 penalty on all attack rolls, skill checks, ability checks, and saving throws

• Each turn, the target has a 50% chance to act normally; otherwise, it takes no action. This ability can only be selected up to twice. The second time, it causes the target to only have a 25% chance of acting normally

This power cannot be dispelled normally, but any effect that would remove ability damage is capable of removing the effects of this power.

Augment

• For every 4 additional power points you spend, you may select another effect to apply to a creature. The same effect can be applied any number of times unless stated otherwise.

• If you spend 2 additional power points, the range increases from touch to close (25 feet + 5 feet/level). For every 2 points you spend on top of this, you may select an additional target within range.

• If you spend 4 additional power points, you gain the ability to affect a creature with multiple manifestations of this power.

• For every 2 power points you spend augmenting this power (including as part of other augments), the save DC increases by 1.`
  },
  Mental_Barrier: {
    name: "Mental Barrier",
    discipline: "Clairsentience",
    level: "Dread 3, gambler 3, gifted blade 3, highlord 3, psion/wilder 3, psychic warrior 3, sighted seeker 3",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You project a field of improbability around yourself, creating a fleeting protective shell. You gain a +4 deflection bonus to Armor Class.

You can use this power even when it's not your turn; however, you must manifest it prior to an opponent's attack roll in order to gain this power's benefit against that attack.

Augment: You can augment this power in one or both of the following ways.

• If you spend 4 additional power points, the deflection bonus to Armor Class increases by 1.

• For every additional power point you spend, this power's duration increases by 1 round.

Mythic Mental Barrier[]

The deflection bonus is increased by 50% (round down) and also applies to Reflex saving throws.

Augmented: If you expend one use of mythic power, you can manifest this power even after an opponent has made its attack roll and still gain the benefits against that attack.`
  },
  Mind_Over_the_Immaterial: {
    name: "Mind Over the Immaterial",
    discipline: "Athanatism",
    level: "Dread 3, psion/wilder 3",
    display: "Auditory and olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One incorporeal creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Your mastery of the immaterial weakens the mind of those once protected by it. The target loses any immunity it has to mind-affecting effects, spells, and powers. However, it gains a +4 inherent bonus on saves against mind-affecting effects not created by you.

Augment: By spending an additional 4 power points, you can manifest this power as a swift action.`
  },
  Mindhunter: {
    name: "Mindhunter",
    discipline: "Clairsentience",
    level: "Dread 3, psion/wilder 3, sighted seeker 3, voyager 3",
    display: "Mental",
    manifestingTime: "8 hours",
    range: "One plane",
    target: "One creature on the same plane",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5",
    description: `When you go to sleep, you psionically split your subconscious mind from your body sending it out to search for another person's subconscious. If the creature is intelligent and not immune to mind-affecting powers, the subconscious mind tracks it down and returns with the information by the time you wake up. If you wake before 8 hours have passed, the power fails as the subconscious mind is violently forced back into your consciousness once again.

When you manifest this power, you gain a general knowledge of where the target person resides if they are on the same plane. You are granted a general overview of the surroundings and a rough estimate of where they are from your current position such as “in a wood 20 miles to the northwest”.

Note that the power points spent while dreaming do not regenerate during this time and thus you awaken with less than your maximum power points.

You must be able to form a mental picture of the target, either through direct personal knowledge, from a picture or portrait, or from a description of the person, in order to use this power.`
  },
  Moan_of_the_Sorrowful_Dead: {
    name: "Moan of the Sorrowful Dead",
    discipline: "Athanatism [emotion, fear, mind-affecting]",
    level: "Dread 2, highlord 3, psion/wilder 3, psychic warrior 3",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "10-ft.-radius spread",
    duration: "1 round/level",
    savingThrow: "Will partial",
    powerResistance: "Yes",
    powerPoints: "3 (dread), 5 (highlord, psion/wilder, psychic warrior)",
    description: `The sounds of the tortured dead cause each living creature in the area to become frightened unless it succeeds on a Will save. Upon success, the creature is shaken for 1 round.

Augment: This power may be augmented in one of the following ways.

• By spending an additional 4 power points, any target that fails its Will save is panicked instead of frightened.

• You may spend an additional 4 power points to have any target that succeeds on its Will save be shaken for an additional round.

• For every 4 additional power points you spend, you increase the radius of this power by 5 feet.

In addition, for every two power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Obsession: {
    name: "Obsession",
    discipline: "Telepathy (Mind-affecting)",
    level: "Psion/Wilder 3",
    display: "Auditory and Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Placing an overwhelming compulsion in the target's mind, you guide them towards a certain mission, object, or entity. If the target of the creature's obsession is an object, place, or creature, the creature will pursue that entity and not allow it to leave their sight, resisting violently if they are forcibly separated. If the target of the creature's obsession is an objective or quest, they will work ardently to complete that objective so long as they remain affected by this power. This power does not cause the creature to perform any actions that would be suicidal or otherwise heavily detrimental to itself (killing a powerful ally is normally considered detrimental in this manner, but sabotaging their weapon or otherwise interfering with their activity would not). However, the creature takes a -2 penalty on all attack rolls, skill checks, and saving throws when acting in opposition to their obsession.

When you manifest this power, you may choose to have instill it with either loving or hateful emotions. If the target's obsession is fueled by love, it will try to safeguard and protect the target of its obsession however it can. If the target is fueled by hateful emotions, it will do everything in its power to inhibit or interfere with the target of its obsession. You have no special influence over a creature affected by this power, but this effect may cause a target to do things that would normally be out of its nature.

Augment

• If you spend 4 additional power points, this power's duration increases to 1 day/level.

• If you spend 4 additional power points, the penalty from this power becomes more severe. For every hour that the target spends acting against its obsession (or for every day, if the duration of the power is 1 day/level), the target takes 2 points of wisdom damage. This damage can be healed by acting in accordance with the obsession in a major way (such as finding the item you are obsessed with or grievously harming the reputation of someone you hate) or by acting on the obsession for at least 10 minutes.`
  },
  Occultation_Myra_s: {
    name: "Occultation, Myra's",
    discipline: "Telepathy [mind-affecting]",
    level: "cryptic 2, dread 2, highlord 3, psion/wilder 3, tactician 3",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "None Power Resistance No",
    powerResistance: "",
    powerPoints: "cryptic 3, dread 3, highlord 5, psion/wilder 5, tactician 5",
    description: `You distort the way others perceive and remember you, making it hard for creatures to recall knowledge of you and your kind. Creatures attempting Knowledge checks to identify you and your traits (such as abilities or weaknesses) suffer a -4 penalty to do so. This does not affect Knowledge checks made to research you or information related to you (such as at a public library) or other forms of information-gathering related to you (such as Sense Motive or Diplomacy checks). Creatures that fail Knowledge checks to identify you and your traits learn false information instead of learning nothing.

Augment: You may augment this power in the following ways:

• For every additional power point you spend, the penalty to Knowledge checks increases by 2.

• If you spend 2 additional power points, you may determine the form of misinformation learned by creatures failing their Knowledge checks.`
  },
  Phantasmagoria: {
    name: "Phantasmagoria",
    discipline: "Athanatism [mind-affecting, fear]",
    level: "Dread 3, psion/wilder 3",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "One 10-ft. cube/level (S)",
    duration: "10 min./level (D); see text",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You draw on ghostly essences to cause horrific apparent changes to take place in the environment, such as people appearing dead or rotting, walls peeling or bleeding, and food decaying. This power has different effects based on how close creatures are to the affected area. Multiple effects stack - for example, if a creature is inside the area, they are also affected as if they were within 30 feet, 10 feet, and inside the area. If a creature would be affected by more than one if the following effects, it makes saves against each effect separately, in order.

Within 30 feet: Creatures within 30 feet of the affected area must succeed at a Will save or suffer a -2 penalty on saves against any of your other mind-affecting powers for as long as they remain within 30 feet of the affected area, and one minute thereafter.

Within 10 feet: Creatures within 10 feet of the affected area must succeed at a Will save or become shaken for as long as they remain within 10 feet of the affected area, and one minute thereafter.

Inside: Creatures that are inside the affected area must succeed at a Will save or be frightened for as long as they remain within the affected area, and 5 rounds thereafter.

Augment: By spending an additional 6 power points, all creatures within the area that fail their save also become confused for as long as they remain within the affected area.`
  },
  Psionic_Blast_Quas_thelin_s: {
    name: "Psionic Blast, Quas'thelin's",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 3, psion/wilder 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft. cone-shaped burst",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `The air ripples with the force of your mental attack, which blasts the minds of all creatures in range. Psionic blast stuns all affected creatures for 1 round.

Augment: For every 2 additional power points you spend, the duration of the stun effect increases by 1 round and the power's save DC increases by 1.`
  },
  Reconfiguration: {
    name: "Reconfiguration",
    discipline: "metacreativity",
    level: "cryptic 3, dread 3, highlord 3, psion/wilder 3, psychic warrior 3, tactician 3, vitalist 3, voyager 3",
    display: "auditory, visual",
    manifestingTime: "1 standard action",
    range: "medium (100 ft + 10 ft./level)",
    target: "one mecha",
    area: "",
    duration: "1 minute/level",
    savingThrow: "Fortitude negates; Power",
    powerResistance: "",
    powerPoints: "5",
    description: `Resistance: yes

With a sudden surge of psionic power, you substantially alter the functionality of a mecha. The targeted mecha immediately gains or loses one mech enhancement chosen by you. If a pilot is currently inside the mech, this change cannot completely prevent the pilot from piloting the mech (such as by reducing the mech's size so that it is too small to fit the pilot).

Augment: This power can be augmented in the following ways:

• For every 4 additional power points you spend, you may add or remove one additional Mech Enhancement from the target mecha.

• For every 2 additional power points you spend, you may affect one additional mech within range. Different enhancements may be applied or removed from different mecha.

• By spending 2 additional power points, you may use this power to add mech enhancements to a non-mech target. You may not use this power to remove enhancements from such a creature unless it is benefitting from enhancements given by another instance of this power being manifested.

• For every 2 additional power points you spend, including those spent as part of other augments, increase the save DC by 1`
  },
  Release_Death_s_Hold: {
    name: "Release Death's Hold",
    discipline: "Athanatism",
    level: "Psion/wilder 3",
    display: "Mental and olfactory",
    manifestingTime: "5 minutes",
    range: "Touch",
    target: "One undead creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You temporarily infuse an undead creature with life energy. The undead creature touched must succeed at a Will save or it becomes infused with life, no longer undead. The target loses the undead type (do not change its HD, skills, or saves), regaining whatever its type was in life (if its original type is uncertain, it instead becomes a magical beast). Its Constitution score becomes 10 temporarily, but it continues to use Charisma to determine hit points and bonus added to Fortitude saves. If it was mindless, it remains mindless. It also loses all undead immunities, channel resistance, and any energy drain abilities it may have possessed. If it was incorporeal, it loses the incorporeal subtype and grows a temporary body similar to the one it had in life, except that it has a Strength score of 10. It also becomes sensitive to pain. Whenever is suffers an amount of damage equal to or greater than its HD, it must succeed at a Will save or become sickened for one round.

Augment: By spending an additional 6 power points and expending your psionic focus, you may allow this power to become contagious. The next undead creature that the target touches is subjected to a second manifestation of this power, including all augments and other enhancements. This second manifestation costs you no additional power points and does not require you to expend your psionic focus.

Special: If this power is manifested on a willing target, the duration becomes 10 min./level and they do not suffer the sensitivity to pain.`
  },
  Respite_of_Sanity: {
    name: "Respite of Sanity",
    discipline: "Telepathy [mind-affecting, network]",
    level: "Highlord 3, Psion/Wilder 3, Tactician 3, Vitalist 3",
    display: "Visual, Material",
    manifestingTime: "1 standard action",
    range: "Close (25 feet + 5 feet/level)",
    target: "1 creature",
    area: "",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "5",
    description: `You ease the mind of the target, suppressing the madness that lurks in their mind temporarily. While under the effects of this power, the target ignores the effects of one madness or mind-affecting effect that is affecting them. The effect resumes when the power's duration expires.

Augment

• For every 2 additional power points you spend, you can negate an additional effect on the target

• If you spend 6 additional power points, you may cause the target to become immune to sanity damage for the duration of this power.`
  },
  Sanguine_Displacement: {
    name: "Sanguine Displacement",
    discipline: "Psychoportation",
    level: "Dread 3, psion/wilder 3, vitalist 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. plus 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude partial",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You teleport blood and vital fluids from your target's body. The target suffers 1d4 points of Constitution damage (save for half). If you feed on blood or life force (such as if you are a vampire or a wight), you may teleport the removed fluids into your own body, gaining 3 temporary hit points per point of Constitution damage dealt by this power; these do not stack with other uses of this power, and last for up to 1 hour. These temporary hit points may be used to satisfy feeding requirements, if applicable.

Augment: For every 4 power points you spend, the damage of this power increases by one die (d4) and its save DC is increased by 2.`
  },
  Shade_Venom: {
    name: "Shade Venom",
    discipline: "Athanatism",
    level: "Cryptic 3, gifted blade 3, highlord 3, psion/wilder 3, psychic warrior 3",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One dose of poison or poisonous natural weapon touched",
    area: "",
    duration: "1 min./level",
    savingThrow: "Fortitude negates (harmless); Power",
    powerResistance: "",
    powerPoints: "5",
    description: `Resistance: Yes (harmless)

You enhance a poison so that it can affect even the immaterial. The target can poison incorporeal creatures as if they possessed no immunity or resistance, substituting a Will save for the normal Fortitude save of the poison.

Augment: For every 2 additional power points spent, you increase the save DC of the target by 1 against incorporeal creatures.`
  },
  Share_Pain_Forced: {
    name: "Share Pain, Forced",
    discipline: "Psychometabolism",
    level: "Gambler 3, highlord 3, psion/wilder 3, tactician 3, vitalist 3",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Share Pain[]

Targets: You and one willing creature, or two willing creatures; see text

This power creates a psychometabolic connection between you and a willing subject so that some of your wounds are transferred to the subject. You take half damage from all attacks that deal hit point damage to you, and the subject takes the remainder. If your hit points are reduced by a lowered Constitution score, that reduction is not shared with the subject because it is not a form of hit point damage. When this power ends, subsequent damage is no longer divided between the subject and you, but damage already shared is not reassigned.

If you and the subject move farther away from each other than close range, the power ends.

You can manifest this power on two willing subjects, one of which you designate to share its damage with the other.

Share Pain, Forced[]

As share pain , except as noted here.

You attempt to force the sharing of your wounds with an unwilling creature for less time. If you are immune to the type of damage dealt, or if you convert lethal damage into nonlethal, the target takes no damage.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Sharpened_Edge: {
    name: "Sharpened Edge",
    discipline: "Metacreativity",
    level: "Cryptic 3, gifted blade 3, highlord 3, marksman 4, psion/wilder 3, psychic warrior 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "10 min./level",
    savingThrow: "Will negates (harmless, object); Power Resistance: Yes (harmless, object)",
    powerResistance: "",
    powerPoints: "Cryptic 5, gifted blade 5, highlord 5, marksman 7, psion/wilder 5, psychic warrior 5",
    description: `Targets: One weapon or fifty projectiles, all of which must be in contact with each other at the time of manifestation

You psionically make a weapon keen, improving its ability to deal telling blows. This doubles the threat range of the weapon. A threat range of 20 becomes 19-20, a threat range of 19-20 becomes 17-20, and a threat range of 18-20 becomes 15-20. The power can be manifested only on piercing or slashing weapons. If used on arrows or crossbow bolts, the effect on a particular projectile ends after one use, whether or not the missile strikes its intended target. Treat shuriken as arrows, rather than as thrown weapons, for the purpose of this power.

Multiple effects that increase a weapon's threat range (such as the keen special weapon property and the Improved Critical feat) don't stack. You can't manifest this power on a natural weapon, such as a claw.`
  },
  Short_Circuit: {
    name: "Short Circuit",
    discipline: "psychokinesis",
    level: "cryptic 3, dread 3, gambler 3, gifted blade 3, highlord 3, psion/wilder 3, psychic warrior 3, tactician 3, voyager 3",
    display: "visual",
    manifestingTime: "1 standard action",
    range: "medium (100 ft. + 10 ft./level)",
    target: "one creature or technological object, or 20- foot radius burst (see text)",
    area: "",
    duration: "instantaneous, see text",
    savingThrow: "Fortitude negates; Power",
    powerResistance: "",
    powerPoints: "5",
    description: `Resistance: no

A machine or component finds itself forcibly stripped of all mechanical function, unable to operate properly, if at all. If this power targets an object with charges, the object loses all of its remaining charges. If the object is powered by electrical means other than charges, its functions are suppressed for 1d4 rounds. If this power targets a creature not of the robot subtype, it affects a random charged or electrically powered item in that creature's possession. If the target is a robot, the robot is staggered for 1 round/ level and cannot use any energy-based attacks for that duration.

Augment: This power can be augmented in the following ways:

• If you spend an additional 6 power points, the targeted short circuit can shut down one technological effect for every four manifester levels you possess.

• If you spend an additional 6 power points, you may choose to cause an area short circuit instead of a targeted short circuit. All creatures within the area must make a fortitude save or have one of their technological items depowered in the manner described above. This also applies to ongoing technological effects that exist outside the area but are operating within it.

• For every 2 additional power points you spend, including as part of augmenting this power, the DC of this power increases by 1.`
  },
  Solicit_Psicrystal: {
    name: "Solicit Psicrystal",
    discipline: "Telepathy",
    level: "Gambler 3, highlord 3, psion/wilder 3, tactician 3, vitalist 3",
    display: "Auditory",
    manifestingTime: "1 swift action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Your psicrystal",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "No",
    powerResistance: "No",
    powerPoints: "5",
    description: `Your psicrystal takes over the responsibility of maintaining concentration on any single power you have manifested and are concentrating on. While maintaining this concentration, the psicrystal is limited to move actions in each round, as normal, unless the maintaining concentration on the power would not allow a move action. When the duration of solicit psicrystal expires, the power you transferred to the psicrystal ends (even if this would mean that the power ends earlier than normal). If necessary, the psicrystal makes concentration checks using your modifier.

You can manifest this power (and transfer the responsibility) with an instant thought, quickly enough to gain the benefit of the power before you take any other actions in a round.

Augment: For every additional power point you spend, this power's maximum duration increases by 1 round.`
  },
  Spasm: {
    name: "Spasm",
    discipline: "Psychometabolism OR telepathy (mind-affecting)",
    level: "Cryptic 3, dread 3, psion/wilder 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude OR Will (see text)",
    powerResistance: "No",
    powerPoints: "5",
    description: `If the target fails its saving throw (Fortitude if this is a psychometabolism power, Will if this is a telepathy power), they begin to spasm uncontrollably, hurting themselves and making movement hard. The target takes 5d6 damage from their spasms, and during their next turn, their speed is halved.

If the target succeeds on their save, they take a -1 penalty to their next d20 roll and a 5 foot penalty to their speed as the focus required to keep their body from spasming distracts them.

Augment: This power may be augmented in one or more of the following ways.

• For every 1 power point you spend on augmenting this power, it deals 1d6 more damage.

• For every 2 additional power points you spend, you can choose another target.

• If you spend 2 additional power points, the range becomes Medium (100 ft. + 10ft/lvl.).

For every 2 power points spent on the above augments, increase the save DC by 1`
  },
  Spiritual_Resting_Place: {
    name: "Spiritual Resting Place",
    discipline: "Athanatism",
    level: "Highlord 3, psion/wilder 3, tactician 3",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Yourself and one willing creature touched/level",
    area: "",
    duration: "2 hours/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5",
    description: `You and the willing creatures you touch are transported to the Ethereal Plane, where you are contained within a impenetrable, transparent, 20 ft. radius dome. This dome is a force effect, and no effects or attacks can travel through it in either direction (though it can be seen through in either direction, and does not hinder sound). You do not have to remain touching the targets while the power is active. When this power ends, you and the creatures you brought with you are returned to the area you were in when this power was manifested.

Augment: You may augment this power in one of the following ways.

• By spending an additional 4 power points, you may instead target yourself and two willing creatures touched/level.

• By spending an additional 2 power points, you may send only the willing creatures touched, excluding yourself.

• By spending an additional 10 power points, you may instead send one unwilling creature touched. This creature receives no save, but may resist with power resistance as normal. When augmented this way, this power has a duration of 10 minutes. A creature targeted by this power may take a full-round action to end this power by succeeding at a DC 20 Charisma check.`
  },
  Tactical_Suppression: {
    name: "Tactical Suppression",
    discipline: "Telepathy (mind-affecting) (network)",
    level: "Cryptic 3, Dread 3, Highlord 3, Psion/Wilder 3, Psychic Warrior 3, Tactician 3, Vitalist 3",
    display: "Mental and Olfactory",
    manifestingTime: "standard action",
    range: "Close (25 feet + 5 feet/2 levels)",
    target: "1 creature",
    area: "",
    duration: "1 minute/level",
    savingThrow: "will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Forcing your will on an opponent, you mentally block one of their abilities from use. When you manifest this power, choose one feat, power, or skill. On a failed save, the target may not use that selected ability for the duration of this power, nor any abilities that require it as a prerequisite (if a skill is selected, treat the target as if they had no ranks in that skill). This power does not give you knowledge of what feats, powers, or skills that the target possesses; if you choose to suppress an ability that the creature does not have, the effect is wasted.

Augment

• For every 2 additional power points you spend, you may select another target within 15 feet of the original target and may suppress one additional ability that each target possesses. You may suppress different abilities for each target.

• If you spend 6 additional power points, you learn what powers, skills, and feats the target possesses once they fail their Will save. You may then choose which abilities to suppress from those that you know the target has.

• If you spend 6 additional power points, you gain the benefits of any feats or skills that you suppress, as well as the ability to manifest any powers you suppress, for the duration of this power.

• For every 2 power points you spend augmenting this power (including as part of other augmentations), the save DC increases by 1.`
  },
  Telekinetic_Force: {
    name: "Telekinetic Force",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 3, psion/wilder 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Concentration, up to 1 round/level, or Instantaneous; see text",
    savingThrow: "Will negates (object)",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `Target or Targets: One or more objects or creatures with a total weight of 250 lb. or less

You can use this power in one of two ways:

Move: You move an object, or even a creature, by concentrating your mind upon its current location and then the location you desire, creating a sustained force. You can move an object weighing no more than 250 pounds up to 20 feet per round. A creature can negate the effect on an object it possesses or itself with a successful Will save or with power resistance. The weight can be moved across the ground or through the air. This power ends if the object is forced out of range. If you cease concentration, the object falls or stops.

You can drop a weight and pick up another during the power's duration, as long as you don't stop concentrating on maintaining the power. An object can be telekinetically manipulated as if you were moving it with one hand.

If you spend at least 5 rounds concentrating on an unattended object, you can attempt to break or burst it as if making a Strength check, except that you apply your key ability modifier to the check instead of your Strength modifier.

If a creature succeeds on its Will save against this effect, either to prevent you moving the creature or an object in its possession, you cannot target another item in that creature's possession nor the creature itself unless you manifest the power again. If the creature fails its Will save, it may still take its normal actions, except it cannot move from its current location.

Thrust: You can affect one or more objects or creatures by concentrating your mind upon, sending them in a deadly hail at your foes—or simply by hurling your foe! You can hurl one object or creature per manifester level (maximum fifteen separate targets), as long as all are within the power's range and each is no more than 10 feet away from another one. Each object or creature can be hurled a maximum distance of 10 feet per level.

You must succeed on ranged attack rolls (one per creature or object thrown) to hit the target of the hurled items with the items, applying your key ability modifier to the attack roll instead of your Dexterity modifier. Hurled weapons deal their standard damage (your Strength bonus does not apply; arrows or bolts deal damage as daggers of their size when used in this manner). Other objects deal damage ranging from 1 point per 25 pounds of weight (for less dangerous objects such as an empty barrel) to 1d6 points per 25 pounds of weight (for hard, dense objects such as a boulder).

Creatures are allowed Will saves (and power resistance) to negate the effect, as are those whose held possessions are targeted by this power. Creatures are not allowed a Will save if an object is thrust at them through the use of this power.

If you use this power to hurl a creature against a solid surface, it takes damage as if it had fallen 10 feet (1d6 points). If you use the thrust option of this power, the duration is instantaneous.

Augment: For every additional power point you spend, the weight limit of the target increases by 25 pounds.`
  },
  Time_Hop: {
    name: "Time Hop",
    discipline: "Psychoportation",
    level: "Nomad 8",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Up to 1 hour/level; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `Time Hop[]

Targets: One Medium or smaller creature, or one object weighing 300 lb. or less

The subject of the power hops forward in time 1 round for every manifester level you have. In effect, the subject seems to disappear in a shimmer of silver energy, then reappear after the duration of this power expires. The subject reappears in exactly the same orientation and condition as before. From the subject's point of view, no time has passed at all.

In each round of the power's duration, on what would have been the subject's turn, it can attempt a DC 15 Wisdom check. Success allows the subject to return. The subject can act normally on its next turn after this power ends.

If the space from which the subject departed is occupied upon his return to the time stream, he appears in the closest unoccupied space, still in his original orientation. Determine the closest space randomly if necessary.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, you can affect a creature of one size category larger, or double the weight of an object to be affected.

• For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Time Hop, Mass[]

Targets: All willing creatures in range

As time hop , except you can affect any number of willing subjects in range, including yourself. You can choose which creatures are affected by the power. The subjects hop forward in time a number of hours equal to your manifester level, or some shorter number of hours; you decide how many hours the mass time hop lasts when you manifest the power.

Augment: If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Tormenting_the_Dead: {
    name: "Tormenting the Dead",
    discipline: "Athanatism",
    level: "Gifted blade 3, highlord 3, psion/wilder 3, psychic warrior 3",
    display: "Auditory and olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One incorporeal creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude half",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You summon ethereal implements to lash and torment the incorporeal. This power deals 5d8 damage to the target; this damage is not reduced by the incorporeal trait.

Augment: This power may be augmented in one of the following ways.

• For every one additional power point you spend, the power deals an additional 1d8 damage.

• By spending an additional 4 power points, you may wrack all targets hit with pain. If they fail the Fortitude save, they are also sickened for 1d6 rounds. This special use of the sickened condition affects incorporeal undead normally, regardless of any immunity they may have.

• By spending an additional 4 power points, this power affects all incorporeal creatures in a 20-ft.-radius spread, instead of only a single target.

In addition, for every 2 power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Touchsight: {
    name: "Touchsight",
    discipline: "Psychometabolism",
    level: "Gambler 3, marksman 3, psion/wilder 3, voyager 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal; see text",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You generate a subtle telekinetic field of mental contact, allowing you to “feel” your surroundings even in total darkness or when your sight would otherwise be obscured by your physical environment. Your touchsight field emanates from you out to 60 feet. You ignore invisibility, darkness, and concealment, though you must have line of effect to a creature or an object to discern it. You do not need to make Perception checks to notice creatures; you can detect and pinpoint all creatures within 60 feet. In many circumstances, comparing your regular senses to what you learn with touchsight is enough to tell you the difference between visible, invisible, hiding, and concealed creatures.

Augment: For every 2 additional power points you spend, the radius of your touchsight field increases by 10 feet.`
  },
  Ubiquitous_Vision: {
    name: "Ubiquitous Vision",
    discipline: "Clairsentience",
    level: "Cryptic 3, gambler 3, gifted blade 3, highlord 3, marksman 3, psion/wilder 3, psychic warrior 3, sighted seeker 3, voyager 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You have metaphoric “eyes in the back of your head,” and on the sides and top as well, granting you benefits in specific situations. In effect, you have a 360-degree sphere of sight, allowing you a perfect view of creatures that might otherwise flank you. Thus, flanking opponents gain no bonus on their attack rolls, and rogues are denied their sneak attack ability while flanking you (but they may still sneak attack you if you are caught flat-footed). Your vision-based Perception checks gain a +4 enhancement bonus. Concurrently, you take a -4 penalty on saves against all gaze attacks during the power's duration.`
  },
  Volatile_Rejection: {
    name: "Volatile Rejection",
    discipline: "Athanatism",
    level: "Psion/wilder 3, vitalist 3",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One possessed creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You force out any entity possessing the target creature. The possessing entity must succeed at a Will saving throw or suffer 3d6 points of damage and be immediately expelled, ending the possession. This damage is not reduced by the incorporeal trait as normal.

Augment: This power may be augmented in one of the following ways.

• For every 2 additional power points spent, this power's damage against the possessing entity increases by one die (d6).

• By spending 4 additional power points, this power also deals half its damage (round down) to the possessed creature.

In addition, for every two power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Augured_Answer: {
    name: "Augured Answer",
    discipline: "Clairsentience",
    level: "Psion/wilder 4, sighted seeker 4, voyager 4",
    display: "Mental and visual",
    manifestingTime: "10 minutes",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You can predict a useful piece of advice in reply to a question concerning a specific goal, event, or activity that is to occur within 1 week. The advice augured can be as simple as a short phrase, or it might take the form of a cryptic rhyme or omen. If your party doesn't act on the information, the conditions may change so that the information is no longer useful. The base chance for a correct answer is 70% + 1% per manifester level, to a maximum of 90%. If the die roll fails, you know the attempt failed, unless specific effects yielding false information are at work.

Multiple attempts about the same topic by the same manifester use the same dice result as the first attempt and yield the same answer each time.

Augured Answer (Mythic)[]

Add twice your mythic tier to the percentage chance of receiving a correct answer. In addition, if an answer indicates that an action will likely lead to an outcome that is both harmful and beneficial, you gain a sense for the relative degree of danger or benefit likely to occur.`
  },
  Aura_Sight: {
    name: "Aura Sight",
    discipline: "Clairsentience",
    level: "Dread 4, gambler 4, marksman 4, psion/wilder 4, sighted seeker 4, voyager 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped emanation centered on you",
    duration: "Concentration, up to 10 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `You discern auras. Auras are invisible to the naked eye, but to a psionic viewer manifesting this power they appear as glowing halos or envelopes of colored light that surround all objects. The color of each aura reveals information to the psionic character. The amount of information revealed depends on how long you study a particular area.

1st Round: Presence of good and evil auras in the area. You can't pin an aura to a particular object or individual at this stage; instead, you see a colored haze suffusing the area. (This power can detect lawful and chaotic auras as well, but doing so requires a separate manifestation that focuses only on that alignment axis.)

2nd Round: Number of auras (creatures, objects, powers, or spells) in the area. You know how many auras are in the area, even though each aura doesn't resolve to its actual location quite yet.

3rd Round: The owner of each aura is revealed, unless the individual is outside your line of sight. If a creature whose aura you detect has 5 or more Hit Dice than you do, you are overwhelmed by its presence and dazed for 1 round, and the power ends.

Augment: For every 2 additional power points you spend, this power's range increases by 5 feet.

Aura Sight (Mythic)[]

You can cease concentrating on the power without ending the effect. It provides no information when you are not concentrating on it, but you can resume and cease concentrating again to use its effects any number of times within the power's duration. On the third round of detection, you can determine whether the alignment aura is from an aligned magic item; aligned power; aligned undead, outsider; cleric, paladin, or antipaladin of an aligned deity, or other character class or type with an aura class feature; or other type of aligned creature. You can detect alignment auras protected by effects that block clairsentience with a manifester level check with a DC of 11 plus the manifester level of the effect, or through lead sheeting with a DC 20 manifester level check, plus 5 per inch of thickness. You can penetrate 3 feet of wood or dirt, 1 foot of stone, or 1 inch of common metal with a DC 15 manifester level check, plus 5 for each multiple of that thickness. If the substance or effect blocking your power is not mythic, or if it already allows a manifester level check or saving throw to penetrate its protection, add your mythic tier on your manifester level check or saving throw.

Augmented: If you expend two uses of mythic  power, any overwhelming auras of the appropriate alignments within the area become clearly visible to everyone at the beginning of your turn on the first round you scan an area. Strong auras become clearly visible at the end of your turn on the first round you concentrate on an area, moderate auras at the end of the second round, and faint auras at the end of the third round. Auras on creatures, objects, or areas that are invisible are also invisible, and you cannot see auras to which you have no line of sight even if you are able to detect their strength and location.`
  },
  Aura_of_Decay: {
    name: "Aura of Decay",
    discipline: "Athanatism",
    level: "Psion/wilder 4, vitalist 4",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Object touched",
    target: "",
    area: "40-ft. radius emanating from the touched object",
    duration: "2 hours/level",
    savingThrow: "Will negates",
    powerResistance: "no",
    powerPoints: "7",
    description: `You deeply infuse one object with the power of decay. Creatures in the area of this power must succeed on a Will save or suffer a -2 penalty on saving throws against ghost special attacks (such as malevolence, corrupting gaze, etc.). This penalty increases by one for each hour that they remain within the area of this power. Those that succeed on the saving throw are immune to this manifestation of this power. In addition, non-magical objects also rot away over time when exposed to this power, suffering 1d10 points of damage each hour, ignoring hardness.

Augment: This power may be augmented in one of the following ways.

1. By expending your psionic focus, you and any objects you carry or wield are immune to this manifestation.

2. You may spend an additional 2 power points to cause rapid aging in those affected. Those that fail the Will save also suffer 1 point of ability damage to Strength, Dexterity, and Constitution for each hour that they remain in the area of this power.

3. By spending 4 additional power points, you reduce the hardness of all non-magical objects in the area by 2. For each hour that an object remains in the area of this power, its hardness is reduced by a further 2. After two hours have passed, and after every two hours that passes thereafter, the hardness of magical objects in the area is reduced by 2 as well. These objects receive their own Will save to resist this power.`
  },
  Cloned_Twin: {
    name: "Cloned Twin",
    discipline: "Psychometabolism",
    level: "Egoist 3, highlord 3, psion/wilder 4, psychic warrior 3, vitalist 4",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "egoist 5, highlord 5, psion/wilder7, psychic warrior 5, vitalist 7",
    description: `Effect: One cloned twin

When you manifest this power, your body creates a perfect copy of yourself into a single adjacent square. As long as the twin exists, whenever you take a move action to move, the twin can move as well, although it does not need to follow you and cannot take any other actions. On subsequent rounds, at the start of your turn, your mind can instantaneously exchange places with your twin, becoming the twin and your original body becoming the twin. This is not an action and does not provoke an attack of opportunity.

The twin has a speed of 30 feet and provokes attacks of opportunity from movement as normal. Your twin cannot speak while you are in your other body, and cannot flank, make attacks of opportunity, or otherwise threaten enemies. It has an AC equal to 10 + 1/2 your manifester level and a number of hit points equal to your manifester level. If the twin is reduced to 0 hit points, it is destroyed, although you can create a new one on your turn as a standard action as long as the duration persists.

Augment: This power can be augmented in one or more of the following ways.

• If you spend 2 additional power points, the duration extends to 1 minute/lvl.

• For every 2 additional power points you spend, you create another cloned twin.

• If you spend 4 additional power points, the twin uses your AC, movement speeds, movement modes and hit points at the time of the split, and retains any spells, powers or effects that were affecting you when you split.

• If you spend 2 additional power points, if you are reduced to 0 hit points, you can freely shift your consciousness into the twin, while the body you inhabited is destroyed.`
  },
  Cold_of_the_Grave: {
    name: "Cold of the Grave",
    discipline: "Athanatism",
    level: "Gifted blade 3, highlord 3, psion/wilder 4, psychic warrior 3",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 minute/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5 (gifted blade, highlord, psychic warrior), 7 (psion/wilder)",
    description: `You lock off your pain receptors, becoming like one of the dead. While this power is active, you are immune to pain and emotion effects and reduce all mental ability damage you would take by two. In addition, whenever you are subjected to a morale effect, you may choose whether or not it affects you. If you choose to not be affected, you are immune to that instance of the particular effect. When this power ends, any such effects resume, provided that their duration has not expired in the meantime. However, any ability damage reduced by the use of this power remains reduced.

Augment: This power may be augmented in one of the following ways.

• You may spend 4 additional power points to increase the amount you reduce mental damage you would take by 1.

• You may spend 4 additional power points to reduce any physical damage you would take by 2.

• By spending an additional 6 power points, increase the duration of this power to 1 hour/level.`
  },
  Corporeal_Haunt: {
    name: "Corporeal Haunt",
    discipline: "Athanatism",
    level: "Dread 3, psion/wilder 4",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "See text",
    duration: "Instantaneous",
    savingThrow: "See text",
    powerResistance: "See text",
    powerPoints: "5 (dread), 7 (psion/wilder)",
    description: `By binding spiritual essence into an area, you effectively create a haunt. When you create this haunt, you may create a haunt from the table below with a ML of 7 or lower. Regardless of the haunt, it always acts on an initiative count of 0. When you haunt an area in this way, it takes on minor characteristics specific to the haunt (for example, ghostly hallways for the orbs haunt, or a spectral churchyard for the mad monk haunt). You are immune to all effects of this haunt. An area can receive only one corporeal haunt power at a time.

Slamming Portal: LE haunt (doors or shutters in 5-ft. radius); ML 1; Perception DC 10 (to see a portal closing); hp 2; tricked by hide from undead . The haunted door or window slams shut, held fast as if by hold portal for 1 minute or until the haunt is destroyed.

Orbs: CE haunt (10-ft.-by-20-ft; hallway); ML 2; Perception DC 10 (to notice pulsating, glowing orbs); hp 4; destroyed by slow effect. This swarm of glowing orbs, ranging in size from tiny peas to large melons, cause witnesses to be subjected to the effects of scare (DC 13).

Cold Spot: NE persistent haunt (15-ft. radius); ML 3; Perception DC 10 (to notice sudden temperature drop); hp 13; damaged by fire. When the area is entered, the temperature immediately drops to freezing, drawing warmth from the living. This duplicates chill touch (DC 11), automatically affecting all creatures in the area for each round they remain.

Choking Hands: CE persistent haunt (15-ft.-by-30-ft.; alleyway); ML 4; Perception DC 20 (to see coalescing vapor); hp 18; tricked by hide from undead . This spirit manifests as a pair of spectral skeletal hands, latching on to the throats of the victim. This +4 touch attack duplicates a vampiric touch each round, adding the temporary hit points to the haunt's hp total.

Mad Monk: CN haunt (25-ft.-radius; churchyard); ML 5; Perception DC 20 (to hear pouring liquid); hp 10. A robed monk materializes, offering a gold chalice to a target in the area. There is a 50% chance that the liquid within functions as a cure critical wounds - otherwise, it functions as the poison spell (DC 16). The haunt ends as soon as one creature drinks from the chalice.

Baleful Apparition: CE haunt (30-ft.-by-30-ft.; chamber); ML 6; Perception DC 18 (to feel an ominous presence); hp 12. Victims of the haunt are subject to disturbing, phantasmal images. These unnatural sights and sounds cause all in the area to be affected as if by fear (DC 16).

Deathless Defenders: CE haunt (30-ft. radius); ML 7; Perception DC 20 (to see spectral image of a decayed regiment); hp 14; tricked by hide from undead . Appearing as regiments of spectral, decaying warriors, these haunts charge those in the area bearing rusting arms and armor. These attacks mimic the effects of eyebite (DC 19).

Ghastly Whispers: CE haunt (up to 40-ft. radius); ML 8; Perception DC 20 (to hear whispers growing louder); hp 16. Those in the area can hear a faint whispering, growing louder and louder. This maddening disorientation functions as an insanity (DC 20).

Ectoplasmic Miasma: CE persistent haunt (30-ft. radius; ethereal cloud); ML 9; Perception DC 15 (to see congealing mist); hp 40; tricked by hide from undead . Dozens of spectral visages appear, howling and twisting, in the fog, their limbs and faces mangled. These figures pass through those in the area, duplicating both solid fog and acid fog (DC 17), except that they deal untyped damage.

Headless Horseman: CE persistent haunt (10-ft.-by-50. ft.; bridge); ML 10; Perception DC 20 (to hear the galloping of a phantom horse); hp 45. This haunt appears as a headless, mounted rider, wearing ancient armor, head swinging from the saddle of its rotting horse. Every round, it gallops by, attacking a target within the area as if with mage's sword (with a +16 attack bonus).

Spectral Carriage: CE haunt (15-ft.-by-60-ft.; roadway); ML 11; Perception DC 22 (to hear galloping hooves); hp 22. Appearing as a translucent horse-drawn carriage, full of laughing ghosts in rotting finery, this haunt swerves to run down all the area. This functions as a clenched fist (+25 attack), affecting every target in the area.

Hungry Earth: CE haunt (80-ft.-radius; graveyard); ML 12; Perception DC 29 (to feel the ground shift); hp 24. Deep, yawning graves open in the earth beneath each target in the area, functioning as an earthquake cast on open ground (DC 15 or 20). Victims that fall into the grave are buried as normal until they free themselves or are recovered.

Gjenganger: CE persistent haunt (up to 65-ft. radius); ML 13; Perception 28 (to see the haunt becoming corporeal); hp 58. The gjenganger manifests corporeally, appearing as a twisted, stunted double of a target in the area. However it appears, the haunt relies on its “dead man's pinch”, a +13 melee touch attack that causes bubonic plague, as if by contagion (DC 16).

Keening Suicides: CE haunt (60-ft.-radius; tower); ML 14; Perception DC 30 (to hear distant, plummeting screams); hp 28. This haunt appears with the awful wails of those leaping to their deaths from high atop the tower. These wails overwhelm the living, filling them with lethal sorrow. This functions as a wail of the banshee (DC 23) to all within the area.

Augment: For every 2 additional power points you spend, increase the possible ML of the haunt by 1, to a maximum of your manifester level.`
  },
  Correspond: {
    name: "Correspond",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Highlord 4, psion/wilder 4, tactician 4",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "See text",
    target: "One creature with an Intelligence score of 3 or higher",
    area: "",
    duration: "1 round/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `You forge a passive mental link with a creature with which you have previously had physical or mental contact. The subject need not be within sight or even on the same plane as you are. The subject recognizes you, and you can mentally communicate with it for the duration (though nothing forces the subject to respond to you), exchanging messages of twenty-five words or less once per round. Receiving a message is not an action and does not provoke attacks of opportunity; however, sending a message is equivalent to a standard action that can provoke attacks of opportunity. You do not need line of sight or line of effect to use this power.

Augment: If you spend an additional 4 power points, the power's duration increases to 10 minutes/level.

Mythic Correspond[]

You can communicate with an additional number of creatures equal to your tier and can choose whether or not those can communicate through you with the other creatures affected by mythic correspond .`
  },
  
  Crystalline_Aura_Kyria_s: {
    name: "Crystalline Aura, Kyria's",
    discipline: "Metacreativity",
    level: "Highlord 4, psion/wilder 4, psychic warrior 4",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You create a cloud of whirling, razor-sharp crystals around yourself. When you manifest this power, choose defensive or offensive (you may alter this choice as a swift action). While this power is in defensive mode, the shards lock together to protect you from attacks; you gain a +3 shield bonus to AC, as well as a +3 competence bonus to Reflex saves. While this power is in offensive mode, creatures within a 10 ft. radius of you suffer 5d6 slashing damage at the beginning of each round (and whenever they voluntarily enter a space within 10 ft. of you) and must succeed at a Reflex save or suffer 2d6 bleed damage.

Augment: You may augment this power in one or both of the following ways:

• For every 2 additional power points you spend, the bonuses granted by the defensive mode increase by 1, and the damage of the offensive mode increases by 1 die (d6; this includes the bleed damage).

• For every 2 additional power points you spend, the area of the offensive mode increases by 5 ft.

Surge Augmentation: If you invoke your wild surge while manifesting this power, you may choose to manifest it in both defensive and offensive mode at the same time. If you do so, you may not switch its mode for this manifestation, and its duration is cut in half (rounded down).`
  },
  Battle_Transformation: {
    name: "Battle Transformation",
    discipline: "Clairsentience",
    level: "Highlord 4, psychic warrior 4, tactician 4",
    display: "Mental, Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "no; see text",
    powerPoints: "7",
    description: `You become a paragon of battle—stronger, tougher, faster, and more skilled in combat.
    You gain a +2 luck bonus on attack rolls, weapon damage rolls, Strength checks, and Strength-based skill checks. You also gain 1 temporary hit point per manifester level. Whenever you make a full-attack action, you can make an additional attack at your full base attack bonus, plus any appropriate modifiers. This additional attack is not cumulative with similar effects, such as physical acceleration or weapons with the speed special ability.
    
    Augment: This power may be augmented in one or more of the following ways.

For every 3 additional power points spent, the luck bonus improves by 1.
\n• If you spend 4 additional power points, the power's duration becomes 10 minutes/level.
\n• If you spend 2 additional power points, this power gains the Network descriptor. If used in this fashion, the power's saving throw becomes Will negates (harmless) and power resistance becomes Yes (harmless).

Mythic:
You can still manifest powers and use power completion and power trigger items, but the level of the power you're manifesting or using must be equal to or less than your tier. You gain a number of temporary hit points equal to your manifester level.`
  },
  Form_Astral_Armor: {
    name: "Form Astral Armor",
    discipline: "Metacreativity",
    level: "Gifted blade 3, highlord 3, psychic warrior 3",
    display: "Material, Visual",
    manifestingTime: "1 full-round action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "no; see text",
    powerPoints: "5",
    description: `You form a suit of astral armor, similar to an aegis, of the astral skin, astral armor or astral juggernaut type over your body. The astral suit has the free customizations of associated suit at the appropriate manifester levels (see aegis base class for details) plus an additional 5 customization points. Use your manifester level to determine your aegis level when gaining free customizations from this power. If you already possess the ability to manifest an astral suit you may add these customization points to your astral suit when you manifest this power. If you possess the mind armaments class feature (see armored blade soulknife archetype), you may use these customization points (and any purchased through augmenting this power) to add astral suit customizations to your mind armor.
Augment: For every 2 additional power points you spend, you gain 1 customization point.`
  },
  Deadly_Fear: {
    name: "Deadly Fear",
    discipline: "Telepathy [Fear, Mind-Affecting]",
    level: "Dread 4, gambler 4, psion/wilder 4",
    display: "Visual; see original text",
    manifestingTime: "One standard action",
    range: "Medium (100 feet + 10 feet/level)",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will disbelief (if interacted with), then Fortitude partial; see text",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You create a mental image of the most fearsome creature imaginable to the subject simply by forming the fears of the subject's subconscious mind into something that its conscious mind can visualize: this most horrible beast. Only the power's subject can see the nightmarish beast. The target first gets a Will save to recognize the image as unreal. If that save fails, the beast touches the subject, and the subject must succeed on a Fortitude save or die from fear. Even if the Fortitude save is successful, the subject takes 3d6 points of damage.

If the subject of a deadly fear attack succeeds in disbelieving and possesses telepathy or is wearing a helm of telepathy , the effect can be turned upon you. You must then disbelieve it or become subject to the deadly fear attack.

Augment: For every 2 additional power points spent, both Difficulty Classes increase by 1.

For every 5 additional power points spent, you can attempt to affect one additional creature. If affecting more than one creature, no two can be more than 30 feet apart.

Mythic Deadly Fear[]

If the target fails its Will save but succeeds at its Fortitude save, the fearsome beast persists in the target's mind, giving it the dazed condition until your next turn. On your next turn, the target must attempt another Fortitude save against the phantasm. Success means it takes 3d6 points of damage; failure means it dies from fear.

Augmented (6th): If you expend two uses of mythic power, the power can affect a living target that is immune to fear, illusions, or mind-affecting effects.`
  },
  Death_Urge_Blackstock_s: {
    name: "Death Urge, Blackstock's",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Gambler 4, psion/wilder 4",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One living creature",
    area: "",
    duration: "1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You plant a hidden death-urge impulse in the subject's unconscious. On the subject's next turn, it looks for the quickest method to end its life and attempts to do so. The subject takes no other action on its turn except attempting to harm itself.

If armed, the subject attacks itself as a full-round action. The attack automatically succeeds and deals damage as a critical hit. If unarmed, the subject moves adjacent to the nearest enemy and provokes an attack of opportunity, offering its opponent an opening, which the opponent may or may not choose to take advantage of.

If the subject is unarmed and no enemy is nearby, the subject simply does nothing at all. A subject close to an immediate and lethal hazard such as a cliff or a fire might hurl itself off the cliff or into the fire instead of striking itself with a weapon.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1. For every 2 point increase in the power's save DC, the duration increases by 1 round.

Mythic Blackstock's Death Urge[]

If the subject is unarmed and no enemy is nearby, it will simply assault itself on the floor, ground, or any other hard surface, dealing damage as if making an unarmed strike that is a critical hit.

If the creature makes a successful saving throw, it instead suffers a -2 penalty to its Armor Class and saving throws as the impulse to die is not totally negated.`
  },
  Deathless_Form: {
    name: "Deathless Form",
    discipline: "Psychometabolism [healing]",
    level: "Highlord 4, Psion/Wilder 4, Tactician 4, Vitalist 4",
    display: "Visual, Material",
    manifestingTime: "1 standard action",
    range: "Close (25 feet + 5 feet/level)",
    target: "1 creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "yes",
    powerPoints: "7",
    description: `You place the target in a state where death cannot reach it, the creature's body healing off the bare minimum of injuries needed to keep the target alive. While under the effects of this power, the target cannot be killed by hit point damage; the creature automatically stabilizes when below 0 hit points, and any damage that would kill the creature is negated. However, the creature does not heal nor regain consciousness; further healing is required in order to bring the creature back to positive hit points.

Augment

• If you spend 4 additional power points, you may use this power as an immediate action

• If you spend 2 additional power points, you may also render the target immune to death from ability damage, ability drain, and death effects while they are affected by this power. Their ability scores still drop as normal and inhibit function when reduced to 0, but do not kill the creature.

• If you spend 4 additional power points, the duration of this power extends to 1 minute/level`
  },
  Detect_Remote_Viewing: {
    name: "Detect Remote Viewing",
    discipline: "Clairsentience",
    level: "Gambler 4, psion/wilder 4, sighted seeker 4, voyager 4",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "40 ft.",
    target: "",
    area: "40-ft.-radius emanation centered on you",
    duration: "24 hours",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `You immediately become aware of any attempt to observe you by means of a scrying power or spell. The power's effect radiates from you and moves as you move. You know the location of every psionic or magical sensor within the power's area.

If the viewing attempt originates within the area, you also know the viewer's location. Otherwise, you and the remote viewer immediately make opposed manifester level checks (1d20 + manifester level, or viewer's caster level as appropriate). If you at least match the remote viewer's result, you get a visual image of the remote viewer and an accurate sense of the remote viewer's direction and distance from you.

Mythic Detect Remote Viewing[]

Add your tier to the opposed manifester level check to get a visual image of the remote viewer. If the manifester of the viewing attempt originates in the area of the power, you can teleport the manifester of the viewing attempt to you unless it makes a successful Will saving throw.`
  },
  Empathic_Feedback: {
    name: "Empathic Feedback",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 4, gifted blade 3, highlord 3, psion/wilder 4, psychic warrior 3, tactician 4, vitalist 4",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "Gifted blade 5, highlord 5, psion/wilder 7, psychic warrior 5, tactician 7, vitalist 7",
    description: `You empathically share your pain and suffering with your attacker. Each time a creature strikes you in melee, it takes damage equal to one quarter the amount it dealt to you (rounded down, minimum 1) unless it succeeds on a Will save. This damage is empathic in nature, so powers and abilities the attacker may have such as damage reduction and regeneration do not lessen or change this damage. The damage from empathic feedback has no type, so even if you took fire damage from a creature that has immunity to fire, empathic feedback will damage your attacker. The damage from empathic feedback is a mind-affecting effect, a successful Will save negates this damage, and the damage is subject to power resistance.

Augment: This power may be augmented in one of the following ways.

• By spending 3 additional power points, the damage suffered by your attacker increases to one half the damage dealt to you.

• By spending 6 additional power points, the damage suffered by your attacker is equal to the damage dealt to you.

Mythic Empathic Feedback[]

Any attack against you that originates within medium range (100 feet + 10 feet/level) invokes the empathic feedback.

Augmented: If you expend one use of mythic power, you add your tier to the save DC and any attempts to overcome power resistance.`
  },
  Energy_Adaptation: {
    name: "Energy Adaptation",
    discipline: "Psychometabolism [see text]",
    level: "Psion/wilder 7, vitalist 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal and close (25 ft. + 5 ft./2 levels); see text",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `Energy Adaptation[]

Your body assimilates some of the effect of an energy attack and converts it to harmless light. You gain resistance 10 against any attack that deals acid, cold, electricity, fire, or sonic damage.

When you absorb damage, you can choose to radiate visible light that illuminates a 60-foot radius for a number of rounds equal to the points of damage you successfully resisted, or merely dissipate the energy without giving off a visual display.

The energy resistance provided by this power increases to 20 points at 7th manifester level and to a maximum of 30 points at 11th level.

The power protects your equipment as well.

The resistance provided by this power does not stack with other forms of energy resistance.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Energy Adaptation, Specified[]

As energy adaptation, except the type of energy to which you gain resistance when this power is manifested is your active energy type.

This power's subtype is the same as the type of damage it protects against.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Energy Conversion[]

Effect: Ray; see text

As energy adaptation , except that instead of radiating away energy as light, you store up the energy and can later discharge it as a ray. To discharge a ray requires a standard action. You can choose to fire any number of rays during the power's duration. The ray you fire must be of one of the energy types you have stored (if you have stored more than one type, you can choose what kind of energy to use for each ray). If a ray successfully strikes its target (requiring a ranged touch attack), the target takes damage equal to the amount of energy damage of that type you have stored, up to a maximum of three times your manifester level. As long as this power remains in effect, you can continue to absorb energy damage and fire additional rays using the stored damage. Damage you fire in rays is subtracted from the damage you have absorbed, so you may not fire off rays if you have depleted the energy you have absorbed.

This power's subtype is the same as the type of energy you discharge in a ray; thus, its subtype can change during the course of the power's duration.

Mythic Energy Adaptation[]

You gain a +6 bonus to saves against effects that deal acid, cold, electricity, fire, or sonic damage.

Augmented (5th): If you expend two uses of mythic power, you gain immunity against effects that deal acid, cold, electricity, fire, or sonic damage.

Mythic Specified Energy Adaptation[]

You gain a +4 bonus on saves against effects that deal damage of the selected energy type. Once each round as a free action, you can choose one adjacent ally to gain energy resistance 5 against the chosen energy type for 1 round. This increases to energy resistance 10 at manifester level 7 and energy resistance 15 at manifester level 11.

Mythic Energy Conversion[]

You may fire rays as if making an attack with a ranged weapon, allowing the use of iterative attacks for a high base attack bonus. If firing multiple rays in a single round, the rays can target the same creature or different creatures, as long as both all targets are in range.

Augmented (5th): If you expend two uses of mythic power, the amount of damage you can retain increases to 10 times your manifester level, and you can fire rays of two different energy types. Such rays deal damage based upon the amount and type of energy chosen when firing the ray.`
  },
  Energy_Allergy: {
    name: "Energy Allergy",
    discipline: "Psychometabolism",
    level: "Cryptic 3, dread 3, psion/wilder 4",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "Cryptic 5, dread 5, psion/wilder 7",
    description: `The skin of your foe begins to discolor as its very nature changes, introducing a potentially fatal flaw in its defenses. When you manifest this power, the target gains vulnerability to the energy type you selected when you last gained psionic focus. Such a creature takes an additional 50% damage from that energy type for the duration of energy allergy .

Resistance and immunity to the energy type you specify remain unaffected by this power.

Augment: By spending an additional four power points you can specify a second energy type or specify an energy type other than the type you chose when last gaining psionic focus.

Mythic Energy Allergy

A creature with immunity to the energy type you specify is no longer immune, but reduces all damage taken of that energy type by 50%.`
  },
  Fold_Space: {
    name: "Fold Space",
    discipline: "Psychoportation (Teleportation)",
    level: "Cryptic 4, gambler 4, gifted blade 4, highlord 4, psion/wilder 4, psychic warrior 4, voyager 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None and Will negates (object); Power",
    powerResistance: "",
    powerPoints: "7",
    description: `Target or Targets: You and touched objects or other touched willing creatures

Resistance: No and Yes (object)

You instantly transfer yourself from your current location to any other spot within range. You always arrive at exactly the spot desired—whether by simply visualizing the area or by stating direction. After using this power, you can't take any other actions until your next turn. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as two Large creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you.

If you arrive in a place that is already occupied by a solid body, you and each creature traveling with you take 1d6 points of damage and are shunted to a random open space on a suitable surface within 100 feet of the intended location.

If there is no free space within 100 feet, you and each creature traveling with you take an additional 2d6 points of damage and are shunted to a free space within 1,000 feet. If there is no free space within 1,000 feet, you and each creature travelling with you take an additional 4d6 points of damage and the power simply fails.

Augment: If you spend 6 additional power points, you can manifest this power as a move action, although you still cannot take any other actions until your next turn.

Mythic Fold Space[]

The duration of this power changes to 1 round per 2 manifester levels, and it creates a temporary, invisible, one-way portal in your square to your destination. You immediately pass through the portal and arrive at the destination, but you can't take any other creatures with you.

When manifesting the power, you can designate a number of creatures equal to your manifester level. These creatures can see and use the portal, passing through it to arrive at the destination (this isn't an action). A creature that passes through the portal can't take any other actions until its next turn.`
  },
  Hive_Control: {
    name: "Hive Control",
    discipline: "Telepathy",
    level: "Highlord 4, Psion/Wilder 4, Tactician 4",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level); see text",
    target: "1 unintelligent creature or swarm of unintelligent creatures",
    area: "",
    duration: "1 day/level; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Mind Control[]

You can control the actions of any humanoid creature through a telepathic link that you establish with the subject's mind.

If you and the subject have a common language, you can generally force the subject to perform as you desire, within the limits of its abilities. If no common language exists, you can communicate only basic commands, such as “Come here,” “Go there,” “Fight,” and “Stand still.” You know what the subject is experiencing, but you do not receive direct sensory input from it, nor can it communicate with you telepathically.

Once you have given a controlled creature a command, it continues to attempt to carry out that command to the exclusion of all other activities except those necessary for day-to-day survival (such as sleeping, eating, and so forth). Because of this limited range of activity, a Sense Motive check against DC 15 (rather than DC 25) can determine that the subject's behavior is being influenced by an enchantment effect (see the Sense Motive skill description).

Changing your orders or giving a dominated creature a new command is a move action.

By concentrating fully on the power (a standard action), you can receive full sensory input as interpreted by the mind of the subject, though it still can't telepathically communicate with you. You can't actually see through the subject's eyes, so it's not as good as being there yourself, but you still get a good idea of what's going on.

Subjects resist this control, and any subject forced to take actions against its nature receives a new saving throw with a +2 bonus. Obviously self-destructive orders are not carried out. Once control is established, the range at which it can be exercised is unlimited, as long as you and the subject are on the same plane. You need not see the subject to control it.

If you don't spend at least 1 round concentrating on the power each day, the subject receives a new saving throw to throw off the mind control.

Protection from evil or a similar effect can prevent you from exercising control or using the telepathic link while the subject is so warded, but such an effect does not automatically dispel it.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, this power can also affect an animal, fey, magical beast, or monstrous humanoid.

• If you spend 4 additional power points, this power can also affect an aberration, dragon, elemental, or outsider in addition to the creature types mentioned above.

• For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

In addition, for every 2 additional power points you spend to achieve any of these effects, this power's save DC increases by 1.

Hive Control[]

Your willpower seizes hold of a nearby entity of infinitesimal intellect, enabling you to usurp control over their actions. This ability functions as mind control , save that it does not affect a single creature. Rather, it takes control of a single creature or swarm of creatures with an intelligence score of -. Even if such creatures cannot understand your commands, they intuitively know your commands and obey them.

Augment

• For every 2 additional power points you spend, you may target one additional creature or swarm with this effect.

• If you spend 6 additional power points, you may use this power to control intelligent swarms or troops as if they were unintelligent swarms.

• For every 2 additional power points you spend (including as part of other augments), the save DC of this power increases by 1.

Mythic Mind Control[]

The Sense Motive DC to notice your target is dominated increases by double your tier. You can give orders to the target even if it's protected by non-mythic effects that block magical control, such as protection from evil . If the target is protected by a mythic effect, you can attempt to overcome this defense with a manifester level check (DC 15 plus the manifester level of the effect); add your tier to your roll and the opposing manifester's tier to the DC. If the target succeeds at its Will save to break your control, as an immediate action you can expend one use of mythic power to force it to reroll the save and use the lower result.`
  },
  Hurl_Enemy: {
    name: "Hurl Enemy",
    discipline: "Psychokinesis [force]",
    level: "Highlord 4, psion/wilder 4, tactician 4",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "short (25 ft. + 5 ft./2 levels)",
    target: "one creature (see text)",
    area: "",
    duration: "instantaneous",
    savingThrow: "Fortitude negates",
    powerResistance: "yes",
    powerPoints: "7",
    description: `You concentrate on a creature and use telekinesis to try to hurl it at another target. The creature being hurled must weigh less than 50 pounds per manifester level. If the targeted creature fails its save, you forcefully launch it at another target that must be within 30 ft. of the affected creature.

Make a ranged touch attack against the target. If the attack is successful, deal 7d6 points of damage to both the hurled creature and the target of the ranged attack. If the attack misses, deal 3d6 points of damage to the hurled creature.

Augment: For every additional power point spent, the damage to each creature increases by 1d6. For every additional 2d6 of damage, the save DC increases by 1.`
  },
  Incite_Passion: {
    name: "Incite Passion",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 4, psion/wilder 4, vitalist 4",
    display: "Material, Olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round / level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `The target creature's mind is subtly altered to embrace its more instinctual urges instead of logic. For the duration of the power, the target creature takes a -2 penalty on all Intelligence-related checks and may not take 10 or take 20 on any skill check. In addition, the target cannot competently grasp combat tactics and suffers a -2 penalty on attack rolls and Armor Class, cannot fight defensively, and cannot use Combat Expertise or any other feats that require it.

Mythic Incite Passion[]

Add half your mythic tier (minimum 1) to the penalties suffered by the target.

Augmented: If you expend one use of mythic power, the target must make concentration checks to cast spells or manifest powers (DC equal to 14 plus your key ability modifier plus your mythic tier.)`
  },
  Insurrection: {
    name: "Insurrection",
    discipline: "Telepathy (mind-affecting)",
    level: "Dread 4, Psion/Wilder 4",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 feet + 5 feet/level)",
    target: "1 creature/2 manifester levels within range",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "7",
    description: `You sow discord and tension in your opponent's mind, stemming them to violence against their former allies. The affected creature has a 50% chance to attack the nearest target each round. (Roll to determine each creature's behavior every round at the beginning of its turn.) A creature that does not attack its nearest neighbor is free to act normally for that round. Creatures forced by an insurrection to attack their fellows employ all methods at their disposal, choosing their deadliest spells and most advantageous combat tactics. Affected creatures will continue to attack unconscious allies until they are dead, and may go beyond killing them if the character knows that resurrection is easily obtainable. If there are no creatures which the creature would be able to attack while acting abnormally, it moves in a random direction that turn.

Augment

• For every 2 power points you spend, the save DC increases by 1 and an additional target may be selected with this power. Additional targets must be within 15 feet of the original

• If you spend 6 additional power points, the target has a 75% chance to attack the nearest target each round rather than 50%.`
  },
  Intellect_Fortress: {
    name: "Intellect Fortress",
    discipline: "Psychokinesis",
    level: "Highlord 4, psion/wilder 4, tactician 4",
    display: "Auditory, Visual",
    manifestingTime: "1 immediate action",
    range: "20 ft.",
    target: "",
    area: "20-ft.-radius spread centered on you",
    duration: "1 round",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You encase yourself and your allies in a shimmering fortress of telekinetic force. All damage from powers and psi-like abilities taken by subjects inside the area of the intellect fortress, including ability damage, is halved. This lowering takes place prior to the effects of other powers or abilities that lessen damage, such as damage reduction and evasion.

Powers that are not subject to power resistance are not affected by an intellect fortress.

Augment: This power may be augmented in one or both of the following ways.

• For every additional power point you spend, this power's duration increases by 1 round.

• By spending 4 additional power points, this power may also affect breath weapons that deal damage.

Mythic Intellect Fortress[]

You can designate which creatures within the area benefit from the mythic intellect fortress and which do not. In addition, you reduce hit point damage taken by an additional amount equal to your mythic  tier and ability damage taken by an additional amount equal to half your mythic tier.`
  },
  Interference_Field: {
    name: "Interference Field",
    discipline: "Psychokinesis",
    level: "Highlord 4, Psion/Wilder 4, Psychic Warrior 4, Tactician 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "20 feet",
    target: "",
    area: "20-foot emanation centered on you",
    duration: "1 round/level",
    savingThrow: "Fortitude partial",
    powerResistance: "no",
    powerPoints: "7",
    description: `Psychokinetic static floods the area, making it difficult for foes to focus or utilize their abilities. Creatures within this aura that fail their Fortitude save take a -8 penalty on all concentration checks made while inside the area of this effect, and may not concentrate on powers or spells while in the area. Those that succeed on their save take only a -4 penalty on such checks.

Augment

• If you expend psionic focus, you may exempt yourself from the effects of this power

• If you spend 6 additional power points, you may cause this power to not have a Fortitude save, treating all creatures inside the area as if they had failed their save.

• For every 2 power points spent augmenting this power (including as part of other augments), the save DC increases by 1 and the range increases by 10 feet`
  },
  Mindwipe: {
    name: "Mindwipe",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 4, gambler 4, psion/wilder 4",
    display: "Auditory, mental, and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You partially wipe your victim's mind of past experiences, bestowing two negative levels upon it. If the subject has at least as many negative levels as Hit Dice, it dies. The effects of multiple negative levels stack.

If the subject survives, it loses all negative levels after 1 hour. (No Fortitude save is necessary to avoid gaining the negative level permanently.)

Augment: You can manifest this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's save DC increases by 1.

• For every 3 additional power points you spend, this power bestows an additional negative level on the subject.`
  },
  Moment_of_Terror: {
    name: "Moment of Terror",
    discipline: "Telepathy [Evil, Mind-Affecting]",
    level: "Dread 4, gambler 4, psion/wilder 4",
    display: "Mental",
    manifestingTime: "One standard action",
    range: "Medium (100 feet + 10 feet/ level)",
    target: "One creature of up to Large size",
    area: "",
    duration: "1 round; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You brutally force the target's consciousness into a dimension of nightmares and terror. This unnatural dislocation opens conduits of pain for the target, causing the target's body to fall prone and helpless as the target mindlessly screams unless it makes a successful Will save.

If the target failed its Will save, once the initial effect ends, the memory of the awful pain remains, making the target susceptible to other mental assault, imposing a -2 penalty on Will saves against mind-affecting effects for a period of one day. This penalty does not stack from multiple uses of this power.

Augment: If you spend 4 additional power points, the target suffers the penalty on Will saves against mind-affecting effects even if it made a successful save.`
  },
  Personality_Parasite: {
    name: "Personality Parasite",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 4, gambler 4, psion/wilder 4",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One Medium or smaller humanoid",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You attempt to briefly partition the mind of your foe, calving off a minor personality that is antagonistic to the main personality. The parasitic personality functions with complete autonomy from the main personality. It does not control the body physically, but it can take one standard action each round that is purely mental, such as manifesting a power, in the same turn that the subject takes its normal actions.

The parasitic personality manifests powers using the subject's power point reserve and known powers, or any spells prepared or known and available spell slots, but can only manifest powers or cast spells three or more levels lower than the highest level of power or spell the subject can normally manifest or cast.

The parasitic personality actively attempts to manifest powers or cast spells that negatively impact the subject, using the highest-level powers or spells possible (so as to deplete the subject's power point reserve and available spell slots), and the most deadly to the subject. You do not have control over what the parasitic personality does, though it always works against the interest of the subject.

Both minds communicate with each other telepathically. If a creature is targeted by a compulsion or charm effect while under the effect of this power, it can make a second saving throw if the first one fails. If both saving throws fail, then this power ends and the creature is affected by the charm or compulsion effect.

The parasitic personality does not gain any advantages if the main personality is subjected to a haste or schism effect.`
  },
  Physical_Rebirth: {
    name: "Physical Rebirth",
    discipline: "Psychometabolism",
    level: "Psion/wilder 4, vitalist 4",
    display: "Visual, Mental",
    manifestingTime: "10 minutes",
    range: "Touch",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "none",
    powerResistance: "No",
    powerPoints: "7",
    description: `Using special oils and powdered crystals (worth 1000 gp), you draw out the impurities and heal the ravages of time on a single living creature. You reverse the effects of aging, returning the target to the youngest mature age for their race, removing any and all physical penalties for age. However, this transformation is draining and the target takes 2 permanent negative levels after this process is complete.

Augment: This power may be augmented in one or more of the following ways.

• For every 2 additional power points and an extra 1000 gp, the target takes 1 less permanent negative level.

• If you spend 4 additional power points and an additional 5000 gp, you can target a creature that died in the last week, bringing them back to life at their youngest state.`
  },
  Power_Leech: {
    name: "Power Leech",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Dread 4, gambler 4, psion/wilder 4",
    display: "Visual; see text",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Any living psionic creature",
    area: "",
    duration: "Concentration, up to 1 round/level; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Your brow erupts with an arc of crackling dark energy that connects with your foe, draining it of 1d6 power points and adding 1 of those points to your reserve (unless that gain would cause you to exceed your maximum).

The drain continues in each round you maintain concentration while the subject of the drain remains in range. If the subject is drained to 0 power points, this power ends.

Concentrating to maintain power leech is a full-round action (you can take no other actions aside from a 5-foot step) instead of a standard action.`
  },
  Psychic_Reformation: {
    name: "Psychic Reformation",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gifted blade 4, highlord 4, psion/wilder 4, tactician 4, vitalist 4",
    display: "Auditory, mental, and visual",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `When this power is manifested, the subject can choose to spend its most recently gained skill ranks differently (picking new skills and abandoning old ones if it chooses) and to choose a different feat from the one it selected when advancing from its previous level to its current level. The subject can also choose to forget powers or spells it acquired when advancing to its current level, replacing them with new ones.

The subject can undo decisions of these sorts that were made at lower levels, although he suffers increased penalties the farther back he goes to undo decisions. The subject must abide by the standard rules for selecting skills and feats, and so it cannot take feats for which it doesn't qualify. Any change made must have been available at the level selected. For example, a 7th level psion who uses this power to change a 2nd level power gained at 3rd level psion cannot select a 4th level power to replace it - he must choose a 1st or 2nd level power.

The subject is not limited to changing only a single level's choices should he decide to undo decisions from prior levels. Every level between his current level and the earliest level may be altered, so long as the choices made were valid at the appropriate level.

If the subject goes farther back than the changes from the previous level to its current level, the subject suffers a cumulative -1 penalty on all ability checks, attack rolls, combat maneuver checks, Combat Maneuver Defense, saving throws, and skill checks for each level back the power changes. In addition, the creature reduces its current and total hit points by 5 for each level back the power changes. The creature is also treated as one level lower for the purpose of level-dependent variables (such as spellcasting or manifesting) for each level back the power changes. These penalties last for 24 hours.

Augment: This power may be augmented in either of the following ways.

• If you spend 2 additional power points, the penalties end after the subject rests for 8 hours.

• If you spend 6 additional power points, the subject does not suffer any penalties.`
  },
  Psychokinetic_Charge: {
    name: "Psychokinetic Charge",
    discipline: "Psychokinesis [force]",
    level: "Gambler 4, highlord 4, psion/wilder 4, tactician 4",
    display: "Auditory, Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "one willing creature",
    area: "",
    duration: "instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "yes (harmless)",
    powerPoints: "",
    description: `You telekinetically launch an ally (or yourself) across the battlefield to anywhere within this power's range. While moving, your ally is flying just above the ground unless you wish otherwise. Movement from this power provokes attacks of opportunity as normal, although you can lift your ally over objects or out of enemy reach, as long as your ally remains within range. If your ally lands adjacent to an opponent, he can spend an immediate action to make a melee attack against that opponent with a +2 bonus on the attack roll.`
  },
  Raise_the_Shroud: {
    name: "Raise the Shroud",
    discipline: "Athanatism",
    level: "Highlord 4, psion/wilder 4, tactician 4",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "20-ft.-radius spread",
    duration: "1 round/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You forcibly and temporarily separate the Ethereal and the Material planes. This power affects both the Ethereal and the Material Plane in the area. Affected ethereal creature and effects cannot affect the Material Plane, and affected material creatures and effects cannot effect the Ethereal Plane while within the area of this power. In addition, powers or effects that attempt to bridge the planes such as dead hand or ethereal jaunt cannot function within this area, and are suppressed for as long as they are in the area.

Augment: You may augment this power in one of the following ways.

• You may spend an additional 4 power points to increase the radius affected by this power by 10 feet.

• By spending an additional 4 power points, increase the duration of this power to 1 minute/level.

• By spending an additional 8 power points, increase the duration of this power to 10 minutes/level.

• By spending an additional 4 power points, you may center the area of this power on a held object, allowing it to move as the object does.`
  },
  Relapse: {
    name: "Relapse",
    discipline: "Clairsentience (mind-affecting)",
    level: "Cryptic 4, Dread 4, Highlord 4, Psion/Wilder 4, Psychic Warrior 4, Tactician 4, Vitalist 4",
    display: "Material and Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 feet + 10 feet/level)",
    target: "1 creature",
    area: "",
    duration: "instantaneous",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "7",
    description: `Reaching through the target's memories and experiences, you reactive an effect that has ended upon their mind and body, as if it had begun anew. When a creature fails their save against this ability, choose one power or spell that has affected them within the last 24 hours that has ended or been dispelled. The effect begins again, using the same duration that the original power or spell had. For example, you may use this power on a creature which was under the effects of compelling voice three rounds ago, reactivating the compelling voice effect with a duration equal to the duration of the original power and using all the same variables (such as effect, manifester level, dispel DC, and damage type for certain powers) as the original power. An individual power can only be relapsed once.

Using this power does not give you automatic knowledge of all powers that have affected the creature over that duration, and this power has no effect if you try to reactivate a power or spell that the target has never been subject to. This power does not work if the original power is still active upon the target. If the power you are reactivating has a duration of concentration, you must concentrate to keep its effects active.

Augment

• If you spend 4 additional power points, you may choose to affect the target with any power or spell that they have been affected with in the past, rather than just within the last 24 hours.

• If you spend 8 additional power points, you may relapse a power that has previously been relapsed.

• If you expend psionic focus, you immediately figure out all powers and spells that have affected the target in the last 24 hours.`
  },
  Rewind_Age: {
    name: "Rewind Age",
    discipline: "Psychometabolism",
    level: "Psion/wilder 4, vitalist 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "24 hours",
    savingThrow: "No",
    powerResistance: "No",
    powerPoints: "7",
    description: `You ignore the physical detriments of being middle-aged. This spell does not cause you to look younger, nor does it prevent you from dying of old age, but as long as the spell is in effect, you ignore the -1 penalties to Strength, Dexterity, and Constitution that accrue once you become middle-aged. You retain the age-related bonuses to Intelligence, Wisdom, and Charisma while under the effects of this spell. Additional penalties that you accrue upon becoming old or venerable apply in full.

Augment: This power may be augmented in one or more of the following ways.

1. For every 3 power points you spend, you ignore the penalties of another, higher, age category (old, venerable).

2. If you spend 3 additional power points, the duration becomes 1 day/level.

3. If you spend 2 additional power points, the range becomes Touch and the target becomes: One living creature.`
  },
  Slip_the_Bonds: {
    name: "Slip the Bonds",
    discipline: "Psychoportation",
    level: "Cryptic 4, gambler 4, gifted blade 4, highlord 4, marksman 4, psion/wilder 4, psychic warrior 4, tactician 4, voyager 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You can move and attack normally for the duration of the power, even under the influence of effects that usually impedes movement, such as paralysis, solid fog , slow , and web . All combat maneuver checks made to grapple you automatically fail. You automatically succeed on any combat maneuver checks and Escape Artist checks made to escape a grapple or a pin.

You can also move and attack normally while underwater, even with slashing weapons such as axes and swords or with bludgeoning weapons such as flails, hammers, and maces, provided that the weapon is wielded in the hand rather than hurled. This does not, however, grant water breathing.`
  },
  Spectral_Stare: {
    name: "Spectral Stare",
    discipline: "Athanatism",
    level: "Psion/wilder 4",
    display: "Olfactory and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude partial",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You emulate the horrific gaze attacks of the spectral dead, causing corruption with a glance. As a standard action as long as this power's effects persist, you may direct your spectral stare at a creature or object within 30 feet of your location. Targeted creatures must succeed at a Fortitude save or suffer 2d10 points of damage and 1d4 Charisma damage. A successful save negates the Charisma damage but not the physical damage.

Augment: You may augment this power in one of the following ways.

• By spending an additional 4 power points, you expend your psionic focus when directing your gaze at a creature to grant them 1d4 negative levels instead of Charisma damage. They may negate this by succeeding at a Fortitude save. This is a death effect.

• For every 4 additional power points spent, you deal an additional 1d10 damage points of damage, as well as an additional point of Charisma damage to those that fail the save.

In addition, for every two power points spent augmenting this power, increase the power's save DC by 1.`
  },
  Spiritual_Lordship: {
    name: "Spiritual Lordship",
    discipline: "Athanatism",
    level: "Dread 4, psion/wilder 4",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One haunt",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `You exert your authority over a nearby haunt. By succeeding at an opposed manifester level check, you gain temporary control over the target. While you are in control of a haunt, you may manually trigger it with a mental command (a standard action) and may choose targets that it affects (a free, mental action).

Augment: For every 2 additional power points spent, you increase the effective caster or manifester level of the haunt by 1, to a maximum of your manifester level.`
  },
  Telekinetic_Maneuver: {
    name: "Telekinetic Maneuver",
    discipline: "Psychokinesis [Force]",
    level: "Gambler 4, psion/wilder 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You can affect a foe by concentrating your mind upon its current status and the status you desire, once per round. You can perform a bull rush, a disarm, a grapple (including a pin), or a trip. Resolve these attempts as normal, except that they don't provoke attacks of opportunity, you use your manifester level in place of your base attack bonus, you use your key ability modifier in place of your Strength modifier or Dexterity modifier, and a failed attempt doesn't result in you being disarmed or knocked prone (if attempting a disarm or trip). No save is allowed against these attempts, but power resistance applies normally.

Augment: For every 2 additional power points you spend, this power grants a +1 bonus on your CMB.`
  },
  Temporary_Awakening: {
    name: "Temporary Awakening",
    discipline: "Psychometabolism or telepathy (mind-affecting)",
    level: "Psion/wilder 4, vitalist 4",
    display: "Visual",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One sentient creature without the psionic subtype",
    area: "",
    duration: "see text (D)",
    savingThrow: "none",
    powerResistance: "No",
    powerPoints: "7",
    description: `Inside everyone there is a spark that can be fanned into true power. You trigger a temporary awakening of psionic power inside a creature that had none before, temporarily sharing some of your own insights and fueling their internal power. The more powerful the target is, the more power they can contain, but their knowledge is temporary, a gift from you. Choose one 1st level power that you know, as long as this power is in effect, you cannot use the power. The target gains access to that 1st level power, gains 1 power point and a manifester level of 1, and a number of bonus power points as if his hit dice was his manifester level and his highest mental ability score was his primary manifesting ability score (which it also is for purposes of this granted power). Each morning the target can meditate to regain these power points as normal but if they ever are reduced to 0 power points, this power ends. The target can also recharge their power points from cognizance crystals as if he was a true manifester. Both the original manifester and the target can end this power as a swift action at any time.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, you can choose another 1st level power you know to gift the target, but you lose access to this power for the duration of this power.

• 1. If you spend 4 additional power points, the target gains a 2nd level power in addition to the 1st level power and has an effective manifester level of 3 for the purposes of manifesting these powers. You lose access to this 2nd level power for the duration.`
  },
  Trace_Psychoport: {
    name: "Trace Psychoport",
    discipline: "Clairsentience",
    level: "Gambler 4, psion/wilder 4, sighted seeker 4, voyager 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "Spread with a radius of 25 ft. + 5 ft./2 levels, centered on you",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `Detect Teleportation[]

You sense the use of any effects of the teleportation subdiscipline within the area. You sense the use of these powers whether or not you have line of sight or line of effect (although a force effect prevents this detection). When you sense the use of an appropriate power, you know the direction in which the power was used, though not the distance or the exact effect.

Augment: If you spend 2 additional power points, this power's range increases to Medium (100 ft. + 10 ft./level).

Trace Psychoport[]

As detect teleportation , except you can trace the destination of any psionic or magical teleportation made by others within this power's area within the last minute.

You know the direction and distance the individuals traveled and could teleport to the location yourself if you so desired (and if you know the psychoport power), as if you had “seen casually” the location. This power does not grant you any information on the conditions at the other end of the trace beyond the mental coordinates of the location.

Augment: If you spend 2 additional power points, this power's range increases to Medium (100 ft. + 10 ft./level).`
  },
  Vacuum_Ball: {
    name: "Vacuum Ball",
    discipline: "Psychoportation",
    level: "Cryptic 3, dread 3, psion/wilder 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One creature",
    area: "",
    duration: "Concentration up to 1 round/level",
    savingThrow: "Reflex negates; see text",
    powerResistance: "Yes",
    powerPoints: "Cryptic 5, dread 5, psion/wilder 7",
    description: `A skin of force abruptly surrounds your foe, then the environment within changes to mimic the hostile space between worlds. When you target a creature with this power, you transport the atmosphere and environment that surrounds them to space, leaving behind an area of vacuum. An affected creature immediately takes 3d6 points of damage from sudden decompression. Additionally, the area within a vacuum ball does not support the transmission of sound, so is treated as if under the effects of silence . Finally, a creature within a vacuum ball begins suffocating if they need to breathe.

A creature cannot escape from a vacuum ball by means of movement; the hostile area follows them as they move. This does not prevent escape by means of psychoportive travel such as fold space . If a creature does manage to escape the confines of a vacuum ball , the power immediately ends.

The membrane surrounding a vacuum ball is semipermeable, allowing the surrounded creature to act normally in most ways. They are still able to make melee and ranged attacks (though items and abilities relying on air such as firearms may not function). Fire does not function within a vacuum ball , so carried torches will be immediately extinguished, but this does not interfere with powers with a duration of instantaneous from harming a creature within if they deal fire damage. A flaming weapon is suppressed while its wielder is within a vacuum ball .

Mythic Vacuum Ball

A creature within the confines of a mythic vacuum ball takes an additional 3d6 points of damage each round that you maintain concentration. After five rounds of being contained with a mythic vacuum ball , such a creature's blood vessels begin to rupture. Such a creature must make a Fortitude save (DC same as the power's) or become temporarily blind. This blindness ends two rounds after this power ends.`
  },
  Wall_of_Ectoplasm: {
    name: "Wall of Ectoplasm",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 4, highlord 4, psion/wilder 4, tactician 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `Effect: Wall whose area is up to one 10-ft. square/level or a sphere or hemisphere with a radius of up to 1 ft./level

You fashion a roiling wall of ectoplasm, imbuing it with solidity. The wall cannot move once it is formed. It is 1 inch thick per four manifester levels and occupies up to one 5-foot square per level. Each 5-foot square of the wall has 10 hit points per inch of thickness and hardness 5. A section of the wall whose hit points drop to 0 is breached. If a creature tries to break through the wall, the DC for the Strength check is 15 + 2 per inch of thickness.

The wall of ectoplasm is susceptible to dispel psionics , but it gains a +4 bonus on any check to determine whether the wall is negated. Spells, powers, and breath weapons cannot pass through the wall in either direction (though they could damage it). It blocks ethereal creatures as well as material creatures (though ethereal creatures can usually get around the wall by floating under or over it through material floors and ceilings). The wall is opaque, so neither vision nor gaze attacks operate through it. The wall does not block psychoportive travel, such as that provided by the psychoport power.

You can form the wall into a flat plane whose area is up to one 10-foot square per level or into a sphere or hemisphere with a radius of up to 1 foot per level.

The wall of ectoplasm must be continuous and unbroken when manifested. If its surface is interrupted by any object or creature, the power fails.`
  },
  Waters_of_Lethe: {
    name: "Waters of Lethe",
    discipline: "Athanatism",
    level: "Psion/wilder 4",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One incorporeal creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You draw on the powers of Lethe to wipe away the past of an incorporeal creature. Starting with the present, you can wipe all memories going back a number of days equal to 2 per level. This can erase anger, rage, frustration, or even knowledge of the target's cause of death. Following the use of this power, you or others may attempt to “fill in” these blanks using skill checks or roleplaying, at the GM's discretion.`
  },
  Wither: {
    name: "Wither",
    discipline: "Psychometabolism",
    level: "Gambler 4, psion/wilder 4, vitalist 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Your touch disrupts the target's physical form, draining the strength from its muscles. The creature suffers 2d4 points of Strength damage. A successful Fortitude save halves the Strength damage taken.

Augment: For each additional 4 power points spent, this power causes an additional 1d4 points of Strength damage.`
  },
  Adapt_Body: {
    name: "Adapt Body",
    discipline: "Psychometabolism",
    level: "Cryptic 5, highlord 5, psion/wilder 5, psychic warrior 5, tactician 5, vitalist 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `Your body automatically adapts to hostile environments. You can adapt to underwater, extremely hot, extremely cold, or airless environments, allowing you to survive as if you were a creature native to that environment. You can breathe and move (though penalties to movement and attacks, if any for a particular environment, remain), and you take no damage simply from being in that environment. You need not specify what environment you are adapting to when you manifest this power; simply activate it, and your body will instantly adapt to any hostile environment as needed throughout the duration.

You can somewhat adapt to extreme environmental features such as acid, lava, fire, and electricity. Any environmental feature that normally directly deals 1 or more dice of damage per round deals you only half the usual amount of damage.

Adapt Body (Mythic)[]

Each time you move from one plane to another while this power is in effect, you can shift the power's effects as a swift action to adapt you to the new plane. When you adapt yourself to a plane, you may choose to gain energy resistance 30 to one type of energy associated with that plane, energy resistance 20 to two forms of energy associated with that plane, or energy resistance 10 against acid, cold, electricity, fire, and sonic. You must make this choice when you enter a new plane and you may not change the selected resistance(s) unless you shift to a new plane.

Augmented (3rd): If you expend one use of mythic power, you can target a number of additional creatures equal to your mythic tier to a gain the effects of mythic adapt body.`
  },
  Atmospheric_Generation: {
    name: "Atmospheric Generation",
    discipline: "metacreativity (creation)",
    level: "marksman 4, psion/wilder 5, vitalist 5",
    display: "olfactory and material",
    manifestingTime: "1 round",
    range: "medium (100 feet + 10 feet/level)",
    target: "",
    area: "",
    duration: "1 minute/level",
    savingThrow: "see text",
    powerResistance: "no",
    powerPoints: "cryptic 9, marksman 7, psion/wilder 9",
    description: `Effect: atmosphere in a 20-foot spread, 20 feet high

You manifest an area of regulate atmospheric conditions, controlling pressure, air composition, and other factors inside of it. The atmosphere simulates the air makeup of a location of your choice, allowing creatures which would be comfortable in the conditions you specify to effectively breathe and speak regardless of local conditions (for example, if you manifested this power in the void of space, terrestrial creatures inside the atmosphere would be capable of breathing and speaking normally if you choose to simulate an atmosphere similar to the one on their home planet or a similar planet). This atmosphere is held together by an intangible mesh of ectoplasm and psionic energy, preventing it from being dispersed.

Alternatively, this power can be used to simulate an atmosphere with more hostile effects. If the manifester so wishes, she may apply one of the following effects to the generated atmosphere. However, depending on how the manifester specifies the composition, what may be harmful to one creature may not be problematic for another, and vice versa (for example, a methane-based atmosphere may sustain creatures from such world but harm humans).

Acidic : The air deals 5d6 points of acid damage each round to all creatures inside (fortitude half)

Airless : The area is deprived of a component that certain types of creatures require in order to breathe. Those inside must hold their breath, eventually suffocating if they remain inside for too long.

Foggy : The atmosphere is full of fog, or otherwise makes it difficult to see through. The fog obscures all sight, including darkvision, beyond 5 feet. A creature within 5 feet has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker can't use sight to locate the target).

Highly Flammable : The air inside the atmosphere has a high content of oxygen or other flammable gas. If an open flame comes inside the area, the atmosphere explodes and is destroyed, dealing 10d6 damage to all creatures inside the area (reflex half).

High Pressure : The air pressure is unusually high, causing all creatures inside to have their movement speed reduced to 10 feet for so long as they remain inside.

Low Pressure : The air is abnormally thin, resulting in creatures struggling to fight in the comparative emptiness. Creatures take a -4 penalty to their CMD and AC.

Toxic : The air is hazardous to creatures inside the area. All entities inside must make a fortitude save each round or take 1d4 points of constitution damage (fortitude half). This is a poison effect, and creatures that do not need to breathe are unaffected by this damage.

Unusual Temperature : The atmosphere's temperature warms or cools to a comfortable 60 degrees. Alternatively, the atmosphere may increase or decrease the temperature inside of it by 30 degrees.

Other physical implications may occur as a result of this power's effects, in which case they are subject to the will of the GM.

This power can be made permanent by use of an incarnate power whose manifester level is at least 13 at a cost of 12,500 gp worth of components.

Augment: This power can be augmented in the following ways:

• For every 2 additional power points you spend, you may cause an additional hazardous effect within the atmosphere.

• For every 2 additional power points you spend, you may alter the temperature by an additional 30 degrees in either direction

• If you spend 4 additional power points, you may choose to center the effect on a single creature. The atmosphere surrounds the creature, moving with them. The creature is allowed a fortitude save to negate this effect, in which case the atmosphere simply appears in their area.

• If you spend 2 additional power points, you may move the area of this effect up to 20 feet in any direction as a standard action

• For every 4 additional power points you spend, the area of this effect increases by 20 feet in all directions.

• For every 2 power points you spend augmenting this power (including as part of other augmentations), the save DC increases by 1.`
  },
  Catapsi: {
    name: "Catapsi",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 5, highlord 5, psion/wilder 5, psychic warrior 5, tactician 5",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft.-radius emanation centered on you",
    duration: "1 round/level",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `By manifesting this power, you generate psychic static, interfering with the ability of other psionic characters to manifest their powers or use psi-like abilities (you are not affected by your own catapsi manifestation). All psionic activity within the area requires 4 more power points to manifest than normal, unless a character makes a Will save each time he attempts to manifest a power. Using a psi-like ability becomes a full-round action, instead of a standard action, in a catapsi field. If two or more fields of catapsi overlap, the effects are not cumulative.

The limit on the number of power points a subject can spend on a power remains in effect; thus, a subject may not be able to manifest its highest-level powers. If manifesting a power would cause the manifester to exceed his available power points or his spending limits, the manifestation fails automatically, but no power points are expended.

Augment: For every 4 additional power points you spend, this power's range and the radius of its area both increase by 5 feet.

Mythic Catapsi[]

The psychic static only affects those creatures you wish to affect in the area and the range increases to 60 feet.

Augmented: If you expend one use of mythic power, creatures that fail their save while manifesting a power or using a psi-like ability are staggered for one round.

Augmented (5th): If you expend two uses of mythic power, non-mythic creatures in the affected area are unable to manifest any psionic powers or psi-like abilities unless they succeed on the saving throw, and non-mythic creatures that make their saving throw are still required to pay the additional power point cost or, for psi-like abilities, use a full-round action to activate the ability.`
  },
  Coded_Resurrection: {
    name: "Coded Resurrection",
    discipline: "athanatism",
    level: "cryptic 5, dread 5, highlord 5, psion/wilder 5, tactician 5, vitalist 5",
    display: "mental",
    manifestingTime: "1 standard action",
    range: "touch",
    target: "dead creature touched",
    area: "",
    duration: "instantaneous",
    savingThrow: "see text",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `A creature's not-quite-departed soul is returned to this world to be encoded upon a device. Such a device, such as a storage bay, compact AI core or robot which your artificial intelligence will inhabit, must be present at the time of this manifestation, as must be the body of creature from which you are obtaining the information. The creature becomes an AI, which possesses the same intelligence, wisdom, and charisma scores as the creature from which it is born, and possesses all of the base creature's skills, supernatural abilities, saves, feats, and class features (including the ability to manifest powers). The AI's CR is equal to the base creature's effective class level. The AI gains no additional skills, feats, languages, or special abilities from the Artificial Intelligence creature type. If the AI is being stored in a robot, the robot is allowed a will save to prevent itself from being taken over by the new AI.

Editor's Note: When asked, the dev stated that this power has a timescale akin to raise dead , i.e. it can only work on creatures who have been dead for no longer than 1 day per manifester level.`
  },
  Dream_Message: {
    name: "Dream Message",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 5, psion/wilder 5",
    display: "Mental",
    manifestingTime: "One minute",
    range: "Unlimited",
    target: "One living creature touched",
    area: "",
    duration: "See text",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You, or a messenger you touch, send a message to others in the form of a dream. At the beginning of the effect, you must name the recipient or identify him or her by some title that leaves no doubt as to identity. The messenger then enters a trance, appears in the intended recipient's dream, and delivers the message. The message can be of any length, and the recipient remembers it perfectly upon waking. The communication is one-way. The recipient cannot ask questions or offer information, nor can the messenger gain any information by observing the dreams of the recipient. Once the message is delivered, the messenger's mind returns instantly to its body. The duration of the power is the time required for the messenger to enter the recipient's dream and deliver the message.

If the recipient is awake when the power begins, the messenger can choose to wake up (ending the effect) or remain in the trance. The messenger can remain in the trance until the recipient goes to sleep, then enter the recipient's dream and deliver the message as normal. A messenger that is disturbed during the trance comes awake, ending the effect.

Creatures who don't sleep or don't dream cannot be contacted by this power.

The messenger is unaware of its own surroundings or of the activities around it while in the trance. It is defenseless both physically and mentally (always failing any saving throw) while in the trance.

Augment: If the recipient is awake when you begin to manifest the power, the messenger can choose to expend a number of power points (if the messenger is psionic) equal to the recipient's Hit Dice -4 to plant the message, which the recipient receives when next she sleeps.`
  },
  Ectoplasmic_Creation_Major: {
    name: "Ectoplasmic Creation, Major",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 9",
    display: "Material",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "17",
    description: `Ectoplasmic Creation[]

Effect: Unattended, nonpsionic, nonmagical object of nonliving matter, up to 1 cu. ft./level

You shape raw ectoplasm into a nonmagical, unattended object of nonliving, organic matter. The volume of the item created cannot exceed 1 cubic foot per manifester level. You must succeed on an appropriate Craft skill check to make a complex item.

Attempting to use any created object as a material component for spells causes the spell to fail.

Ectoplasmic Creation, Major[]

This power functions like ectoplasmic creation, except that you can also create an object of mineral nature: stone, crystal, metal, or the like. The duration of the created item varies with its relative hardness and rarity, as indicated on the following table.

* Includes adamantine, alchemical silver, and mithral. You can't use major ectoplasmic creation to create a cold iron item. Additional rare items are possible at the GM's discretion, but should typically be limited to 1 round/level.

True Creation[]

As major ectoplasmic creation , except items created are enduring and cannot be negated by dispelling magic or negating powers. For all intents and purposes, these items are completely real.

You suffer one point of ability burn to your key ability score per 5,000 gp value of the item created. You suffer no ability burn if the value of the item created is under 50 gp.

Mythic Ectoplasmic Creation[]

You may choose to increase the duration of the items you create to 1 day/level or increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.

Mythic Major Ectoplasmic Creation[]

You may choose to increase the duration of the vegetable matter, stone, crystal, or base metal items you create to 1 day/level, precious metals or gems to 1 hour/level, or rare metals to 1 minute/level; or you may increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.`
  },
  Ectoplasmic_Shambler: {
    name: "Ectoplasmic Shambler",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 5, psion/wilder 5",
    display: "Auditory, material, and olfactory; see text",
    manifestingTime: "1 round",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "",
    duration: "1 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `Effect: One ectoplasmic manifestation of a size equal to ten 10-ft. cubes (S)

You fashion an ephemeral, many-legged mass of pseudo-living ectoplasm called an ectoplasmic shambler. You can direct the shambler as a free action. It has a speed of 10 feet. It can completely surround objects (and opponents) over which it is manifested or onto which it moves, because it has the consistency of thick mist. The vision of those within the shambler is limited to 5 feet, and manifesting powers (or casting spells) within the shambler is difficult due to the constant turbulence felt by those caught in the shambler's form. Vision through the shambler is similarly impaired for those outside the shamble.

Creatures enveloped by the shambler, regardless of Armor Class, take 1 point of damage for every two manifester levels you have in each round they become enveloped in or remain within the roiling turbulence of the shambler. Anyone trying to manifest a power must make a concentration check (DC 15 + power's or spell's level) to successfully manifest a power or cast a spell inside the shambler.

A wind stronger than 20 miles per hour that blows against the shambler reduces its speed to 0 feet during the first round, and in subsequent rounds moves it in the direction of the wind at a speed of 5 feet. A wind stronger than 20 miles per hour that blows in the direction the shambler travels increases its speed to 15 feet.

Mythic Ectoplasmic Shambler[]

The damage taken while inside the shambler is increased by 1 point per tier per round and the concentration DC to manifest a power or cast a spell is increased by your tier. Creatures within the shambler have their movement reduced to half speed.

Augmented (3rd): If you expend one use of mythic power, all creatures within the shamble are entangled. The shambler's speed becomes 20 feet and is immune to wind effects.`
  },
  Ghostly_Possession: {
    name: "Ghostly Possession",
    discipline: "Athanatism [polymorph]",
    level: "Dread 5, psion/wilder 5",
    display: "Auditory and material",
    manifestingTime: "1 round",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "9",
    description: `You adopt a ghostlike form. You are treated as incorporeal, but you may not make attacks, cast spells, or manifest powers in this state. Instead, you gain a single use of the following ability: you can merge your body with an adjacent creature that you can see on the Material Plane. While you are merged with the creature, its life force is temporarily trapped outside its body, unable to act, but visible on the Ethereal Plane. You keep your Intelligence, Wisdom, Charisma, level, class, base attack bonus, base save bonuses, alignment, and mental abilities (including psionics). The body retains its Strength, Dexterity, Constitution, hit points, natural abilities, and automatic abilities. You can't choose to activate this body's extraordinary or supernatural abilities. The creature's powers and psi-like abilities do not stay with the body. The target can negate this possession with a successful Will save. A creature that successfully saves cannot be possessed by you again for 24 hours. If this power expires or the creature dies while you are possessing it, the possession immediately ends, placing you in a square of your choice adjacent to the possessed creature.`
  },
  Incarnate: {
    name: "Incarnate",
    discipline: "Metacreativity",
    level: "Highlord 5, psion/wilder 5, tactician 5, vitalist 5",
    display: "Material",
    manifestingTime: "2 rounds",
    range: "See text",
    target: "",
    area: "",
    duration: "Permanent; see text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `Target, Effect, or Area: See text

This power makes certain other powers permanent by mimicking the qualities of psionic tattoos. Depending on the power to be affected, you must be of a minimum manifester level and must expend a specific gp value of diamond dust and tattoo ink.

You can make the powers on the incarnate power list permanent only in regard to yourself, and must have a manifester level at least 8 higher than the level of the power to be made permanent. Powers made permanent in this way can be dispelled only by a manifester of higher level than you were when you manifested the power. Powers made permanent by incarnate are not shared through the fission power, and the effect does not end when fission ends. You manifest the desired power and then follow it with the incarnate manifestation.

Additionally, at the GM's discretion, additional powers may be made permanent using the following formula: GP cost = (Minimum Manifester Level - 8) x 2,500 GP. Should the power being made permanent be augmented, increase the GP cost by 1,250 GP for every power point spent on augmentation.

Mythic Incarnate[]

A mythic incarnate (and any effect it makes permanent) cannot be dispelled by non-mythic means, up to and including non-mythic mage's disjunction or unravel psionics , and you add your mythic tier to DC of manifester level checks made to dispel your mythic incarnate even with mythic effects. If you use mythic incarnate on yourself, it can be dispelled only by a mythic creature, and only if their manifester level plus their mythic tier exceeds your manifester level plus your mythic tier.

Augmented: You can reduce the gp cost of manifesting mythic incarnate by 500 gp per use of mythic power you expend while manifesting the power.

Augmented (3rd): If you expend two uses of mythic power, you can target a psionic item with mythic incarnate while spending 1,000 gp times the item's manifester level. That item gains immunity to having its powers negated or suppressed by any non-mythic effect, including a non-mythic null psionics field, dispel psionics, unravel psionics, rod of cancellation , or rod of negation .`
  },
  Induce_Nightmare: {
    name: "Induce Nightmare",
    discipline: "Telepathy [Evil, Mind-Affecting]",
    level: "Dread 5, psion/wilder 5",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "Unlimited",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You send a hideous and unsettling phantasmal vision to a specific creature that you name or otherwise specifically designate.

The nightmare prevents restful sleep and causes 1d10 points of damage. The nightmare leaves the subject fatigued and unable to regain power points and arcane spells for the next 24 hours.

The difficulty of the save depends on your knowledge the subject and the physical connection (if any) you have to that creature.

*You must have some sort of connection to a creature you have no knowledge of.

Dispel evil cast on the subject while you are manifesting the power dispels the nightmare and causes you to be stunned for 10 minutes per caster level of the dispel evil . If the recipient is awake when the power begins, you can choose to cease manifesting (ending the power) or to enter a trance until the recipient goes to sleep, whereupon you become alert again and complete the casting. If you are disturbed during the trance, you must succeed on a Concentration check as if you were in the midst of manifesting a power or the power ends.

If you choose to enter a trance, you are not aware of your surroundings or the activities around you while in the trance.

You are defenseless, both physically and mentally, while in the trance. (You always fail Reflex and Will saving throws, for example.)

Creatures who don't sleep (such as elves, but not halfelves) or dream are immune to this effect.

Augment: For every 2 additional power points spent, this power causes an additional 1d10 points of damage when the sleeper wakes.

Mythic Induce Nightmare[]

The power's damage increases to 4d6 points of damage for each 1d10 damage it would have dealt, and the target is also shaken for 24 hours.

Augmented (6th): You can deliver a mind-affecting power through a mythic induce nightmare . The maximum level of the delivered power  is  equal  to half your tier, and you must expend one use of mythic power for each power level of the imbued power in addition to the two uses needed to manifest mythic induce nightmare . You choose whether the delivered power affects the creature immediately or when it awakens. The delivered power affects only the target, even if it normally affects multiple creatures or an area.`
  },
  Leech_Field: {
    name: "Leech Field",
    discipline: "Psychometabolism",
    level: "Psion/wilder 5, vitalist 5",
    display: "Visual; see text",
    manifestingTime: "1 standard action",
    range: "Personal; see text",
    target: "You",
    area: "",
    duration: "1 min.",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `You raise a field of potentiality that drains the vitality from powers that you successfully save against. When you succeed on a saving throw against a foe's power on you, your body erupts in a brief flash of crackling dark energy. You gain 1 power point for every 2 power points your foe spent to manifest the power you just saved against (to a maximum number of points equal to your manifester level). You cannot gain power points that would cause you to exceed your normal daily maximum.

This power is effective against any power that targets a single creature or has an area of effect and allows the target a saving throw. This power also works against spells that would affect you. The power points gained from saving against spells is 1 power point per spell level cast.

If multiple creatures are under the effect of leech field and succeed on a saving throw against the same manifestation of a power or casting of a spell, the power points that would be gained are divided evenly among all affected creatures. For example, if two creatures under the effect of leech field successfully saved against a 12 power point manifestation of energy ball , each would only gain 3 power points.

Augment: For every 2 additional power points you spend, this power's duration increases by 1 minute.

Mythic Leech Field[]

The power points gained are not divided if two or more creatures are under the effects of mythic leech field and succeed on a saving throw against the same manifestation of a power or casting of a spell.

Augmented (3rd): If you expend one use of mythic power, the manifester or caster of the spell that triggers mythic leech field must make a Will saving throw or lose a number of power points equal to those you gain, or a random spell of the spell level equal to half of the number of power points gained.`
  },
  Lifeseeker: {
    name: "Lifeseeker",
    discipline: "Athanatism",
    level: "Cryptic 5, Dread 5, Highlord 5, Marksman 4, Psychic Warrior 5, Psion/Wilder 5, Tactician 5",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "personal",
    target: "",
    area: "60-foot radius spread centered on manifester",
    duration: "10 minute/level",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "Marksman 7, Others 9",
    description: `Reaching out, you probe the area around you for any signs of life, detecting all souls or other entities that wander your vicinity. You automatically detect any living creatures that are in the area, knowing their exact location. This ability works even through physical barriers, and line of effect is not required in order to sense an entity with this ability. This ability only works on living creatures, so undead, objects, and constructs are not detected.

Augment

• If you spend 4 additional power points, you automatically possess line of effect with your psionic powers on any creature that you detect, even if it would otherwise be on the other side of some obstacle.

• If you spend 4 additional power points, this power also works on undead and constructs.

• For every additional power point you spend, the range of this ability increases by 5 feet`
  },
  Manifest_Veil: {
    name: "Manifest Veil",
    discipline: "Metacreativity",
    level: "All 5",
    display: "Olfactory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "1 minute/level (D)",
    savingThrow: "Will negates (harmless)",
    powerResistance: "No",
    powerPoints: "9",
    description: `

You shape the essence of this power into a veil and manifest it around the touched creature. Choose a veil that can be shaped in the following chakra slots: Hands, Feet, Head.

You immediately shape that veil into the selected chakra slot of the touched creature. This veil is treated as bound to its chakra for the duration of this spell, after which the veil is unshaped. If the creature already has a veil shaped in that slot, this spell fails. If this veil is sundered, this spell immediately ends.

The creature uses your manifester level as its veilweaving level for that veil, to a maximum of their Hit Dice, and its Wisdom as its veilweaving modifier. If the creature is already a veilweaver, they may use their own veilweaving modifier and their own veilweaving level, if they are higher.

Additionally, the creature gains a number of temporary essences equal to their maximum essence capacity. This temporary essence is immediately invested into the veil. When the spell ends, or If the essence is removed from the veil, these points of temporary essence are lost.

Augment: For every 2 additional power points spend, you can shape veils from a more powerful slot in the following order: Wrists -> Shoulders -> Headband -> Neck -> Belt`
  },
  Mental_Evolution: {
    name: "Mental Evolution",
    discipline: "Psychometabolism",
    level: "Cryptic 5, Dread 5, Highlord 5, Psion/Wilder 5, Tactician 5, Vitalist 5",
    display: "Olfactory, Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 feet + 10 feet/level)",
    target: "one creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `Reaching into a creature's mental faculties, you radically alter the thinking capacity of your target, enhancing it to sophisticated intelligence or reducing it to animalistic instinct.

: If this ability is used on a creature with an Intelligence score of 2, 1, or -, the manifester rolls 3d6 and changes the creature's Intelligence score to the result. In addition, the creature's Charisma score increases by +1d6, or +2d6 if the creature was originally mindless. The creature gains feats and skills as appropriate to its new Intelligence score, and gains the ability to understand one language that the manifester knows plus an additional number equal to its Intelligence modifier. The affected creature is friendly toward you and is of an alignment chosen by the manifester. However, the manifester has no special empathy or connection with a creature affected in this way.

If this power is used on an intelligent creature (Intelligence score of 3 or higher), the power instead has a degrading effect. The target creature's Intelligence and Charisma scores each drop to 1. The affected creature is unable to use Intelligence- or Charisma- based skills, cast spells, manifest powers, understand language, or communicate coherently. Still, it knows who its friends are and can follow them and even protect them.

The effects of this power can only be removed via psychic chirurgery, bend reality, cleanse spirit, or similarly powerful magic.

Augment

• If you expend 2 additional power points, you may give a creature whose Intelligence score you increase the ability to speak any language that it understands.

• If you spend 2 additional power points, this power ignores power resistance.

• For every 2 additional power points you spend (including those spent as part of other augments), the DC of this power increases by 1.`
  },
  Mind_Trap: {
    name: "Mind Trap",
    discipline: "Telepathy [mind-affecting]",
    level: "cryptic 5, dread 5, highlord 5, psion/wilder 5, tactician 5, voyager 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level or until discharged",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `You store a single power in your mind as a trap to any who would trespass there. When you manifest this power, select another power you know with a range of close or greater, and a target of 'one creature'. That power is stored inside your mind trap (you may still manifest it normally).

When you succeed at a saving throw against a mind-affecting power, spell, or ability, you may trigger the stored power, targeting the source of the effect you saved against (regardless of the distance between you and that source). You must pay all costs associated with the power, and may augment it as normal.

Augment: For every 4 additional power points you spend, you may trigger the power stored in your mind trap an additional time. You still need to pay all costs associated with the triggered power each time you use it.`
  },
  Pierce_the_Veils: {
    name: "Pierce the Veils",
    discipline: "Clairsentience",
    level: "Cryptic 5, dread 5, gambler 5, marksman 4, psion/wilder 5, voyager 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 9, dread 9, marksman 7, psion/wilder 9, voyager 9",
    description: `You gain the ability to see all things as they actually are. You see through normal and psionic darkness, notice secret doors hidden by psionics, see the exact locations of creatures or objects under blur or displacement effects, see invisible creatures or objects normally, see through illusions, and see the true form of polymorphed , changed, or transmuted things. Further, you can focus your vision as a standard action to instead see into the Ethereal Plane (but not into extradimensional spaces). The visual range of the effect conferred is 120 feet.

This does not, however, penetrate solid objects. It in no way confers X-ray vision or its equivalent. It does not negate concealment, including that caused by fog and the like. This effect does not help you see through mundane disguises, spot creatures that are simply hiding, or notice secret doors hidden by mundane means. In addition, the effects cannot be further enhanced with known magic, so one cannot use this power through a crystal ball or in conjunction with effects such as clairaudience / clairvoyance .`
  },
  Planar_Travel: {
    name: "Planar Travel",
    discipline: "Psychoportation",
    level: "Dread 5, gambler 5, psion/wilder 5, voyager 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `Targets: Willing creature touched, or up to eight willing creatures joining hands

You move yourself or some other creature to another plane of existence or alternate dimension. If several willing persons link hands in a circle, as many as eight can be affected by the power at the same time. Precise accuracy as to a particular arrival location on the intended plane is nigh impossible. From the Material Plane, you can reach any other plane, though you appear 5 to 500 miles (5d%) from your intended destination. Planar travel transports creatures instantaneously and then ends. The creatures need to find other means if they are to travel back (including manifesting planar travel again).

Augment: For every two additional power points spent, the number of d% rolled is reduced by 1, to a maximum of -5, when the power places you at your intended destination.`
  },
  Power_Resistance: {
    name: "Power Resistance",
    discipline: "Clairsentience",
    level: "Highlord 5, psion/wilder 5, tactician 5, vitalist 5",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "9",
    description: `The creature gains power resistance equal to 12 + your manifester level.`
  },
  Psychic_Crush: {
    name: "Psychic Crush",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 5, gambler 5, psion/wilder 5, voyager 5",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will partial; see text",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `Your will abruptly and brutally crushes the mental essence of any one creature, debilitating its acumen. The target must make a Will save with a +4 bonus or collapse unconscious and dying at -1 hit points. If the target succeeds on the save, it takes 3d6 points of damage.

Augment: For every 2 additional power points you spend, this power's damage on a successful save increases by 1d6 points and its save DC increases by 1.`
  },
  Rending_Force: {
    name: "Rending Force",
    discipline: "Psychokinesis [force]",
    level: "psion/wilder 5",
    display: "Material",
    manifestingTime: "1 full-round action",
    range: "close (25 ft. + 5 ft./2 levels)",
    target: "one creature",
    area: "",
    duration: "instantaneous",
    savingThrow: "Fortitude partial (see text)",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You rip the body of the target creature apart with telekinetic force, rending it limb from limb. The target creature suffers 9d6 points of damage. If this damage reduces the target's hit point total by more than half, a limb is removed from the creature's body flies 15 feet in a random direction away from the creature and causes the affected creature to bleed. The creature suffers one additional 5 points of damage each round. The bleeding can be stopped by a DC 15 Heal check or the application of any effect that heals hit point damage, but the limb can only be restored by powerful healing effects such as regeneration or heal .

If the damage reduces the target's hit points to below zero, all of its limbs are affected in this fashion.

Creatures without a discernible anatomy or limbs are unaffected by rending force .

Augment: This power can be augmented in one or more of the following ways.

• If you spend 2 additional power points, the damage dealt uses d8 instead of d6.

• If you spend 2 additional power points, a limb is removed if the damage reduces the target's hit point total by more than 1/4.

• If you spend 2 additional power points, the target is also sickened if a limb is removed.

In addition, for each power point spent augmenting this power, the damage increases by an additional die of damage.`
  },
  Riding_the_Shell: {
    name: "Riding the Shell",
    discipline: "Athanatism [spirit]",
    level: "Cryptic 5, psion/wilder 5",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One living creature",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You take a ghostlike form, leaping into the body of a nearby creature. For the duration of the power, you see and hear everything they do, can not be attacked or affected in any way, and can only take purely mental actions, but may not regain your psionic focus, manifest powers, or use psi-like abilities. The duration of this power may be extended to 1 hour/level by targeting a willing creature. If you were hidden from the target at the time of manifestation, they are not aware of this power or that you are currently inhabiting them.

Augment: By spending an additional 2 power points, you may expend your psionic focus as a standard action at any time during the duration of this power to manifest a single power or use a single psi-like ability. You may not apply metapsionic feats to a power manifested this way.`
  },
  Shatter_Mind_Blank: {
    name: "Shatter Mind Blank",
    discipline: "Telepathy",
    level: "Gambler 5, psion/wilder 5",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "30 ft.",
    target: "",
    area: "30-ft.-radius burst centered on you",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `This power can negate a barred mind, mind blank, or a personal barred mind affecting all creatures within range. If the affected creatures fail their saves and do not overcome your attempt with power resistance, you can shatter the effects by making a successful check (1d20 + your manifester level, maximum +20) against a DC equal to 11 + the manifester level of the creator of each of the effects. If you succeed, the barred mind or mind blank effect ends. Use the same check against each barred mind, mind blank, or personal barred mind effect.

Augment: By spending an additional 4 power points, you may designate creatures within the affected area who are not affected by your manifestation of shatter mind blank .`
  },
  Shrapnel_Burst: {
    name: "Shrapnel Burst",
    discipline: "Metacreativity",
    level: "Gambler 5, highlord 4, psion/wilder 5, psychic warrior 4",
    display: "Mental, Visual",
    manifestingTime: "1 standard action",
    range: "",
    target: "",
    area: "40 ft. burst",
    duration: "Instantaneous",
    savingThrow: "Reflex half",
    powerResistance: "No",
    powerPoints: "Highlord 7, psion/wilder 9, psychic warrior 7",
    description: `You emit a burst of crystalline shrapnel, dealing 9d6 points of piercing damage to all creatures within a 40 ft. burst centered on you.

Augment: For every additional power point you spend, the power deals an additional 1d6 points of damage. For every two additional dice of damage, the save DC is increased by 1.`
  },
  Soul_Exchange: {
    name: "Soul Exchange",
    discipline: "Athanatism",
    level: "Psion/wilder 5, vitalist 5",
    display: "Material and mental",
    manifestingTime: "1 round",
    range: "Touch",
    target: "Willing, living creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `You muddle that which affects a soul, switching them between different souls. You and the target exchange all soul-based curses, blessings, or effects. In addition, you exchange all mental ability damage and drain, as well as negative levels. If any of these effects could be reduced or removed with a save, their new owner may attempt a new save against each such effect. This does not count as if you gained a new version of whatever effect you receive - instead, the duration on any of these effects continues as normal, just as if nothing had happened. If either target is possessed when you manifest this power, the possessing entity may succeed on a Will save to choose one of the targets to transfer to - otherwise, they remain with the body they were originally possessing.

Augment: By spending an additional 4 power points, this power may target an unwilling, living creature touched, unless they succeed on a Will save. Power resistance provides protection from this use as normal.`
  },
  Soul_Feast: {
    name: "Soul Feast",
    discipline: "Athanatism",
    level: "Dread 5, psion/wilder 5",
    display: "Olfactory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One corpse",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `You devour the most delectable parts of the souls of the fallen. The target must have been dead no more than 1 round per manifester level. You gain a soul pool, with soul points equal to the target's HD plus its Charisma modifier. You may spend one or more soul points from this pool to grant yourself one of the following bonuses: heal a point of ability damage (this costs 3 soul points), heal a point of ability drain (this costs 5 soul points), heal a negative level (7 soul points), or gain temporary hit points equal to the target's HD (1 soul point). Spending soul points from a soul pool is always a free action.

The soul pool and any bonuses or temporary hit points granted by this power vanish at the end of the day. In addition, anyone attempting to return a target of this power to life or raise a target of this power as an undead creature must succeed on an opposed manifester level check with you - if they fail, the attempt fails. If you manifest this power while you have soul points in your soul pool (such as from a previous manifestation of this power), the previous soul pool is emptied, and all bonuses or temporary hit points gained from it are immediately lost.

Augment: You may augment this power in one of the following ways.

• You may spend an additional 2 power points to share this feast with one ally that is also adjacent to the target. That ally gains temporary hit points equal to the target's HD. These temporary hit points vanish at the end of the day.

• By spending an additional 2 power points, while you have one or more soul points from this power, you gain a bonus on saves against negative energy, death effects, and energy drain equal to the target's Charisma modifier.`
  },
  Tortured_Visions: {
    name: "Tortured Visions",
    discipline: "Athanatism [mind-affecting, evil]",
    level: "Dread 4, psion/wilder 5",
    display: "Auditory and mental",
    manifestingTime: "10 minutes",
    range: "Unlimited",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "7 (dread), 9 (psion/wilder)",
    description: `You summon the spectral horrors of the Ethereal Plane to haunt the dreams of a specific creature that you name or otherwise specifically designate. These tortured visions prevent restful sleep and cause 1d10 points of damage. The tortured visions leave the subject fatigued and unable to regain arcane spells or power points for the next 24 hours. The difficulty of the save depends on your knowledge of the subject and the physical connection (if any) you have to that creature.

*You must have some sort of connection to a creature you have no knowledge of.

Dispel psionics manifested on the subject while you are manifesting this power dispels the tortured visions and causes you to be stunned for 10 minutes per manifester level of the dispel psionics. If the recipient is awake when the power begins, you can choose to cease manifesting (ending the power) or to enter a trance until the recipient goes to sleep, whereupon you become alert again and complete the manifesting. If you are disturbed during the trance, you must succeed on a Concentration check as if you were in the midst of manifesting a power or the power ends.

If you choose to enter a trance, you are not aware of your surroundings or the activities around you while in the trance. You are defenseless, both physically and mentally, while in the trance (you always fails Will saving throws, for example). Creatures who don't sleep (such as elves, but not half-elves) or dream are immune to this power.

Augment: By spending an additional 4 power points, a creature that fails its save is haunted for 24 hours by imaginary creatures. The creature suffers a -2 penalty to all d20 rolls and is shaken. In addition, they may see into the Ethereal Plane within 20 feet of them.`
  },
  Tower_of_Iron_Will: {
    name: "Tower of Iron Will",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Highlord 5, psion/wilder 5, tactician 5, vitalist 5",
    display: "Auditory",
    manifestingTime: "1 immediate action",
    range: "10 ft.",
    target: "",
    area: "10-ft.-radius emanation centered on you",
    duration: "1 round",
    savingThrow: "None (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "9",
    description: `You generate a bastion of thought so strong that it offers protection to you and everyone around you, improving the self-control of all. You and all allies in the power's area gain power resistance 19 against all mind-affecting powers.

You can manifest this power instantly, quickly enough to gain its benefits in an emergency. Manifesting the power is an immediate action.

You can use this power even when it is not your turn.

Augment: For every additional power point you spend, this power's duration increases by 1 round and the power resistance it provides increases by 1 point.`
  },
  Upheaval: {
    name: "Upheaval",
    discipline: "Psychoportation",
    level: "Gambler 5, highlord 5, psion/wilder 5, psychic warrior 6, tactician 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "20 ft. radius burst",
    duration: "Instantaneous",
    savingThrow: "Reflex half",
    powerResistance: "No",
    powerPoints: "Highlord 9, psion/wilder 9, psychic warrior 11, tactician 9",
    description: `You translocate entire chunks of the earth 50 ft. into the air, where they fall onto the targets below. Each creature in the area affected takes 9d6 points of bludgeoning damage as the earth falls back to the ground. Unlike normal damage from powers, this damage is subject to damage reduction that would affect mundane bludgeoning damage.

In addition, the ground in the affected area becomes difficult terrain, making movement through it harder.

Augment: For each additional 2 power points spent, this power can affect an area 5 ft. larger in radius and the save DC increases by 1.`
  },
  Aura_Alteration: {
    name: "Aura Alteration",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 6, psion/wilder 6, vitalist 6",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One willing creature",
    area: "",
    duration: "10 min./level or instantaneous; see text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `You can use this power in one of two ways: to disguise the subject's aura (alignment) and level, or to remove a compulsion or charm effect from the subject.

Disguise: If you use this power to disguise the subject's alignment and level, the power has a duration of 10 minutes per level. You can change the subject's alignment by only one step. You can adjust the subject's apparent level up or down by a number equal to 1/2 your own level (rounded down) or less.

Remove Compulsion: If you use this power to attempt to cleanse the subject's aura of a baleful or controlling effect, the duration is instantaneous. This power can remove the compulsion of a curse or a geas/quest effect. It can also negate any charm and compulsion powers or spells of 6th level or lower, such as crisis of breath or death urge. When aura alteration is manifested for this purpose, the subject gains another saving throw to remove the compulsion afflicting it against the original save DC, but with a +2 bonus.

Augment: You can augment this power in one of the following ways.

• For every additional power point you spend, the duration of the disguise aura increases by 10 minutes.

• If you spend 2 additional power points, the subject's alignment shifts an additional step; if you spend 4 additional power points, the subject's alignment changes to its opposite.

• For every 3 additional power points you spend, the bonus against the original save is increased by 1.

Aura Alteration (Mythic)[]

If disguising an aura, there is no restriction to the alignment you can set for the subject, and you can adjust the apparent level by one-half your own level plus one-half your mythic tier (total rounded down) or less. If removing a compulsion, any non-mythic compulsion is automatically removed and you add your tier to the bonus gained on the saving throw for any mythic compulsions`
  },
  Breath_of_the_Black_Dragon: {
    name: "Breath of the Black Dragon",
    discipline: "Psychometabolism [Acid]",
    level: "Gambler 6, highlord 6, psion/wilder 6, psychic warrior 6",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "Cone-shaped burst",
    duration: "Instantaneous",
    savingThrow: "Reflex half",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `Your mouth spews forth vitriolic acid that deals 11d6 points of acid damage to any targets in the area.

Augment: For every additional power point you spend, this power's damage increases by 1d6 points. For every two additional damage dice, this power's save DC increases by 1.

Mythic Breath of the Black Dragon[]

Creatures damaged by the power take the same damage each round thereafter for 1 round per 3 manifester levels.`
  },
  Brutalize_Wounds: {
    name: "Brutalize Wounds",
    discipline: "Telepathy [Compulsion, Mind-Affecting]",
    level: "Gambler 6, highlord 6, psion/wilder 6, psychic warrior 6, tactician 6, vitalist 6",
    display: "Visual",
    manifestingTime: "One standard action",
    range: "Close (25 feet + 5 feet/2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will partial",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `You invade the target's mind and temporarily reduce its ability to ward off attacks. If the target succeeds at its saving throw, its hardiness is still depleted; the target takes 1 extra point of damage per die of damage it is dealt from melee or ranged attacks while the duration lasts. If it fails its save, it takes maximum damage plus 1 point of extra damage per die of damage it is dealt from melee or ranged attacks while the duration lasts. For instance, if a greatsword that normally deals 2d6 points of damage hits the target, they take 14 points of damage from the hit automatically.

A target that knows that it is under the effect may spend a move action to make an additional Will save at the original save DC to attempt to reduce the effect to only taking 1 extra point of damage per die of damage it is dealt.

Mythic Brutalize Wounds[]

The range increases to 100 feet + 10 feet per level and you add half your mythic tier (minimum 1) to the extra damage per die of damage dealt.

Augmented: If you expend one use of mythic power, the target does not get additional saves to negate the effect.`
  },
  Co_opt_Concentration: {
    name: "Co-opt Concentration",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Gambler 6, highlord 6, psion/wilder 6, tactician 6",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `You take over control of a power that was manifested by the subject and that must be maintained through concentration. Once you wrest control of the power from the subject, you have several options.

• Allow the power to function as normal.

• Keep the power targeted on the subject (if a personal power) but decide how the power fulfills its function each round.

• Retarget the power on yourself (if a personal power).

• Choose not to concentrate on the co-opted power in the next round, ending the power at that point. When the duration of co-opt concentration expires, the power you took control of ends (even if this would mean that the power ends earlier than normal).

Mythic Co-opt Concentration[]

If the target is non-mythic, it does not gain a saving throw to avoid having the power wrested away. You can maintain concentration on the co-opted power as a move action.

Augmented: If you expend one use of mythic power, you can manifest this power as an immediate action after identifying a power or spell via Spellcraft and that power or spell is eligible to be co-opted. You must use mythic co-opt concentration on the identified power when manifesting mythic co-opt concentration in this fashion.`
  },
  Defer_Fatality: {
    name: "Defer Fatality",
    discipline: "Psychometabolism",
    level: "Highlord 6, psion/wilder 6, psychic warrior 6, vitalist 6, voyager 6",
    display: "Auditory",
    manifestingTime: "",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `Manifestation Time: One immediate action

When death is about to claim you because of a lethal attack of any sort, you instead enter a state of suspended animation. While fatality is deferred, you do not age, breathe, grow hungry, sleep, or regain power points. You are unaware of your surroundings and cannot use subconscious powers. Outside forces can damage your body, but as long as your head remains attached to your torso and your brain remains intact, the physical damage can be healed. A coup de grace still forces you to make a Fortitude save or die.

You can manifest this power quickly enough to avoid complete destruction if you are unexpectedly affected by a lethal melee or ranged attack or effect. You cannot manifest this power if you are unconscious.

You remain in a state of deferred fatality until some third party provides you with magical or psionic healing in the amount equal to 10 points + the amount of damage your body originally (and subsequently) sustained which dropped you into this deferred state. When so cured, you become conscious, possess 1 hp, 1 power point, and sustain 1d4+1 points of temporary ability damage on each of your six ability scores. (If this brings your Constitution score to 0, you die normally.)

Mythic Defer Fatality[]

While in suspended animation, your body heals a number of hit points per day equal to your tier and you can choose when to return from suspended animation or to remain in suspended animation once your hit points are above 0. You have a number of hit points and power points equal to your tier when you return from suspended animation.

Augmented: If you expend one use of mythic power, you do not take ability damage when you awaken.`
  },
  Disintegration: {
    name: "Disintegration",
    discipline: "Psychoportation",
    level: "Gambler 6, psion/wilder 6",
    display: "Auditory, material, and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude partial (object)",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `Effect: Ray A thin, green ray springs from your pointing finger. You must make a successful ranged touch attack to hit. Any creature struck by the ray takes 22d6 points of damage. Any creature reduced to 0 or fewer hit points by this power is entirely disintegrated, leaving behind only a trace of fine dust. A disintegrated creature's equipment is unaffected.

When used against an object, the ray simply disintegrates as much as one 10-foot cube of nonliving matter. Thus, the power disintegrates only part of any very large object or structure targeted. The ray affects even objects constructed entirely of force, but not psionic effects such as a null psionics field .

A creature or object that makes a successful Fortitude save is partially affected, taking only 5d6 points of damage. If this damage reduces the creature or object to 0 or fewer hit points, it is entirely disintegrated.

Only the first creature or object struck can be affected; that is, the ray affects only one target per manifestation.

Augment: For every additional power point you spend the damage this power deals to a subject that fails its  throw increases by 2d6 points. Augmenting this  does not change the amount of damage the target takes  it succeeds on its saving throw. For every 4d6  damage, the power's save DC increases by 1.

Mythic Disintegration[]

The damage dealt increases to 3d6 points of damage per manifester level (maximum 60d6) plus 1d4 points of Constitution damage. A creature that succeeds at its saving throw takes 5d8 points of damage plus 1 point of Constitution damage.

A creature whose Constitution score is reduced to 0 by this power is entirely disintegrated.

Augmented (7th): If you expend two uses of mythic power, you fire two rays.

Alternatively, you may fire only one ray, but if the target is a non-mythic creature and it fails its saving throw, it's automatically disintegrated regardless of its current hp.`
  },
  Foot_in_the_Grave: {
    name: "Foot in the Grave",
    discipline: "Athanatism",
    level: "Conduit 9",
    display: "Visual",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft. / 2 levels)",
    target: "You and one other corporeal undead creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text; Power",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Foot in the Grave[]

You can attempt to take control of a nearby corporeal undead creature, forcing your mind and soul into its body, and its mind into your body. You can target any creature whose Hit Dice are equal to or less than your manifester level.

You possess the target's body and force the creature's mind into your body unless it succeeds on a Will save. You can move your mind back into your own body whenever you desire, which returns the subject's mind to its own body and ends the power. If the manifestation succeeds, your life force occupies the host body, and the host's life force takes over yours.

You can call on rudimentary or instinctive knowledge of the subject creature, but not upon its acquired or learned knowledge (such as skills and feats it possesses). The same is true for the subject in your body - mindless undead or undead with no Intelligence score will usually take no actions unless ordered to. The mind switch brings about the following changes.

• You count as undead for all purposes, gaining standard undead immunities.

• You gain the Strength and Dexterity scores of your assumed body.

• You gain the natural armor, natural attacks, movement, and other simple physical characteristics of your assumed body.

• You gain the extraordinary special attacks and qualities of your assumed body, but you do not gain supernatural or spell-like abilities.

• You gain the possessions and equipment of your assumed body.

• You retain your own hit points, saving throws (possibly modified by new ability scores), class abilities, supernatural and psi-like abilities, spells and powers, and skills and feats (although skill checks use your new ability scores, and you may be temporarily unable to use feats whose requirements you do not meet in your new body).

• You suffer one negative level while in your assumed body.

Supernatural abilities that require a certain body part may be unavailable in your new form.

If either body is killed while the power is in effect, the other participant also dies when the power ends. If one participant's body becomes petrified, imprisoned by temporal stasis or imprisonment, or incapacitated in some other way, the other participant will be incapacitated in that way when the power ends.

A targeted dispel psionics (or similar spells or effects) successfully manifested on either participant causes both minds to return to their original bodies.

If you successfully use foot in the grave while already under the effect of foot in the grave , the original target is returned to its original body, the new target occupies your original body, and you occupy the body of the new target.

Augment: This power may be augmented in one of the following ways.

• By spending 6 additional power points, you may expend your psionic focus while this power is active to attempt to take control of a different corporeal undead body. You may do this as many times as you wish while this power is active, but must expend your psionic focus each time to do so. Whenever you leave a body in this way, the original target is returned to its body.

• By spending 4 additional power points, increase the duration of this power to 1 hour/level.

Both Feet in the Grave[]

Resistance: Yes

As foot in the grave , except as noted here. You permanently exchange bodies with the subject. Since this power's duration is instantaneous, you cannot be forced to return to your natural body by means of dispel psionics , an antimagic field , or a similar effect. If the subject's body dies while you are in it, you are dead. The subject immediately suffers one permanent negative level, but otherwise survives the experience in your natural body. If your natural body dies while the subject is in it, you immediately suffer two permanent negative levels, but you likewise survive the experience in your new body. Negative levels gained in this way may only be cured by powerful healing, such as cleanse spirit, greater restoration or restoration ; they do not fade over time.

Your “natural” body is always considered to be the last one you switched out of. If you exchange bodies with a chain of multiple subjects, you need worry only about the welfare of the last body you switched with. In other words, if your mind is expelled from your current body, your mind returns to the last body you switched with, not to your original body. Similarly, if your original body dies but you have since switched minds with a second subject, you take no penalty. You suffer permanent negative levels only if the body you inhabited immediately prior to your current body is killed.

You suffer two temporary negative levels upon manifesting this power, as your mind adjusts to controlling a new body. These negative levels cannot be cured, but fade at a rate of one every 24 hours.

If you successfully use both feet in the grave while under the effect of foot in the grave , the original target of foot in the grave is returned to its original body, the new target of both feet in the grave occupies your original body, and you occupy the body of the target of both feet in the grave .`
  },
  Fuse_Flesh: {
    name: "Fuse Flesh",
    discipline: "Psychometabolism",
    level: "Gambler 6, psion/wilder 6, vitalist 6",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude negates and Fortitude partial; see text",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `You cause the touched subject's flesh to ripple, grow together, and fuse into a nearly seamless whole. The subject is forced into a fetal position (if humanoid), with only the vaguest outline of its folded arms and legs visible below the all-encompassing wave of flesh. The subject retains the ability to breathe, eat, and excrete, but may lose the use of its senses (see below). If the sudden transformation would prove fatal to the creature (such as fusing a swimming air-breathing subject, or a flying subject), the subject gets a +4 bonus on the save. Unless it loses the use of its senses (see below), the creature can still perform purely mental actions, such as manifesting powers.

If the target fails its Fortitude save to avoid the power's effect, the subject must immediately attempt a second Fortitude save. If this second save is failed, the creature's eyes and ears fuse over, effectively blinding and deafening it. Moreover, it loses its extraordinary, supernatural, and spell-like abilities, as well as its ability to manifest powers (if any), and is generally in sorry shape.

Incorporeal or gaseous creatures and creatures not composed of flesh are immune to fuse flesh , and a shapechanger can revert to its unfused form as a standard action.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mythic Fuse Flesh[]

Shapechangers cannot shift out of this effect.

Augmented: The duration becomes instantaneous. The target has to tear itself free from the fused form, suffering 2 points of Constitution damage, or it remains fused permanently.`
  },
  Instill_Sentience: {
    name: "Instill Sentience",
    discipline: "Psychometabolism, athanatism or telepathy (mind-affecting)",
    level: "Psion/wilder 6, vitalist 6",
    display: "Visual",
    manifestingTime: "10 minutes",
    range: "Touch",
    target: "One non-sentient animal, plant or construct (Int - or Int 1-2)",
    area: "",
    duration: "see text (D)",
    savingThrow: "none",
    powerResistance: "No",
    powerPoints: "11",
    description: `You awaken the mind of something that once had none using a specific ritual and previously prepared crystals that are consumed in the ritual (cost of 5000 gp). If you manifest this power as an athanatism power, you infuse the target with the soul of a previously dead, but intelligent, creature. The target gains the psionic subtype and a limited form of telepathy, allowing it to communicate wordlessly with a willing creature within 30 ft.

You have no special empathy or connection with a creature you awaken, although it is friendly and will often help you with specific tasks or endeavors if you communicate your desires to it. Creatures previously under another creature's control, either as shield guardians or a golem crafter's creations, break all connections with that creature.

An awakened plant has characteristics as if it were an animated object of its size, except that it gains the plant type and its Intelligence, Wisdom, and Charisma scores are each 3d6. An awakened plant gains the ability to move its limbs, roots, vines, creepers, and so forth, and it has senses similar to a human's, but generally can't speak beyond its telepathic abilities.

For constructs and animals, roll 3d6 to determine the Intelligence score of the awakened creature, and increase its Charisma score by 2d6.

The creature gains the (augmented) subtype and it gains feats and skill points according to its new Intelligence score, and the skill points are assigned appropriately, as determined by the GM. An awakened creature speaks one language plus one additional language per point of Intelligence bonus (if any). Its alignment is determined by the GM. Such a creature cannot serve as the familiar, animal companion, mount or other servant of another creature unless the GM decides that it is appropriate.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, you can awaken vermin or oozes too.

• If you spend 2 additional power points, and manifest this power as an athanatism power, you can awaken mindless undead too, binding a different spirit to its animated husk.`
  },
  Latent_Programming: {
    name: "Latent Programming",
    discipline: "Telepathy (mind-affecting)",
    level: "Dread 6, Highlord 6, Psion/Wilder 6, Tactician 6, Vitalist 6",
    display: "Mental, Auditory",
    manifestingTime: "1 hour",
    range: "",
    target: "One Creature",
    area: "",
    duration: "permanent until discharged",
    savingThrow: "see text",
    powerResistance: "yes",
    powerPoints: "11",
    description: `Range Close: (25 feet + 5 feet/level)

Delicately, you place a trigger inside the target's mind, setting it to take effect when certain conditions are met. This power functions as Trigger Power, save that the power you set to trigger is placed in the target creature's mind rather than on your body and that the power cannot have a range of personal. You must still manifest the power you wish to set to trigger, and if its normal manifesting time is longer than 1 hour, the manifestation time for that power is used instead. The target is allowed a save against that power at the time of its initial manifesting, but the power does not take effect unless the trigger (set at the moment the creature is affected) occurs.

A creature can only be affected by one Latent Programming power at a time, but a single manifester can have multiple instances of this power active upon multiple creatures. In addition, this power can be made permanent with an incarnate power (minimum ML 19 th ) at a cost of 27,500 gp. If this is done, the power becomes latent again when its duration expires, and can be reactivated by the same trigger an infinite number of times.

Augment

• If you spend 2 additional power points, you may use Latent Programming to set a power that would otherwise have a range of personal.

• If you spend 2 additional power points, you may have this power affect a creature or object that the target is touching rather than the target itself. For example, you could force a creature to make a save against Malefic Metamorphosis as soon as it shakes hands with the target creature.`
  },
  Mental_Contagion: {
    name: "Mental Contagion",
    discipline: "Telepathy [mind-affecting]",
    level: "Dread 5, psion/wilder 6",
    display: "Mental",
    manifestingTime: "1 full-round action",
    range: "Close (25 ft. plus 5 ft. per 2 levels)",
    target: "3 creatures (see text)",
    area: "",
    duration: "5 rounds",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "Dread 9, psion/wilder 11",
    description: `You join your mind with a creature and seize the afflictions around its mind, spreading them to others. When you manifest this power, choose a creature within range, then choose up to two additional creatures within range. The additional creatures must succeed at a Will save or immediately suffer the effects of all mind-affecting abilities affecting the first creature for 5 rounds, except that you are treated as the caster (or origin, as appropriate) for those effects.

Augment: You may augment this power in one or both of the following ways.

• For every 4 additional power points you spend, the number of additional creatures increases by 2, to a maximum of 6.

• If you spend 2 additional power points, make a manifester level check against DC 11 + the caster or manifester level of the highest-level mind-affecting ability affecting the initial creature chosen. If you succeed, all mind-affecting abilities affecting that creature are removed.

Surge Augmentation: If you invoke your wild surge while manifesting this power you shatter the spirit of its victims; creatures that fail their saves also suffer a penalty equal to your wild surge's intensity on attack rolls, skill checks, caster level checks, and manifester level checks for a number of rounds equal to your key ability modifier.`
  },
  Remote_View_Trap: {
    name: "Remote View Trap",
    discipline: "Clairsentience [Electricity]",
    level: "Gambler 6, psion/wilder 6",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "24 hours + 1 hour/level",
    savingThrow: "Will half; see text",
    powerResistance: "No",
    powerPoints: "11",
    description: `When others use clairvoyant sense , remote viewing , or other means of scrying you from afar, your prepared trap gives them a nasty surprise. If the scryer fails its saving throw, you are undetected. Moreover, the would-be observer takes 8d6 points of electricity damage. If the scryer makes its saving throw, it takes only 4d6 points of electricity damage and is able to observe you normally. Either way, you are aware of the attempt to view you, but not of the viewer or the viewer's location. It is possible that you might recognize the quasi-real viewpoint of someone using the remote viewing power if you could pierce its invisibility (which is true for remote viewing whether or not you use this power).`
  },
  Retrieve_Nimar_s: {
    name: "Retrieve, Nimar's",
    discipline: "Psychoportation (Teleportation)",
    level: "Cryptic 5, psion/wilder 6, voyager 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One object you can hold or carry in one hand, weighing up to 10 lb./level",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "Cryptic 9, psion/wilder 11, voyager 9",
    description: `You automatically teleport an item you can see within range directly to your hand. If the object is in the possession of an opponent, it comes to your hand if your opponent fails a Will save.

Augment: For every additional power point you spend, the weight limit of the target increases by 10 pounds.`
  },
  Spacial_Displacement: {
    name: "Spacial Displacement",
    discipline: "Psychoportation",
    level: "Highlord 6, Psion/Wilder 6, Tactician 6",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Long (400 feet + 40 feet/level)",
    target: "",
    area: "20-foot cube of space",
    duration: "1 minute/level",
    savingThrow: "Reflex partial",
    powerResistance: "no",
    powerPoints: "11",
    description: `Ripping out a cube of space, you transplant it elsewhere within range. All contents of the area (including atmosphere and creatures) are transported to another point in range of your choice. One must be aware of location to transport the cube to it. The contents of the area that this cube is transported to is transported to where the original cube was sent from. Creatures on the edge of the area are allowed a Reflex save to jump out of the area of this power, but those within it are transported alongside the other contents of the cube. After being transported, objects and creatures are affected by the physical laws that would otherwise change them in their new location (for example, turf transported into the air will fall, and a cube of air transported underwater will be flooded). When the duration expires, the cubes switch back to their original locations

Augment

• If you spend 6 additional power points, you may extend this power to infinite range, including locations on other planes

• If you spend 2 additional power points, you may create a seal against the effects outside the new location of the cube. Atmosphere and contents do not move between the cube and the outside world unless forcibly moved, though creatures can move between the cube and the exterior unimpeded

• For every additional power points you spend, the range increases by 5 feet in each dimension.`
  },
  Suspend_Life: {
    name: "Suspend Life",
    discipline: "Psychometabolism",
    level: "Gambler 6, highlord 6, psion/wilder 6, psychic warrior 6, vitalist 6",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Permanent unless ended or dismissed; see text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `You can place yourself into a trance so deep that you are almost in suspended animation. Even powers that detect life or thought are incapable of determining that you are alive.

While you are suspended, you are aware of your surroundings. You feel the passage of one day for every year that actually passes. Though on a slower schedule, you grow hungry after a “day” without food (though a year passes in actuality) and begin to suffer the effects of thirst and starvation as appropriate. Time-based physical effects like aging are similarly slowed down, although durations of psionic powers and similar effects are treated normally.

If you take any damage, you come out of your trance 4 rounds later. The trance can also be ended by a successful use of dispel psionics. If you choose to dismiss the power, your trance ends 10 rounds later.`
  },
  Sustained_Flight: {
    name: "Sustained Flight",
    discipline: "Psychoportation",
    level: "Gambler 6, psion/wilder 6",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `This power functions like the nomad power flight , except you can fly at a speed of 40 feet (30 feet if wearing medium or heavy armor, or if carrying a medium or heavy load) with a competence bonus on Fly skill checks equal to half your manifester level. When using this power for long-distance movement, you can hustle without taking nonlethal damage (a forced march still requires Constitution checks). This means you can cover 64 miles in an 8-hour period of flight (or 48 miles at a speed of 30 feet).`
  },
  Temporal_Acceleration_Willian_s: {
    name: "Temporal Acceleration",
    discipline: "Psychoportation",
    level: "Dread 6, psion/wilder 6, voyager 6",
    display: "None",
    manifestingTime: "1 swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round (in apparent time); see text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `You enter another time frame, speeding up so greatly that all other creatures seem frozen, though they are actually still moving at normal speed. You are free to act for 1 round of apparent time. You can manifest powers, cast spells, move, or perform other types of actions, subject to the restrictions outlined below.

While your temporal acceleration is in effect, other creatures are invulnerable to your attacks and powers. This means you cannot target a creature with any attack or power. However, a power you manifest that affects an area and has a duration longer than the remaining duration of your temporal acceleration has its normal effect on creatures in the area once this power ends.

You can affect an unattended object but not an object held, carried, or worn by another creature. You are undetectable by any means while your temporal acceleration lasts.

While under the effect of this power, you cannot enter an area protected by a null psionics field or by a power or spell that neutralizes high-level powers or spells. Normal and magical fire, cold, acid, and the like can still harm you.

When your temporal acceleration expires, you resume acting during your current turn in the standard time frame. You are shaken for 1 round upon your return to the standard time frame.

Splintered or partitioned minds within your own mind, such as might be in effect through the use of powers such as schism , are not temporally speeded up, even if your second mind manifested this power (your primary mind gains the benefit, while your second mind remains stuck in the standard time frame).

Augment: For every 4 additional power points you spend, this power's duration (in apparent time) increases by 1 round.`
  },
  Terraforming: {
    name: "Terraforming",
    discipline: "psychokinesis",
    level: "psion/wilder 6",
    display: "visual, material",
    manifestingTime: "1 standard action",
    range: "medium (100 ft. + 10 ft./level)",
    target: "",
    area: "up to two 10-ft. cubes/level (S)",
    duration: "permanent; see text",
    savingThrow: "see text",
    powerResistance: "no",
    powerPoints: "11",
    description: `Reaching through an area, you rework the earth and stone within, shaping it as you so wish. This power can be used to reshape earth, stone, clay, and other similar materials, but cannot be used on metal structures. Similarly, it does not work on creatures. This power has one a variety of effects

Reshape material : ground or stone within the area is reshaped or moved as the manifester wishes, warping upwards, downwards, or however else the manifester desires. This ability can be used to dig tunnels or ditches, flatten terrain, raise terrain, or otherwise manipulate the landscape within the area. If used offensively, the power deals 10d6 points of damage to targets within the area (reflex half).

Soften material : An area of solid ground or stone is reduced to silt, mud, sand, or another runny substance. The depth of the material created cannot exceed 10 feet. A creature unable to levitate, fly, or otherwise free itself from the material sinks until hip: or chest-deep, reducing its speed to 5 feet and causing a -2 penalty on attack rolls and AC. Brush or similar material thrown atop the material can support creatures able to climb on top of it. Creatures large enough to walk on the bottom can wade through the area at a speed of 5 feet. If this effect is used upon the ceiling of a cavern or tunnel, the material falls to the floor and spreads out in a pool at a depth of 5 feet, dealing 8d6 points of bludgeoning damage to anyone caught directly beneath the targeted area, or half damage to those who succeed on Reflex saves. Castles and large stone buildings are generally immune to this effect of the power, since it can't affect worked stone and doesn't reach deep enough to undermine such buildings' foundations. However, small buildings or structures often rest upon foundations shallow enough to be damaged or even partially toppled by this power.

Solidify material : This power permanently transforms mud, slurry, silt, or quicksand of any depth into soft stone (sandstone or a similar mineral). Any creature inside the area is allowed a Reflex save to escape before the area is hardened to stone. You may also use this effect to condense solid material, reducing the total area that they take up by half but increasing the hardness of compressed material by 2.

The effects of this power last until they are dispelled or if another effect otherwise alters them.`
  },
  Trigger_Power: {
    name: "Trigger Power",
    discipline: "Clairsentience",
    level: "Gambler 6, highlord 6, psion/wilder 6, tactician 6, vitalist 6, voyager 6",
    display: "Olfactory",
    manifestingTime: "10 minutes or longer; see text",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One day/level (D) or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `You can place another power upon your person so that it comes into effect under some condition you dictate when manifesting trigger power . The trigger power power and the companion power are manifest at the same time. The 10-minute manifesting time is the minimum total for both manifestations; if the companion power has a manifesting time longer than 10 minutes, use that instead. The power to be brought into effect by the trigger power must be one that affects your person and be of a power level no higher than one-third your manifester level (rounded down, maximum 6th level).

The conditions needed to bring the power into effect must be clear and discernible, although they can be general. In all cases, the trigger power immediately brings into effect the companion power, the latter being “manifested” instantaneously only when the prescribed circumstances occur. If complicated or convoluted conditions are prescribed, the power combination ( trigger power and the companion power) may fail when called on.

You can use only one trigger power companion power at a time; if a second is manifested, the first one (if still active) is dismissed.`
  },
  True_Awakening: {
    name: "True Awakening",
    discipline: "Psychometabolism or telepathy (mind-affecting)",
    level: "Psion/wilder 6, vitalist 6",
    display: "Visual",
    manifestingTime: "10 minutes",
    range: "Touch",
    target: "One sentient creature without the psionic subtype",
    area: "",
    duration: "Instantaneous",
    savingThrow: "none",
    powerResistance: "No",
    powerPoints: "11",
    description: `By using certain crystals and scented fragrances (worth 2000 gp), you permanently awaken the psionic power in a creature, unleashing their untapped potential into the world. The target gains a power point pool of 2, the psionic subtype, a 1st level power known, and a manifester level of 1 when manifesting the power, regardless of previous class or racial hit dice it possesses. It manifests using its highest mental ability score and gains bonus power points using this ability score.`
  },
  Vascular_Disruption_Kyria_s: {
    name: "Vascular Disruption",
    discipline: "Psychometabolism",
    level: "cryptic 5, dread 5, psion/wilder 6",
    display: "Visual, auditory",
    manifestingTime: "1 Standard action",
    range: "Medium (100 ft. plus 10 ft. per level)",
    target: "1 creature",
    area: "",
    duration: "Instantaneous and 1 round per level (see text)",
    savingThrow: "Fortitude partial",
    powerResistance: "Yes",
    powerPoints: "cryptic 9, dread 9, psion/wilder 11",
    description: `You violently disturb your victim's vascular system, sending an eruption of gooey blood from their body. Your victim suffers 9d6 points of damage and erupts in a 20 ft. burst of blood. Creatures within the burst (including the victim) become entangled for 1 round/level as the blood congeals into a web-like mass that constricts their movement. A successful Fortitude save halves the damage and prevents the burst of blood. Creatures without blood or an equivalent bodily fluid (including, but not limited to, most forms of undead, constructs, and elementals) are immune to the effects of this power.

Augment: You may augment this power in the following ways.

• For every 1 additional power point you spend, this power's damage increases by one die (d6). For each two extra dice of damage, this power's save DC increases by 1.

• If you spend 4 additional power points, the eruption of blood occurs even if the victim succeeds at their saving throw.

Surge Augmentation: If you invoke your wild surge while manifesting this power, you may affect creatures that do not have blood or equivalent bodily fluids; you convert part of their form to liquid and force it outward.`
  },
  Awestrike: {
    name: "Awestrike",
    discipline: "Telepathy (mind-affecting)",
    level: "Dread 6, Psion/Wilder 7, Tactician 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "",
    area: "60-foot spread centered on you",
    duration: "1 round/level, see text",
    savingThrow: "Will partial, see text",
    powerResistance: "yes",
    powerPoints: "11 dread, 13 psion/wilder and tactician",
    description: `You unleash a telepathic shockwave that overtakes the minds of targets, forcing them to stunned silence before your awesome presence. All creatures that fail their saving throws against this effect become helpless for 1 round/level, unable to comprehend the full extent of power they are witnessing. Each round on its turn, a creature affected by this power may attempt a new saving throw to end the effect; this is a full-round action that does not provoke attacks of opportunity.

AUGMENT

• For every 2 power points you spend augmenting this power, the range increases by 10 feet and the DC increases by 1.

• If you spend 2 additional power points and expend psionic focus, this power has a persistent effect. For 1 round/level, any creature that enters the area of this power must save against this power's effects.

• If you spend 4 additional power points, a creature that recovers from this power early after being affected by it for at

• least 1 round is staggered for 1d4 rounds. A creature that makes the initial save to resist this spell is merely staggered for 1 round.`
  },
  Barred_Mind_Personal: {
    name: "Barred Mind, Personal",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 6, dread 6, highlord 6, psion/wilder 7, psychic warrior 6, tactician 7, vitalist 7, voyager 6",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One day",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "Cryptic 11, dread 11, highlord 11, psion/wilder 13, psychic warrior 11, tactician 13, vitalist 13, voyager 11",
    description: `Barred Mind[]

creature: ect is protected from all devices, powers, and spells that gather information about the target through divination powers or magic (such as detect evil , locate ' creature , scry , and see invisible ). Barred mind also grants a +8 resistance bonus on saving throws against all mind-affecting powers, spells, and effects. Barred mind even foils bend ' reality, limited wish , miracle , reality revision , and wish spells when they are used in such a way as to gain information about the target. In the case of remote viewing or scrying that scans an area the creature is in, such as arcane eye , the effect works but the creature simply isn't detected. Remote ' viewing (scrying) attempts that are targeted specifically at the subject do not work at all.

Augment: For every two power points spent, the resistance bonus increases by 1.

Barred Mind, Personal[]

As barred mind , except as noted here.

Barred Mind (Mythic)[]

You gain immunity to non-mythic mind-affecting effects. A non-mythic creature trying to use a mindaffecting effect on you is dazed for a number of rounds equal to your mythic tier (Will negates)

Barred Mind, Personal (Mythic)[]

You are immune to non-mythic mind-affecting effects. If a non-mythic creature tries to affect you with a mind-affecting effect, they are dazed for a number of rounds equal to half your mythic tier (a successful Will save negates the dazing effect)`
  },
  Bend_Reality: {
    name: "Bend Reality",
    discipline: "Clairsentience",
    level: "Psion/wilder 9, tactician 9, vitalist 9",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "See text",
    target: "",
    area: "",
    duration: "See text",
    savingThrow: "See text",
    powerResistance: "See text",
    powerPoints: "17",
    description: `Bend Reality[]

Target, Effect, Area: See text

Bend reality lets you create nearly any type of effect. For example, bend reality can do any of the following:

• Duplicate any psion/wilder power of 6th level or lower, provided the power is on the psion/wilder power list or your discipline power list (if any).

• Duplicate any other power (but not a spell) of 5th level or lower, provided the power is not of a discipline prohibited to you.

• Duplicate any psion/wilder power of 5th on a discipline power list.

• Duplicate any other power (but not a spell) of 4th level or lower, even if it's of a prohibited discipline.

• Undo the harmful effects of many powers, such as mind control, geas/quest, or insanity .

• Produce any other effect whose power level is in line with the above effects, such as a single creature automatically hitting on its next attack or taking a -7 penalty on its next saving throw.

A duplicated power allows saving throws and power resistance as normal (but the save DC is for a 7th-level power).

Manifesting bend reality requires channeling psionic power through specially-treated crystals similar to cognizance crystals that cost 1,500 gp. The psionic energy in the crystal is consumed in the manifestation and the crystal becomes inert and has no value.

Bend Reality (Mythic)[]

When using mythic bend reality to duplicate another power, you can duplicate a mythic power you know. If you don't know the mythic power, you can expend a second use of mythic power to duplicate the mythic version of the desired power.

Reality Revision[]

As bend reality , but with more far-reaching effects. A reality revision can produce any one of the following effects.

• Duplicate any psion power of 8th level or lower, provided the power is not on a discipline-restricted list that you do not have access to.

• Duplicate any psion power of 7th level or lower even if it's a power on a discipline-restricted list that you do not have access to.

• Duplicate any other power or spell of 6th level or lower, such as a psychic warrior power.

• Undo the harmful effects of many other powers, such as microcosm, geas/quest, or insanity .

• Create a non-psionic item of up to 25,000 gp in value.

• Grant a creature a +1 inherent bonus to an ability score. Two to five reality revisions manifested in immediate succession can grant a creature a +2 to +5 inherent bonus to an ability score. Inherent bonuses are instantaneous, so they cannot be negated or dispelled. An inherent bonus cannot exceed +5 for a single ability score. Inherent bonuses to a particular ability score do not stack; only the best one applies.

• Remove injuries and afflictions. A single reality revision can aid one creature per manifester level, and all subjects are cured of the same kind of affliction.

• Revive the dead. Reality revision can bring a dead creature back to life by duplicating a resurrection spell. This power can revive a dead creature whose body has been destroyed, but the task takes two manifestations of reality revision , one to recreate the body and another to infuse the body with life again. Reality revision cannot prevent a character who is brought back to life from suffering a permanent negative level or suffering from Constitution drain.

• Transport travelers. This power can lift one creature per manifester level from anywhere on any plane and place those creatures anywhere else on any plane regardless of local conditions. An unwilling target gets a Will save to negate the effect, and power resistance (if any) applies.

• Undo misfortune. Reality revision can undo a single recent event. Manifesting the power forces a reroll of any single roll made within the last round (including your last turn). Reality reshapes itself to accommodate the new result. The reroll, however, may be as bad as or worse than the original roll. An unwilling target gets a Will save to negate the effect, and power resistance (if any) applies.

You can try to use reality revision to produce more powerful effects than these, but doing so is dangerous. The manifestation may pervert your intent into a literal but undesirable fulfillment or only a partial fulfillment.

Duplicated powers allow saves and power resistance as normal (but save DCs are calculated as though the power is 9th level) and the power is treated as if manifested with 17 power points, allowing the manifester to choose any appropriate augment options. Powers without augment options are simply manifested as normal, but with 9th level save DCs.

Manifesting reality revision requires channeling psionic power through specially-treated crystals similar to cognizance crystals that cost 25,000 gp. The crystal is consumed in the manifestation and becomes inert, unable to be used again and losing any value. If a power or spell duplicated by reality revision has a material component that costs more than 10,000 gp, you must provide that component or additional crystals of the same value.`
  },
  Cosmic_Awareness: {
    name: "Cosmic Awareness",
    discipline: "Clairsentience; Leve l: Cryptic 6, psion/wilder 7, tactician 7, voyager 6",
    level: "",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 minute/level or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 11, psion/wilder 13, tactician 13, voyager 11",
    description: `You gain a sixth sense. Once during the power's duration, you may choose to use its effect. This grants you an insight bonus equal to your manifester level (maximum +25) on any single attack roll, combat maneuver check, opposed ability or skill check, or saving throw. Alternatively, you can apply the insight bonus to your AC against a single attack (even if flat-footed). Activating the effect doesn't take an action; you can even activate it on another character's turn. You must choose to use the cosmic awareness before you make the roll it is to modify, or before the attack roll if applying the bonus to your AC. Once used, the power ends. You can't have more than one cosmic awareness active on you at the same time.

Augment: By spending 2 additional power points, this power's duration increases to “1 hour/level or until discharged”.

Mythic Cosmic Awareness[]

You can activate your insight bonus a number of times equal to one-half your mythic tier. Each time you activate the mythic cosmic awareness , the bonus is reduced by 50% from the previous bonus.`
  },
  Data_Transfer: {
    name: "Data Transfer",
    discipline: "telepathy",
    level: "cryptic 6, psion/wilder 7, vitalist 7",
    display: "material, mental",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "11 cryptic, 13 psion/wilder and vitalist",
    description: `Mind Switch[]

Targets: You and one other creature

You can attempt to take control of a nearby living creature, forcing your mind (and soul) into its body, and its mind into your body. You can target any creature whose Hit Dice are equal to or less than your manifester level.

You possess the target's body and force the creature's mind into your body unless it succeeds on a Will save. You can move your mind back into your own body whenever you desire, which returns the subject's mind to its own body and ends the power. If the manifestation succeeds, your life force occupies the host body, and the host's life force takes over yours.

You can call on rudimentary or instinctive knowledge of the subject creature, but not upon its acquired or learned knowledge (such as skills and feats it possesses). The same is true for the subject in your body. The mind switch brings about the following changes.

• You gain the type of your assumed body.

• You gain the Strength, Dexterity, and Constitution scores of your assumed body.

• You gain the natural armor, natural attacks, movement, and other simple physical characteristics of your assumed body.

• You gain the extraordinary special attacks and qualities of your assumed body, but you do not gain supernatural or spell-like abilities, nor do you gain any class abilities of the assumed body. Any racial trait which relies upon power points, such as the elan's resilience trait, is considered to be a supernatural ability.

• You gain the possessions and equipment of your assumed body.

• You retain your own hit points and saving throws (both possibly modified by new ability scores), class abilities, supernatural and spell-like abilities, spells and powers, and skills and feats (although skill checks use your new ability scores, and you may be temporarily unable to use feats whose requirements you do not meet in your new body). You retain any racial abilities, so long as they are not based upon your original form (for example, the dromite's chitin is based upon his physical body, so would not be retained).

• You suffer one negative level while in your assumed body. Supernatural abilities that require a certain body part may be unavailable in your new form.

If either body is killed while the power is in effect, the other participant also dies when the power ends. If one participant's body becomes petrified, imprisoned by temporal stasis or imprisonment, or incapacitated in some other way, the other participant will be incapacitated in that way when the power ends.

A targeted dispel psionics (or similar spells or effects) successfully manifested on either participant causes both minds to return to their original bodies.

If you successfully use mind switch while already under the effect of mind switch , the original target is returned to its original body, the new target occupies your original body, and you occupy the body of the new target.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mind Switch, True[]

As mind switch, except as noted here.

You permanently exchange bodies with the subject. Since this power's duration is instantaneous, you cannot be forced to return to your natural body by means of dispel psionics, an antimagic field, or a similar effect. If the subject's body dies while you are in it, you are dead. The subject immediately suffers one permanent negative level, but otherwise survives the experience in your natural body. If your natural body dies while the subject is in it, you immediately suffer two permanent negative levels, but you likewise survive the experience in your new body. Negative levels gained in this way may only be cured by powerful healing, such as greater restoration or restoration ; they do not fade over time.

Your “natural” body is always considered to be the last one you switched out of. If you exchange bodies with a chain of multiple subjects, you need worry only about the welfare of the last body you switched with. In other words, if your mind is expelled from your current body, your mind returns to the last body you switched with, not to your original body. Similarly, if your original body dies but you have since switched minds with a second subject, you take no penalty. You suffer permanent negative levels only if the body you inhabited immediately prior to your current body is killed.

You suffer two temporary negative levels upon manifesting this power, as your mind adjusts to controlling a new body. These negative levels cannot be cured, but fade at a rate of one every 24 hours.

If you successfully use true mind switch while under the effect of mind switch , the original target of mind switch is returned to its original body, the new target of true mind switch occupies your original body, and you occupy the body of the target of true mind switch .

Data Transfer[]

This ability functions as true mind switch , except as noted above and save that it instead transfers an AI between machines rather than a mind between creatures. As it is not a mind-affecting power, constructs are not immune to its effects.

Augment: This power can be augmented in the following ways:

• By expending six additional power points, you may use this power to transfer an Artificial Intelligence to a non-robot creature. If you do, this power gains the mind-affecting descriptor and the new target acquires the aggregate template even if they otherwise could not.`
  },
  Decerebrate: {
    name: "Decerebrate",
    discipline: "Psychoportation [Teleportation]",
    level: "Psion/wilder 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `With decerebrate, you selectively remove a portion of the subject's brain stem. The creature loses all cerebral function, vision, hearing, and other sensory abilities, and all voluntary motor activity. The subject becomes limp and unresponsive. Without extreme measures, such as greater restoration or some other suitable effect of 7th level or higher, the creature perishes in 1d4 days.`
  },
  Divert_Teleport: {
    name: "Divert Teleport",
    discipline: "Psychoportation (Teleportation)",
    level: "Psion/wilder 7, tactician 7",
    display: "Visual",
    manifestingTime: "1 immediate action; see text",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "A circle, centered on you, with a radius of 100 ft. + 10 ft./level",
    duration: "10 min./level (D)",
    savingThrow: "Will negates (foils diversion)",
    powerResistance: "Yes (foils diversion)",
    powerPoints: "13",
    description: `Effect: Diverts the teleportation of any object or creature whose weight does not exceed your maximum load

Similar to detect teleportation , except that you know the intended destination, and you can divert the final destination of any teleportation attempt made by others within the area.

You can divert the destination of both incoming and outgoing teleportations, psionic and magical. You must overcome the power resistance of creatures that possess it to make a successful diversion, and the teleporting creature can make a Will save to foil the diversion as well.

For the purpose of this power, “divert” means you choose the actual destination of any teleportation attempt you can affect, as if you yourself were teleporting to that location, regardless of the teleportation range of the effect you are diverting. The destination you choose must be a location with which you are very familiar or that you have studied carefully.

Mythic Divert Teleport[]

The destination you choose can be a location you have only seen casually or viewed once and there is no weight limit.

Augmented: If you expend one use of mythic power, you add your tier to any checks to overcome power resistance.`
  },
  Energy_Conversion: {
    name: "Energy Conversion",
    discipline: "Psychometabolism [see text]",
    level: "Psion/wilder 7, vitalist 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal and close (25 ft. + 5 ft./2 levels); see text",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `Energy Adaptation[]

Your body assimilates some of the effect of an energy attack and converts it to harmless light. You gain resistance 10 against any attack that deals acid, cold, electricity, fire, or sonic damage.

When you absorb damage, you can choose to radiate visible light that illuminates a 60-foot radius for a number of rounds equal to the points of damage you successfully resisted, or merely dissipate the energy without giving off a visual display.

The energy resistance provided by this power increases to 20 points at 7th manifester level and to a maximum of 30 points at 11th level.

The power protects your equipment as well.

The resistance provided by this power does not stack with other forms of energy resistance.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Energy Adaptation, Specified[]

As energy adaptation, except the type of energy to which you gain resistance when this power is manifested is your active energy type.

This power's subtype is the same as the type of damage it protects against.

Augment: If you spend 4 additional power points, you can manifest this power as an immediate action.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Energy Conversion[]

Effect: Ray; see text

As energy adaptation , except that instead of radiating away energy as light, you store up the energy and can later discharge it as a ray. To discharge a ray requires a standard action. You can choose to fire any number of rays during the power's duration. The ray you fire must be of one of the energy types you have stored (if you have stored more than one type, you can choose what kind of energy to use for each ray). If a ray successfully strikes its target (requiring a ranged touch attack), the target takes damage equal to the amount of energy damage of that type you have stored, up to a maximum of three times your manifester level. As long as this power remains in effect, you can continue to absorb energy damage and fire additional rays using the stored damage. Damage you fire in rays is subtracted from the damage you have absorbed, so you may not fire off rays if you have depleted the energy you have absorbed.

This power's subtype is the same as the type of energy you discharge in a ray; thus, its subtype can change during the course of the power's duration.

Mythic Energy Adaptation[]

You gain a +6 bonus to saves against effects that deal acid, cold, electricity, fire, or sonic damage.

Augmented (5th): If you expend two uses of mythic power, you gain immunity against effects that deal acid, cold, electricity, fire, or sonic damage.

Mythic Specified Energy Adaptation[]

You gain a +4 bonus on saves against effects that deal damage of the selected energy type. Once each round as a free action, you can choose one adjacent ally to gain energy resistance 5 against the chosen energy type for 1 round. This increases to energy resistance 10 at manifester level 7 and energy resistance 15 at manifester level 11.

Mythic Energy Conversion[]

You may fire rays as if making an attack with a ranged weapon, allowing the use of iterative attacks for a high base attack bonus. If firing multiple rays in a single round, the rays can target the same creature or different creatures, as long as both all targets are in range.

Augmented (5th): If you expend two uses of mythic power, the amount of damage you can retain increases to 10 times your manifester level, and you can fire rays of two different energy types. Such rays deal damage based upon the amount and type of energy chosen when firing the ray.`
  },
  Energy_Wave: {
    name: "Energy Wave",
    discipline: "Psychokinesis [see text]",
    level: "Psion/wilder 7",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "120 ft.",
    target: "",
    area: "Cone-shaped spread",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `You create a flood of energy of your active energy type (cold, electricity, fire, or sonic) out of unstable ectoplasm that deals 13d6 points of damage to each creature and object in the area. This power originates at your hand and extends outward in a cone.

• Cold: A wave of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold wave is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a wave of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A wave of this energy type deals +1 point of damage per die.

• Sonic: A wave of this energy type deals -1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Wave[]

The power instead deals 1d10 points of damage for each 1d6 points of damage it would have dealt. Any creature that fails its save suffers an effect  based upon the energy type of the damage.

• Cold: Any creature that fails its save is partially encased in ice, reducing its speed by half. Creatures with the cold or incorporeal subtype or immunity to being grappled are immune to this effect. The reduced movement lasts until the ice is destroyed. Destroying the ice requires a successful Strength or dispel check against the spell's  DC,  or  dealing  bludgeoning  or fire damage equal to 1 point per caster level to the creature.

• Electricity: Any creature that fails its save is staggered for 1 round.

• Fire: The damage bypasses fire resistance and immunity.

• Sonic: Any creature that fails its save is knocked prone.`
  },
  Ensconce: {
    name: "Ensconce",
    discipline: "Clairsentience",
    level: "Psion/wilder 7",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One willing creature or one object (up to a 2-ft. cube/level) touched",
    area: "",
    duration: "One day/level (D)",
    savingThrow: "None or Will negates (object)",
    powerResistance: "No or Yes (object)",
    powerPoints: "13",
    description: `When manifested, this power prevents clairsentience or divination effects from detecting or locating the target and also renders the affected target invisible (as the invisibility spell). The power does not prevent the subject from being discovered through tactile means or through the use of devices. Creatures affected by ensconce become comatose and are effectively in a state of suspended animation until the effect ends.

Note : The Will save prevents an attended or magical object from being ensconced. There is no save to see the ensconced creature or object or to detect it with a clairsentience power or divination spell, such an attempt automatically fails.

Mythic Ensconce[]

As a free action, you can wake the ensconced creature without ending the effect, but the creature temporarily loses the benefits of the power. Each round out of the effect counts as one day for determining the duration of the effect. As a standard action, you can reactivate the effects of mythic ensconce .

Augmented (3rd): If you expend one use of mythic power, all other creatures within 60 feet must make a Will save or forget the target  creature  existed. Their memory returns when the ensconced creature returns.`
  },
  Ethereal_Passage: {
    name: "Ethereal Passage",
    discipline: "Psychoportation",
    level: "Cryptic 6, psion/wilder 7, voyager 6",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "One usage per two levels",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Cryptic 11, psion/wilder 13, voyager 11",
    description: `Effect: Ethereal 5-ft. by 8-ft. opening, 10 ft. deep + 5 ft. deep per three levels

You create an ethereal passage through wooden, plaster, or stone walls, but not other materials. The ethereal passage is invisible and inaccessible to all creatures except you, and only you can use the passage. You disappear when you enter the ethereal passage and appear when you exit. If you desire, you can take one other creature (Medium or smaller) through the passage. This counts as two uses of the passage. The passage does not allow light, sound, or power effects through it, nor can you see through it without using it. Thus, the power can provide an escape route, though certain creatures, such as phase spiders, can follow with ease. A gem of true seeing or similar ability reveals the presence of an ethereal passage but does not allow its use.

An ethereal passage is subject to dispel psionics. If anyone is within the passage when it is dispelled, he is harmlessly ejected just as if he were inside a passwall effect.

You can allow other creatures to use the ethereal passage by setting some triggering condition for the door. Such conditions can be as simple or elaborate as you desire. They can be based on a creature's name, identity, or alignment, but otherwise must be based on observable actions or qualities. Intangibles such as level, class, HD, and hit points don't qualify.

Mythic Ethereal Passage[]

While using this power, you can shift into the Material Plane as if using mythic blink , as described in Pathfinder Roleplaying Game Mythic Adventures . If you are 3rd tier or higher, you can spend two points of mythic power to use the augmented effect  of mythic blink . If you remain completely ethereal, you gain energy resistance equal to twice your mythic tier against force effects.`
  },
  Evade_Burst: {
    name: "Evade Burst",
    discipline: "Psychometabolism",
    level: "Cryptic 3, gifted blade 3, highlord 3, marksman 4, psion/wilder 7, psychic warrior 3, tactician 7, vitalist 4, voyager 3",
    display: "Material",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 5, gifted blade 5, highlord 5, marksman 7, psion/wilder 13, psychic warrior 5, tactician 13, vitalist 7, voyager 5",
    description: `You throw off a faux ectoplasmic shell, allowing you to slide out of range of a damaging effect. When you manifest this power in conjunction with making a successful Reflex save against an attack that normally deals half damage on a successful save, you instead take no damage.

Augment: If you spend 4 additional power points, you take only half damage on a failed Reflex save.

Mythic Evade Burst[]

You gain a bonus on Reflex saves equal to your mythic tier. Any hit point damage you take from an effect that allows a Reflex save is reduced by a number of hit points equal to half your mythic tier (round down).

Augmented (5th): If you expend two uses of mythic power, the duration becomes 1 round per level.`
  },
  Immortalized_Essence: {
    name: "Immortalized Essence",
    discipline: "Psychometabolism",
    level: "All 7",
    display: "Olfactory, Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One creature",
    area: "",
    duration: "Concentration (maximum 1 minute)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "13",
    description: `

Your touch suffuses the touched creature with immortalized akasha, causing them to treat all of their essence receptacles as if they were invested with their maximum possible essence capacity for the duration of the power. For the duration, their veils cannot be sundered or suppressed.

Augment: For every 2 additional power points you spend, the maximum duration of the power increases by 1 minute.`
  },
  Oak_Body: {
    name: "Oak Body",
    discipline: "Psychometabolism",
    level: "Highlord , psion/wilder 7, psychic warrior 5, vitalist 7",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Highlord 9, psion/wilder 13, psychic warrior 9, vitalist 13",
    description: `This power transforms your body into living oak, which grants you several advantages.

You gain damage reduction 10/ slashing and a +5 bonus to natural armor that overlaps (does not stack with) any natural armor bonus you may already have. You are immune to ability damage, blindness, deafness, disease, drowning, poison, stunning, and all powers, spells, or attacks that affect your physiology or respiration, because you have no physiology or respiration while this power is in effect.

You take half damage from cold effects of all kinds. However, you become susceptible to all special attacks that affect wood, and you gain vulnerability to fire.

You gain a +4 enhancement bonus to Strength, but you take a -2 penalty to Dexterity (to a minimum Dexterity score of 1), and your speed is reduced to half normal. You can speak but cannot drink (and thus can't use potions) or play wind instruments. You have an armor check penalty of -4 and an arcane spell failure chance of 25%.

Your unarmed attacks deal damage equal to a club sized for you (1d4 for Small characters, 1d6 for Medium characters), and you are considered armed when making unarmed attacks. When you make a full attack against an object or structure using your unarmed strike, you deal double damage.

Augment: For every additional power point you spend, this power's duration increases by 1 minute.`
  },
  Psychosis: {
    name: "Psychosis",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Psion/wilder 7",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `Creatures affected by this power are permanently confused and constantly behave randomly, making them unable to independently determine what they will do. Roll on the following table at the beginning the subject's turn each round to see what the subject does in that round.

A confused character that can't carry out the indicated action does nothing but babble incoherently. Attackers are not at any special advantage when attacking a confused character. Any confused character that is attacked automatically attacks its attackers on its next turn, as long as it is still confused when its turn comes. Note that a confused character will not make attacks of opportunity against any creature that it is not already devoted to attacking (either because of its most recent actions or because it has just been attacked).

Only psychic chirurgery , reality revision , and other similarly extreme measures can restore the subject's sanity.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1, and the power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.`
  },
  Soul_Stealing: {
    name: "Soul Stealing",
    discipline: "Athanatism [death]",
    level: "Psion/wilder 7",
    display: "Olfactory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude partial",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `You rip the soul from another, killing them and turning the stolen essence into a ghost. This power deals 10 points of damage per manifester level to the target. If the target's Fortitude save succeeds, it instead takes 3d6 + 1 point/manifester level. If damage from this power kills the target, you may immediately animate their soul as a ghost that shares your alignment and motivations (and will generally be friendly towards you). In addition, the ghost suffers a permanent -2 penalty on saves against athanatism powers or effects that you manifest

Augment: For every two additional power points you spend, increase the save DC of this power by 1.`
  },
  Ultrablast: {
    name: "Ultrablast",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Psion/wilder 7",
    display: "Auditory; see text",
    manifestingTime: "1 standard action",
    range: "15 ft.",
    target: "",
    area: "15-ft.-radius spread centered on you",
    duration: "Instantaneous",
    savingThrow: "Will half",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `You “grumble” psychically (which both psionic and non-psionic creatures can detect), then release a horrid shriek from your subconscious that disrupts the brains of all enemies in the power's area, dealing 13d6 points of damage to each enemy.

Augment: For every additional power point you spend, this power's damage increases by 1d6 points.`
  },
  Assimilate_Function: {
    name: "Assimilate Function",
    discipline: "telepathy",
    level: "psion/wilder 8, tactician 8",
    display: "mental",
    manifestingTime: "1 full-round action",
    range: "touch",
    target: "one intact or destroyed machine that contained an AI",
    area: "",
    duration: "instantaneous",
    savingThrow: "Will negates",
    powerResistance: "No",
    powerPoints: "15",
    description: `The manifester's mind siphons the information from a machine, absorbing the knowledge and abilities of whatever programming existed in there. Upon completion of this power's manifestation, an AI that exists inside of the targeted machine is forced to make a will save. On a failure, the AI is destroyed and the manifester gains the use of all of the AI's Special Abilities as well as any knowledge that the AI possessed before being destroyed.

Augment: For every 2 additional power points you spend, the save DC of this power increases by 1.`
  },
  Barred_Mind: {
    name: "Barred Mind",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Cryptic 6, dread 6, highlord 6, psion/wilder 7, psychic warrior 6, tactician 7, vitalist 7, voyager 6",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One day",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "Cryptic 11, dread 11, highlord 11, psion/wilder 13, psychic warrior 11, tactician 13, vitalist 13, voyager 11",
    description: `Barred Mind[]

creature: ect is protected from all devices, powers, and spells that gather information about the target through divination powers or magic (such as detect evil , locate ' creature , scry , and see invisible ). Barred mind also grants a +8 resistance bonus on saving throws against all mind-affecting powers, spells, and effects. Barred mind even foils bend ' reality, limited wish , miracle , reality revision , and wish spells when they are used in such a way as to gain information about the target. In the case of remote viewing or scrying that scans an area the creature is in, such as arcane eye , the effect works but the creature simply isn't detected. Remote ' viewing (scrying) attempts that are targeted specifically at the subject do not work at all.

Augment: For every two power points spent, the resistance bonus increases by 1.

Barred Mind, Personal[]

As barred mind , except as noted here.

Barred Mind (Mythic)[]

You gain immunity to non-mythic mind-affecting effects. A non-mythic creature trying to use a mindaffecting effect on you is dazed for a number of rounds equal to your mythic tier (Will negates)

Barred Mind, Personal (Mythic)[]

You are immune to non-mythic mind-affecting effects. If a non-mythic creature tries to affect you with a mind-affecting effect, they are dazed for a number of rounds equal to half your mythic tier (a successful Will save negates the dazing effect)`
  },
  Body_of_Iron: {
    name: "Body of Iron",
    discipline: "Metacreativity (Creation)",
    level: "Highlord 6, psion/wilder 8, psychic warrior 6, vitalist 8",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Highlord 11, psion/wilder 15, psychic warrior 11, vitalist 15",
    description: `You transform your body into living iron, which grants you several powerful resistances and abilities. You gain damage reduction 15/adamantine. You are immune to blindness, critical hits, ability score damage, deafness, disease, drowning, electricity, poison, stunning, and all powers or attacks that affect your physiology or respiration, because you have no physiology or respiration while this power is in effect. You take only half damage from acid and fire. However, you also become vulnerable to all special attacks that affect iron golems.

You gain a +6 enhancement bonus to your Strength score, but you take a -6 penalty to Dexterity as well (to a minimum Dexterity score of 1), and your speed is reduced to half normal. You have an arcane spell failure chance of 35% and a -6 armor check penalty, just as if you were clad in full plate armor. You cannot drink (and thus can't use potions) or play wind instruments.

Your unarmed attack deals damage equal to a club sized for you (1d4 for Small characters or 1d6 for Medium characters), and you are considered armed when making unarmed attacks.

Your weight increases by a factor of 10, causing you to sink in water like a stone. However, you could survive the lack of air at the bottom of the ocean—at least until the duration expires.

Mythic Body of Iron[]

Your enhancement bonus to Strength is increased to +8 and your Dexterity penalty is reduced to -4, and your damage reduction becomes DR 15/adamantine and epic. Your unarmed attack deals damage equal to a greatclub sized for you and this counts as adamantine, cold iron, and magic for the purpose of overcoming damage reduction.`
  },
  Coded_Incarnation: {
    name: "Coded Incarnation",
    discipline: "telepathy",
    level: "psion/wilder 8, tactician 8, vitalist 8",
    display: "",
    manifestingTime: "24 hours",
    range: "touch",
    target: "one creature",
    area: "",
    duration: "instantaneous",
    savingThrow: "see text Power Resistance No",
    powerResistance: "",
    powerPoints: "15",
    description: `Display material: , auditory

A creature's psyche, with all of the abilities and experiences that it contains, is transformed into an artificial intelligence and encoded into a storage device. Such a device, such as a compact AI core or robot which your artificial intelligence will inhabit, must be present at the time of this manifestation, as must be the creature from which you are copying the information. An unwilling robot is allowed a will save to avoid being taken over by the new AI.

The AI created by this power possesses the same intelligence, wisdom, and charisma scores as the creature from which it is made, and possesses all of the base creature's skills, supernatural abilities, saves, feats, and class features (including the ability to manifest powers). The AI's CR is equal to the base creature's effective class level. The AI gains no additional skills, feats, languages, or special abilities from the Artificial Intelligence creature type. However, the AI is free-willed, and the manifester has no control over its actions. However, being a replication of the mind of another creature, the AI is normally inclined to act in the same way and possess the same alignment as the creature it was created from.

Like most AIs, those created by this power lack a physical composition, and cannot act without a host body that they can inhabit. This host must be either a computer system of some sort or a robot the AI is controlling.

Once the AI is completed, the original creature's mind ceases to function. The creature cannot be raised or resurrected so long as the AI created by this power exists.

Augment: This power can be augmented in the following ways:

• If you spend 4 additional power points, you may use this power to copy an existing AI or create a copy of a creature's mind, rather than transferring it. The original AI or creature remains in its body or other storage device, with a replica being created in the storage device the manifester chooses. Using the power in this way requires 15,000 gp worth of expensive mechanical and psionic components.`
  },
  Matter_Manipulation: {
    name: "Matter Manipulation",
    discipline: "Metacreativity",
    level: "Psion/wilder 8",
    display: "Auditory and mental",
    manifestingTime: "1 standard action; see text",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "1 cu. ft./level of inanimate material",
    duration: "1 minute / level; see text",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `You can weaken or strengthen the substance of an object or structure. You can affect both mundane and magical inanimate material. Weakening an object's substance decreases its hardness and hit points, and strengthening it increases its hardness and hit points. You can increase or decrease an object's hardness by up to 5 from its original hardness. When hardness increases, the object (or portion of an object) gains 3 hit points per inch of thickness for every point of increased hardness. When hardness decreases, the object (or portion of an object) loses 2 hit points per inch of thickness for every point of decreased hardness (to a minimum of 1 hit point per inch of thickness).

You can't decrease the hardness of an object that already has hardness 0. You cannot increase an object's hardness by more than 5 from the hardness of the original base object, nor decrease it by more than 5 from the hardness of the original base object. For example, you could not manifest this power twice to increase an object's hardness by 10, but could decrease the hardness by 5, then manifest again to increase the hardness by 5, and then manifest again to increase the hardness again by 5, because the change from the original base object's hardness is only 5.

Working Manipulated Metals: An object or portion thereof whose hardness is decreased or increased is permanently changed. Even hardening adamantine to 25 is possible. You can also harden or weaken a preforged weapon, a suit of armor, or some other finished item.

You may choose to spend one hour manifesting this power, rather than a standard action. This results in the duration of the power changing to “Instantaneous” instead of 1 minute / level, making the change permanent.

Mythic Matter Manipulation[]

You can increase or decrease an object's base hardness by up to 10. If an object has a base hardness of under 10, you can give it the fragile quality.`
  },
  Psychoport_Greater: {
    name: "Psychoport, Greater",
    discipline: "Psychoportation (Teleportation)",
    level: "Nomad 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Psychoport[]

Target or Targets: You and touched objects or other touched willing creatures

Resistance: No or Yes (object)

This power instantly transports you to a designated destination, which may be as distant as 100 miles per manifester level. Interplanar travel is not possible. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. As with all powers where the range is personal and the target is you, you need not make a saving throw, nor is power resistance applicable to you. Only objects held or in use (attended) by another person receive saving throws and power resistance.

You must have some clear idea of the location and layout of the destination. The clearer your mental image, the more likely the teleportation works. Areas of strong physical or psionic energy may make teleportation more hazardous or even impossible.

To see how well the teleportation works, roll d% and consult the table at the end of this power. Refer to the following information for definitions of the terms on the table.

Familiarity : “Very familiar” is a place where you have been very often and where you feel at home. “Studied carefully” is a place you know well, either because you can currently physically see it or you've been there often. “Seen casually” is a place that you have seen more than once but with which you are not very familiar. “Viewed once” is a place that you have seen once, possibly using powers such as remote viewing .

“False destination” is a place that does not truly exist or if you are teleporting to an otherwise familiar location that no longer exists as such or has been so completely altered as to no longer be familiar to you. When traveling to a false destination, roll 1d20+80 to obtain results on the table, rather than rolling d%, since there is no real destination for you to hope to arrive at or even be off target from.

On Target : You appear where you want to be.

Off Target : You appear safely a random distance away from the destination in a random direction. Distance off target is d% of the distance that was to be traveled. The direction off target is determined randomly.

Similar Area : You wind up in an area that's visually or thematically similar to the target area. Generally, you appear in the closest similar place within range. If no such area exists within the power's range, the power simply fails instead.

Mishap : You and anyone else teleporting with you have gotten “scrambled.” You each take 1d10 points of damage, and you reroll on the chart to see where you wind up. For these rerolls, roll 1d20+80. Each time “Mishap” comes up, the characters take more damage and must reroll.

Augment: For every 2 additional power points you spend, consider the familiarity of a location 1 step better, with the exception of a false destination, which is always considered a false destination.

Psychoport, Greater[]

As psychoport, except that there is no range limit and there is no chance you arrive off target. In addition, you need not have seen the destination, but in that case you must have at least a reliable description of the place to which you are teleporting. If you attempt to teleport with insufficient information (or with misleading information), you disappear and simply reappear in your original location. Interplanar travel is not possible.

Interplanetary Psychoport[]

This functions as greater psychorport , except there is truly no range limit and you do not need to have seen your destination, though you must have a solid grasp of which world you wish to travel to (“the third planet from the sun” is an acceptable destination, but “a habitable world near that bright star” is not). If you have a specific location on a planet in mind, you arrive there without a chance of failure; otherwise you arrive at a location that would not immediately be life-threatening. If no such safe landing zone exists on the world, such as someone attempting to travel into the sun without the proper precautions in place, the power simply fails.

Psychoport Trigger[]

You specify a situation that triggers your automatic manifestation of a psychoport, taking you to a predetermined location. You must know the psychoport power and have sufficient power points to manifest it when the specified situation occurs.

The psychoport trigger goes off on the initiative count immediately after the specified situation occurs, even if you are flat-footed or you have already taken your turn in the current round. The specified situation can be described in general terms or specific terms.

Psychoportation Circle[]

Effect: 5-ft.-radius circle that teleports those who activate it

You create a circle on the floor or other horizontal surface that teleports, as greater psychoport , any creature who stands on it to a designated spot. Once you designate the destination for the circle, you can't change it. The power fails if you attempt to set the circle to teleport creatures into a solid object, to a place with which you are not familiar and have no clear description, or to another plane.

The circle itself is subtle and nearly impossible to notice. If you intend to keep creatures from activating it accidentally, you need to mark the circle in some way.

Magic traps such as psychoportation circle are hard to detect and disable. A character with the trapfinding class feature can use the Disable Device to disarm magic traps. The DC in each case is 25 + spell level, or 34 in the case of psychoportation circle .`
  },
  Recall_Death: {
    name: "Recall Death",
    discipline: "Clairsentience [Death, Mind-Affecting]",
    level: "Psion/wilder 8",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will partial; see text",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `Recall Agony[]

The fabric of time parts to your will, revealing wounds your foe has received in the past (or has yet to receive). That foe takes 2d6 points of damage as the past (or future) impinges briefly on the present.

Augment: For every additional power point you spend, this power's damage increases by 1d6 points. For each extra 2d6 points of damage, this power's save DC increases by 1.

Recall Death[]

As recall agony , except the wounds revealed by folding the fourth dimension are potentially fatal. If the target fails its Will save, it dies. If the save succeeds, the target instead takes 5d6 points of damage.`
  },
  Retarget_Power: {
    name: "Retarget Power",
    discipline: "Psychokinesis",
    level: "Cryptic 5, psion 8, vitalist 8",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level) and touch",
    target: "One creature touched and one creature; see text",
    area: "",
    duration: "Immediate",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "Cryptic 9, psion 15, vitalist 15",
    description: `A bridge of coruscating multi-hued light builds between two creatures, photonic evidence of magical redirection. Retarget power can be used to move an ongoing magical spell or psionic power from one creature to another. Prior to its use, you must have identified the specific single spell or power you intend to move either through the use of Spellcraft, or by having been the original caster or manifester of the spell or power. Simply being told, even by the original caster is insufficient for this purpose though any experience equivalent to first-hand knowledge (such as by means of mind-reading) is.

You must touch the creature that is currently under the effects of the ongoing spell or power. That creature is entitled to a Will saving throw to resist your transfer though they may choose to voluntarily fail their save as usual. If this condition is satisfied, the target creature you select may also make a saving throw to resist accepting the transfer. If either creature succeeds at its saving throw, retarget power has no effect and the spell or power remains active on its original target. Spell resistance applies to both the source and target creatures.

This power cannot be used to transfer a power that cannot apply to the target creature. For instance, hold person cannot be moved to an outsider (because hold person can only target humanoids). Retarget power is, however, usable in cases of immunity, for instance allowing you to move mind-affecting spells or powers onto undead.

Augment: For every additional two power points you spend, the DC of this power is increased by 1.

Mythic Retarget Power

You may hold open the psionic conduit between the source creature and the target creature for one round per mythic tier you possess. This may be useful to allow you to get closer to a target creature that is outside of the power's range. Manifesting any other power or casting any other spell (or use of psi-like or spell-like abilities) ends this power immediately.

Augmented (6th): By expending three uses of mythic power, you may manifest one power or cast one spell without ending this power.`
  },
  Shadow_Body: {
    name: "Shadow Body",
    discipline: "Psychometabolism",
    level: "Psion/wilder 8",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "15",
    description: `Your body and all your equipment are subsumed by your shadow. As a living shadow, you blend perfectly into any other shadow and vanish in darkness. You appear as an unattached shadow in areas of full light.

You can move at your normal speed, on any surface, including walls and ceilings, as well as across the surfaces of liquids—even up the face of a waterfall.

Your space does not change, so you cannot move into locations you would not normally be able to move into.

While in your shadow body, you gain damage reduction 10/magic and darkvision out to 60 feet. You are immune to extra damage from critical hits, ability damage, disease, drowning, and poison. You take only half damage from acid, electricity, and fire of all kinds.

While affected by this power, you can be detected by powers that read thoughts, life, or presences (including true seeing ), or if you make suspicious movements in lighted areas.

You cannot harm anyone physically or manipulate any objects, but you can use your powers normally. Doing so may attract notice, but if you remain in a shadowed area, you get a +15 bonus on your Stealth check to remain unnoticed.`
  },
  Shaken_the_Mortal_Coil: {
    name: "Shaken the Mortal Coil",
    discipline: "Athanatism",
    level: "Psion/wilder 8",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One undead creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will partial",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `Your power threatens to tear the target's body down to the spirit. This power instantly deals 150 points of damage. If the target succeeds on its save, it instead takes 3d6 + 15 damage. If this damage destroys the target, it cannot return or reform, such as through a ghost's rejuvenation ability.

Augment: You may augment this power in one of the following ways.

• For every additional power point spent, power deals an additional 10 points of damage on a failed save. For every two points you spend augmenting this power, increase the save DC by 1.

• By expending your psionic focus, you may target a living creature touched with this power.`
  },
  True_Metabolism: {
    name: "True Metabolism",
    discipline: "Psychometabolism (Healing)",
    level: "Psion/wilder 8, vitalist 8",
    display: "Material",
    manifestingTime: "1 round",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "15",
    description: `You are difficult to kill while this power persists. You automatically heal damage at the rate of 10 hit points per round.

This power is not effective against damage from starvation, thirst, or suffocation. Also, attack forms that don't deal hit point damage (for example, most poisons) ignore true metabolism . You can also use this power to regrow lost portions of your body and to reattach severed limbs or body parts, if you do nothing but concentrate on regrowing the lost body part or reattaching the severed limb for the duration of the power. You do not gain the benefits described earlier when you manifest true metabolism for this purpose. You must have a Constitution score to gain any of this power's benefits.`
  },
  Affinity_Field: {
    name: "Affinity Field",
    discipline: "Psychometabolism",
    level: "Psion/wilder 9, tactician 9, vitalist 9",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "20 ft.",
    target: "",
    area: "20-ft.-radius emanation, centered on you",
    duration: "1 round/level (D)",
    savingThrow: "Fortitude negates (potentially harmless)",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `You create an affinity feedback loop with all creatures within the area. While the duration lasts, affected creatures take all damage (including ability damage) as you do and heal all wounds as you do. Hit points gained or lost persist after this power ends.

Creatures in range are also subject to magical and psionic effects of 3rd level or lower. Creatures that have an affinity to you gain a saving throw against each new power transferred through the affinity field as if the power were manifested upon them normally. All magical and psionic effects transferred to subjects fade at the end of this power's duration, although instantaneous effects remain. If you suddenly become immune to a particular effect or power, the effect or power to which you are immune cannot be transferred to creatures that have affinity to you, although effects already on creatures that have affinity to you are not ended unless that creature also gains the same immunity.

Affinity Field (Mythic)[]

You choose which creatures share beneficial effects and which one share harmful effects and you add half your mythic tier to the level of magical and psionic effects that creatures are also subject to.

Augmented: If you expend one use of mythic power, non-mythic effects that are transferred do not end when this power ends; they are in effect as if each target was targeted normally`
  },
  Apopsi: {
    name: "Apopsi",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Psion/wilder 9",
    display: "Auditory, material, and visual",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One living psionic creature",
    area: "",
    duration: "Instantaneous; see text",
    savingThrow: "Fortitude negates; see text",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `By using this power, you delete 1d4 powers or spells permanently from the subject's mind. You specify the level of each power or spell, and the DM randomly determines which of the subject's powers or spells is actually deleted. After 24 hours, the target may make an additional Fortitude save to negate the effect. Psychic chirurgery or reality revision can be used to restore the lost powers or spells, but it must be performed within 1 week of losing the powers or spells. The deleted powers or spells no longer count against the subject's powers or spells known the next time they gain a level. If a character gains a level after losing powers or spells in this fashion, he or she may choose new powers or spells to replace those lost, but they must be the same level as the power or spell lost.

Apopsi (Mythic)[]

If the target knows the mythic powers or spells, the power or spell to be deleted is chosen randomly from their mythic powers or spells, and they lose the mythic and non-mythic version of the power or spell. If the target does not know mythic powers or spells, the number of powers or spells deleted is increased to 1d6.

Augmented: If you expend one use of mythic power, the power can affect any non-mindless creature`
  },
  Assimilate: {
    name: "Assimilate",
    discipline: "Psychometabolism",
    level: "Psion/wilder 9, tactician 9, vitalist 9",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One living creature touched",
    area: "",
    duration: "Instantaneous and 1 hour; see text",
    savingThrow: "Fortitude half",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Your pointing finger turns black as obsidian. A creature touched by you is partially assimilated into your form and takes 20d6 points of damage. Any creature reduced to 0 or fewer hit points by this power is killed, entirely assimilated into your form, leaving behind only a trace of fine dust. An assimilated creature's equipment is unaffected.

A creature that is partially assimilated into your form (that is, a creature that has at least 1 hit point following your use of this power) grants you a number of temporary hit points equal to half the damage you dealt for 1 hour. Temporary hit points gained by assimilating multiple creatures, like all temporary hit points, do not stack.

A creature that is completely assimilated grants you a number of temporary hit points equal to the hit points it had prior to your attack. If the assimilated creature knows psionic powers, you gain knowledge of one of its powers for 1 hour (chosen randomly). You gain some semblance of a creature you completely assimilate for 1 hour, granting you a +10 bonus on Disguise checks made to appear as that creature during that time. You also gain a bonus to your ability scores for 1 hour for completely assimilating creatures based upon the creature's relative hit dice related to yours as shown on the chart below.

Assimilate (Mythic)[]

The damage dealt to the assimilated creature is 20d8 instead of 20d6. You permanently retain knowledge of all powers the target knew. You gain the target's memories and can sift through them as a swift action to remember something specific.`
  },
  Sidestep: {
    name: "Sidestep",
    discipline: "Clairsentience",
    level: "Dread 2, highlord 2, marksman 2, psychic warrior 2, voyager 2",
    display: "visual",
    manifestingTime: "1 immediate action",
    range: "personal",
    target: "self",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `When you manifest this power, when you would normally be hit with an attack from a melee weapon, you may deflect it so that you take no damage from it.`
  },
  Ethereal_Form_Greater: {
    name: "Ethereal Form, Greater",
    discipline: "Psychoportation",
    level: "Psion/wilder 9",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes (harmless)",
    powerPoints: "17",
    description: `Ethereal Form[]

You become ethereal, along with your equipment. For the duration of the power, you are in the Ethereal Plane, which overlaps the Material Plane. When the power expires, you return to material existence.

An ethereal creature is invisible, insubstantial, and capable of moving in any direction, even up or down, albeit at half normal speed. As an insubstantial creature, you can move through solid objects, including living creatures. An ethereal creature can see and hear on the Material Plane, but everything looks gray and ephemeral. Sight and hearing onto the Material Plane are limited to 60 feet.

Force effects and abjurations affect an ethereal creature normally. Their effects extend onto the Ethereal Plane from the Material Plane, but not vice versa. An ethereal creature can't attack material creatures, and powers you manifest while ethereal affect only other ethereal things. Certain material creatures or objects have attacks or effects that work on the Ethereal Plane.

Treat other ethereal creatures and ethereal objects as if they were material.

If you end the power and become material while inside a material object (such as a solid wall), you are shunted off to the nearest open space and take 1d6 points of damage per 5 feet that you so travel.

Ethereal Form, Greater[]

Targets: You and one other touched willing creature/three levels; all targets must be joined by linked hands

This power functions like ethereal form , except that you and other willing creatures joined by linked hands (along with their equipment) become ethereal. Besides yourself, you can bring one creature per three manifester levels to the Ethereal Plane. Once ethereal, the subjects need not stay together.

When the power expires, all affected creatures on the Ethereal Plane return to material existence.

If you end the power or the power ends normally and any of the affected creatures including you become material while inside a material object (such as a solid wall), that creature or creatures are shunted off to the nearest open space and take 1d6 points of damage per 5 feet shunted.

Mythic Ethereal Form[]

While using this power, you can shift into the Material Plane as if using mythic blink, as described in Pathfinder Roleplaying Game Mythic Adventures. If you are 3rd tier or higher, you can spend two points of mythic power to use the augmented effect of mythic blink. If you remain completely ethereal, you gain energy resistance equal to twice your mythic tier against force effects.

Mythic Greater Ethereal Form[]

Creatures using this power can shift into the Material Plane as if using mythic blink , as described in Pathfinder Roleplaying Game Mythic Adventures . If your mythic tier is at least 3rd, you can spend two uses of your mythic power to use the augmented version of mythic blink . If you remain completely ethereal, you gain energy resistance equal to twice your mythic tier against force effects.`
  },
  Interplanetary_Psychoport: {
    name: "Interplanetary Psychoport",
    discipline: "Psychoportation (Teleportation)",
    level: "Nomad 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Psychoport[]

Target or Targets: You and touched objects or other touched willing creatures

Resistance: No or Yes (object)

This power instantly transports you to a designated destination, which may be as distant as 100 miles per manifester level. Interplanar travel is not possible. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. As with all powers where the range is personal and the target is you, you need not make a saving throw, nor is power resistance applicable to you. Only objects held or in use (attended) by another person receive saving throws and power resistance.

You must have some clear idea of the location and layout of the destination. The clearer your mental image, the more likely the teleportation works. Areas of strong physical or psionic energy may make teleportation more hazardous or even impossible.

To see how well the teleportation works, roll d% and consult the table at the end of this power. Refer to the following information for definitions of the terms on the table.

Familiarity : “Very familiar” is a place where you have been very often and where you feel at home. “Studied carefully” is a place you know well, either because you can currently physically see it or you've been there often. “Seen casually” is a place that you have seen more than once but with which you are not very familiar. “Viewed once” is a place that you have seen once, possibly using powers such as remote viewing .

“False destination” is a place that does not truly exist or if you are teleporting to an otherwise familiar location that no longer exists as such or has been so completely altered as to no longer be familiar to you. When traveling to a false destination, roll 1d20+80 to obtain results on the table, rather than rolling d%, since there is no real destination for you to hope to arrive at or even be off target from.

On Target : You appear where you want to be.

Off Target : You appear safely a random distance away from the destination in a random direction. Distance off target is d% of the distance that was to be traveled. The direction off target is determined randomly.

Similar Area : You wind up in an area that's visually or thematically similar to the target area. Generally, you appear in the closest similar place within range. If no such area exists within the power's range, the power simply fails instead.

Mishap : You and anyone else teleporting with you have gotten “scrambled.” You each take 1d10 points of damage, and you reroll on the chart to see where you wind up. For these rerolls, roll 1d20+80. Each time “Mishap” comes up, the characters take more damage and must reroll.

Augment: For every 2 additional power points you spend, consider the familiarity of a location 1 step better, with the exception of a false destination, which is always considered a false destination.

Psychoport, Greater[]

As psychoport, except that there is no range limit and there is no chance you arrive off target. In addition, you need not have seen the destination, but in that case you must have at least a reliable description of the place to which you are teleporting. If you attempt to teleport with insufficient information (or with misleading information), you disappear and simply reappear in your original location. Interplanar travel is not possible.

Interplanetary Psychoport[]

This functions as greater psychorport , except there is truly no range limit and you do not need to have seen your destination, though you must have a solid grasp of which world you wish to travel to (“the third planet from the sun” is an acceptable destination, but “a habitable world near that bright star” is not). If you have a specific location on a planet in mind, you arrive there without a chance of failure; otherwise you arrive at a location that would not immediately be life-threatening. If no such safe landing zone exists on the world, such as someone attempting to travel into the sun without the proper precautions in place, the power simply fails.

Psychoport Trigger[]

You specify a situation that triggers your automatic manifestation of a psychoport, taking you to a predetermined location. You must know the psychoport power and have sufficient power points to manifest it when the specified situation occurs.

The psychoport trigger goes off on the initiative count immediately after the specified situation occurs, even if you are flat-footed or you have already taken your turn in the current round. The specified situation can be described in general terms or specific terms.

Psychoportation Circle[]

Effect: 5-ft.-radius circle that teleports those who activate it

You create a circle on the floor or other horizontal surface that teleports, as greater psychoport , any creature who stands on it to a designated spot. Once you designate the destination for the circle, you can't change it. The power fails if you attempt to set the circle to teleport creatures into a solid object, to a place with which you are not familiar and have no clear description, or to another plane.

The circle itself is subtle and nearly impossible to notice. If you intend to keep creatures from activating it accidentally, you need to mark the circle in some way.

Magic traps such as psychoportation circle are hard to detect and disable. A character with the trapfinding class feature can use the Disable Device to disarm magic traps. The DC in each case is 25 + spell level, or 34 in the case of psychoportation circle .`
  },
  Mechanical_Rapture: {
    name: "Mechanical Rapture",
    discipline: "psychokinesis",
    level: "psion/wilder 9",
    display: "visual",
    manifestingTime: "1 standard action",
    range: "close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "all technological effects and technological items within a 40-ft.-radius burst, or one technological item (see text)",
    duration: "1 minute/level",
    savingThrow: "Fortitude negates; Power",
    powerResistance: "",
    powerPoints: "17",
    description: `Resistance: No

The ultimate weapon in the face of ever-escalating conflict is the ability to invalidate your opponent's' greatest assets. Such a power can only be described as Rapture. All technological effects and technological items within the radius of the power, except for those that you carry or touch, are raptured. Technological items must make a Fortitude save or loose all charges, and those that do not use charges have their effects suppressed for 1 minute/level. Robots in the area must succeed on a fort save or be dazed for the duration of the power, becoming staggered if the succeed. An item in a creature's possession uses its own Fortitude save bonus or its possessor's Fortitude save bonus, whichever is higher. If an item's saving throw results in a natural 1 on the die, the item is destroyed instead of being suppressed.

You can also use this power to target a single item. The item gets a Fortitude save at a -5 penalty to avoid being permanently destroyed. Even artifacts are subject to rapture. If successful, the artifact's power unravels, and it is destroyed.`
  },
  Microcosm: {
    name: "Microcosm",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Psion/wilder 9",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Target or Area: One creature; or one or more creatures within a 15-ft.-radius sphere

This power enables you to warp the consciousness and senses of one or more creatures, sending the victim into a catatonic state. When microcosm is manifested, you can target either a single creature within range or a group of creatures all located within the power's area.

Single Target: If microcosm targets a single creature, that creature's senses are pinched off from the real world if it currently has 100 or fewer hit points. The subject's senses are all completely fabricated from within its own mind, though it may not realize this. In reality, the subject sprawls limply, drooling and mewling, and eventually dies of thirst and starvation without care. The subject lives within its own made-up world until the time of its actual death.

Area Effect: If microcosm is manifested on an area, it sends all affected creatures into a shared catatonia (the world is a construct, but within the world, the victims can interact with each other). It affects only creatures that currently have 30 or fewer hit points, and only up to a total of 300 hit points of such creatures. The power affects creatures with the lowest hit point totals first. (Creatures with negative hit points count as having 0 hit points.)

Manifesting microcosm a second time on an affected creature turns its sensory pathways outward once more. Otherwise, only very potent powers (such as psychic chirurgery or reality revision ) or similar effects (such as miracle or wish ) can undo the mental crosswiring that this power brings about.

Augment: For every additional power point you spend, the number of hit points for a single target the power can affect increases by 10, and the number of hit points for an area effect increases by 30, and the maximum individual hit point of the creatures in the area affected increases by 3.

Mythic Microcosm[]

If targeting a single creature, add ten times your tier to the maximum number of hit points that can be affected. If targeting an area, add twice your tier to the maximum number of hit points a particular creature can have to be affected, and ten times your tier to the total number of hit points of creatures that can be affected. This power bypasses non-mythic sources of power resistance, and you add your tier to checks to overcome mythic sources of power resistance.

Augmented: If you expend two uses of mythic power, you can double the number of hit points used to determine creatures eligible to be affected.`
  },
  Reality_Revision: {
    name: "Reality Revision",
    discipline: "Clairsentience",
    level: "Psion/wilder 9, tactician 9, vitalist 9",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "See text",
    target: "",
    area: "",
    duration: "See text",
    savingThrow: "See text",
    powerResistance: "See text",
    powerPoints: "17",
    description: `Bend Reality[]

Target, Effect, Area: See text

Bend reality lets you create nearly any type of effect. For example, bend reality can do any of the following:

• Duplicate any psion/wilder power of 6th level or lower, provided the power is on the psion/wilder power list or your discipline power list (if any).

• Duplicate any other power (but not a spell) of 5th level or lower, provided the power is not of a discipline prohibited to you.

• Duplicate any psion/wilder power of 5th on a discipline power list.

• Duplicate any other power (but not a spell) of 4th level or lower, even if it's of a prohibited discipline.

• Undo the harmful effects of many powers, such as mind control, geas/quest, or insanity .

• Produce any other effect whose power level is in line with the above effects, such as a single creature automatically hitting on its next attack or taking a -7 penalty on its next saving throw.

A duplicated power allows saving throws and power resistance as normal (but the save DC is for a 7th-level power).

Manifesting bend reality requires channeling psionic power through specially-treated crystals similar to cognizance crystals that cost 1,500 gp. The psionic energy in the crystal is consumed in the manifestation and the crystal becomes inert and has no value.

Bend Reality (Mythic)[]

When using mythic bend reality to duplicate another power, you can duplicate a mythic power you know. If you don't know the mythic power, you can expend a second use of mythic power to duplicate the mythic version of the desired power.

Reality Revision[]

As bend reality , but with more far-reaching effects. A reality revision can produce any one of the following effects.

• Duplicate any psion power of 8th level or lower, provided the power is not on a discipline-restricted list that you do not have access to.

• Duplicate any psion power of 7th level or lower even if it's a power on a discipline-restricted list that you do not have access to.

• Duplicate any other power or spell of 6th level or lower, such as a psychic warrior power.

• Undo the harmful effects of many other powers, such as microcosm, geas/quest, or insanity .

• Create a non-psionic item of up to 25,000 gp in value.

• Grant a creature a +1 inherent bonus to an ability score. Two to five reality revisions manifested in immediate succession can grant a creature a +2 to +5 inherent bonus to an ability score. Inherent bonuses are instantaneous, so they cannot be negated or dispelled. An inherent bonus cannot exceed +5 for a single ability score. Inherent bonuses to a particular ability score do not stack; only the best one applies.

• Remove injuries and afflictions. A single reality revision can aid one creature per manifester level, and all subjects are cured of the same kind of affliction.

• Revive the dead. Reality revision can bring a dead creature back to life by duplicating a resurrection spell. This power can revive a dead creature whose body has been destroyed, but the task takes two manifestations of reality revision , one to recreate the body and another to infuse the body with life again. Reality revision cannot prevent a character who is brought back to life from suffering a permanent negative level or suffering from Constitution drain.

• Transport travelers. This power can lift one creature per manifester level from anywhere on any plane and place those creatures anywhere else on any plane regardless of local conditions. An unwilling target gets a Will save to negate the effect, and power resistance (if any) applies.

• Undo misfortune. Reality revision can undo a single recent event. Manifesting the power forces a reroll of any single roll made within the last round (including your last turn). Reality reshapes itself to accommodate the new result. The reroll, however, may be as bad as or worse than the original roll. An unwilling target gets a Will save to negate the effect, and power resistance (if any) applies.

You can try to use reality revision to produce more powerful effects than these, but doing so is dangerous. The manifestation may pervert your intent into a literal but undesirable fulfillment or only a partial fulfillment.

Duplicated powers allow saves and power resistance as normal (but save DCs are calculated as though the power is 9th level) and the power is treated as if manifested with 17 power points, allowing the manifester to choose any appropriate augment options. Powers without augment options are simply manifested as normal, but with 9th level save DCs.

Manifesting reality revision requires channeling psionic power through specially-treated crystals similar to cognizance crystals that cost 25,000 gp. The crystal is consumed in the manifestation and becomes inert, unable to be used again and losing any value. If a power or spell duplicated by reality revision has a material component that costs more than 10,000 gp, you must provide that component or additional crystals of the same value.`
  },
  Timeless_Body: {
    name: "Timeless Body",
    discipline: "Psychoportation",
    level: "Psion/wilder 9, tactician 9, vitalist 9",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "17",
    description: `Your body ignores all harmful (and helpful) effects, beginning when you finish manifesting this power and ending at the end of your next turn. While timeless body is in effect, you are invulnerable to all attacks and powers.

This power cannot be quickened.`
  },
  Timestepped_Form: {
    name: "Timestepped Form",
    discipline: "Psychoportation",
    level: "Psion/wilder 9",
    display: "Mental",
    manifestingTime: "1 hour",
    range: "Personal",
    target: "You",
    area: "",
    duration: "24 hours",
    savingThrow: "No",
    powerResistance: "No",
    powerPoints: "17",
    description: `Over the manifestation of this power, you siphon off tiny slices of yourself from the current timestream, cementing your physical form where it is when you manifest this power. Note your current hit point total, physical ability scores (Strength, Dexterity, and Constitution), and any conditional modifiers or conditions such as ability damage to physical ability scores, disease, negative levels, and poison. If at any point within the duration of the power you are reduced to fewer than 0 hit points or are slain by a death effect that is not mind-affecting, you can immediately let your current physical body die and assume the timestepped form of your physical body on your next turn.

When this happens, your corpse disappears, and you can either resume the place of your dead body (already wearing any clothing still attached to the corpse) or appear in any place you've been within 500 feet of where your corpse lies (but without any of your gear).

You still retain your original mind, and therefore don't regain any power points or expended abilities. You are still under any mental influences and energy drain effects you were under when you recalled the form of your physical body, but don't retain any physical effects such as bleed damage or poison (unless you suffered from these conditions at the time the power was manifest). Spells and powers affecting you when you time-stepped your body abide by their normal durations. Manifesting this power again replaces any previous version of yourself that you time-stepped.

Augment: If you spend 2 additional power points, no time has passed for your time-stepped body when you recall it, so all powers and effects that were active when you time-stepped are once again active when you recall it.`
  },
  Unravel_Psionics: {
    name: "Unravel Psionics",
    discipline: "Psychokinesis",
    level: "Psion/wilder 9",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "All psionic effects and psionic items within a 40-ft.- radius burst, or one psionic item (see text)",
    duration: "1 minute/level",
    savingThrow: "Will negates",
    powerResistance: "No",
    powerPoints: "17",
    description: `All psionic effects and psionic items within the radius of the power, except for those that you carry or touch, are disjoined. That is, powers and psi-like effects are unraveled and destroyed completely (ending the effect as a dispel psionics power does), and each permanent psionic item must make a successful Will save or be turned into a normal item for the duration of this power. An item in a creature's possession uses its own Will save bonus or its possessor's Will save bonus, whichever is higher. If an item's saving throw results in a natural 1 on the die, the item is destroyed instead of being suppressed.

You also have a 1% chance per manifester level of destroying a null psionics field . If the null psionics field survives the disjunction, no items within it are disjoined.

You can also use this power to target a single item. The item gets a Will save at a -5 penalty to avoid being permanently destroyed. Even artifacts are subject to disjunction, though there is only a 1% chance per manifester level of actually affecting such powerful items. If successful, the artifact's power unravels, and it is destroyed (with no save). If an artifact is destroyed, you must make a DC 25 Will save or permanently lose all manifesting abilities. These abilities cannot be recovered by mortal power, not even reality revision , miracle , or wish . Destroying artifacts is a dangerous business, and it is 95% likely to attract the attention of some powerful being who has an interest in or connection with the device.`
  },
  Accelerated_Entropy: {
    name: "Accelerated Entropy",
    discipline: "Athanatism",
    level: "Conduit 1, cryptic 1, dread 1",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates, see text",
    powerResistance: "No",
    powerPoints: "1",
    description: `Effect: Ray

The smell of rancid, rotting vegetation suffuses the area as the object of your ire rapidly ages and falls apart. When you manifest this power, you must make a ranged touch attack (typically AC 10) against a single magical or psionic consumable item such as a potion, scroll, shard, or power stone. The object targeted must make a successful saving throw or it is immediately broken. If the item is unattended, use its manifester level as its Will saving throw bonus. If the item is attended, use the Will saving throw bonus of the creature holding it.

This power cannot be normally be used against items that contain more than one charge, such as wands or dorjes. In the case of items such as scrolls that are single-use but contain more than one spell or power, one randomly chosen spell or power can be ruined per manifestation of accelerated entropy .

Augment: If you spend 2 additional power points, you can target a single, non-magical item weighing up to 10 pounds per manifester level. In addition, for every two additional power points you spend, the saving throw DC increases by 1.

Mythic Accelerated Entropy

This power can now apply to items that contain more than one charge. In such a case, if the item fails its saving throw, a number of charges equal to twice your mythic tier are lost, as if they had been used.`
  },
  Guidance_of_the_Ancestors: {
    name: "Guidance of the Ancestors",
    discipline: "Athanatism",
    level: "Conduit 1, cryptic 1, highlord 1, psychic warrior 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `By questioning the spirits of your ancestors, you gain vast knowledge. You may make Knowledge skill checks untrained. When you manifest this power, choose one Knowledge skill. You gain a +2 insight bonus on skills checks made using that skill.

Augment: This power may be augmented in one of the following ways.

• For every additional power point you spend, you increase the bonus you gain to skill checks from this power by 1, to a maximum of +10.

• You may spend an additional 4 power points and expend your psionic focus to you gain one armor or weapon proficiency of your choice.

• You may spend an additional 2 power points to choose a language you do not speak. You may read, write, and speak it.

For every 4 power points you spend augmenting this power, you may choose another Knowledge skill.`
  },
  Hauntvision: {
    name: "Hauntvision",
    discipline: "Athanatism",
    level: "Conduit 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped emanation centered on you",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `Your body becomes coated in a sheen of frost as your core temperature drops, hinting at the spiritual sight you have gained. While under the effect of hauntvision , you can detect, identify, and eventually understand haunts nearby. The amount of information revealed by the manifestation of this power depends on how long you study a particular area or subject.

Detection of a haunt may trigger it to manifest, depending on the conditions and nature of the individual haunt.

• 1st Round: Presence or absence of haunts.

• 2nd Round: Number of different haunts and the strength of the most potent haunt. For purposes of determining a haunt's strength, those with CR 1-3 are considered weak, CR 4-6 moderate, CR 7-9 strong, CR 10- 12 potent, CR 13-15 imposing, and CR 16+ deadly.

• 3rd Round: The strength and location of each haunt. If the haunts are within line of sight, you can make Knowledge (religion) checks to attempt identification.

Mythic Hauntvision

You may add your mythic tier to Knowledge (religion) rolls made to identify haunts.`
  },
  Insight_of_the_Dead: {
    name: "Insight of the Dead",
    discipline: "Athanatism",
    level: "Conduit 1",
    display: "Mental and visual",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One corpse",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You see through the eyes of the dead, accessing their last living memories. When you manifest this power, you see and hear the last round of the creature's life. The base chance for receiving a meaningful result is 70%, and shows exactly what the creature saw and heard during that time. This includes illusions, darkness, or anything else that might alter or obscure perceptions. If the creature was unconscious during this time, you see and hear nothing, but you learn that it was unconscious. If the power fails, the vision is flawed, changing or obscuring the details.

Augment: For each additional power point you spend, you may see an additional round before the creature died. For every power point you spend augmenting this power, increase the chance of a meaningful result by 5%, to a maximum of 90%.`
  },
  Seance: {
    name: "Seance",
    discipline: "Athanatism",
    level: "Conduit 1, highlord 1, tactician 1",
    display: "Mental",
    manifestingTime: "1 hour",
    range: "Unlimited; see text",
    target: "One specific departed soul",
    area: "",
    duration: "1 hour",
    savingThrow: "Will negates",
    powerResistance: "No",
    powerPoints: "1",
    description: `You and a group of allies summon pieces of a departed soul for questioning. You may include up to two others in this power as members, whom you must remain in close proximity to for the entire manifestation time. When you manifest this power, you must specify a departed soul by name. That departed soul is the target, and can be targeted on different planes. The departed soul is physically drawn to your location, and cannot take any actions while there except to communicate. It is not an actual creature, and cannot be attacked or effected in any way. You and each other that aided you in the manifestation of this power may each ask the departed soul a question, which the departed soul must answer -though it only knows what it knew in life. The departed soul can be deceptive or cryptic, if it so wishes.

Augment: You may augment this power in one of the following ways.

• For every 2 additional power points spent, you can include an additional member in the manifestation of this power.

• By spending an additional 8 power points, you may target a departed soul that has been destroyed in the last week.`
  },
  Bond_of_Death: {
    name: "Bond of Death",
    discipline: "Athanatism",
    level: "Conduit 2",
    display: "Mental",
    manifestingTime: "5 minutes",
    range: "Touch",
    target: "One willing animal companion or familiar touched with 3 HD or less",
    area: "",
    duration: "1 day/level",
    savingThrow: "None",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `You reinforce the bond between a master and servant, allowing them to join in undeath. If the target's master dies and is animated as any kind of intelligent undead, the target immediately dies. They reanimate as a ghost, retaining all of the same benefits they had in life as a familiar or animal companion, including the bond to their master.

Augment: For every additional power point spent, the maximum HD of creature that this power can target is increased by 1.`
  },
  Bring_Forth_the_Soul: {
    name: "Bring Forth the Soul",
    discipline: "Athanatism",
    level: "Conduit 2",
    display: "Auditory and olfactory",
    manifestingTime: "5 minutes",
    range: "10 ft.",
    target: "One dead creature",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "3",
    description: `You bring back the soul of one that is recently dead, allowing you to question them freely or raise them more easily. A soul brought back in this way is treated as a shadow, except that they cannot create spawn and do not deal ability damage with their attacks. This soul is not obliged to stay or serve, and may attempt a Will saving throw to resist being brought back. The soul suffers a penalty on saves equal to your Charisma modifier against any Athanatism powers or effects that you manifest in the future. A soul that succeeds on this saving throw may not be targeted again by this power by the same manifester for 24 hours. If the targeted creature has been dead for longer than a week, or died due to negative energy or soul-draining effects, this power fails. This power does not affect a corpse that has been turned into an undead creature. Each corpse can only be affected by one instance of this power at a time.

Augment: This power may be augmented in one of the following ways.

• For every 2 additional power points you spend, the corpse targeted by this power may have been dead for one additional week.

• By spending an additional 4 power points, increase the duration of this power to 1 hour/level.

• By spending an additional 6 power points, increase the duration of this power to 1 day/level.

• By spending an additional 10 power points, you may raise the soul from the dead. The soul must be willing to return. It returns to life with two permanent negative levels. If it is 1st level, it takes 2 points of Constitution drain instead (if this would reduce its Con to 0 or less, it can't be raised). A target that died with spells prepared has a 50% chance of losing any given spell upon being raised. A spellcasting creature that doesn't prepare spells has a 50% chance of losing any given unused spell slot as if it had been used to cast a spell. A manifester that died with power points is raised with half its maximum power points, round up. A raised creature has a number of hit points equal to its current HD. Any normal poison or diseases affecting the target are cured when it returns to life, but missing limbs, magical diseases, and curses remain unchanged. It retains the penalty to saves against your athanatism effects. When you augment this power in this way, you suffer a permanent negative level. This power gains the healing subtype.`
  },
  Corpsewalk: {
    name: "Corpsewalk",
    discipline: "Athanatism",
    level: "Conduit 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One mindless undead",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `The lurching and uncoordinated movements of a nearby monster suddenly take a controlled and purposeful smoothness. When you manifest corpsewalk , you temporarily gain the ability to inhabit the body of a mindless undead creature such as a skeleton or zombie. Your body becomes limp and unresponsive while your consciousness is riding in its temporary host. You remain aware of events around your body and you may return to it by dismissing corpsewalk (a standard action).

While you inhabit an undead husk, it is unable to act in any way. You control its body and may use it as you wish, making slam attacks, moving, or using whatever equipment you can place its hands upon.

You gain whatever senses your undead host possesses and the body retains any defensive or passive abilities (such as Damage Reduction) it has which do not require activation. Otherwise, you do not gain control of any supernatural, or psi-like abilities the creature has, nor do you gain access to any feats it possesses. You are able to use feats and skills you know as long as they are appropriate to the body you are occupying.

You may make Disguise or Bluff checks to attempt to disguise yourself but a mindless undead typically moves with a gait that is distinctive and unnatural, meaning you are likely to be spotted as unusual while in motion.

If your undead host body is destroyed while you occupy it, corpsewalk immediately ends. During this power, you are merely linking to the undead body and your soul remains within your own, so if your host body is within a negative energy effect such as channel negative energy, the body heals and you suffer no ill effect.

Augment: For every additional two power points you spend manifesting this power, you gain the ability to manifest one psionic power while you are controlling the undead body and the DC for this power increases by one.

Mythic Corpsewalk

You may attempt to take over the bodies of intelligent undead, but doing so reduces the duration of this power to one round per level.`
  },
  Ghostward: {
    name: "Ghostward",
    discipline: "Athanatism",
    level: "Conduit 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "",
    area: "",
    duration: "Concentration up to 1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Conduit 3",
    description: `Effect: Ectoplasmic coating whose area is up to one 10-ft. square/level

A shadowy silhouette of your hand reaches out from you and appears to spread a portion of your essence upon a nearby surface. This power allows you to cover a wall, floor, ceiling, or similar surface with energies that incorporeal undead find repulsive. Such creatures are unwilling to cross through this energy, making the area you ward impassable to them. You may shape the area you designate to some degree, but your ward always coats existing physical materials and you must be able to see the surfaces you intend to cover. This generally does not allow you to imprison an incorporeal undead as you normally cannot see all surfaces of a container, but it might allow you to ward all surfaces of a room you occupy to keep the creature out.

Mythic Ghostward

Instead of coating a material surface, you may choose to cover an incorporeal undead creature that you can see (and which has a surface area within your manifestation limits). Doing so hinders the creature's ability to pass through solid objects. Such a warded creature cannot pass through any walls etc, but is still able to ignore armor that does not have the ghost touch property.`
  },
  Object_Possession: {
    name: "Object Possession",
    discipline: "Athanatism",
    level: "Conduit 2",
    display: "Auditory and mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You take a ghostlike form, leaping into a nearby object. This object must be of Small size or smaller, and must be no further away than 50 feet. You effectively become that object, counting as an animated object of the object's size and shape, except that you do not gain immunity to mind-affecting effects. If the object is destroyed while you are inhabiting it, this power immediately ends and you are dazed for one round.

Augment: This power may be augmented in one of the following was.

• By spending an additional 4 power points, increase the duration of this power to 10 minutes/level. However, if you augment the power in this way, the object targeted does not become animated - instead, you can take no action while inside it other than to dismiss this power. You may observe the object's surroundings using your skills and normal senses, however.

• You may spend an additional 3 power points to increase the size of object you may animate by one step (to a maximum of Huge).`
  },
  Deathbond: {
    name: "Deathbond",
    discipline: "Athanatism (scrying)",
    level: "Conduit 3",
    display: "Auditory",
    manifestingTime: "10 minutes",
    range: "Touch",
    target: "One creature touched",
    area: "",
    duration: "1 day/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You form a connection with the target's soul, seeing their surroundings at the moment of their death. If the target dies while this power is active, you immediately know it, and can see the events of the previous round in its immediate area, including who and what killed it. This is treated as a scrying sensor, so you can still be fooled by disguises, invisibility, stealth, or other similar effects. In addition, in the round immediately following the target's death, you may manifest any single athanatism power that requires a newly dead body or spirit, targeting them regardless of distance or line of effect.

Augment: By spending an additional 4 power points, you may place a sensor identical to the one created by clairvoyant sense at the location where the target died. This sensor lasts for 1 minute/level.`
  },
  Insubstantial: {
    name: "Insubstantial",
    discipline: "Athanatism",
    level: "Dread 2, conduit 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Dread 3, conduit 5",
    description: `Your form becomes indistinct and blurry as if viewed through a heat-haze. While under the effect of this power, you gain the incorporeal monster ability. Because this transformation is temporary, it only grants you the ability to move through solid objects as an incorporeal creature would, though insubstantial can be augmented to offer additional benefits.

When this power ends, you are staggered for one round. Additionally, if you are partially or completely inside a material object when this power ends, you are ejected into the nearest free space, taking 1d6 points of damage per 5 feet of material you move through to find a free space.

Augment: You may augment this power in one or more of the following ways.

• By spending an additional two power points, you gain the innate sense of direction common to naturally incorporeal creatures, able to move at full speed even when you cannot see. This does not grant you any additional senses and is therefore mostly useful while passing through solid objects.

• By spending an additional two power points, you can move silently. Creatures making Perception checks to observe or locate you suffer a -5 penalty on those checks.

• By spending an additional four power points, your Armor Class is altered as a natural incorporeal creature; you lose any natural armor bonus to Armor Class and gain a deflection bonus equal to your Charisma modifier. This bonus does not stack with other sources. Any armor or shield that does not have the ghost touch property ceases applying to your Armor Class while you are incorporeal.

• By spending an additional eight power points, you gain immunity to non-magical attack forms and take only half damage from magic weapons and powers from corporeal sources. Corporeal powers and effects that do not cause damage only have a 50% chance of affecting you. Force powers and effects, such as from entangling debris , affect an incorporeal creature normally.

Mythic Insubstantial

This power's duration changes to 1 round per mythic tier you possess.`
  },
  Quicken_Rejuvenation: {
    name: "Quicken Rejuvenation",
    discipline: "Athanatism [healing]",
    level: "Conduit 3, vitalist 3",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "1 ghost destroyed within the last round",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "5",
    description: `You infuse unnatural vitality into the target, returning it to unlife. The recently destroyed ghost immediately activates its rejuvenation ability, restoring itself completely. A ghost may not targeted by this power more than once in a given week.

Augment: You may augment this power in one of the following ways.

• By spending an additional 6 power points, you may target a ghost that was destroyed a number of days ago equal to your manifester level (round down) or less.

• By spending an additional 6 power points and expending your psionic focus, you may manifest this power on yourself as an immediate action when you would be reduced to 0 or fewer hit points. When you do, you and your gear are immediately destroyed, returning to life 2d4 days unharmed with all gear intact. You must currently be incorporeal or under the effects of a power with the spirit subtype to augment the power in this way.`
  },
  Resting_with_the_Fallen: {
    name: "Resting with the Fallen",
    discipline: "Athanatism",
    level: "Conduit 3, cryptic 3, highlord 3, tactician 3",
    display: "Auditory and mental",
    manifestingTime: "1 round plus up to 1 round/level; see text",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One dead body",
    area: "",
    duration: "See text",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5",
    description: `You transfer your soul into a dead body, claiming their memories as your own. When you manifest this power, your body is emptied – you are treated as unconscious and helpless. However, as you are not within your body, you are immune to mind-affecting effects for this time. While this power is active, you may dredge through the target's most recent memories. For each round that you remain in the target's mind (up to 1 round/level), you access two rounds worth of memory. These memories start from immediately before the target died, and continue backwards from there (for example, if you were in their mind for 4 rounds, you would learn the last 8 rounds of their memories prior to death). You only learn anything they experienced or learned in that time period.

If the target's body is destroyed, raised from the dead, or animated as undead while you are in it, this power immediately ends, and you must succeed at a Will save or be dazed for 1d6 rounds.

Augment: You may augment this power in one of the following ways.

• By spending an additional 6 power points, you instead gain access to 1 hour of memories for each round you spend in the target's mind.

• By spending an additional 6 power points, you may corrupt any memories you access, changing them subtly in ways you choose. This affects any future manifestations of this or other similar effects on the target, as well as affecting the target's memories should they be later raised or become undead.

• By spending an additional 4 power points, you may animate the body. While this power is active, the dead body is treated as a wight, completely under your control.`
  },
  Binding_of_the_Flesh: {
    name: "Binding of the Flesh",
    discipline: "Athanatism [healing]",
    level: "Conduit 4",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Dead creature touched",
    area: "",
    duration: "1 hour/level",
    savingThrow: "None",
    powerResistance: "Yes (harmless)",
    powerPoints: "7",
    description: `You bind pieces of the spirit world to the body of the fallen, granting it a new (if temporary) lease on life. The subject cannot be a construct, an elemental, an outsider, or undead, must have its soul free and willing to return, must have been dead no more than 1 round/level, must not have been killed by a death effect or turned into an undead creature, and its body must be whole. Any normal poison or diseases affecting the target are cured when it returns to life, but missing limbs, magical diseases, and curses remain unchanged. Your target returns to life with half of their full normal hit points, with any powers points or spells it had previously expended still expended. The target dies immediately when this power ends. When they do so, their bodies rot away to nothing in an instant, leaving their gear and possessions behind. They may not be the target of any power that expressly requires remains, such as raise dead , binding of the flesh , etc.

Augment: By spending an additional 4 power points, the duration of this power becomes 1 day/level.`
  },
  Gift_of_the_Corpse: {
    name: "Gift of the Corpse",
    discipline: "Athanatism",
    level: "Conduit 6, cryptic 5",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 minutes/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11 (conduit), 9 (cryptic)",
    description: `Gift of the Corpse[]

You exhale your life force temporarily, unbinding your spirit from your body. For the duration of this power, you lay in a deathlike comatose state.

: While this power is active, you gain a shadow's darkvision, defensive abilities (including incorporeal), fly speed, racial Stealth modifier, and Strength damage attack. You do not gain the creature's create spawn ability, nor its skill ranks or Hit Dice. Your spirit has Hit Dice and hit points equal to your own. Your spirit has the undead type and may be turned or affected as undead. If your spirit is slain, you return to your physical body and are immediately reduced to -1 hit points. Your condition becomes dying, and you must begin making Constitution checks to stabilize.

When this power ends, as long as your body has not been completely destroyed (such as through the effects of disintegrate ) and is on the same plane of existence, you automatically return to it. If it is not, this power remains active except that if you have not reached your body after a number of minutes equal to your manifester level, your spirit dies instantly.

Augment: This power may be augmented in one of the following ways.

1. By spending an additional 2 power points, you may manifest this power on a willing creature that you touch.

2. By spending an additional 4 power points, you may manifest this power as an immediate action in response to being attacked. This has the added effect of making it appear that the triggering attack killed you.

3. By spending an additional 4 power points, the duration of this power doubles.

Ex Nihilo[]

This power functions exactly like gift of the corpse , except that you become similar to a ghost instead of a shadow, gaining the following changes for as long as this power is active: you become incorporeal, count as undead for all purposes (including immunities and vulnerabilities), gain a +4 enhancement bonus to Charisma, a deflection bonus to your AC equal to your Charisma modifier, temporary hit points equal to your manifester level, and channel resistance +4. While in this state, you cannot benefit from any gear you possess unless it has the ghost touch special property.

Augment: You may spend 4 additional power points to have your body temporarily vanish when you manifest this power. If you do so, your body is immune to all damage and effects until this power ends, when it reappears wherever it was originally.`
  },
  Inverse_Possession: {
    name: "Inverse Possession",
    discipline: "Athanatism",
    level: "Conduit 4",
    display: "Olfactory and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft./2 levels)",
    target: "One incorporeal creature",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You draw an incorporeal creature Into your body, where you are free to draw on it for power. The target is immune to all damage and effects while this power is active, and it cannot take actions or do anything but communicate with you. As a free action, once per HD the incorporeal creature possesses, you may increase the DC of a conduit power you manifest by 1. This power ends once you have gained the above bonus a number of times equal to the HD of the incorporeal creature. You may only have one instance of this power active at a time. When this power ends, the incorporeal creature is returned from whence it came.

Augment: You may augment this power in one of the following ways.

• By spending an additional 2 power points, you may make this power incredibly draining for the target. When the power ends, the target suffers a penalty to attack rolls, damage rolls, and skill checks equal to the number of times you activated this power. This penalty lasts for half as long as this power was active. For example -Deren targets a 10-HD creature with this power. He uses the power's bonus ten times in the following six rounds, ending it early. The creature receives a -10 penalty on attack rolls, damage rolls, and skill checks for 3 rounds, since 3 is half of the number of rounds it was affected by this power.

• By spending an additional 2 power points, you may drain the creature of power. Instead of increasing the DC of a conduit power you manifest, you may gain a number of temporary power points equal to your Charisma modifier. These temporary power points vanish 5 minutes after this power ends.`
  },
  Scales_of_Damnation: {
    name: "Scales of Damnation",
    discipline: "Athanatism",
    level: "Gifted blade 4, conduit 4, highlord 4, psychic warrior 4, tactician 4",
    display: "Mental and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `By binding yourself to the spirit world, you can send power to it, or draw its power into yourself. While this power is active, you may, as a standard action, either give or drain energy from the spirit world. When you give energy to the spirit world, you may expend any amount of hit points. You extend the duration of this power by 1 round for every 2 hit points you lose this way. When you drain energy from the spirit world, you gain a +2 insight bonus to AC and all saving throws until you give energy to the spirit world.

Augment: This power may be augmented in one of the following ways.

• By spending an additional 6 power points, you gain temporary power points equal to twice your Charisma modifier whenever you drain energy from the spirit world. These power points disappear when the power ends, and may not spent for this power or its augments.

• You may spend an additional 2 power points and lose 5 hit points to increase the insight bonus to AC and saving throws by 1.`
  },
  Ephemeral_Binding: {
    name: "Ephemeral Binding",
    discipline: "Athanatism",
    level: "Conduit 5",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Object held",
    area: "",
    duration: "1 min./level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You cause a held object to serve as a bridge between planes. The object counts as both ethereal and material, and can be interacted with equally by each side. This functions exactly like the ghost touch special item property, except that it can be applied to any object that can be reasonably held by the manifester.

Augment: You may spend 4 additional power points to instead affect part of any object touched, up to 5 square ft./level. This can include parts of buildings, ground, or other similar objects.`
  },
  Horrid_Fetter: {
    name: "Horrid Fetter",
    discipline: "Athanatism",
    level: "Conduit 5",
    display: "Material and visual",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels); see text",
    target: "One incorporeal creature with 6 HD or less",
    area: "",
    duration: "Instantaneous; see text",
    savingThrow: "Will negates",
    powerResistance: "No and yes; see text",
    powerPoints: "9",
    description: `By using this power, you attempt to bind an incorporeal creature to an object important to it, which must lie within the powers' range. The called creature is bound to the object and to your service until it agrees to perform one service in return for its freedom.

First, you must locate an object important to that creature. This can the breath of a dying man, a bloodied sword, or be an object that holds significance to members of its type (a mirror for a mirror shade, for example). When calling a specific individual, you would use things like an item that it wielded in life, a picture of it, the tears of its widow, or its corporeal remains if it is undead. The type of creature must be known and stated. If you wish to call a specific individual, you must use that individual's proper name in manifesting this power.

The target creature is allowed a Will saving throw. If the saving throw succeeds, the creature resists the power. If the saving throw fails, the creature is immediately drawn to the object (power resistance does not keep it from being called), and is unable to harm or act against you for as long as you hold or own the object it is bound to. You can add a special diagram (a two-dimensional bounded figure with no gaps along its circumference, augmented with various psionic sigils) to make the circle more secure. Drawing the diagram by hand takes 10 minutes and requires a DC 20 Spellcraft check. You do not know the result of this check. If the check fails, the diagram is ineffective. You can take 10 when drawing the diagram if you are under no particular time pressure to complete the task. This task also takes 10 full minutes. If time is no factor at all, and you devote 3 hours and 20 minutes to the task, you can take 20.

A successful diagram allows you to manifest a wrench spell on the circle during the round before manifesting any summoning power. The anchor holds any called creatures in the circle for 24 hours per manifester level. A creature cannot use its power resistance against a circle prepared with a diagram, and none of its abilities or attacks can cross the diagram. If the creature tries a Charisma check to break free of the trap (see below), the DC increases by 5. The creature is immediately released if anything disturbs the diagram—even a straw laid across it. The creature itself cannot disturb the diagram either directly or indirectly, as noted above.

The creature can flee from you by successfully pitting its power resistance against your manifester level check, by dimensional travel, or with a successful Charisma check (DC 15 + 1/2 your manifester level + your Charisma modifier). It can try each method once per day. If it breaks loose, it can flee or attack you. If the creature is held within a successful circle enhanced by wrench (as described above), they may not escape by dimensional travel.

If the creature does not break free of this power, you may keep it bound for as long as you wish. You can attempt to compel a creature to perform a service by describing the service and either offering some sort of reward or damaging the object to attempt to coerce it. In either case, you can only attempt to issue the creature commands or negotiate for services once in a 24-hour period, and impossible demands or unreasonable commands are never agreed to.

For the former case, you make a Charisma check opposed by the creature's Charisma check. The check is assigned a bonus of +0 to +6 based on the nature of the service and the reward. If the creature wins the opposed check, it refuses service. This process can be repeated until the creature promises to serve, until it breaks free, or until you decide to get rid of it by means of some other effect. If you ever roll a natural 1 on the Charisma check, the creature breaks free of the power's effect and can escape or attack you.

In the latter case, you may damage the object a total of five times to attempt to compel the creature. After the fifth time, the object breaks, and this power ends. When you damage the item (a standard action), the creature takes damage equal to half its maximum hit points, round up, and is sickened for 1 round/level. Instead of taking damage, the creature may follow one command you give it to the best of its ability.

Once the service or command is completed, the creature need only to inform you to be instantly sent back whence it came. The creature might later seek revenge. If you assign some open-ended task that the creature cannot complete through its own actions, the power remains in effect for a maximum of 1 day per manifester level, and the creature gains an immediate chance to break free (with the same chance to resist as when it was called). Note that a clever recipient can subvert some instructions.

Augment: For each additional power point that you spend, increase the HD of the creature that you can summon by 1. In addition, you may expend your psionic focus to target up to three creatures of the same kind, as long as their total Hit Dice is no more than the total creature HD you are summoning. Each creature gets a saving throw, makes an independent attempt to escape, and must be individually persuaded to aid you.`
  },
  Orphic_Descent: {
    name: "Orphic Descent",
    discipline: "Athanatism",
    level: "Conduit 5",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "8 hours",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `You descend into the vaults of night, returning hours later with a fallen soul. For the duration of this power, you vanish, effectively ceasing to exist. The duration of any effect active on you continues as normal, and may expire while you are gone. When this power ends, you return in the same location you left, bringing with you the spirit of a currently dead person you were at least familiar with, who is then restored to life at full hit points and with all spells prepared and power points regained, just as if they had rested and recovered them naturally. This power ends automatically at the next midnight, at which point target immediately dies, its spirit returning from whence it came. If the spirit died of old age, is unwilling to go with you, or is a construct, outsider, or undead creature, this power fails, ending after only 4 hours.

Augment: By spending an additional 6 power points, you may attempt to target an unwilling spirit by succeeding on a manifester level check against a DC of 10 + the target's Hit Dice + the target's Charisma modifier. If you return an unwilling spirit to life in this way, they are controlled by you as if through a mind control power manifested by you.

Special: This power may only be manifested at night.`
  },
  Autolingua: {
    name: "Autolingua",
    discipline: "Athanatism",
    level: "Conduit 6",
    display: "Mental",
    manifestingTime: "See text",
    range: "Personal",
    target: "You",
    area: "",
    duration: "See text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `You allow the spirit world access to your hands, gaining information on a person, place, or thing through their written words at the cost of some of your essence. If the person or thing is at hand, or if you are in the place in question, the casting time is 1d4 x 10 minutes. If you have only detailed information on the person, place, or thing, the casting time is 1d10 days, and the resulting lore is less complete and specific (though it often provides enough information to help you find the person, place, or thing, thus allowing a better autolingua result next time). If you know only rumors, the casting time is 2d6 weeks, and the resulting lore is vague and incomplete (though it often directs you to more detailed information, thus allowing a better autolingua result next time).

During the casting, you cannot engage in other than routine activities: eating, sleeping, and so forth. When completed, the written words bring legends (if any) about the person, place, or things to your mind. These may be legends that are still current, legends that have been forgotten, or even information that has never been generally known. If the person, place, or thing is not of legendary importance, you gain no information. As a rule of thumb, characters who are 11th level and higher are “legendary,” as are the sorts of creatures they contend with, the major magic items they wield, and the places where they perform their key deeds.

Augment: This power may be augmented in one of the following ways.

• By spending an additional 2 power points, you reduce the manifesting time of this power when the person, place, or thing is not at hand from 1d10 days to 1d10 hours.

• By spending an additional 4 power points, you reduce the manifesting time of this power when you know only rumors of the person, place, or thing from 2d6 weeks to 2d6 days.

• By spending an additional 4 power points, you create a map towards the person, place, or thing if it is not on hand. This map shows the shortest, most direct physical route to its location at the time you finish manifesting this power, as long as it is on the same plane as you. If you are not on the same plane as it, you instead learn which plane it is currently on.`
  },
  Bind_Flesh_to_Soul: {
    name: "Bind Flesh to Soul",
    discipline: "Athanatism",
    level: "Conduit 6, highlord 6, tactician 6",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `You force a target to share in the pain felt by nearby spirits. While the duration lasts, the target takes all damage and heals all wounds that any incorporeal or ethereal creature within 30 feet of them takes. The target is also subject to magical and psionic effects of 3rd level or lower that target or effect any incorporeal or ethereal creature within 30 feet of them. If the effect offers a saving throw, the target gains one as well.

Augment: You may augment this power in one of the following ways.

• You may spend an additional 2 power points to have this power affect one additional target and have its DC increased by 1.

• For every additional 4 power points spent, the maximum level of effects that are shared between the target and nearby incorporeal or ethereal creatures is increased by 1. For example, if you augment this power twice in this way, the target will be subject to magical or psionic effects of 5th level or lower that target or effect any incorporeal of ethereal creatures within 30 feet instead of 3rd or lower.`
  },
  Death_Pact: {
    name: "Death Pact",
    discipline: "Athanatism",
    level: "Conduit 6",
    display: "Mental and visual",
    manifestingTime: "10 minutes",
    range: "Touch",
    target: "One willing, living creature",
    area: "",
    duration: "Permanent",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "11",
    description: `You form a lasting bond with a willing creature, ensuring them eternal unlife even if death should claim them. All it costs them is their allegiance. When the target dies, they immediately become a ghost, applying the ghost template as normal. They only gain corrupting touch as a special attack, however. While the subject is affected by this power, they are friendly to you, share your motivations and goals, and are likely to follow any reasonable suggestions you make. You may not manifest this power on yourself.

Augment: You may augment this power in one of the following ways

• You may expend your psionic focus to instead have the target become a free-willed wraith after they die. This wraith retains its initial alignment. This augment may only be used if the target has 7 or more Hit Dice.

• You may spend an additional 2 power points and expend your psionic focus to instead have the target become a free-willed spectre after they die. This spectre retains its initial alignment. This augment may only be used if the target has 9 or more Hit Dice.

• You may spend an additional 6 power points and expend your psionic focus to instead have the target become a free-willed banshee after they die. This banshee retains its initial alignment. This augment may only be used if the target has 15 or more Hit Dice.

• You may spend an additional 2 power points and gain a permanent negative level to grant the target one additional ghost special attack of your choice.`
  },
  Ex_Nihilo: {
    name: "Ex Nihilo",
    discipline: "Athanatism",
    level: "Conduit 6, cryptic 5",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 minutes/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11 (conduit), 9 (cryptic)",
    description: `Gift of the Corpse[]

You exhale your life force temporarily, unbinding your spirit from your body. For the duration of this power, you lay in a deathlike comatose state.

: While this power is active, you gain a shadow's darkvision, defensive abilities (including incorporeal), fly speed, racial Stealth modifier, and Strength damage attack. You do not gain the creature's create spawn ability, nor its skill ranks or Hit Dice. Your spirit has Hit Dice and hit points equal to your own. Your spirit has the undead type and may be turned or affected as undead. If your spirit is slain, you return to your physical body and are immediately reduced to -1 hit points. Your condition becomes dying, and you must begin making Constitution checks to stabilize.

When this power ends, as long as your body has not been completely destroyed (such as through the effects of disintegrate ) and is on the same plane of existence, you automatically return to it. If it is not, this power remains active except that if you have not reached your body after a number of minutes equal to your manifester level, your spirit dies instantly.

Augment: This power may be augmented in one of the following ways.

1. By spending an additional 2 power points, you may manifest this power on a willing creature that you touch.

2. By spending an additional 4 power points, you may manifest this power as an immediate action in response to being attacked. This has the added effect of making it appear that the triggering attack killed you.

3. By spending an additional 4 power points, the duration of this power doubles.

Ex Nihilo[]

This power functions exactly like gift of the corpse , except that you become similar to a ghost instead of a shadow, gaining the following changes for as long as this power is active: you become incorporeal, count as undead for all purposes (including immunities and vulnerabilities), gain a +4 enhancement bonus to Charisma, a deflection bonus to your AC equal to your Charisma modifier, temporary hit points equal to your manifester level, and channel resistance +4. While in this state, you cannot benefit from any gear you possess unless it has the ghost touch special property.

Augment: You may spend 4 additional power points to have your body temporarily vanish when you manifest this power. If you do so, your body is immune to all damage and effects until this power ends, when it reappears wherever it was originally.`
  },
  Horrid_Transformation: {
    name: "Horrid Transformation",
    discipline: "Athanatism [evil, death]",
    level: "Conduit 7",
    display: "Auditory and mental",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One incorporeal creature",
    area: "",
    duration: "5 rounds",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `By wracking a incorporeal creature with incredible pain and suffering, you attempt to transform it into a wraith. The target is stunned for the duration of this power. It can attempt a new save at the end of each of its turns to end this effect – but it receives a penalty on this save equal to the number of rounds it has been stunned (for example, the target's second save is at a -2, the third at a -3, and so on to a maximum of -5 for the fifth save). If all five rounds pass and the target is still stunned by this power, it is immediately destroyed, returning as a wraith in 1d4 rounds. You gain no special control or influence over this wraith – in fact, it is likely to be enraged towards you for the pain you caused it. However, a wraith created through this power suffers a permanent penalty on saves equal to your Charisma modifier against athanatism powers or effects you create.

Augment: You may spend an additional 2 power points to have this power target a corporeal creature within range.

Special: Though this is a death effect, incorporeal undead creatures gain no immunity against this power.`
  },
  Sever_the_Strand: {
    name: "Sever the Strand",
    discipline: "Athanatism",
    level: "Conduit 7",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One corpse",
    area: "",
    duration: "Permanent",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "13",
    description: `Using your mastery of the spirit world, you sever a soul from the newly-dead. The subject must have been dead no more than 1 round/level. Once you have severed the soul, it cannot be returned to life or animated as an undead creature by any means (including, but not limited to, wish or miracle ).`
  },
  Soul_Chorus: {
    name: "Soul Chorus",
    discipline: "Athanatism",
    level: "Conduit 7, Tactician 7, Vitalist 7",
    display: "Mental, Visual, see text",
    manifestingTime: "1 minute",
    range: "20 ft.",
    target: "You and up to five deceased psionic creatures in range; see text",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `Metaconcert[]

You link your psychic might with other psionic creatures, creating a composite network more powerful than the sum of its parts. If there are no willing, psionic creatures in the area other than you when you use this power, it fails.

When you manifest this power, up to five willing, psionic creatures in the area connect with you into a metaconcert network (a “metanetwork”), a distributed, metaphysical analogue of a psionic manifester. Misty strands of glowing power link the brows of each member in a complex and shifting pattern, and a mental image of each other member appears in the minds of everyone so linked. A number of power points you designate flow from each member (including yourself) into a collective pool. If a member does not have enough power points to contribute, he drops out of the metaconcert (see below).

One individual is chosen as the metaconcert conductor by mutual consent of the other members (this is usually the manifester, but doesn't have to be). Until the power ends, this conductor directs the efforts of the network. Members of a metaconcert can continue to take actions of their own as normal without disrupting the metanetwork, provided they stay within the area (see below).

All the powers known of each member (except metaconcert) are available to the conductor through the metanetwork. While the conductor may still manifest his own powers as normal, he may instead choose to manifest a power from the metanetwork instead of from his own powers known. If he does so, he must use the power point pool of the metanetwork and may not use any of his feats or class features to modify the manifestation (although items are permitted), but he also gains numerous benefits. When manifesting a power from the metanetwork, his manifester level increases by one for each other metanetwork member (for instance, the normal maximum membership of five members besides the conductor increases the conductor's manifester level by five). It is obvious to an outsider when the conductor manifests from the metanetwork, as arcs of light pulse between the various members in a scintillating pattern, streaming to the conductor as his power manifests -- this display cannot be hidden.

The metanetwork also supports its members. Each member of the metanetwork gains a bonus on saving throws made against spells or powers equal to the number of other members, as the metanetwork distributes incoming magical energy about its nodes. If a spell or power would deal damage or ability damage to the conductor, he may choose to instead distribute it evenly between himself and all willing members. An individual member may decline receiving damage this way on a case-by-case basis (for example, if a metaconcert consists of the conductor and four other members, one of whom is not willing to receive damage at this time, the conductor may split the incoming damage between himself and the three willing members). Damage split to willing members this way is typeless and empathic in nature. This splitting takes place prior to the effects of other powers or abilities that lessen damage, such as energy resistance or the intellect fortress power. Spells and powers that are not subject to power resistance cannot have their damage or ability damage split this way, though the saving throw bonus still applies.

Once the metanetwork forms, the members must remain within the power's area, and as a group can move at half the slowest member's speed on the conductor's turn. This counts as a move action for each member (that is, if the group moves, each member is treated as having used a move action on their next turn). If a member moves outside the area (whether willingly or involuntarily), that individual drops out of the group, and the power point pool of the metanetwork is instantly recalculated.

All members who leave before a metaconcert ends or is dismissed reclaim a number of power points equal to the metanetwork's current power point pool divided by the number of members. That same number of points is removed from the metanetwork's power point pool. If the conductor drops out, the power ends. When a metaconcert ends normally or is dismissed, remaining power points in the pool are divided among all the members (the conductor receives the remainder if the points can't be divided evenly). No creature can leave a metaconcert with more power points than they had when they entered it -- surplus points dissipate as harmless light radiating from the creature's eyes.

Augment: For every additional power point you spend, this power's duration increases by 1 minute. For every 2 additional power points spent this way, the maximum number of members of the metanetwork increases by one, and the range and radius of the area of effect increase by 5 ft.

Soul Chorus[]

Drawing upon the powers of the fallen, you harness their latent psionic power for your own gain. This functions as metaconcert , save that instead of targeting willing allies, you instead target dead psionic creatures within range. The soul chorus draws all power points that the dead targets possessed at the time that they died, and the conductor may use any powers that were known to any of the creatures. Damage can be split evenly between the manifester and the dead targets as between creatures in a metanetwork (a corpse normally possesses 10 hp, plus 10 for each size it is above small), but any ability damage that would be transferred instead destroys any dead bodies that would take it.

Alternatively, this power can be used as a normal metaconcert power, save that it can target undead creatures as well as living creatures.

Augment

• For every additional power point you spend, this power's duration increases by 1 minute.

• For every 2 additional power points spent this way, the maximum number of members of the metanetwork increases by one, and the range and radius of the area of effect increase by 5 ft.

Mythic Metaconcert[]

The metaconcert conductor can manifest any mythic powers known by members of the metanetwork and gains an additional bonus to his manifester level equal to your tier. Members of the metanetwork gain a bonus on saving throws equal to your mythic tier. Hit point and ability damage is reduced by your tier before it is distributed.

Augmented: If you expend one use of mythic power, members of the metanetwork may spend a swift action to add more power points into the metanetwork's power point pool.`
  },
  Spiritual_Contingency: {
    name: "Spiritual Contingency",
    discipline: "Athanatism",
    level: "Conduit 7",
    display: "Olfactory",
    manifestingTime: "10 minutes or longer; see text",
    range: "Personal",
    target: "You",
    area: "",
    duration: "One day/level (D) or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `You link a power to your spiritual essence, causing it to trigger under some condition you dictate when manifesting spiritual contingency . The spiritual contingency power and the companion power are manifest at the same time. The 10-minute manifesting time is the minimum total for both manifestations; if the companion power has a manifesting time longer than 10 minutes, use that instead. The power to be brought into effect by the spiritual contingency must be one that affects your person and be of a power level no higher than one-third your manifester level (rounded down, maximum 6th level).

The conditions needed to bring the power into effect must be clear and discernible, although they can be general. In all cases, the spiritual contingency immediately brings into effect the companion power, the latter being “manifested” instantaneously only when the prescribed circumstances occur. If complicated or convoluted conditions are prescribed, the power combination ( spiritual contingency and the companion power) may fail when called on. The companion power may one that affects a dead creature, in which case the power combination manifests immediately upon your death.

You can use only one spiritual contingency companion power at a time; if a second is manifested, the first one (if still active) is dismissed.`
  },
  Vestigial_Servitor: {
    name: "Vestigial Servitor",
    discipline: "Athanatism (Spirit)",
    level: "Conduit 7",
    display: "Visual, Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 feet + 10 feet/level)",
    target: "",
    area: "",
    duration: "1 round/level",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "13",
    description: `Effect: 1 Phantom Servitor

You call upon a spirit to aid you, acting as a repository for your powers. The spirit is an incorporeal entity with a number of hit points equal to your manifester level, and appears at a location within range.

As a move action, you may move the spirit up to 40 feet. You can see through its eyes and hear through its ears as if you were standing where it is, and during your turn you can switch from using its senses to using your own, or back again, as a free action. While you are using its senses, your body is considered blinded and deafened.

If you desire, any power you manifest whose range is touch or greater can originate from the spirit instead of from you. The powers affect targets normally, despite originating from the spirit.

Finally, you may take an additional standard action's worth of mental actions each round for each spirit that you have active. If you do, you take a -2 penalty to your manifester level for each active spirit.

Augment

• For every 3 additional power points you spend, you may create an additional spirit. You may move all of these spirits as part of the same action.

• If you expend psionic focus, you may use the senses of your spirit without becoming blind or deaf.`
  },
  Feed_to_Oblivion: {
    name: "Feed to Oblivion",
    discipline: "Athanatism",
    level: "Conduit 8",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 feet + 10 feet/level)",
    target: "1 creature",
    area: "",
    duration: "concentration (maximum 1 round/level)",
    savingThrow: "Fortitude partial (affects objects)",
    powerResistance: "No",
    powerPoints: "15",
    description: `You violently tear open a portal to the netherworld inside the target, consuming its very essence and reducing it to nothingness. Each round you concentrate, the target must make a Fortitude save or take 10 points of damage per manifester level alongside 1d4 negative levels (fortitude half for both). As this effects targets a creature or object's very existence, even entities that are normally immune to negative levels (including undead) suffer from this power. If reduced to 0 hit points, the target is obliterated completely, and can only be restored via a reality revision power or similarly powerful magic.

Augment

• For every 3 additional power points you spend, you may target one additional creature or object each round you concentrate.`
  },
  Gate_of_Avernus: {
    name: "Gate of Avernus",
    discipline: "Athanatism",
    level: "Conduit 8",
    display: "Mental and visual",
    manifestingTime: "10 minutes",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Permanent (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "15",
    description: `You tear open a hole in the planes, bringing forth a gate to the Ethereal Plane.

Creating a gate of Avernus has two effects.

First, it creates an interdimensional connection between your plane of existence and the Ethereal Plane, allowing travel between these two planes in either direction.

Second, you may call a particular ethereal individual or kind of incorporeal being through the gate of Avernus.

When you manifest this power, you dedicate a part of yourself to maintaining it. Any power points that you spent manifesting this power cannot be regained or restored while the power exists. In addition, you suffer 1d6 points of Constitution and Wisdom drain when you finish manifestation.

The gate of Avernus is a circular hoop or disk from 5 to 20 feet in diameter (manifester's choice) oriented in the direction you desire when it comes into existence (typically vertical and facing you). It is a two-dimensional window looking into the plane you specified when manifesting the power, and anyone or anything that fulfills your entry terms, if any, that moves through is shunted instantly to the other side. However, this travel is not without risk. Those that would cross from the Ethereal Plane suffer 1d6 Wisdom drain, while those that would cross into the Ethereal Plane suffer 1d6 Constitution drain. Otherwise, this functions much like a plane shift .

Planar Travel: For this use, you may set entry terms, if you wish. If you do so, you may choose either keyed entry, only allowing certain people, or only allowing a certain type of people. Once you decide on these terms, they cannot be changed.

In the first case, any one in possession of a key or specific, special object, or knowing a certain passphrase may pass. This key or phrase must be decided when manifesting this power, and cannot be changed.

In the second case, you may indicate a number of people up to your manifester level when you manifest this power. These people, as well as yourself, are the only targets that may pass. No disguise, spell, or effect can fool this power.

In the third case, you may indicate a certain characteristic that all who would pass must share. This can be as concrete as alignment, hair color, or possession of a certain class ability, or as abstract as deity worshiped or personal philosophy.

Calling Creatures: The second use of this power is to call forth powerful spirits from the Ethereal Plane. By naming a particular being or kind of being as you manifest this power (which must have the incorporeal subtype or be native to the Ethereal Plane, or this power fails, not expending any material components), you cause the gate of Avernus to open in the immediate vicinity of the desired creature and pull the subject through, willing or unwilling. Deities and unique beings are under no compulsion to come through the gate of Avernus , although may choose to do so of their own accord. This use of this power creates a gate of Avernus that remains open just long enough to transport the called creatures. This use of this power has a material cost of 10,000 gp in intricate scrimshaw and rare tributes. This cost is in addition to any cost that must be paid to the called creatures.

If you choose to call a kind of creature instead of a known individual, you may call either a single creature or several creatures. In either case, their total HD cannot exceed twice your manifester level, and they must either have the incorporeal subtype or be native to the Ethereal Plane. In the case of a single creature, you can control it if its HD does not exceed your manifester level. A creature with more HD than your manifester level can't be controlled. Deities and unique beings cannot be controlled in any event. An uncontrolled being acts as it pleases, making the calling of such creatures dangerous. An uncontrolled being may return to the Ethereal Plane at any time.

If you choose to exact a longer or more involved form of service from a called creature, you must offer some fair trade in return for that service. The service exacted must be reasonable with respect to the promised favor or reward; see the lesser planar ally spell for appropriate rewards. Some creatures may want their payment in “livestock”, time spent possessing a mortal body, memories, or emotions (negative levels and ability drain) rather than in coin. Immediately upon completion of the service, the being is transported to your vicinity, and you must then and there turn over the promised reward. After this is done, the creature is instantly freed to return to its own plane.

Failure to fulfill the promise to the letter results in your being subjected to service by the creature or by its liege and master, at the very least. At worst, the creature or its kin may attack you.`
  },
  Inurement: {
    name: "Inurement",
    discipline: "Athanatism",
    level: "Conduit 8",
    display: "Auditory and visual",
    manifestingTime: "5 minutes",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 day/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "15",
    description: `By binding your soul to a ghostly power source, you ensure your own eternal unlife. If you are killed while this power is active, you immediately become a ghost. When you do so, you suffer two permanent negative levels, just as if you had been hit by an energy-draining creature. These negative levels cannot be removed unless the one attempting to remove them succeeds on a DC 26 manifester level check. Your ghostly form retains your personality, memories, and class levels. For selecting ghost special attacks, you count as if your CR were equal to half your manifester level. Except as noted above, this functions exactly as if you were applying the ghost template to your character.`
  },
  Both_Feet_in_the_Grave: {
    name: "Both Feet in the Grave",
    discipline: "Athanatism",
    level: "Conduit 9",
    display: "Visual",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft. / 2 levels)",
    target: "You and one other corporeal undead creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text; Power",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Foot in the Grave[]

You can attempt to take control of a nearby corporeal undead creature, forcing your mind and soul into its body, and its mind into your body. You can target any creature whose Hit Dice are equal to or less than your manifester level.

You possess the target's body and force the creature's mind into your body unless it succeeds on a Will save. You can move your mind back into your own body whenever you desire, which returns the subject's mind to its own body and ends the power. If the manifestation succeeds, your life force occupies the host body, and the host's life force takes over yours.

You can call on rudimentary or instinctive knowledge of the subject creature, but not upon its acquired or learned knowledge (such as skills and feats it possesses). The same is true for the subject in your body - mindless undead or undead with no Intelligence score will usually take no actions unless ordered to. The mind switch brings about the following changes.

• You count as undead for all purposes, gaining standard undead immunities.

• You gain the Strength and Dexterity scores of your assumed body.

• You gain the natural armor, natural attacks, movement, and other simple physical characteristics of your assumed body.

• You gain the extraordinary special attacks and qualities of your assumed body, but you do not gain supernatural or spell-like abilities.

• You gain the possessions and equipment of your assumed body.

• You retain your own hit points, saving throws (possibly modified by new ability scores), class abilities, supernatural and psi-like abilities, spells and powers, and skills and feats (although skill checks use your new ability scores, and you may be temporarily unable to use feats whose requirements you do not meet in your new body).

• You suffer one negative level while in your assumed body.

Supernatural abilities that require a certain body part may be unavailable in your new form.

If either body is killed while the power is in effect, the other participant also dies when the power ends. If one participant's body becomes petrified, imprisoned by temporal stasis or imprisonment, or incapacitated in some other way, the other participant will be incapacitated in that way when the power ends.

A targeted dispel psionics (or similar spells or effects) successfully manifested on either participant causes both minds to return to their original bodies.

If you successfully use foot in the grave while already under the effect of foot in the grave , the original target is returned to its original body, the new target occupies your original body, and you occupy the body of the new target.

Augment: This power may be augmented in one of the following ways.

• By spending 6 additional power points, you may expend your psionic focus while this power is active to attempt to take control of a different corporeal undead body. You may do this as many times as you wish while this power is active, but must expend your psionic focus each time to do so. Whenever you leave a body in this way, the original target is returned to its body.

• By spending 4 additional power points, increase the duration of this power to 1 hour/level.

Both Feet in the Grave[]

Resistance: Yes

As foot in the grave , except as noted here. You permanently exchange bodies with the subject. Since this power's duration is instantaneous, you cannot be forced to return to your natural body by means of dispel psionics , an antimagic field , or a similar effect. If the subject's body dies while you are in it, you are dead. The subject immediately suffers one permanent negative level, but otherwise survives the experience in your natural body. If your natural body dies while the subject is in it, you immediately suffer two permanent negative levels, but you likewise survive the experience in your new body. Negative levels gained in this way may only be cured by powerful healing, such as cleanse spirit, greater restoration or restoration ; they do not fade over time.

Your “natural” body is always considered to be the last one you switched out of. If you exchange bodies with a chain of multiple subjects, you need worry only about the welfare of the last body you switched with. In other words, if your mind is expelled from your current body, your mind returns to the last body you switched with, not to your original body. Similarly, if your original body dies but you have since switched minds with a second subject, you take no penalty. You suffer permanent negative levels only if the body you inhabited immediately prior to your current body is killed.

You suffer two temporary negative levels upon manifesting this power, as your mind adjusts to controlling a new body. These negative levels cannot be cured, but fade at a rate of one every 24 hours.

If you successfully use both feet in the grave while under the effect of foot in the grave , the original target of foot in the grave is returned to its original body, the new target of both feet in the grave occupies your original body, and you occupy the body of the target of both feet in the grave .`
  },
  Lore_of_the_Deceased: {
    name: "Lore of the Deceased",
    discipline: "Athanatism",
    level: "Conduit 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "touch",
    target: "one dead creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "none",
    powerResistance: "yes",
    powerPoints: "17",
    description: `Drawing upon the secrets of a dead creature's body, you draw upon the knowledge it possessed in life. You learn one psionic power known by the deceased creature, including one that it possesses as a psi-like ability. You may manifest this power as if it were a power known.`
  },
  Rending_the_Veil: {
    name: "Rending the Veil",
    discipline: "Athanatism",
    level: "Conduit 9",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "40 ft.",
    target: "",
    area: "40-ft. radius spread centered on you",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `You tear down the walls between the ethereal and the material, juxtaposing the planes. All creatures in the area become corporeal for 24 hours, losing any and all ethereal or incorporeal special abilities or defenses they had (this includes the special ability to become ethereal). If the target lacks a corporeal body, it assume a form of ectoplasm of the same size and shape, effectively identical to its incorporeal form (except that it is corporeal). Any targets that were incorporeal or ethereal when you manifested this power are dazed for 1d4 rounds.`
  },
  Corrosive_Aura: {
    name: "Corrosive Aura",
    discipline: "Psychometabolism [Acid]",
    level: "Egoist 1, highlord 1, psychic warrior 1",
    display: "Material, Visual",
    manifestingTime: "1 standard action",
    range: "5 ft.",
    target: "",
    area: "All squares adjacent to you",
    duration: "1 round / level (D)",
    savingThrow: "Reflex half",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You surround yourself with a corrosive aura, damaging all who come near. Each creature that ends its turn in your square or adjacent to you takes 1d6 points of acid damage.

Augment: For every additional power point spent, the damage increases by 1d6. For every two additional dice of damage, the save DC increases by 1.

Mythic Corrosive Aura[]

Creatures that suffer the acid damage from mythic corrosive aura suffer half that damage on subsequent rounds for the duration of the effect.

Augmented: If you expend one use of mythic power, you can exclude creatures from the aura as a swift action at the beginning of your turn.

Augmented (3rd): If you expend one use of mythic power, you double the radius of the effect.`
  },
  Natural_Healing: {
    name: "Natural Healing",
    discipline: "Psychometabolism (Healing)",
    level: "Egoist 1, vitalist 1",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You rapidly accelerate your natural healing ability. You heal 3 hit points of damage.

Augment: For every additional power point you spend, this power heals an additional 3 hit points.`
  },
  Thicken_Skin: {
    name: "Thicken Skin",
    discipline: "Psychometabolism",
    level: "Gifted blade 1, egoist 1, highlord 1, psychic warrior 1, vitalist 1",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Your skin or natural armor thickens and spreads across your body, increasing your natural armor bonus by +1.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the bonus increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.`
  },
  Animal_Affinity_Lanis_s: {
    name: "Animal Affinity, Lanis's",
    discipline: "Psychometabolism",
    level: "Cryptic 2, egoist 2, gambler 2, highlord 2, psychic warrior 2, vitalist 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You forge a psychometabolic affinity with an idealized animal form, thereby boosting one of your ability scores (choose Strength, Dexterity, Constitution, Intelligence, Wisdom, or Charisma). The power grants a +4 enhancement bonus to the ability score you choose, adding the usual benefits provided by a high ability bonus. Because you are emulating the idealized form of an animal, you also take on minor aspects of the animal you choose. If you choose to increase the ability you use to manifest powers, you do not gain the benefit of an increased ability score long enough to gain any bonus power points for a high ability score, but the save DCs of your powers increase for the duration of this power.

Augment: For every 5 additional power points you spend, this power grants a +4 enhancement bonus to another ability score.

Animal Affinity, Lanis's (Mythic)[]

You gain a bonus to checks for the selected ability score equal equal to half your mythic tier, and once during the power's duration you can elect to reroll either a skill check based on that ability score, a Fortitude saving throw if you selected Constitution, a Reflex saving throw if you selected Dexterity, or Will saving throw if you selected Wisdom. This reroll must be used immediately after the result of the first roll is determined, and the reroll must be used even if it is worse than the original roll.

Augmented (6th): If you expend two uses of mythic power, the +4 enhancement bonus is increased to +6.`
  },
  Chameleon: {
    name: "Chameleon",
    discipline: "Psychometabolism",
    level: "Cryptic 1, egoist 2, gifted blade 1, marksman 1, psychic warrior 1, sighted seeker 1, voyager 1",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 1, egoist 3, gifted blade 1, marksman 1, psychic warrior 1, sighted seeker 1",
    description: `Your skin and equipment take on the color and texture of nearby objects, including floors and walls. You receive a +10 enhancement bonus on Stealth checks.

Augment: For every two additional power points spent, the enhancement bonus on Stealth checks increases by 1.

Mythic Chameleon[]

Add your tier to the bonus to Stealth checks. If you stand still, you can hide without cover or concealment.

Augmented: If you expend one use of mythic power, the duration becomes one hour per level.`
  },
  Empathic_Transfer: {
    name: "Empathic Transfer",
    discipline: "Psychometabolism",
    level: "Egoist 2, highlord 2, psychic warrior 2, tactician 2, vitalist 2",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Willing creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You heal another creature's wounds, transferring some of its damage to yourself. When you manifest this power, you can heal as much as 2d10 points of damage. The target regains a number of hit points equal to the dice result, and you lose hit points equal to half of that amount. (This loss can bring you to 0 or fewer hit points.) Powers and abilities you may have such as damage reduction and regeneration do not lessen or change this damage, since you are taking the target's pain into yourself in an empathic manner. The damage transferred by this power has no type, so even if you have immunity to the type of damage the target originally took, the transfer occurs normally and deals hit point damage to you.

Alternatively, you can use this power to absorb one poison or one disease afflicting the target creature into yourself. When you absorb a poison or disease, you do not take any of the damage previously dealt to the target by the affliction, but you do assume the burden of making the secondary and/or continuing Fortitude saves to combat the affliction. Finally, you can use this power to transfer up to 1 point of ability damage per manifester level from the target to yourself.

Augment: For every additional power point you spend, you can heal an additional 2d10 points of damage (to a maximum of 10d10 points per manifestation).

Mythic Empathic Transfer[]

Increase the damage healed to 3d10 and 3d10 per power point augmented, and increase the maximum to 15d20 points of damage. The amount of hit points you lose is reduced by your tier and the amount of ability damage you receive, if any, is reduced by half (round up).`
  },
  Resist_Toxin: {
    name: "Resist Toxin",
    discipline: "Psychometabolism (Healing)",
    level: "Cryptic 2, egoist 2, highlord 2, psychic warrior 2, vitalist 2",
    display: "Mental, visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour / level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `You become temporarily immune to poison. Any poison in your system or any poison to which you are exposed during the power's duration does not affect you until the duration has expired. This does not cure any damage that poison may have already done.

Augment: This power may be augmented in one of the following ways.

• If you spend 2 additional power points, this power can instead cure all diseases from you are suffering. You must make a manifesting level check (1d20 + manifester level) against the DC of each disease affecting you. Success means that the disease is cured. The power's duration changes to Instantaneous when using this augment option. This does not prevent reinfection after a new exposure to the same disease at a later date.

• If you spend 4 additional power points, this power can instead detoxify any sort of venom in you. You must make a manifester level check (1d20 + manifester level) against the DC of each poison affecting you. Success means that the poison is neutralized. You suffer no additional effects from the neutralized poison, and any temporary effects are ended, but this does not reverse instantaneous effects, such as hit point damage, temporary ability damage, or effects that don't go away on their own. The power's duration changes to Instantaneous when using this augment option.`
  },
  Ectoplasmic_Form: {
    name: "Ectoplasmic Form",
    discipline: "Psychometabolism",
    level: "Dread 6, Egoist 6, Highlord 6, Psychic Warrior 6",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "touch",
    target: "You",
    area: "",
    duration: "1 hour/level (D); see text",
    savingThrow: "no and Will negates (harmless)",
    powerResistance: "no and yes (harmless)",
    powerPoints: "11",
    description: `Ectoplasmic Form[]

You and all your gear become a partially translucent mass of rippling ectoplasm that generally conforms to your normal shape. You gain damage reduction 10/psionics, and you gain immunity to poison and critical hits. Your material armor becomes meaningless, although your size, Dexterity, deflection bonuses, and armor bonuses from force effects (such as those gained by inertial armor ) still apply to your Armor Class.

You can manifest powers while in ectoplasmic form , but you must make a concentration check (DC 20 + power level) for each power you attempt to manifest.

You cannot physically attack, you lose supernatural abilities (if any), and you can't speak while in ectoplasmic form . You can't run, but you can fly at a speed of 20 feet (perfect). You can pass through small holes or narrow openings, even mere cracks, with all you were wearing or holding in your hands. You are subject to the effects of wind, and you can't enter water or other liquid. You also can't manipulate objects or activate items, even those carried along with you. Continuously active items remain active, though in some cases their effects may be moot (such as items that provide armor or natural armor bonuses).

Ectoplasmic Voyager[]

Targets: you and one touched creature per three levels

This power functions as ectoplasmic form , save that the manifester can affect others and also travel at a much greater speed. As a free action, a creature affected by this ability can change the fly speed granted by this power from 20 feet (perfect) to 600 feet (poor) or back to 20 feet (perfect). A creature can regain its physical form as desired and later resume the ectoplasmic form. Each change to and from ectoplasmic form takes 5 rounds, which counts toward the duration of the power (as does any time spent in physical form). As noted above, you can dismiss the power, and you can even dismiss it for individual characters and not others.

Augment

• If you spend 4 additional power points, you may reduce the time needed to change between physical and ectoplasmic form to one move action.

Mythic Ectoplasmic Form[]

The damage reduction changes to DR 10/epic and psionics, and the fly speed increases to 30 feet. You can expand yourself as a free action, filling an area equal to double you normal space and height (a Medium creature fills a 10-foot-by-10-foot space to a height of about 10 feet) and blocking vision as obscuring mist . Returning from expanded to normal size is also a free action.

Augmented: If you expend two uses of mythic power, you can shift into or out of ectoplasmic form as a move action.`
  },
  Expose_Weakness: {
    name: "Expose Weakness",
    discipline: "Psychometabolism",
    level: "Egoist 3, highlord 3, psychic warrior 3, tactician 3, voyager 3",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "rget: One creature",
    area: "",
    duration: "1 round / level ; Power Resistance: Yes",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Save: Fortitude negates

The target of the power becomes clumsy and moves in the worst possible way when attacked. The target is considered flanked to all attackers and all attacks on the subject gain a +4 circumstance bonus to confirm critical hits. Any fortification against sneak attacks and critical hits must be rolled twice, with the worse roll used to determine if the extra damage is negated.

Augment: By spending an additional 6 power points, the target is considered flat-footed rather than flanked.`
  },
  Hustle: {
    name: "Hustle",
    discipline: "Psychometabolism",
    level: "Egoist 3, gambler 3, gifted blade 3, highlord 2, marksman 3, psychic warrior 2, vitalist 3, voyager 3",
    display: "Auditory",
    manifestingTime: "1 swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Egoist 5, gifted blade 5, highlord 3, marksman 5, psychic warrior 3, vitalist 5, voyager 5",
    description: `Effect: 1 extra move action

You gain an additional move action in the current round. Taking a full round's worth of attacks and then using this power to move away from your foe does provoke attacks of opportunity.

Mythic Hustle[]

The power lasts one additional round per two tiers (minimum 1). You can spend a swift action during the duration to gain an additional move action. If you use the move action provided by mythic hustle , you gain your tier as a bonus to your armor class against any attacks of opportunity provokes by the movement.

Augmented: If you expend one use of mythic power, the duration becomes one round per tier.`
  },
  Metamorphosis: {
    name: "Metamorphosis",
    discipline: "psychometabolism",
    level: "egoist 9",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min/level Power Points 17",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `Metamorphosis, Minor[]

You channel your psionic power, snapping bones and twisting flesh, transforming yourself into a new shape or form. You can take the form of any creature of the same size as yourself, but this is a purely cosmetic change, your abilities, powers or stats do not change beyond the options selected below. This grants you a +10 bonus on Disguise skill checks.

If you choose to imitate an existing person, you gain an additional +2 circumstance bonus to Disguise checks to convince people that you are that person. If you choose to take on an intimidating, horrifying, or otherwise imposing form, you gain a +2 circumstance bonus to Intimidate checks.

In addition, you get one choice from either the Enhancement Menu A or Abilities Menu A.

Enhancement Menu A

• +2 enhancement bonus to Strength

• +2 enhancement bonus to Dexterity

• +2 enhancement bonus to Constitution

• Increase your size by one size category (+2 size bonus to Strength, -2 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by one size category (+2 size bonus to Dexterity, -2 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Increase your base land speed by 10 feet.

Abilities Menu A

• You gain 5 temporary hit points.

• You gain the Cleave feat.

• You gain the Improved Trip feat.

• You gain a +1 natural armor bonus.

• You gain a natural slam/claw/bite (pick one) attack that deals 1d8 damage if Medium (1d10 if Large).

• You gain Resistance 5 against one of these energy types: Cold, Acid, Fire, Electricity.

• You gain a swim speed of 20 feet.

• You gain a climb speed of 20 feet.

• You gain a burrow speed of 15 feet.

Augment: For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A. You may not choose the same option twice.

Metamorphosis[]

As minor metamorphosis , except you instead gain one option from enhancement menu B or one option from abilities menu B. Choices that give similar benefits to those from enhancement menu B or abilities menu B do not stack. For example, you cannot pick to gain two natural attacks from abilities menu B and also to gain a natural attack from abilities menu A to get three attacks.

Enhancement Menu B

• +4 enhancement bonus to Strength

• +4 enhancement bonus to Dexterity

• +4 enhancement bonus to Constitution

• Increase your size by two size categories (+4 size bonus to Strength, -4 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by two size categories (+4 size bonus to Dexterity, -4 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Pick 3 choices from Enhancement Menu A. You may not choose the same option twice.

• Increase your base land speed by 20 feet.

Abilities Menu B

• You gain two natural slam/bite/claw attacks that deal 1d8 damage if Medium (1d10 if Large).

• You gain Fast Healing 2.

• You gain a +3 natural armor bonus.

• You gain 20 temporary hit points.

• You gain the Improved Critical feat with any natural attacks you have.

• You gain damage reduction 5/magic.

• You gain a fly speed of 20 feet (poor).

• You gain a poison attack. When you hit with a natural melee attack, the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You can spit poison as a ranged touch attack (30 feet) as a standard action. If it hits, it deals 3d6 acid damage and the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability score modifier) or take 1 point of Constitution damage.

• You gain a swim speed of 40 feet.

• You gain a climb speed of 40 feet.

• You gain a burrow speed of 30 feet.

• You gain 3 choices from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Metamorphosis, Major[]

As minor metamorphosis, except you instead gain one option from Enhancement Menu C or one option from Abilities Menu C. Choices that give similar benefits to those from Enhancement Menu C or Abilities Menu C do not stack. For example, you cannot pick to gain three natural attacks from Abilities Menu C and also to gain a natural attack from Abilities Menu A to get four attacks.

Enhancement Menu C

• +6 enhancement bonus to Strength

• +6 enhancement bonus to Dexterity

• +6 enhancement bonus to Constitution

• Pick 2 choices from Enhancement Menu B from metamorphosis . You may not choose the same option twice.

• Increase your base land speed by 30 feet.

Abilities Menu C

• You gain the Rend ability. If you hit the same opponent with two natural attacks in one round, you deal additional damage equal to 2d6 + your Strength modifier.

• You gain three natural slam/bite/claw attacks that deal 2d6 damage if Medium (2d8 if Large).

• Your natural attacks extrude poison and acid. When you hit with a natural melee attack, it deals +2d6 acid damage and the target must make a Fortitude save (DC10+ ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You gain Fast Healing 5.

• You gain +6 natural armor bonus.

• You gain 40 temporary hit points.

• You gain a fly speed of 40 feet (good).

• You gain a swim speed of 60 feet.

• You gain a climb speed of 60 feet.

• You gain a burrow speed of 60 feet.

• You gain 2 choices from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Metamorphosis, True[]

As minor metamorphosis, except you gain two menu choices from the Enhancement Menu C and two menu choices from Abilities Menu C from major metamorphosis . As a swift action, you can change your menu choices while the duration of this power is in effect.

While under the effects of this power, you can choose to become one of the following types, with the associated benefits: aberration, dragon, fey, humanoid, magical beast or monstrous humanoid. As a swift action, you can change what type you are while the duration of this power is in effect.

Augment You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Mythic Minor Metamorphosis[]

Add your tier to the bonus to Disguise checks. In addition, you gain one choice from Enhancement Menu A and Abilities Menu A, instead of one choice between the two menus.

Mythic Metamorphosis[]

You gain one choice from Enhancement Menu B and Abilities Menu B, instead of one choice between the two menus.

Mythic Major Metamorphosis[]

You gain one choice from Enhancement Menu C and Abilities Menu C, instead of one choice between the two menus.

Mythic True Metamorphosis[]

You can also choose to become one of the following types, with the associated traits: construct, elemental, or plant.`
  },
  Physical_Acceleration: {
    name: "Physical Acceleration",
    discipline: "Psychometabolism",
    level: "Egoist 3, gifted blade 3, highlord 3, marksman 3, psychic warrior 3, sighted seeker 4, vitalist 4, voyager 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Egoist 5, gifted blade 5, highlord 5, marksman 5, psychic warrior 5, sighted seeker 7, vitalist 7, voyager 5",
    description: `You move and act more quickly than normal. This extra speed has several effects.

When making a full attack action, you gain one additional attack. The attack is made using your full base attack bonus, plus any modifiers appropriate to the situation. (This effect is not cumulative with similar effects, such as that provided by a speed weapon, nor does it actually grant an extra action, so you can't use it to manifest a second power or otherwise take an extra action in the round.)

You gain a +1 bonus on attack rolls and a +1 dodge bonus to AC and Reflex saves. Any condition that makes you lose your Dexterity bonus to Armor Class (if any) also makes you lose dodge bonuses.

All of your modes of movement (including land movement, burrow, climb, fly, and swim) increase by 30 feet, to a maximum of twice your normal speed using that form of movement. This increase counts as an enhancement bonus, and it affects your jumping distance as normal for increased speed. Multiple physical acceleration effects don't stack, nor does it stack with haste . Physical acceleration negates slow .

Augment: If you spend an additional 6 power points, you can manifest this power as a swift action.`
  },
  Hidden_Body: {
    name: "Hidden Body",
    discipline: "Psychometabolism",
    level: "Cryptic 4, egoist 4",
    display: "Olfactory, Visual",
    manifestingTime: "1 round",
    range: "Touch",
    target: "Willing living creature touched",
    area: "",
    duration: "1 hour / level (D)",
    savingThrow: "None (harmless)",
    powerResistance: "No (harmless)",
    powerPoints: "7",
    description: `You meld into the touched creature, psionically fusing with their form. At the time of manifesting, it is decided if you or the creature touched are the host and the other is the passenger. While fused, the passenger is dormant and unaware. Any other effects that were on the passenger do not affect the host, and vice versa, while the power is in effect. The passenger does not need to eat, drink, or sleep, has no concept of time, and is not aware of surroundings or anything that occurs to the host. The host can discharge the passenger as a standard action that does not provoke attacks of opportunity. If the host is killed or the power ends, the passenger is immediately discharged adjacent to the host (or the host's last location for effects such as disintegration ). You cannot be under the effect of hidden body and fusion at the same time.

Augment: This power can be augmented in one of the following ways.

• If you spend 4 additional power points, the passenger is aware of everything the host is aware of, although the passenger can still take no actions while fused.

• If you spend 8 additional power points, the passenger is aware of everything the host is aware of and can take purely mental actions such as manifesting powers, although the passenger is restricted to the senses of the host unless using some other means of senses. The power's duration changes to 1 round / level (D).`
  },
  Psychic_Drain: {
    name: "Psychic Drain",
    discipline: "Psychometabolism",
    level: "Egoist 4, highlord 4, psychic warrior 4, vitalist 4",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `This power shrouds your hand or a natural weapon you possess with darkness that you can use to drain an opponent's power.

If you manifest this power to affect your hand, the next successful melee touch attack you make (if the victim fails its Fortitude save) drains 2 power points from your foe for every manifester level you have. The drained points simply dissipate. Your touch attack, charged with psionic power, is treated as an armed attack.

If you manifest this power to affect a natural weapon you possess, you must make a successful melee attack with the weapon to gain the power's benefit.

Against a psionic being that has no power points or a nonpsionic foe, your attack instead deals 2 points of Intelligence, Wisdom, or Charisma damage (your choice).`
  },
  Resist_Death: {
    name: "Resist Death",
    discipline: "Psychometabolism [Network]",
    level: "Egoist 4, vitalist 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "Self",
    area: "",
    duration: "1 hour / level",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes",
    powerPoints: "Egoist 7, vitalist 5",
    description: `The manifester combines life force and psionic energy into a shield that protects the target from negative energy attacks. This power prevents energy drain and any negative energy effects, including channeled energy. Once the power has prevented (or helped prevent) one effect, the power dissipates. When manifested the power deals 2 points of non-lethal damage to the target. The damage may be healed normally. The subject gains +4 moral bonus against death spells and magical/psionic death effects even if a save to negate such effects is not normally allowed.

This power does not remove negative levels that the target has already gained, but it does remove penalties from negative levels for the duration of the power.

Resist death does not protect against other sorts of attacks, even if those attacks might be lethal.

Augment: For every additional 2 points spent, the power prevents 1 additional effect.`
  },
  Psionic_Revivify: {
    name: "Psionic Revivify",
    discipline: "Psychometabolism (Healing) [Good]",
    level: "Egoist 5, vitalist 5",
    display: "",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Dead creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "Yes (harmless)",
    powerPoints: "9",
    description: `Psionic revivify lets a manifester reconnect a corpse's psyche with its body, restoring life to a recently deceased creature. The power must be manifested within 1 round of the victim's death. Before the psyche of the deceased has completely left the body, this power halts its journey while repairing somewhat the damage to the body.

This power functions like the raise dead spell, except that the affected creature receives a permanent negative levels, but suffers no Constitution loss, and no loss of powers.

The creature has –1 hit points (but is stable) after being restored to life.

For every additional negative level that the subject suffers, the manifestation of this power can be delayed by 2 additional rounds. All of the negative levels gained in this manner fade after twenty-four hours.

Augment: By spending 2 additional power points, this power may also affect outsiders.`
  },
  Psychofeedback: {
    name: "Psychofeedback",
    discipline: "Psychometabolism",
    level: "Egoist 5, highlord 5, psychic warrior 5, vitalist 5",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `You can readjust your body to boost one physical ability score at the expense of one or more other scores. Select one physical ability score you would like to boost, and increase it by the same amount that you decrease one or more other scores. All score decreases are treated as ability damage. You can boost your Strength, Dexterity or Constitution score by an amount equal to your manifester level (or any lesser amount), assuming you can afford to burn your other ability scores to such an extent.

When the duration of this power expires, your ability boost also ends, but your ability damage remains until it is healed.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, the ability damage you suffer to increase another score is delayed until the power fades.

• If you spend 4 additional power points, the power's duration increases to 1 minute/level (D).

• If you spend 6 additional power points, the ability damage you suffer to increase another score fades when the power's duration expires.`
  },
  Restore_Extremity: {
    name: "Restore Extremity",
    discipline: "Psychometabolism (Healing)",
    level: "Egoist 5, vitalist 5",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "9",
    description: `You restore a severed extremity to a creature that has lost a digit, hand, arm, leg, or even its head. This power does not restore life, but it returns a lost extremity to a living or dead creature if the creature is otherwise mostly intact. The original extremity need not be present when this power is manifested; a new extremity is created by the power. If a head is restored to a body, the original head (if not already destroyed) loses all spark of identity, and can be considered dead tissue.`
  },
  Cleanse_Spirit: {
    name: "Cleanse Spirit",
    discipline: "Psychometabolism (Healing)",
    level: "Egoist 6, vitalist 6",
    display: "Material",
    manifestingTime: "3 rounds",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "11",
    description: `This power cures all ability damage, and it restores all points drained from a single ability score (your choice if more than one score is drained). It also eliminates any fatigue or exhaustion suffered by the target. Cleanse spirit does not restore levels or Constitution points lost due to death.

Cleanse spirit can remove negative levels. It can also restore one level to a creature that has had a level drained, if the number of days since the creature lost the level is equal to or less than your manifester level. In such a case, cleanse spirit brings the creature up to the minimum number of experience points necessary to advance it to the next higher level, gaining it an additional Hit Die and level benefits accordingly.

Librarian's Note: Level draining does not exist in Pathfinder, the text about that is likely a holdover from 3.5.

Augment: By spending an additional 6 power points, the power dispels all permanent and temporary negative levels afflicting the healed creature. The power also dispels all psionic effects penalizing the creature's abilities, cures all temporary ability damage, and restores all points permanently drained from all ability scores. It also eliminates fatigue and exhaustion, and removes all forms of insanity, confusion, and similar mental effects.

Mythic Cleanse Spirit[]

Mythic cleanse spirit always provides the benefits of the 6 power point augment option without having to spend power points augmenting it.

Augmented: If you expend two uses of mythic power, you can manifest this power with a manifesting time of 1 round.

Augmented (8th): If you expend four uses of mythic power, mythic cleanse spirit removes all negative effects including curses, hexes, and other supernatural effects.`
  },
  Ectoplasmic_Voyager: {
    name: "Ectoplasmic Voyager",
    discipline: "Psychometabolism",
    level: "Dread 6, Egoist 6, Highlord 6, Psychic Warrior 6",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "touch",
    target: "You",
    area: "",
    duration: "1 hour/level (D); see text",
    savingThrow: "no and Will negates (harmless)",
    powerResistance: "no and yes (harmless)",
    powerPoints: "11",
    description: `Ectoplasmic Form[]

You and all your gear become a partially translucent mass of rippling ectoplasm that generally conforms to your normal shape. You gain damage reduction 10/psionics, and you gain immunity to poison and critical hits. Your material armor becomes meaningless, although your size, Dexterity, deflection bonuses, and armor bonuses from force effects (such as those gained by inertial armor ) still apply to your Armor Class.

You can manifest powers while in ectoplasmic form , but you must make a concentration check (DC 20 + power level) for each power you attempt to manifest.

You cannot physically attack, you lose supernatural abilities (if any), and you can't speak while in ectoplasmic form . You can't run, but you can fly at a speed of 20 feet (perfect). You can pass through small holes or narrow openings, even mere cracks, with all you were wearing or holding in your hands. You are subject to the effects of wind, and you can't enter water or other liquid. You also can't manipulate objects or activate items, even those carried along with you. Continuously active items remain active, though in some cases their effects may be moot (such as items that provide armor or natural armor bonuses).

Ectoplasmic Voyager[]

Targets: you and one touched creature per three levels

This power functions as ectoplasmic form , save that the manifester can affect others and also travel at a much greater speed. As a free action, a creature affected by this ability can change the fly speed granted by this power from 20 feet (perfect) to 600 feet (poor) or back to 20 feet (perfect). A creature can regain its physical form as desired and later resume the ectoplasmic form. Each change to and from ectoplasmic form takes 5 rounds, which counts toward the duration of the power (as does any time spent in physical form). As noted above, you can dismiss the power, and you can even dismiss it for individual characters and not others.

Augment

• If you spend 4 additional power points, you may reduce the time needed to change between physical and ectoplasmic form to one move action.

Mythic Ectoplasmic Form[]

The damage reduction changes to DR 10/epic and psionics, and the fly speed increases to 30 feet. You can expand yourself as a free action, filling an area equal to double you normal space and height (a Medium creature fills a 10-foot-by-10-foot space to a height of about 10 feet) and blocking vision as obscuring mist . Returning from expanded to normal size is also a free action.

Augmented: If you expend two uses of mythic power, you can shift into or out of ectoplasmic form as a move action.`
  },
  Metamorphosis_Major: {
    name: "Metamorphosis, Major",
    discipline: "psychometabolism",
    level: "egoist 9",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min/level Power Points 17",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `Metamorphosis, Minor[]

You channel your psionic power, snapping bones and twisting flesh, transforming yourself into a new shape or form. You can take the form of any creature of the same size as yourself, but this is a purely cosmetic change, your abilities, powers or stats do not change beyond the options selected below. This grants you a +10 bonus on Disguise skill checks.

If you choose to imitate an existing person, you gain an additional +2 circumstance bonus to Disguise checks to convince people that you are that person. If you choose to take on an intimidating, horrifying, or otherwise imposing form, you gain a +2 circumstance bonus to Intimidate checks.

In addition, you get one choice from either the Enhancement Menu A or Abilities Menu A.

Enhancement Menu A

• +2 enhancement bonus to Strength

• +2 enhancement bonus to Dexterity

• +2 enhancement bonus to Constitution

• Increase your size by one size category (+2 size bonus to Strength, -2 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by one size category (+2 size bonus to Dexterity, -2 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Increase your base land speed by 10 feet.

Abilities Menu A

• You gain 5 temporary hit points.

• You gain the Cleave feat.

• You gain the Improved Trip feat.

• You gain a +1 natural armor bonus.

• You gain a natural slam/claw/bite (pick one) attack that deals 1d8 damage if Medium (1d10 if Large).

• You gain Resistance 5 against one of these energy types: Cold, Acid, Fire, Electricity.

• You gain a swim speed of 20 feet.

• You gain a climb speed of 20 feet.

• You gain a burrow speed of 15 feet.

Augment: For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A. You may not choose the same option twice.

Metamorphosis[]

As minor metamorphosis , except you instead gain one option from enhancement menu B or one option from abilities menu B. Choices that give similar benefits to those from enhancement menu B or abilities menu B do not stack. For example, you cannot pick to gain two natural attacks from abilities menu B and also to gain a natural attack from abilities menu A to get three attacks.

Enhancement Menu B

• +4 enhancement bonus to Strength

• +4 enhancement bonus to Dexterity

• +4 enhancement bonus to Constitution

• Increase your size by two size categories (+4 size bonus to Strength, -4 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by two size categories (+4 size bonus to Dexterity, -4 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Pick 3 choices from Enhancement Menu A. You may not choose the same option twice.

• Increase your base land speed by 20 feet.

Abilities Menu B

• You gain two natural slam/bite/claw attacks that deal 1d8 damage if Medium (1d10 if Large).

• You gain Fast Healing 2.

• You gain a +3 natural armor bonus.

• You gain 20 temporary hit points.

• You gain the Improved Critical feat with any natural attacks you have.

• You gain damage reduction 5/magic.

• You gain a fly speed of 20 feet (poor).

• You gain a poison attack. When you hit with a natural melee attack, the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You can spit poison as a ranged touch attack (30 feet) as a standard action. If it hits, it deals 3d6 acid damage and the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability score modifier) or take 1 point of Constitution damage.

• You gain a swim speed of 40 feet.

• You gain a climb speed of 40 feet.

• You gain a burrow speed of 30 feet.

• You gain 3 choices from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Metamorphosis, Major[]

As minor metamorphosis, except you instead gain one option from Enhancement Menu C or one option from Abilities Menu C. Choices that give similar benefits to those from Enhancement Menu C or Abilities Menu C do not stack. For example, you cannot pick to gain three natural attacks from Abilities Menu C and also to gain a natural attack from Abilities Menu A to get four attacks.

Enhancement Menu C

• +6 enhancement bonus to Strength

• +6 enhancement bonus to Dexterity

• +6 enhancement bonus to Constitution

• Pick 2 choices from Enhancement Menu B from metamorphosis . You may not choose the same option twice.

• Increase your base land speed by 30 feet.

Abilities Menu C

• You gain the Rend ability. If you hit the same opponent with two natural attacks in one round, you deal additional damage equal to 2d6 + your Strength modifier.

• You gain three natural slam/bite/claw attacks that deal 2d6 damage if Medium (2d8 if Large).

• Your natural attacks extrude poison and acid. When you hit with a natural melee attack, it deals +2d6 acid damage and the target must make a Fortitude save (DC10+ ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You gain Fast Healing 5.

• You gain +6 natural armor bonus.

• You gain 40 temporary hit points.

• You gain a fly speed of 40 feet (good).

• You gain a swim speed of 60 feet.

• You gain a climb speed of 60 feet.

• You gain a burrow speed of 60 feet.

• You gain 2 choices from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Metamorphosis, True[]

As minor metamorphosis, except you gain two menu choices from the Enhancement Menu C and two menu choices from Abilities Menu C from major metamorphosis . As a swift action, you can change your menu choices while the duration of this power is in effect.

While under the effects of this power, you can choose to become one of the following types, with the associated benefits: aberration, dragon, fey, humanoid, magical beast or monstrous humanoid. As a swift action, you can change what type you are while the duration of this power is in effect.

Augment You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Mythic Minor Metamorphosis[]

Add your tier to the bonus to Disguise checks. In addition, you gain one choice from Enhancement Menu A and Abilities Menu A, instead of one choice between the two menus.

Mythic Metamorphosis[]

You gain one choice from Enhancement Menu B and Abilities Menu B, instead of one choice between the two menus.

Mythic Major Metamorphosis[]

You gain one choice from Enhancement Menu C and Abilities Menu C, instead of one choice between the two menus.

Mythic True Metamorphosis[]

You can also choose to become one of the following types, with the associated traits: construct, elemental, or plant.`
  },
  Fission: {
    name: "Fission",
    discipline: "Psychometabolism",
    level: "Egoist 7",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `Effect: Duplicate of yourself

You can divide yourself, creating a duplicate that comes into existence 5 feet away. Your duplicate thinks and acts exactly as you do and follows your orders, although it will not do anything you wouldn't do yourself. Your duplicate has all your abilities but none of your psionic or magical equipment (it does possess a duplicate of all your mundane equipment, clothing, armor, and implements, as well as mundane versions of any psionic or magical equipment you have). You and your duplicate evenly split your power points, your remaining usages of pertinent special abilities for the day, and so on. You retain your psionic focus, if you maintain such when this power is manifested. Treat your duplicate as yourself with a manifester level two lower for the purpose of determining the powers to which the duplicate has access (while the duration of this power lasts, this manifester level penalty cannot be removed by any means). Your duplicate has all other physical traits you had at the time you manifest this power. Powers, spells, or other effects affecting you when you manifest this power do not transfer to your duplicate. Your duplicate has the same number of hit points you did at the time this power was manifested.

When the duration expires or when you dismiss the power, you and your duplicate rejoin, no matter how far from each other you are. You gain back any power points the duplicate has not spent. At the time of rejoining, your hit points become the average between the current hit points of you and your duplicate. This could potentially leave you with negative hit points, but it can't reduce your hit points so low as to kill you when the duration ends.

If your duplicate dies before the duration expires, no rejoining occurs, and you gain one negative level and are sickened for ten minutes. If you die, your duplicate remains in existence and is sickened for ten minutes, and is for all intents you, but with two negative levels, and without the manifester level penalty. (Once the duration expires, the negative levels can be removed by standard means.)

You can have only one fissioned duplicate in existence at one time; your duplicate cannot use this power. You cannot use fusion or metaconcert with a duplicate, or share any other power or effect that pools abilities (the sum of you and you is still just you). Similarly, attempting to use powers such as claws of the vampire or vampiric blade to hurt your duplicate only damages your duplicate; these powers do not heal you. Empathic transfer and similar powers are likewise ineffective (transferring wounds to yourself isn't a good healing strategy).

All beneficial powers affecting a fissioned creature, either the original or the duplicate, end when the fission ends. Any detrimental powers affecting your duplicate end when the duration ends, unless you die and your duplicate survives, in which case any detrimenal effects on your duplicate continue. All ability damage, ability drain, and ability burn damage is added together, although as stated above, your hit points become the average hit points between you and your duplicate.

Mythic Fission[]

You can choose how many power points your duplicate can use, rather than splitting them evenly. Your hit points are never lowered when you rejoin with your duplicate – whichever version of you has the highest hit points is used to determine the hit points when the effect ends.

Augmented: If you expend one use of mythic power, your duplicate has a manifester level equal to yours and you are only staggered when your duplicate dies, instead of gaining a negative level and being sickened for ten minutes.

Augmented (3rd): If you expend one use of mythic power, you and your duplicate maintain telepathic communication for the duration of the effect.`
  },
  Fusion: {
    name: "Fusion",
    discipline: "Psychometabolism",
    level: "Egoist 8, tactician 9, vitalist 9",
    display: "Auditory, material, and visual",
    manifestingTime: "1 round",
    range: "Touch",
    target: "",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Egoist 15, tactician 17, vitalist 17",
    description: `Targets: You and one touched willing creature of your type and your size or smaller

You and another willing, corporeal, living creature of the same or smaller size fuse into one being. As the manifester, you control the actions of the fused being. However, you can give up this control to the other creature. Once you give up control, you cannot regain it unless the other creature relinquishes it.

The fused being has your current hit points plus the other creature's current hit points. The fused being knows all the powers you and the other creature know, has the sum of your and the other creature's power points, and knows or has prepared any spells you or the other creature possesses (if any). Likewise, all feats, racial abilities, and class features are pooled (if both creatures have the same ability, the fused being gains it only once). For each of the six ability scores, the fused being's score is the higher of yours and the other creature's, and the fused being also has the higher Hit Dice or manifester level—this effectively means the fused being uses the better saving throws, attack bonus, and skill modifiers of either member, and it manifests powers at the higher of the manifester levels that you or the other creature possessed before becoming fused.

You decide what equipment is absorbed into the fused being and what equipment remains available for use. These fused items are restored once the power ends.

When the power ends, the fused being separates. The other creature appears in an area adjacent to you that you determine. If separation occurs in a cramped space, the other creature is expelled through the Astral Plane, finally coming to rest materially in the nearest empty space and taking 1d6 points of damage for each 10 feet of solid material passed through.

Damage taken by the fused being is split evenly between you and the other creature when the power ends. You do not leave the fusion with more hit points than you entered it with, unless you were damaged prior to the fusion and the fused being was subsequently healed. In a like manner, the fused being's remaining power points are split between you and the other creature (you can leave with more points than you entered with, as long as you don't exceed the maximum power points for your level and ability score). Ability damage and negative levels are also split between you and the other creature. (If an odd number of negative levels or ability score reductions must be split, you decide whether you or the other creature receives the additional loss.)

If a fused being is killed, it separates into its constituent creatures, both of which are also dead. You cannot use fission on a fused being.

Mythic Fusion[]

The target creature can be up to one size category larger than you to fuse with you. There is no damage taken if the other creature is expelled through the Astral Plane.`
  },
  Metamorphosis_True: {
    name: "Metamorphosis, True",
    discipline: "psychometabolism",
    level: "egoist 9",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min/level Power Points 17",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `Metamorphosis, Minor[]

You channel your psionic power, snapping bones and twisting flesh, transforming yourself into a new shape or form. You can take the form of any creature of the same size as yourself, but this is a purely cosmetic change, your abilities, powers or stats do not change beyond the options selected below. This grants you a +10 bonus on Disguise skill checks.

If you choose to imitate an existing person, you gain an additional +2 circumstance bonus to Disguise checks to convince people that you are that person. If you choose to take on an intimidating, horrifying, or otherwise imposing form, you gain a +2 circumstance bonus to Intimidate checks.

In addition, you get one choice from either the Enhancement Menu A or Abilities Menu A.

Enhancement Menu A

• +2 enhancement bonus to Strength

• +2 enhancement bonus to Dexterity

• +2 enhancement bonus to Constitution

• Increase your size by one size category (+2 size bonus to Strength, -2 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by one size category (+2 size bonus to Dexterity, -2 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Increase your base land speed by 10 feet.

Abilities Menu A

• You gain 5 temporary hit points.

• You gain the Cleave feat.

• You gain the Improved Trip feat.

• You gain a +1 natural armor bonus.

• You gain a natural slam/claw/bite (pick one) attack that deals 1d8 damage if Medium (1d10 if Large).

• You gain Resistance 5 against one of these energy types: Cold, Acid, Fire, Electricity.

• You gain a swim speed of 20 feet.

• You gain a climb speed of 20 feet.

• You gain a burrow speed of 15 feet.

Augment: For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A. You may not choose the same option twice.

Metamorphosis[]

As minor metamorphosis , except you instead gain one option from enhancement menu B or one option from abilities menu B. Choices that give similar benefits to those from enhancement menu B or abilities menu B do not stack. For example, you cannot pick to gain two natural attacks from abilities menu B and also to gain a natural attack from abilities menu A to get three attacks.

Enhancement Menu B

• +4 enhancement bonus to Strength

• +4 enhancement bonus to Dexterity

• +4 enhancement bonus to Constitution

• Increase your size by two size categories (+4 size bonus to Strength, -4 size penalty to Dexterity, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that increase your size.

• Decrease your size by two size categories (+4 size bonus to Dexterity, -4 size penalty to Strength, appropriate size modifiers to AC, CMB, attack rolls, etc). This effect does not stack with other effects that decrease your size.

• Pick 3 choices from Enhancement Menu A. You may not choose the same option twice.

• Increase your base land speed by 20 feet.

Abilities Menu B

• You gain two natural slam/bite/claw attacks that deal 1d8 damage if Medium (1d10 if Large).

• You gain Fast Healing 2.

• You gain a +3 natural armor bonus.

• You gain 20 temporary hit points.

• You gain the Improved Critical feat with any natural attacks you have.

• You gain damage reduction 5/magic.

• You gain a fly speed of 20 feet (poor).

• You gain a poison attack. When you hit with a natural melee attack, the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You can spit poison as a ranged touch attack (30 feet) as a standard action. If it hits, it deals 3d6 acid damage and the target must make a Fortitude save (DC10 + ½ your manifester level + your key ability score modifier) or take 1 point of Constitution damage.

• You gain a swim speed of 40 feet.

• You gain a climb speed of 40 feet.

• You gain a burrow speed of 30 feet.

• You gain 3 choices from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

Metamorphosis, Major[]

As minor metamorphosis, except you instead gain one option from Enhancement Menu C or one option from Abilities Menu C. Choices that give similar benefits to those from Enhancement Menu C or Abilities Menu C do not stack. For example, you cannot pick to gain three natural attacks from Abilities Menu C and also to gain a natural attack from Abilities Menu A to get four attacks.

Enhancement Menu C

• +6 enhancement bonus to Strength

• +6 enhancement bonus to Dexterity

• +6 enhancement bonus to Constitution

• Pick 2 choices from Enhancement Menu B from metamorphosis . You may not choose the same option twice.

• Increase your base land speed by 30 feet.

Abilities Menu C

• You gain the Rend ability. If you hit the same opponent with two natural attacks in one round, you deal additional damage equal to 2d6 + your Strength modifier.

• You gain three natural slam/bite/claw attacks that deal 2d6 damage if Medium (2d8 if Large).

• Your natural attacks extrude poison and acid. When you hit with a natural melee attack, it deals +2d6 acid damage and the target must make a Fortitude save (DC10+ ½ your manifester level + your key ability modifier) or take 1 point of Constitution damage.

• You gain Fast Healing 5.

• You gain +6 natural armor bonus.

• You gain 40 temporary hit points.

• You gain a fly speed of 40 feet (good).

• You gain a swim speed of 60 feet.

• You gain a climb speed of 60 feet.

• You gain a burrow speed of 60 feet.

• You gain 2 choices from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Augment: You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Metamorphosis, True[]

As minor metamorphosis, except you gain two menu choices from the Enhancement Menu C and two menu choices from Abilities Menu C from major metamorphosis . As a swift action, you can change your menu choices while the duration of this power is in effect.

While under the effects of this power, you can choose to become one of the following types, with the associated benefits: aberration, dragon, fey, humanoid, magical beast or monstrous humanoid. As a swift action, you can change what type you are while the duration of this power is in effect.

Augment You can augment this power in the following ways.

• For every 6 power points you spend, you gain one choice from Enhancement Menu C and one choice from Abilities Menu C. You may not choose the same option twice.

• For every 2 power points you spend, you gain one choice from Enhancement Menu A and one choice from Abilities Menu A from minor metamorphosis. You may not choose the same option twice.

• For every 4 power points you spend, you gain one choice from Enhancement Menu B and one choice from Abilities Menu B from metamorphosis . You may not choose the same option twice.

Mythic Minor Metamorphosis[]

Add your tier to the bonus to Disguise checks. In addition, you gain one choice from Enhancement Menu A and Abilities Menu A, instead of one choice between the two menus.

Mythic Metamorphosis[]

You gain one choice from Enhancement Menu B and Abilities Menu B, instead of one choice between the two menus.

Mythic Major Metamorphosis[]

You gain one choice from Enhancement Menu C and Abilities Menu C, instead of one choice between the two menus.

Mythic True Metamorphosis[]

You can also choose to become one of the following types, with the associated traits: construct, elemental, or plant.`
  },
  Regenerative_Aura: {
    name: "Regenerative Aura",
    discipline: "Psychometabolism (Healing)",
    level: "Egoist 9, vitalist 9",
    display: "Material, visual",
    manifestingTime: "1 standard action",
    range: "30 ft",
    target: "",
    area: "30 ft. radius sphere centered on you",
    duration: "1 round / level (D)",
    savingThrow: "Fort negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "17",
    description: `Psionic power radiates out from your body, causing all living creatures within range to rapidly heal as their healing ability is hyperaccelerated. All living creatures within range heal 25 hit points per round.

Augment: By expending your psionic focus while manifesting this power, you may select which creatures are healed.`
  },
  Control_Object: {
    name: "Control Object",
    discipline: "Psychokinesis",
    level: "Gambler 1, kineticist 1",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One unattended object weighing up to 100 lb.",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `You telekinetically “bring to life” an inanimate object. Though it is not actually alive, the object moves under your control. Live vegetation cannot be controlled in this fashion, nor can already animated objects or undead. The controlled object moves like a puppet, with jerky and clumsy movements, at a speed of up to 20 feet. If its form is rigid, it makes creaking, groaning, or grating sounds as you control it.

A controlled object can attack an opponent if you direct it to do so. It has one slam attack, at a base attack bonus equal to your base attack bonus plus your Intelligence modifier. If the attack hits, it deals points of damage equal to 1d6 plus your primary ability modifier. A controlled object has its usual hardness and hit points.

You can use this power on a nonmagical lock, making it move in such a way as to attempt to unlock itself. If another character makes a Disable Device check to open a lock in the device that you are concentrating on controlling, the character gains a +4 bonus on the check.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, you can control another object at the same time.

• For every 2 additional power points you spend, the weight of the object you can control increases by 100 lb.

Mythic Control Object[]

You only need to concentrate on the power as a move action to maintain the  effect,  and  you  add your tier to the slam attack damage and the bonus to Disable Device checks.

Augmented: If you expend one use of mythic power, the effect lasts as long as you maintain concentration as is no longer limited to up to 1 round per level.

Augmented (3rd): If you expend two uses of mythic power, the object gains an additional slam attack per three tiers you possess (round up).`
  },
  Control_Air: {
    name: "Control Air",
    discipline: "Psychokinesis",
    level: "Kineticist 2, marksman 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "50-ft.-radius spread",
    duration: "Concentration, up to 1 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "Kineticist 3, marksman 5",
    description: `You have some control over wind speed and direction. The speed of the wind within the area of this power can be increased or decreased by up to 10 miles per hour.

This power also gives you the ability to alter the direction of the wind by as much as 90 degrees.

Powerful enough winds can cause creatures to be blown away, knocked down, or checked.

Augment: For every additional power point you spend, you can modify the wind speed by an additional 10 miles per hour, to a maximum change in wind speed of 60 miles per hour.

Mythic Control Air[]

You can alter the direction of the wind to blow in any direction. You can cease concentrating on the power without ending the effect, and alter the nature of the wind in the affected area by concentrating as a swift action.`
  },
  Energy_Missile: {
    name: "Energy Missile",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 2, kineticist 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `Targets: Up to five creatures or unattended objects; no two targets can be more than 15 ft. apart.

You release a powerful missile of your active energy type (cold, electricity, fire, or sonic) at your foe. The missile deals 3d6 points of damage to each creature or unattended object you target, to the maximum of five targets. You cannot hit the same target multiple times with the same manifestation of this power.

• Cold: A missile of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold missile is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a missile of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A missile of this energy type deals +1 point of damage per die.

• Sonic: A missile of this energy type deals –1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For every two additional dice of damage, the power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Missile[]

The damage dice of the power and its augments increase to d10s. The range between targets increases to 30 ft. apart.

Augment (3rd): If you expend one use of mythic power, you can target one additional creature or unattended object for every three mythic tiers you possess.

Augmented (8th): If you expend three uses of mythic power, you can target a single creature with every missile from mythic energy missile .`
  },
  Telekinetic_Bola: {
    name: "Telekinetic Bola",
    discipline: "Psychokinesis",
    level: "Highlord 2, kineticist 2, psychic warrior 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "5 feet",
    target: "Up to three objects weighing no more than 5 pounds each",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `A small number of items become animated, hurling about your person in a dizzying orbit, ready to act at your behest. When you manifest this power, you must choose one of two modes in which you intend it to be used. Once chosen, this choice cannot be altered until the power ends.

In either case, you cause a set of objects to spin rapidly around you, primed to either defend you, or aid in your offense. These objects move quickly enough that they do not impair your vision, nor do they provide you cover or concealment. The objects so animated remain within your square at all times and if they are removed by any means, they cease being under the control of the power.

Defensive : In this mode, the objects you animate are prepared to intercept physical attacks against you. Once per animated object per round, you can direct an object to try to block such an attack as a free action that can be taken outside of your turn. The animated item moves to intercede, providing you a +1 shield bonus against that attack. Unlike most cases, this bonus stacks with any shield bonus you have from another source.

Offensive: In this mode, the objects you animate can be used to make offensive attacks. Once per animated object per round, you can direct an object to attack a creature that is attacking you as a free action. This is resolved after the attack that you are reacting to. You make an attack roll using your base attack bonus and adding your manifesting ability bonus. If you hit, the animated object deals 1d3 points of damage. You cannot react with more than one object per attack made against you.

Augment: For every four additional power points you spend, the shield bonus granted increases by +1 or the damage dealt increases by 1d3.

Mythic Telekinetic Bola

Your shield bonus is now constant, applying to all attacks during the power's duration. Similarly, in offensive mode the mythic telekinetic bola automatically counter-attacks after every melee attack made against you, and the damage dice increase to 1d6.`
  },
  Wardrobe_Malfunction: {
    name: "Wardrobe Malfunction",
    discipline: "Psychokinesis",
    level: "Highlord 2, kineticist 2, tactician 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./level)",
    target: "One worn suit of armor or clothing",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "Reflex negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `With furrowed brow, you remotely loosen straps, open buckles, and otherwise disassemble an enemy's armor. When you manifest this power, if your target fails their saving throw, you may start removing portions of their armor, reducing the armor bonus to AC that it grants by 2. Each round that you concentrate on this power, the target must make an additional saving throw to resist its effects. Failure results in further reductions in armor bonus, to a minimum of zero.

As a standard action on their turn, your target may refasten their armor, restoring their armor bonus by up to 2, to a maximum of the normal armor bonus granted by their armor. Disassembly caused by wardrobe malfunction remains after the power ends, and a creature wearing such armor must spend actions to reassemble it.

This power does not harm a suit of armor, even one that appears to be one integral piece, such as in the case of hide armor. Such armor merely becomes improperly seated on its wearer, and can be donned normally once this power's influence is ended.

This power does not affect armor bonuses granted from sources other than armor, such as that granted by inertial armor or bracers of armor .

Wardrobe malfunction can be similarly used upon common clothing. In this case, each round you may designate a single article of clothing your target is wearing. If the target fails its saving throw that round, the item slips off of them.

Mythic Wardrobe Malfunction

Once this power has reduced a suit of armor's armor bonus to 0, the manifester may start reducing the shield bonus (if any) their target possesses. Additionally, this power may be used to reduce a creature's natural armor bonus by pulling and prying portions of protective plating out of place, but only once the target's armor and shield bonuses to AC are reduced to 0.`
  },
  Charge_Weapon: {
    name: "Charge Weapon",
    discipline: "Psychokinesis (energy)",
    level: "Highlord 3, kineticist 3, psychic warrior 3, tactician 3",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One weapon",
    area: "",
    duration: "1 minute / level",
    savingThrow: "none",
    powerResistance: "No",
    powerPoints: "5",
    description: `You touch a weapon, filing it with a humming charge of your current energy type. The weapon gains a charge of 3d6 energy damage that the wielder can choose to unleash with an attack. The wielder chooses how many dice to add to an attack before making the attack roll; if the attack misses, the damage is lost. In addition, attacks made with the weapon have a secondary effect depending on the energy type.

Energy type

• Fire – you deal 1 point of fie damage with all attacks with the charged weapon.

• Cold – all attacks with the charged weapon slow down enemies, anyone hit while the weapon is charged takes a 5 ft penalty to their speed in their next turn.

• Electricity – you gain a +2 bonus to attacks against creatures made of metal or in metal armor while the weapon is charged.

• Sonic – all attacks with the charged weapon ignores ½ hardness on all attacks as the weapon vibrates.

Augment: This power may be augmented in one or more of the following ways.

• For every additional power point you spend, increase the damage by 1d6.

• If you spend 3 additional power points, increase the dice size to d8.

• If you spend 5 additional power points, increase the dice size to d10.`
  },
  Energy_Cone: {
    name: "Energy Cone",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 3, kineticist 3",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped spread",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text;",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You create a cone of energy of your active energy type (cold, electricity, fire, or sonic), extending outward from your hand, that deals 5d6 points of damage to every creature or object within the area.

• Cold: A cone of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold cone is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a cone of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A cone of this energy type deals +1 point of damage per die.

• Sonic: A cone of this energy type deals –1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Cone[]

The damage dice of the power and its augments increase to d10s. You can choose any point within 30 feet of you to be the point of origin for the cone.

Augmented (3rd): If you expend two uses of mythic power, you can affect creatures in the cone based upon the energy type.

• Cold: Creatures that fail their save are staggered.

• Electricity: Creatures that fail their save are knocked prone.

• Fire: Creatures that fail their save are set on fire, suffering one point of damage per dice of  damage dealt by the cone each round until the fire is extinguished.

• Sonic: Creatures that fail their save are dazed for one round. Creatures that succeed on their save are deafened for a number of rounds equal to your tier.`
  },
  Localized_Windstorm: {
    name: "Localized Windstorm",
    discipline: "Psychokinesis [Air]",
    level: "Kineticist 3, marksman 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. +5 ft/level)",
    target: "",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "None, see text",
    powerResistance: "Yes",
    powerPoints: "Kineticist 5, marksman 3",
    description: `Effect: Wall up to 10 ft./level long and 5 ft./level high (S)

Through force of will alone, you generate a small storm of psychokinetic turbulence in the air. The storm itself manifests as a wall which can intensify the existing winds in a small area, or can instead be set to exactly counter such winds, generating a peaceful area of calm. While the wall must be vertical, you can shape it in any continuous path along the ground that you like. It is possible to create cylindrical or square walls to enclose specific points.

Choose to intensify or pacify the winds when you manifest this power (although the decision can be changed when you reshape the effect, see below).

Intensifying the winds creates an invisible vertical curtain of wind. It is 2 feet thick and of considerable strength. It is a roaring blast sufficient to blow away any bird smaller than an eagle, or tear papers and similar materials from unsuspecting hands. (A Reflex save allows a creature to maintain its grasp on an object.) Flying creatures smaller than Medium size cannot pass through the barrier. Loose materials and cloth garments fly upward when caught in a wind wall. Projectiles of 1 pound or less passing through the wind wall are deflected upward and miss. For every pound above 1 of the projectile's weight, it has a 10% chance to not be blown off course. Projectiles weighing 10 lbs or more are unaffected by the wind wall. Gases, most gaseous breath weapons, and creatures in gaseous form cannot pass through the wall (although it is no barrier to incorporeal creatures).

Pacifying the winds allows you to generate a region of calm that consists of every 5 ft. cube that shares an edge or space with where the wind wall would otherwise be. These regions are treated as if their wind conditions were two categories fairer than they would naturally be, to a minimum of no winds. Additionally, if these areas of calm overlap an existing wind wall or an intensifying localized windstorm, the two effects cancel, letting normal wind conditions prevail in the square.

At any point during the duration, you may extend your concentration to a full-round action. Doing so allows you reshape the wall into any other configuration you could have chosen when you manifest this power, including the choice to intensify or pacify.

Augment: You may augment this power in one or more of the following ways:

• If you spend 2 additional power points, the duration increases to 1 round/level. You no longer need to maintain concentration. You may reshape the wall by spending a standard action in concentration.

• If you spend 2 additional power points, the range of this power increases to Medium (100 ft. +10 ft./level).

• If you spend 2 additional power points, your control over the localized windstorm increases greatly. You may reshape the wall as normal or as an immediate action. You may also generate pockets of calm interspersed with pockets of intense winds when you shape the wall (effectively, this is the intensify option except that the wall may be broken with as many 5-foot cubes of calm that you choose, as per the pacify option).

• For every 2 additional power points you spend, you can reduce the wind conditions an additional category when using the pacify option.

• For every additional power point, the weight limit of projectiles that are deflected increases by 1 lb. In addition, for every 2 power points spent achieving any of these effects, increase the save DC by 1.

Mythic Localized Windstorm[]

The chance for ranged weapons other than arrows and bolts that pass through the barrier to not be blow off course is reduced to 5% per pound above 1 pound. Giant-thrown boulders, siege engine projectiles, and similar massive ranged weapons passing through the barrier have a 20% miss chance.

Augmented (3rd): If you expend two uses of mythic power, giant-thrown boulders, siege engine projectiles, and similar massive ranged weapons passing through the barrier have a 50% miss chance while smaller ranged weapons are automatically deflected. In addition, Medium and smaller creatures cannot pass through the barrier unless they succeed on a DC 10 Strength check or DC 20 Fly check; this check is made as part of their movement and does not require a separate action.`
  },
  Telekinetic_Barrier: {
    name: "Telekinetic Barrier",
    discipline: "Psychokinesis",
    level: "Highlord 3, kineticist 3, psychic warrior 3, tactician 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "",
    target: "Personal or touch",
    area: "",
    duration: "1 hour / level or until discharged",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "5 (highlord, kineticist, psychic warrior) or 7 (tactician)",
    description: `Effect: Area 40 ft. radius

You surround yourself or the target with a telekinetic barrier that slows down all incoming projectiles, draining them of their energy and force, causing them to drop to the ground when entering the aura. You and all allies inside the aura gain Damage Reduction 20/magic against all ranged projectile or thrown attacks. This power lasts until it has prevented a total of 50 points of damage.

Augment: This power may be augmented in one or both of the following ways.

• For every additional power point you spend on this power, the pool of damage before it is discharged is increased by 50.

• If you spend 2 additional power points, the damage reduction changes to 20/- instead of 20/magic.`
  },
  Control_Body: {
    name: "Control Body",
    discipline: "Psychokinesis",
    level: "Gambler 4, kineticist 4",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One Medium or smaller creature with humanoid physiology",
    area: "",
    duration: "Concentration, up to 1 min./level",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You psychokinetically control the actions of any humanoid (including undead or outsiders with a humanoid physiology) that is within range and to which you have line of sight. Control body doesn't require mental contact with the subject, since you are actually forcing limb movements independent of the target's mind. You can force the subject to stand up, sit down, walk, turn around, and so on, but operating the vocal cords is too difficult. You can also hold the subject immobile, rendering it helpless. You cannot force the subject to manifest powers, cast spells, or use any special ability that is not a function of just its body movements. If you lose line of sight to the subject, the effect of this power ends.

If you force the subject to engage in combat, its attack bonus is equal to your base attack bonus + your Intelligence bonus, and its bonus on damage rolls is equal to your Intelligence bonus. A subject of this power cannot make attacks of opportunity. The subject gains no benefit to Armor Class from its Dexterity, but it does gain a bonus to its AC equal to your Intelligence bonus.

Although the subject's body is under your control, the subject's mind is not. Creatures capable of taking purely mental actions (such as manifesting powers) can do so. The subject may make an additional Fortitude save each round you maintain concentration.

The subject is treated as being staggered and may only perform a single move action or standard action under your direction each round.

You cannot be the target of your own control body power.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, this power can affect a target one size category larger.

• If you spend 4 additional power points, the controlled target is no longer treated as being staggered.

Mythic Control Body[]

The controlled subject can make attacks of opportunity, but they count against your limit of attacks of opportunity for the round. Add your tier to the attack rolls and the bonus to Armor Class of the subject. You may cease concentrating on the power without ending the effect, but the subject regains use of its body while you are not concentrating. You may resume concentration of the power as a standard action.

Augmented (5th): If you expend two uses of mythic power, the controlled subject is not staggered by the effect.`
  },
  Energy_Ball: {
    name: "Energy Ball",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 4, kineticist 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "20-ft.-radius spread",
    duration: "Instantaneous",
    savingThrow: "Reflex half or Fortitude half; see text;",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You create an explosion of energy of your active energy type (cold, electricity, fire, or sonic) that deals 7d6 points of damage to every creature or object within the area. The explosion creates almost no pressure.

• Cold: A ball of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold ball is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a ball of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A ball of this energy type deals +1 point of damage per die.

• Sonic: A ball of this energy type deals –1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Ball[]

The damage dice of the power and its augments increase to d10. In addition, the mythic energy ball has different effects based upon the energy type.

• Cold: Any creature that fails its save is partially encased in ice, reducing its speed by half. Creatures with the cold or incorporeal subtype or immunity to being grappled are immune to this effect. The reduced movement lasts until the ice is destroyed. Destroying the ice requires a successful Strength or dispel check against the spell's DC, or dealing bludgeoning or fire damage equal to 1 point per caster level to the creature.

• Electricity: Any creature that fails its save is staggered for 1 round.

• Fire: Any creature that fails its Reflex saving throw catches on fire, taking 2d6 points of fire damage each round until the fire is extinguished. Attempts to extinguish this fire use the power's save DC.

• Sonic: Any creature that fails its save is knocked prone.

Augmented (6th): If you expend two uses of mythic power, the area increases to a 40-foot radius spread, and any damage dealt by the power bypasses appropriate resistance and immunity for that energy type.`
  },
  Hydrokinesis: {
    name: "Hydrokinesis",
    discipline: "psychokinesis (water)",
    level: "kineticist 4",
    display: "olfactory and auditory",
    manifestingTime: "1 standard action",
    range: "long (400 ft. + 40 ft./level)",
    target: "",
    area: "water in a volume of 10 ft./level by 10 ft./level by 2 ft./level (S)",
    duration: "10 min./level (D), see text",
    savingThrow: "none; see text",
    powerResistance: "no",
    powerPoints: "7",
    description: `You force water into or out of an area, raising or lowering the water level. The first version of this power causes water in the area to swiftly evaporate or to sink into the ground below, lowering the water's depth. The second version causes the water to surge and rise, increasing its overall depth and possibly flooding nearby areas.

Lower water : This causes water or similar liquid to reduce its depth by as much as 2 feet per caster level (to a minimum depth of 1 inch). The water is lowered within a squarish depression whose sides are up to manifester level x 10 feet long. In extremely large and deep bodies of water, such as a deep ocean, the power creates a whirlpool that sweeps ships and similar craft downward, putting them at risk and rendering them unable to leave by normal movement for the duration of the power. When cast on water elementals and other water-based creatures, this power staggers them for 1 round/level (Will negates). The power has no effect on other creatures.

Raise water : This causes water or similar liquid to rise in height, just as the lower water version causes it to lower. Boats raised in this way slide down the sides of the hump that the spell creates. If the area affected by the power includes riverbanks, a beach, or other land nearby, the water can spill over onto dry land. This power can be used to call up water that is not in its liquid state (for example, melting underground ice and bringing it to the surface, or transforming water vapor to condense).

With either version of this power, you may reduce one horizontal dimension by half and double the other horizontal dimension to change the overall area of effect.

Augment: This power can be augmented in the following ways:

• For every 4 power points you spend, the area of this power doubles in one dimension.

• If you expend 4 additional power points, you may use this power on liquid other than water, such as oil, magma, or slag. Effects are modified to accommodate this (for example, a creature with magma for blood may be affected as a water elemental).

• If you spend 2 additional power points, you may use the raise water effect of this power even if there is no water (or other material being used) present.

• If you spend 8 additional power points, you may siphon water from plant life and living creatures within range of this power when using lower water. Subjects that you choose to siphon water from take 1d6 points of damage for every power point spent on this power, or 1d8 if they are water elementals or plant creatures. Creatures are allowed a fortitude save to halve this damage.

• If you spend 8 additional power points, you may manipulate water you have raised with raise water as a standard action so long as you concentrate. The water moves up to thirty feet per round. The mass of water possesses the engulf special ability, automatically engulfing any creature or object that it moves over and that fits within its dimensions. The Reflex save DC of engulf is equal to the saving throw of this power, and engulfed creatures take 8d6 points of damage per round while engulfed.`
  },
  Inertial_Barrier: {
    name: "Inertial Barrier",
    discipline: "Psychokinesis",
    level: "Gifted blade 4, kineticist 4, highlord 4, marksman 4, psychic warrior 4, vitalist 4",
    display: "Auditory and mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "10 min./level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You create a skin-tight psychokinetic barrier around yourself that resists blows, cuts, stabs, and slashes, as well as providing some protection against falling. You gain damage reduction 5/–. Inertial barrier also absorbs half the damage you take from any fall.

Mythic Inertial Barrier[]

The psychokinetic barrier grants you resistance 5 against force damage. Once during the power's duration, you can shift the psychokinetic barrier to one creature within 30 feet as an immediate action. That creature gains the benefits of the psychokinetic barrier until the end of your next turn, at which point the power ends.

Augmented: If you expend one use of mythic power, you increase the damage reduction by your mythic tier and you add your tier to your CMD for any combat maneuvers that attempt to move you, such as bull rush, reposition, or trip attempts.`
  },
  Energy_Current: {
    name: "Energy Current",
    discipline: "Psychokinesis [see text]",
    level: "Gambler 5, kineticist 5",
    display: "Visual; see text",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Any two creatures no more than 15 ft. apart",
    area: "",
    duration: "Concentration, up to 1 round/level",
    savingThrow: "Reflex half or Fortitude half; see text;",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `Your body's psionically fueled bioenergetic currents produce an arc of energy of your active energy type (cold, electricity, fire, or sonic) that targets a creature you designate as the primary foe for 9d6 points of damage in every round when the power remains in effect. Energy also arcs off the primary foe to strike one additional foe that is initially within 15 feet of the primary foe, or that subsequently moves within 15 feet of the primary foe while the duration lasts. Secondary foes take the same damage that the primary foe takes in every round while the duration lasts.

Should either the primary or secondary foe fall to less than 0 hit points (or should a target completely evade the effect with a special ability or power), or should the primary foe move out of range of the effect, the energy current 's arc randomly retargets another primary and/or secondary foe while the duration lasts, depending on which foe or foes can no longer be targeted. Targeted foes can move normally, possibly moving out of range of the effect, but each round they are targeted and remain in range they must make a saving throw to avoid taking full damage in that round.

Concentrating to maintain energy current is a full-round action. If you take damage while maintaining energy current , you must make a successful concentration check (DC 10 + damage dealt) to avoid losing your concentration on the power.

The save DC to halve the damage for the secondary target is 2 lower than the DC for the primary target.

• Cold: A current of this energy type deals +1 point of damage per die. The saving throw to reduce damage from a cold current is a Fortitude save instead of a Reflex save.

• Electricity: Manifesting a current of this energy type provides a +2 bonus to the save DC and a +2 bonus on manifester level checks for the purpose of overcoming power resistance.

• Fire: A current of this energy type deals +1 point of damage per die.

• Sonic: A current of this energy type deals –1 point of damage per die and ignores an object's hardness.

This power's subtype is the same as the type of energy you manifest.

Augment: You can augment this power in one or both of the following ways.

• For every additional power point you spend, this power's damage increases by one die (d6). For each extra two dice of damage, this power's save DC increases by 1.

• For every 4 additional power points you spend, this power can affect an additional secondary foe. Any additional secondary foe cannot be more than 15 feet from another target of the power.

Special: A kineticist does not need to select an energy type for this power when he gains psionic focus. He may choose the type of damage at the time the power is manifested.

Mythic Energy Current[]

The damage dice of the power and its augments increase to d10s. Maintaining concentration on the energy current is reduced to a standard action, and the distance between the primary target and secondary target or targets increases to 30 feet.

Augmented: If you expend one use of mythic power, you can always choose which foes are secondary targets, as long as they are within 30 feet of all other targets of mythic energy current .

Augmented (5th): If you expend two uses of mythic power, the damage to secondary targets is equal to the damage to the primary target.`
  },
  Halt: {
    name: "Halt",
    discipline: "Psychokinesis (cold)",
    level: "Kineticist 5",
    display: "Auditory, Visual",
    manifestingTime: "1 standard action",
    range: "personal",
    target: "",
    area: "30-foot radius centered on manifester",
    duration: "instantaneous and concentration (maximum 1 round/level)",
    savingThrow: "Fortitude partial, see text",
    powerResistance: "yes",
    powerPoints: "9",
    description: `Sapping all energy from the surrounding area, you leave everything within range at a standstill. Projectiles lose their momentum and clatter to the ground where they are, psionic effects are shut down as if affected by a Dispel Psionics power, and creatures must make a Fortitude save or become paralyzed for the duration of this power. Creatures normally immune to paralysis are still affected by this power, but those immune to cold are not. Creatures are entitled to a Fortitude save each round to escape this effect each round that the manifester concentrates.

Librarian's Note: Per dev comment , this power was not intended to paralyze the manifester.

Augment

• If you spend 4 additional power points, this power can be manifested as an immediate action

• For every 2 additional power points spent on this power, the radius increases by 10 feet and the DC increases by 1.`
  },
  Fiery_Discorporation: {
    name: "Fiery Discorporation",
    discipline: "Psychokinesis [Fire]",
    level: "Gambler 5, kineticist 5",
    display: "Visual",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous and one day; see text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `You use your mastery of energy to cheat death. If you are within 30 feet of an open flame, you can use this power. Any damage that would reduce you to 0 hit points or lower instead has a chance to discorporate you. You attempt a Will save (DC 5 + damage dealt); if it succeeds, you take no damage and simply break apart into dozens of flitting tongues of flame and vanish, along with all your gear and anything you are holding or carrying.

One day later, you reappear adjacent to an open flame nearest to the place where you discorporated, seeming to materialize from the fire (you choose where you appear along the perimeter of that open flame). While discorporated, you do not exist—you can do nothing, nor can any of your enemies do anything to you.

Augment: For every 3 additional power points you spend, you gain a +1 bonus on your Will save to determine whether you discorporate.

Mythic Fiery Discorporation[]

You can use mythic fiery discorporation as long as you are within 100 feet of an open flame. You can choose any time within the next 24 hours to reappear from the fire.`
  },
  Dispelling_Buffer: {
    name: "Dispelling Buffer",
    discipline: "Psychokinesis",
    level: "Gambler 6, highlord 6, kineticist 6, psychic warrior 6, tactician 6, voyager 6",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal or close (25 ft. + 5 ft./2 levels); see text",
    target: "You or one willing creature or one object (object weighing up to 100 lb./level); see text",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "None",
    powerResistance: "Yes (harmless, object)",
    powerPoints: "11",
    description: `You create a psychokinetic shield around the subject that improves the chance that any powers affecting the subject will resist a dispel psionics power (or a dispel magic spell) or a negation effect that targets a specific power (such as shatter mind blank ). When dispelling buffer is manifested on a creature or object, on each dispel check, add +5 to the DC for the ongoing effect that is subject to being dispelled.

Dispel psionics can negate dispelling buffer , but against a targeted dispel, dispelling buffer is always checked last (with the same +5 bonus). Against an area dispel, dispelling buffer is checked in the order according to its level (with the same +5 bonus).

Special: When a psychic warrior manifests this power, the range is personal and the target is the manifester.

Mythic Dispelling Buffer[]

Add your tier to the bonus on DCs against dispel checks.`
  },
  Null_Psionics_Field: {
    name: "Null Psionics Field",
    discipline: "Psychokinesis",
    level: "Gambler 6, kineticist 6",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "10 ft.",
    target: "",
    area: "10-ft.-radius emanation centered on you",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "See text",
    powerPoints: "11",
    description: `An invisible barrier surrounds you and moves with you. The space within this barrier is impervious to most psionic effects, including powers, psi-like abilities, and supernatural abilities. Likewise, it prevents the functioning of any psionic items or powers within its confines. A null psionics field suppresses any power or psionic effect used within, brought into, or manifested into its area, but does not negate it. Time spent within a null psionics field counts against a suppressed effect's duration.

Astral constructs, summoned creatures, and incorporeal undead wink out if they enter a null psionics field if they fail any applicable power resistance check. They reappear in the same spot once the field goes away. Time spent winked out counts normally against the duration of the power that is maintaining the construct or summoned creature.

Creation powers with instantaneous durations and calling powers are not affected by a null psionics field because the power itself is no longer in effect, only its result.

A normal creature (a normally encountered construct rather than a created one, for instance) can enter the area, as can normal missiles. Furthermore, while a psionic sword does not function psionically within the area, it is still a sword (and a masterwork sword at that). The power has no effect on golems and other constructs that are imbued with magic during their creation process and are thereafter self-supporting (unless they have been summoned or have a limited duration, in which case they are treated like any other summoned creatures). Elementals, corporeal undead, and outsiders are likewise unaffected unless summoned. These creatures' spell-like or supernatural abilities, however, may be temporarily nullified by the field.

Dispel psionics does not remove the field. Two or more null psionics fields sharing any of the same space have no effect on each other. Certain powers may be unaffected by null psionics field (see the individual power descriptions). Artifacts and deities are unaffected by mortal power such as this. Should a creature's space extend across the boundary of the area enclosed by the field, any part of the creature that lies outside the effect is unaffected by the field.`
  },
  Ecological_Alteration: {
    name: "Ecological Alteration",
    discipline: "psychokinesis",
    level: "kineticist 7",
    display: "olfactory",
    manifestingTime: "10 minutes, see text",
    range: "2 miles",
    target: "",
    area: "2-mile-radius circle, centered on you; see text",
    duration: "4d12 hours; see text",
    savingThrow: "see text",
    powerResistance: "no",
    powerPoints: "13",
    description: `You change the weather in the local area. It takes 10 minutes to manifest this power and an additional 10 minutes for the effects to come into play. You can call forth weather appropriate to the climate and season of the area you are in. However, the manifester cannot change this weather once it has taken effect. The following effects can be manifested using this power, plus additional effects at GM discretion:

Alter temperature : The temperature becomes up to 60 degrees hotter or colder

Clear sky : This effect clears all clouds, weather effects, or other atmospheric phenomena from the area, leaving a clear sky above.

Fog : Thick fog obscures all sight, including darkvision, beyond 5 feet. A creature 5 feet away has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker cannot use sight to locate the target).

Hail : Pelting hail pours down over the area, dealing 5d6 points of bludgeoning damage each round (reflex half)

Lightning : Once per minute, lightning strikes somewhere in the area, dealing 10d6 points of damage (reflex half). The manifester is capable of declaring the location of a number of these strikes equal to his manifesting ability modifier.

Rain : Rain ranging from a light drizzle to a torrential downpour pours down from above. If the rain is significant enough, it obscures all sight, including darkvision, beyond 5 feet. A creature 5 feet away has concealment (attacks have a 20% miss chance). Creatures farther away have total concealment (50% miss chance, and the attacker cannot use sight to locate the target). Speed is reduced by three-quarters.

Snow : Snow or Sleet pours over the area. This effect blocks all sight (even darkvision) within it and causes the ground in the area to be icy. A creature can walk within or through the area of sleet or snow at half normal speed with a DC 10 Acrobatics check. Failure means it can't move in that round, while failure by 5 or more means it falls (see the Acrobatics skill for details).

Windstorm : The winds become powerful and violent, moving as the manifester intends. This ability can be used to create up to tornado-force winds, blowing in whatever direction the manifester chooses. Depending on the location, this effect may whip sandstorms into being within the area.

Augment: This power can be augmented in the following ways:

• For every additional power point you spend, the radius increases by one mile and the duration increases by 1d12 hours

• For every 2 additional power points you spend, you may activate an additional effect with this power.

• If you spend 2 additional power points, you may call weather that would be inappropriate for the season or climate. This includes manifesting weather in an area where no atmosphere would exist.`
  },
  Reddopsi: {
    name: "Reddopsi",
    discipline: "Psychokinesis",
    level: "Kineticist 7",
    display: "Auditory, mental, and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Until expended or 10 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `Powers and psi-like effects targeted on you are reversed back upon the original manifester. Reddopsi turns only powers that have you as a target. Effect and area powers are not affected. Reddopsi also fails to stop touch range powers. Up to 15 power points (or eight spell levels in psionic-magic transparency games) worth of powers are reversed in this fashion.

When you are targeted by a power using a higher amount of power points than the amount of reddopsi you have left, that power is partially reversed. Subtract the amount of reddopsi left from the power points of the incoming power, then divide the result by the total power points of the incoming power to see what fraction of the effect gets through. For damaging powers, you and the manifester each take a fraction of the damage. For nondamaging powers, each of you has a proportional chance to be the one who is affected. If you and a manifesting attacker are both warded by reddopsi effects in operation, a resonating field is created. Roll randomly to determine the result.`
  },
  Psychokinetic_Sphere: {
    name: "Psychokinetic Sphere",
    discipline: "Psychokinesis [Force]",
    level: "Kineticist 8",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "Reflex negates (object)",
    powerResistance: "Yes (object)",
    powerPoints: "15",
    description: `Effect: 1-ft.-diameter/level sphere, centered around creatures or objects

A globe of shimmering force encloses a creature, provided the creature is small enough to fit within the diameter of the sphere, and contains it for the duration of the effect. Anything contained within the sphere weighs only one-sixteenth of its normal weight. You can telekinetically lift anything in the sphere that normally weighs 5,000 pounds or less. The telekinetic control extends from you out to medium range (100 feet + 10 feet per manifester level) after the sphere has succeeded in encapsulating its contents.

You can move the sphere, along with the objects and creatures it contains that weigh a total of 5,000 pounds or less, by concentrating on the sphere. You can begin moving a sphere in the round after manifesting the power. If you concentrate on doing so (a standard action), you can move the sphere as much as 30 feet in a round. If you cease concentrating, the sphere does not move in that round (if on a level surface) or descends at its falling rate (if aloft) until it reaches a level surface. You can resume concentrating on your next turn or any later turn during the duration.

The sphere falls at a rate of only 60 feet per round, which is not fast enough to cause damage to the contents of the sphere.

You can move the sphere telekinetically even if you are in it.

The sphere functions as a wall of force , except that it can be negated by dispel psionics . A subject inside the sphere can breathe normally. The sphere cannot be physically moved either by people outside it or by the struggles of those within.`
  },
  Shockwave: {
    name: "Shockwave",
    discipline: "psychokinesis",
    level: "gambler 6, kineticist 8",
    display: "auditory",
    manifestingTime: "1 standard action",
    range: "long (400 ft. + 40 ft./level)",
    target: "",
    area: "80-ft.-radius spread (S)",
    duration: "1 round",
    savingThrow: "see text",
    powerResistance: "no",
    powerPoints: "gambler 11, kineticist 15",
    description: `A telekinetic scream echoes throughout a massive distance, shattering any material that stands in its way. The powerful shockwave created by this power knocks creatures down, collapses structures, opens cracks in the ground, and more. The effect lasts for 1 round, during which time creatures on the ground can't move or attack. A manifester on the ground must make a Concentration check (DC 20 + power level) or lose any power he or she tries to manifest. The shockwave affects all terrain, vegetation, structures, and creatures in the area. All creatures inside the area of effect take 10d6 points of force damage. The specific effect of a shockwave power depends on the nature of the terrain where it is cast.

Cave, Cavern, or Tunnel : The roof collapses, dealing 8d6 points of damage to any creature caught under the cave-in (Reflex DC 15 half) and pinning that creature beneath the rubble (see below). An earthquake cast on the roof of a very large cavern could also endanger those outside the actual area but below the falling debris and rubble.

Cliffs : Earthquake causes a cliff to crumble, creating a landslide that travels horizontally as far as it falls vertically. Any creature in the path takes 8d6 points of bludgeoning damage (Reflex DC 15 half) and is pinned beneath the rubble (see below).

Open Ground : Each creature standing in the area must make a DC 15 Reflex save or fall down. Fissures open in the earth, and every creature on the ground has a 25% chance to fall into one (Reflex DC 20 to avoid a fissure). The fissures are 40 feet deep. At the end of the spell, all fissures grind shut. Treat all trapped creatures as if they were in the bury zone of an avalanche, trapped without air (see Environment for more details).

Pinned Beneath Rubble : Any creature pinned beneath rubble takes 1d6 points of nonlethal damage per minute while pinned. If a pinned character falls unconscious, he or she must make a DC 15 Constitution check or take 1d6 points of lethal damage each minute thereafter until freed or dead.

River, Lake, or Marsh : Fissures open under the water, draining away the water from that area and forming muddy ground. Soggy marsh or swampland becomes quicksand for the duration of the spell, sucking down creatures and structures. Each creature in the area must make a DC 15 Reflex save or sink down in the mud and quicksand. At the end of the spell, the rest of the body of water rushes in to replace the drained water, possibly drowning those caught in the mud.

Structure : Any structure standing on open ground takes 100 points of damage, enough to collapse a typical wooden or masonry building, but not a structure built of stone or reinforced masonry. hardness does not reduce this damage, nor is it halved as damage dealt to objects normally is. Any creature caught inside a collapsing structure takes 8d6 points of bludgeoning damage (Reflex DC 15 half) and is pinned beneath the rubble (see below).

Underwater : The water in the area thrashes violently and erratically, dealing an additional 4d6 damage to creatures and objects inside the area and stopping them from moving while they are in the area of effect. Slip the bonds or a similar effect negates this entrapment, as can a successful DC 40 swim or profession (sailor) check.

Augment: This power can be augmented in the following ways:

• If you expend psionic focus, you may exempt yourself from the effects of this power, even if you are in the area.

• If you expend 2 additional power points, this power's duration becomes concentration. Its effects occur again each round you concentrate.`
  },
  Armageddon: {
    name: "Armageddon",
    discipline: "Psychokinesis (force)",
    level: "Kineticist 9",
    display: "Auditory, Visual",
    manifestingTime: "1 minute",
    range: "Personal",
    target: "",
    area: "1 mile radius/level, centered on manifester",
    duration: "Instantaneous",
    savingThrow: "Fortitude half",
    powerResistance: "No",
    powerPoints: "17",
    description: `Channelling all of your raw psionic power into a single burst, you unleash cosmic destruction over all that you survey. All things within range, including you, take 10d6 points of force damage. Upon manifesting this power, you take 4d6 points of ability burn to your manifesting ability score.`
  },
  Tornado_Blast_Willian_s: {
    name: "Tornado Blast, Willian's",
    discipline: "Psychokinesis",
    level: "Kineticist 9",
    display: "Auditory and visual; see text",
    manifestingTime: "1 round",
    range: "Long (400 ft. + 40 ft./level)",
    target: "",
    area: "40-ft.-radius spread",
    duration: "Instantaneous",
    savingThrow: "Reflex half; see text",
    powerResistance: "No",
    powerPoints: "17",
    description: `You induce the formation of a slender vortex of fiercely swirling air. When you manifest it, a vortex of air visibly and audibly snakes out from your outstretched hand.

If you want to aim the vortex at a specific creature, you can make a ranged touch attack to strike the creature. If you succeed, direct contact with the vortex deals 8d6 points of damage to the creature (no save).

Regardless of whether your ranged touch attack hits (and even if you forgo the attack), all creatures in the area (including the one possibly damaged by direct contact) are picked up and violently dashed about, dealing 17d6 points of damage to each one. Creatures that make a successful Reflex save take half damage, but are still picked up.

After being dashed about, each creature that was affected finds itself situated in a new space 1d4 x 10 feet away from its original space in a random direction. Walls and other barriers can restrict this relocation; in such a case, the creature ends up adjacent to the barrier.

Augment: For every additional power point you spend, this power's area damage (not the damage from direct contact dealt to a specific creature) increases by 1d6 points. For each extra 2d6 points of damage, this power's save DC increases by 1.`
  },
  Burst: {
    name: "Burst",
    discipline: "Psychoportation",
    level: "Gifted blade 1, highlord 1, marksman 1, nomad 1, psychic warrior 1, sighted seeker 1, voyager 1",
    display: "Auditory",
    manifestingTime: "1 swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `This power increases your land speed by 10 feet. This adjustment counts as an enhancement bonus to speed.

Augment: For every 4 additional power points you spend, the enhancement bonus to speed increases by 10 feet.

Mythic Burst[]

The increase to your land speed lasts an additional number of rounds equal to your tier.

Augmented: If you expend one use of mythic power, the increase to your land speed is doubled.

Augmented (3rd): If you expend two uses of mythic power, the duration increases to 10 minutes per level.`
  },
  Detect_Teleportation: {
    name: "Detect Teleportation",
    discipline: "Clairsentience",
    level: "Gambler 4, psion/wilder 4, sighted seeker 4, voyager 4",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "Spread with a radius of 25 ft. + 5 ft./2 levels, centered on you",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `Detect Teleportation[]

You sense the use of any effects of the teleportation subdiscipline within the area. You sense the use of these powers whether or not you have line of sight or line of effect (although a force effect prevents this detection). When you sense the use of an appropriate power, you know the direction in which the power was used, though not the distance or the exact effect.

Augment: If you spend 2 additional power points, this power's range increases to Medium (100 ft. + 10 ft./level).

Trace Psychoport[]

As detect teleportation , except you can trace the destination of any psionic or magical teleportation made by others within this power's area within the last minute.

You know the direction and distance the individuals traveled and could teleport to the location yourself if you so desired (and if you know the psychoport power), as if you had “seen casually” the location. This power does not grant you any information on the conditions at the other end of the trace beyond the mental coordinates of the location.

Augment: If you spend 2 additional power points, this power's range increases to Medium (100 ft. + 10 ft./level).`
  },
  Dimension_Swap: {
    name: "Dimension Swap",
    discipline: "Psychoportation (Teleportation)",
    level: "Gifted blade 2, highlord 2, nomad 2, psychic warrior 2, tactician 2, voyager 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless, object)",
    powerResistance: "Yes (harmless, object)",
    powerPoints: "3",
    description: `Targets: You and one ally in range, or any two allies in range; see text

You instantly swap positions between your current position and that of a designated ally in range. Alternatively, you can swap the positions of any two allies in range. This power affects creatures of Large or smaller size. You can bring along objects, but not other creatures.

Special: A psychic warrior can manifest this power to swap positions with an ally, but not to swap the positions of two allies.

Augment: For every 2 additional power points you spend, this power can affect a target one size category larger.

Mythic Dimension Swap[]

The range increases to Medium (100 feet + 10 feet/ level).

Augmented (3rd): If you expend one use of mythic power, you can swap a number of willing creatures equal to your tier.`
  },
  Gravitational_Well: {
    name: "Gravitational Well",
    discipline: "Psychoportation",
    level: "Gambler 2, marksman 2, nomad 2, voyager 2",
    display: "Material, Olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "1 round / level",
    savingThrow: "Reflex negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `An artificial well of gravity manifests on the target, pulling other objects in towards it. All attacks against the target gain a +2 circumstance bonus to the attack roll as attacks are drawn toward it from the increased gravitational pull.

In addition, attacks made against any other creatures within 10 ft. of the target suffer a -2 penalty to attack rolls, as the altered gravity attempts to pull the attack toward the affected creature.

Any attempt to move closer to or around the target is unhindered, but any attempt to move away from the affected creature is treated as difficult terrain until more than 10 ft. away. A successful Reflex save negates this effect.

Creatures benefiting from Stability or Personal Gravity, such as an elocater, gain a +4 bonus to their saving throw.

Augment: This power may be augmented in one or both of the following ways.

• By spending an additional 2 power points, ranged attacks, but not ranged touch attacks, fired at nearby targets are likely to veer off course, turning toward the creature affected. Any ranged attack within 10 ft. that misses its target has a 25% chance of striking at the creature affected. Roll a second attack roll at a -4 penalty with the affected creature as the target. If the attack roll is successful, the affected creature is struck by the ranged attack.

• For every 4 additional power points spent, the distance from the target increases by 5 ft. to determine if a missed attack strikes at the affected creature.`
  },
  Astral_Caravan: {
    name: "Astral Caravan",
    discipline: "Psychoportation",
    level: "Nomad 3",
    display: "None",
    manifestingTime: "1 hour",
    range: "Personal",
    target: "",
    area: "",
    duration: "See text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Targets: You and touched willing creatures

You lead a caravan into the Astral Plane, leaving the Material Plane behind. Since the Astral Plane touches upon other planes, you can travel astrally to any of these other planes as you wish, but only if you know your way (see below).

You can bring other willing creatures with you, provided that these subjects have each manifested astral traveler and are linked hand to hand with you at the time of the astral caravan 's manifestation. These fellow travelers are dependent upon you and must accompany you at all times. If something happens to you during the journey that causes you to break hand-to-hand contact, your companions are stranded wherever you leave them. Because the planes are a dangerous place, those who lead astral caravans usually choose to manifest this power only if they have a large party of travelers assembled. Sometimes groups of lower-level adventurers may hire you to lead forays beyond the Material Plane.

The astral caravan power lasts while you and your fellow travelers maintain your original formation, until (1) you reach your intended destination plane, (2) you desire to end the power while still traversing the Astral Plane, (3) you or anyone traveling with you breaks the hand-to-hand chain connecting the travelers for 2 consecutive rounds, or (4) the power is terminated by some outside means, such as dispel psionics . When the power ends, you and your fellow travelers halt in whatever portion of the Astral Plane you happen to be traversing (the Astral Plane is in many ways subjective in location; in any event, one place on the Astral looks much like any other).

While you are traveling through the Astral Plane, those natives who happen to glimpse you and your fellow travelers perceive you to be moving at a speed of 30 feet (you can't run), with you flying in the lead and your fellow travelers strung out behind you, each linked to the next by one hand.

Depending on your knowledge of the planes, your journey through the subjective space that is the Astral Plane may take a longer or shorter period of time. For each 24 hours you travel, make a Knowledge (planes) check. Unless a location is particularly hard to find and well guarded, or conversely easy to find and well advertised, the average DC for an astral caravan journey should be set at 20. You cannot take 20 on this check, though you can take 10. Each check may be modified by your degree of familiarity with the destination or by some connection you have with the place; see the following tables.

*If you have no direct knowledge of your destination, you must have some connection to it in order to travel there; see below.

Each successful check indicates that you are one step closer to your goal. To finally arrive at your location, you must succeed on six checks within a span of 12 days. (If you fail to make six successful checks within the first 12 days, you can continue to make one check per day until you get the requisite six successes within a span of 12 consecutive days). When you successfully make the requisite number of checks, the journey ends, and you appear on your chosen plane within 10–1,000 (1d% x 10) miles of your intended destination on that plane.

Augment: If you spend 2 additional power points, this power weaves a quasi-real filmy membrane around yourself and all those adjacent to each other in the caravan (being linked by hand is not required if this membrane is used). You remain visible within the translucent, amorphous enclosure. You can pick up or drop willing passengers, easily reaching through the film. Anything you hold is enveloped by the film. Any attacks made through the enclosure in either direction have a 25% miss chance due to the rippling membrane.

When you manifest this power in its augmented form, your apparent speed to those observing on the Astral Plane is 40 feet, and you can make a Knowledge (planes) check once every 12 hours to attempt to make it to your destination (six successful checks within 12 consecutive days still sees you to your desired goal).

Astral Caravan (Mythic)[]

You can take an additional number of companions equal to your mythic tier, and the manifester level check to dispel your mythic astral caravan is increased by an amount equal to your mythic tier. If a mythic creature using mythic astral caravan has its astral body killed, it may expend one use of its mythic power to gain only one permanent negative level rather than two.

Augmented (6th): If you expend one additional use of mythic power per creature, you can surround each of the physical bodies of creatures left behind within an individual wall of force that lasts as long as the mythic astral caravan does unless it is destroyed.`
  },
  Delayed_Response: {
    name: "Delayed Response",
    discipline: "Psychoportation",
    level: "Highlord 3, nomad 3, tactician 3, voyager 3",
    display: "Auditory, Mental",
    manifestingTime: "1 immediate action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You force the target to delay their action until after the next creature in the initiative order takes their action unless the target makes a successful Will save. You must manifest this power before the results of the creature's actions are determined. This may result in the creature's action being invalid, such as attacking a target that has moved, in which case the action is wasted. If the target was manifesting a power or casting a spell, they do not need to make a concentration check.

Augment: For every 3 additional power points you spend, the target's action is delayed until after an additional creature in the initiative order.`
  },
  Gravitational_Anchor: {
    name: "Gravitational Anchor",
    discipline: "Psychoportation",
    level: "Marksman 3, nomad 3, voyager 3",
    display: "Material, Olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature, object, or location; see text",
    area: "10 ft. radius burst",
    duration: "1 round / level",
    savingThrow: "Reflex negates; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You generate an increased gravity field at a single point within range, pulling creatures and objects downward. The targeted point can be a creature or unattended object, but if so, the target is allowed a Reflex save to negate the effect.

Each creature moving or attacking within the affected area must make a Reflex Save each round or be affected by the effects of the gravity field for that round. The increased gravity field inflicts a -2 penalty on all non-ray attack that pass through the affected area (even ranged attacks originated by or targeting creatures outside of the field), and all movement through the affected area counts as difficult terrain. Creatures attempting to fly or levitate in the field are forcibly dragged down 20 ft. per round at the end of their turn. Any creature that falls more than 10 ft. in the field that strikes the ground takes double damage from the fall. In addition, trip attempts gain a +2 circumstance bonus, rather than the -2 penalty, against affected targets within the field.

Creatures benefiting from Stability or Personal Gravity, such as an elocater, gain a +4 bonus to their saving throw.`
  },
  Expulsion: {
    name: "Expulsion",
    discipline: "Psychoportation",
    level: "Nomad 4, voyager 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One extraplanar creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You force an extraplanar creature back to its proper plane if it fails a Will save. If the manifestation is successful, the creature is instantly whisked away, but there is a 20% chance of actually sending the subject to a plane other than its own.

Mythic Expulsion[]

If the target is a non-mythic extraplanar creature, it receives no saving throw to avoid being sent back to its proper plane, and there is no chance it will be sent back to plane other than its own. A mythic creature gains a saving throw to resist the power, but you may add your mythic tier to manifester level checks to overcome its power resistance.`
  },
  Flight: {
    name: "Flight",
    discipline: "Psychoportation",
    level: "Gambler 4, nomad 4, voyager 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You can fly at a speed of 60 feet (or 40 feet if you wear medium or heavy armor, or if you carry a medium or heavy load). You can ascend at half speed and descend at double speed, and your maneuverability is good. Using this power requires only as much concentration as walking, so you can attack or manifest normally. You can charge but not run, and you cannot carry aloft more weight than your maximum load, plus any armor you wear. You gain a bonus on Fly skill checks equal to 1/2 your manifester level.

Should the duration expire while you are still aloft, the power fails slowly. You float downward 60 feet per round for 1d6 rounds. If you reach the ground in that amount of time, you lands safely. If not, you fall the rest of the distance, taking 1d6 points of damage per 10 feet of fall. Since dispelling a power effectively ends it, you also descend safely in this way if the power is dispelled, but not if it is negated by a null psionics field .

Mythic Flight[]

The fly speed changes to 120 feet (or 80 feet if wearing medium or heavy armor, or carrying a medium or heavy load) with perfect maneuverability. When the duration expires, you are protected by catfall for a number of rounds equal to your manifester level.

Augmented (3rd): If you expend two uses of mythic power, you add your tier on Reflex saves and as a dodge bonus to AC. You gain these bonuses only while flying.`
  },
  Wrench: {
    name: "Wrench",
    discipline: "Psychoportation",
    level: "Nomad 4, voyager 4",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "1 min./level",
    savingThrow: "None",
    powerResistance: "Yes (object)",
    powerPoints: "7",
    description: `Effect: Ray

A green ray springs from your hand. You must make a ranged touch attack to hit the target. Any creature or object struck by the ray is covered with a shimmering field that completely blocks extradimensional travel, wrenching it fully in its current planar location. Forms of movement barred by this include astral projection , blink , dimension door , ethereal form , ethereal jaunt , etherealness , gate , maze , plane shift , teleport , and similar abilities. The power also prevents the use of a gate or teleportation circle for the duration.

Wrench does not interfere with the movement of creatures already in ethereal or astral form when the power is manifested, nor does it block extradimensional perception or attack forms. Also, wrench does not prevent summoned creatures from disappearing at the end of a summoning power.`
  },
  Baleful_Teleport_Kolbjorn_s: {
    name: "Baleful Teleport, Kolbjorn's",
    discipline: "Psychoportation (Teleportation)",
    level: "Gambler 5, Nomad 5, voyager 5",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One corporeal creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude half",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `You psychoportively disperse minuscule portions of the subject, dealing 9d6 points of damage. Targets can be protected from the effects of this power by wrench .

Augment: For every additional power point you spend, this power's damage increases by 1d6 points. For each extra 2d6 points of damage, this power's save DC increases by 1 and your manifester level increases by 1 for the purpose of overcoming power resistance.

Baleful Teleport, Kolbjorn's (Mythic)[]

The range increases to 100 feet + 10 feet per level. Non-mythic manifestations of wrench do not protect the target from the effect.

Augmented: If you expend one use of mythic power, the effect deals damage using d10s instead of d6s.

Augmented (3rd): If you expend two uses of mythic power, you can target up to your tier in creatures to affect.`
  },
  Gravitic_Charge: {
    name: "Gravitic Charge",
    discipline: "psychoportation",
    level: "marksman 4, nomad 5, voyager 5",
    display: "",
    manifestingTime: "1 standard action",
    range: "long (400 feet + 40 feet/level), see text",
    target: "1 creature or object",
    area: "",
    duration: "1 round/level",
    savingThrow: "Fortitude negates (affects objects), see text",
    powerResistance: "yes",
    powerPoints: "marksman 7, nomad 9, voyager 9",
    description: `Display material: , olfactory

You immensely increase the mass of an object, causing other objects to fall towards it. On a failed save, all creatures and objects within 40 feet of the target move towards the target each round as if affected by a bull rush combat maneuver in the direction of the target (CMB = 5 + your manifester level + your manifesting ability modifier). If creatures are within the area of effect of two Gravitic Charge powers, they are pulled apart by the combating forces, taking 5d6 points of damage each so long as they remain in the area (Fortitude negates).

If used in an environment of no gravity, this power can be used on an object to grant it a normal gravity field out to 40 feet. Creatures can walk along it as if it was ground acting in normal gravity, although oblong shapes in the structure may cause certain parts to be treated as difficult terrain. This power is often used upon starships to simulate baseline gravity.

Augment: You may augment this power in the following ways:

• For every 2 power points you spend, the gravity field's range increases by 10 feet, the save DCs increase by 1, and the CMB increases by 1

• If you spend 6 additional power points, you may grant a target a gravity field even within areas that possess gravity. Creatures within this gravity field ignore any gravity possessed by objects or entities outside the field.`
  },
  Psychoport: {
    name: "Psychoport",
    discipline: "Psychoportation (Teleportation)",
    level: "Nomad 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Psychoport[]

Target or Targets: You and touched objects or other touched willing creatures

Resistance: No or Yes (object)

This power instantly transports you to a designated destination, which may be as distant as 100 miles per manifester level. Interplanar travel is not possible. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. As with all powers where the range is personal and the target is you, you need not make a saving throw, nor is power resistance applicable to you. Only objects held or in use (attended) by another person receive saving throws and power resistance.

You must have some clear idea of the location and layout of the destination. The clearer your mental image, the more likely the teleportation works. Areas of strong physical or psionic energy may make teleportation more hazardous or even impossible.

To see how well the teleportation works, roll d% and consult the table at the end of this power. Refer to the following information for definitions of the terms on the table.

Familiarity : “Very familiar” is a place where you have been very often and where you feel at home. “Studied carefully” is a place you know well, either because you can currently physically see it or you've been there often. “Seen casually” is a place that you have seen more than once but with which you are not very familiar. “Viewed once” is a place that you have seen once, possibly using powers such as remote viewing .

“False destination” is a place that does not truly exist or if you are teleporting to an otherwise familiar location that no longer exists as such or has been so completely altered as to no longer be familiar to you. When traveling to a false destination, roll 1d20+80 to obtain results on the table, rather than rolling d%, since there is no real destination for you to hope to arrive at or even be off target from.

On Target : You appear where you want to be.

Off Target : You appear safely a random distance away from the destination in a random direction. Distance off target is d% of the distance that was to be traveled. The direction off target is determined randomly.

Similar Area : You wind up in an area that's visually or thematically similar to the target area. Generally, you appear in the closest similar place within range. If no such area exists within the power's range, the power simply fails instead.

Mishap : You and anyone else teleporting with you have gotten “scrambled.” You each take 1d10 points of damage, and you reroll on the chart to see where you wind up. For these rerolls, roll 1d20+80. Each time “Mishap” comes up, the characters take more damage and must reroll.

Augment: For every 2 additional power points you spend, consider the familiarity of a location 1 step better, with the exception of a false destination, which is always considered a false destination.

Psychoport, Greater[]

As psychoport, except that there is no range limit and there is no chance you arrive off target. In addition, you need not have seen the destination, but in that case you must have at least a reliable description of the place to which you are teleporting. If you attempt to teleport with insufficient information (or with misleading information), you disappear and simply reappear in your original location. Interplanar travel is not possible.

Interplanetary Psychoport[]

This functions as greater psychorport , except there is truly no range limit and you do not need to have seen your destination, though you must have a solid grasp of which world you wish to travel to (“the third planet from the sun” is an acceptable destination, but “a habitable world near that bright star” is not). If you have a specific location on a planet in mind, you arrive there without a chance of failure; otherwise you arrive at a location that would not immediately be life-threatening. If no such safe landing zone exists on the world, such as someone attempting to travel into the sun without the proper precautions in place, the power simply fails.

Psychoport Trigger[]

You specify a situation that triggers your automatic manifestation of a psychoport, taking you to a predetermined location. You must know the psychoport power and have sufficient power points to manifest it when the specified situation occurs.

The psychoport trigger goes off on the initiative count immediately after the specified situation occurs, even if you are flat-footed or you have already taken your turn in the current round. The specified situation can be described in general terms or specific terms.

Psychoportation Circle[]

Effect: 5-ft.-radius circle that teleports those who activate it

You create a circle on the floor or other horizontal surface that teleports, as greater psychoport , any creature who stands on it to a designated spot. Once you designate the destination for the circle, you can't change it. The power fails if you attempt to set the circle to teleport creatures into a solid object, to a place with which you are not familiar and have no clear description, or to another plane.

The circle itself is subtle and nearly impossible to notice. If you intend to keep creatures from activating it accidentally, you need to mark the circle in some way.

Magic traps such as psychoportation circle are hard to detect and disable. A character with the trapfinding class feature can use the Disable Device to disarm magic traps. The DC in each case is 25 + spell level, or 34 in the case of psychoportation circle .`
  },
  Psychoport_Trigger: {
    name: "Psychoport Trigger",
    discipline: "Psychoportation (Teleportation)",
    level: "Nomad 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Psychoport[]

Target or Targets: You and touched objects or other touched willing creatures

Resistance: No or Yes (object)

This power instantly transports you to a designated destination, which may be as distant as 100 miles per manifester level. Interplanar travel is not possible. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. As with all powers where the range is personal and the target is you, you need not make a saving throw, nor is power resistance applicable to you. Only objects held or in use (attended) by another person receive saving throws and power resistance.

You must have some clear idea of the location and layout of the destination. The clearer your mental image, the more likely the teleportation works. Areas of strong physical or psionic energy may make teleportation more hazardous or even impossible.

To see how well the teleportation works, roll d% and consult the table at the end of this power. Refer to the following information for definitions of the terms on the table.

Familiarity : “Very familiar” is a place where you have been very often and where you feel at home. “Studied carefully” is a place you know well, either because you can currently physically see it or you've been there often. “Seen casually” is a place that you have seen more than once but with which you are not very familiar. “Viewed once” is a place that you have seen once, possibly using powers such as remote viewing .

“False destination” is a place that does not truly exist or if you are teleporting to an otherwise familiar location that no longer exists as such or has been so completely altered as to no longer be familiar to you. When traveling to a false destination, roll 1d20+80 to obtain results on the table, rather than rolling d%, since there is no real destination for you to hope to arrive at or even be off target from.

On Target : You appear where you want to be.

Off Target : You appear safely a random distance away from the destination in a random direction. Distance off target is d% of the distance that was to be traveled. The direction off target is determined randomly.

Similar Area : You wind up in an area that's visually or thematically similar to the target area. Generally, you appear in the closest similar place within range. If no such area exists within the power's range, the power simply fails instead.

Mishap : You and anyone else teleporting with you have gotten “scrambled.” You each take 1d10 points of damage, and you reroll on the chart to see where you wind up. For these rerolls, roll 1d20+80. Each time “Mishap” comes up, the characters take more damage and must reroll.

Augment: For every 2 additional power points you spend, consider the familiarity of a location 1 step better, with the exception of a false destination, which is always considered a false destination.

Psychoport, Greater[]

As psychoport, except that there is no range limit and there is no chance you arrive off target. In addition, you need not have seen the destination, but in that case you must have at least a reliable description of the place to which you are teleporting. If you attempt to teleport with insufficient information (or with misleading information), you disappear and simply reappear in your original location. Interplanar travel is not possible.

Interplanetary Psychoport[]

This functions as greater psychorport , except there is truly no range limit and you do not need to have seen your destination, though you must have a solid grasp of which world you wish to travel to (“the third planet from the sun” is an acceptable destination, but “a habitable world near that bright star” is not). If you have a specific location on a planet in mind, you arrive there without a chance of failure; otherwise you arrive at a location that would not immediately be life-threatening. If no such safe landing zone exists on the world, such as someone attempting to travel into the sun without the proper precautions in place, the power simply fails.

Psychoport Trigger[]

You specify a situation that triggers your automatic manifestation of a psychoport, taking you to a predetermined location. You must know the psychoport power and have sufficient power points to manifest it when the specified situation occurs.

The psychoport trigger goes off on the initiative count immediately after the specified situation occurs, even if you are flat-footed or you have already taken your turn in the current round. The specified situation can be described in general terms or specific terms.

Psychoportation Circle[]

Effect: 5-ft.-radius circle that teleports those who activate it

You create a circle on the floor or other horizontal surface that teleports, as greater psychoport , any creature who stands on it to a designated spot. Once you designate the destination for the circle, you can't change it. The power fails if you attempt to set the circle to teleport creatures into a solid object, to a place with which you are not familiar and have no clear description, or to another plane.

The circle itself is subtle and nearly impossible to notice. If you intend to keep creatures from activating it accidentally, you need to mark the circle in some way.

Magic traps such as psychoportation circle are hard to detect and disable. A character with the trapfinding class feature can use the Disable Device to disarm magic traps. The DC in each case is 25 + spell level, or 34 in the case of psychoportation circle .`
  },
  Banish: {
    name: "Banish",
    discipline: "Psychoportation",
    level: "Gambler 6, nomad 6",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `Targets: One or more extraplanar creatures, no two of which can be more than 30 ft. apart

You force extraplanar creatures out of your home plane. As many as 2 Hit Dice of creatures per manifester level can be banished.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1 and your manifester level increases by 1 for the purpose of overcoming power resistance.

Banish (Mythic)[]

If the target is a non-mythic extraplanar creature, it receives no saving throw to avoid being sent back to its proper plane, and there is no chance it will be sent back to plane other than its own. A mythic creature gains a saving throw to resist the power, but you may add your mythic tier to manifester level checks to overcome its power resistance.`
  },
  Reposition: {
    name: "Reposition",
    discipline: "Psychoportation (Teleportation) [Network]",
    level: "Highlord 6, nomad 6, tactician 6, voyager 6",
    display: "Auditory, Material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "1 willing creature / 2 levels",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless); see text; Power",
    powerResistance: "",
    powerPoints: "11",
    description: `Resistance: Yes (harmless); see text

You instantly reposition each willing target anywhere within Medium range (100 ft. + 10 ft./level) from your location to which you have line of effect. This does not provoke attacks of opportunity for the creatures moved. The destination must be a valid space; this power cannot reposition creatures inside of another creature, a boulder, or some other solid structure, etc., although it could reposition a creature through a wall, as long as the manifester has line of effect to the destination, or reposition a creature underwater, midair, or over a bonfire. Attempts to reposition a creature into a harmful situation allow the creature a save.

Augment: This power may be augmented in the following ways.

• If you spend 6 additional power points, you may target unwilling creatures.

• If you spend 8 additional power points, you may manifest this power as an immediate action.`
  },
  Dream_Travel: {
    name: "Dream Travel",
    discipline: "Psychoportation",
    level: "Dread 6, nomad 7, voyager 6",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "Dread 11, nomad 13, voyager 11",
    description: `Targets: You and touched creature or creatures (up to one/level)

You and any creature you touch are drawn along a crystal arc of reverie to the edge of conscious thought and into the region of dreams. You can take more than one creature along with you (subject to your level limit), but each one must be touching another one. You physically enter the land of dreams, leaving nothing behind.

In the region of dreams, you move through a menagerie of thoughts, desires, and phantoms created by the minds of dreamers everywhere. For every minute you move through dream, you can “wake” to find yourself five miles displaced in the waking world. Thus, a character can use this power to travel rapidly by physically entering where only dreams normally prowl, moving the desired distance, and then stepping back into the waking world. You know where you will come out in the waking world.

Dream travel can also be used to travel to the Dreamscape and other planes that contain creatures that dream, but doing this requires crossing into the dreams of outsiders, where you are subject to the vagaries of many dream realities—a potentially perilous proposition. Transferring to another plane of existence in this fashion requires 1d4 hours of uninterrupted travel.

Any creatures that come along when dream travel is manifested also make the transition to the borders of unconscious thought. A creature separated from you wanders off into the dreamscape. When the duration ends, all affected creatures return to the waking world as much as 1,000 miles (d%x10) from their starting point. If a creature remains in the dreamscape, it is powerless to leave unless it can manifest the dream travel power itself or someone who manifests the power seeks out the lost creature.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Ethereal_Form: {
    name: "Ethereal Form",
    discipline: "Psychoportation",
    level: "Psion/wilder 9",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "You",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes (harmless)",
    powerPoints: "17",
    description: `Ethereal Form[]

You become ethereal, along with your equipment. For the duration of the power, you are in the Ethereal Plane, which overlaps the Material Plane. When the power expires, you return to material existence.

An ethereal creature is invisible, insubstantial, and capable of moving in any direction, even up or down, albeit at half normal speed. As an insubstantial creature, you can move through solid objects, including living creatures. An ethereal creature can see and hear on the Material Plane, but everything looks gray and ephemeral. Sight and hearing onto the Material Plane are limited to 60 feet.

Force effects and abjurations affect an ethereal creature normally. Their effects extend onto the Ethereal Plane from the Material Plane, but not vice versa. An ethereal creature can't attack material creatures, and powers you manifest while ethereal affect only other ethereal things. Certain material creatures or objects have attacks or effects that work on the Ethereal Plane.

Treat other ethereal creatures and ethereal objects as if they were material.

If you end the power and become material while inside a material object (such as a solid wall), you are shunted off to the nearest open space and take 1d6 points of damage per 5 feet that you so travel.

Ethereal Form, Greater[]

Targets: You and one other touched willing creature/three levels; all targets must be joined by linked hands

This power functions like ethereal form , except that you and other willing creatures joined by linked hands (along with their equipment) become ethereal. Besides yourself, you can bring one creature per three manifester levels to the Ethereal Plane. Once ethereal, the subjects need not stay together.

When the power expires, all affected creatures on the Ethereal Plane return to material existence.

If you end the power or the power ends normally and any of the affected creatures including you become material while inside a material object (such as a solid wall), that creature or creatures are shunted off to the nearest open space and take 1d6 points of damage per 5 feet shunted.

Mythic Ethereal Form[]

While using this power, you can shift into the Material Plane as if using mythic blink, as described in Pathfinder Roleplaying Game Mythic Adventures. If you are 3rd tier or higher, you can spend two points of mythic power to use the augmented effect of mythic blink. If you remain completely ethereal, you gain energy resistance equal to twice your mythic tier against force effects.

Mythic Greater Ethereal Form[]

Creatures using this power can shift into the Material Plane as if using mythic blink , as described in Pathfinder Roleplaying Game Mythic Adventures . If your mythic tier is at least 3rd, you can spend two uses of your mythic power to use the augmented version of mythic blink . If you remain completely ethereal, you gain energy resistance equal to twice your mythic tier against force effects.`
  },
  Time_Hop_Mass: {
    name: "Time Hop, Mass",
    discipline: "Psychoportation",
    level: "Nomad 8",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Up to 1 hour/level; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `Time Hop[]

Targets: One Medium or smaller creature, or one object weighing 300 lb. or less

The subject of the power hops forward in time 1 round for every manifester level you have. In effect, the subject seems to disappear in a shimmer of silver energy, then reappear after the duration of this power expires. The subject reappears in exactly the same orientation and condition as before. From the subject's point of view, no time has passed at all.

In each round of the power's duration, on what would have been the subject's turn, it can attempt a DC 15 Wisdom check. Success allows the subject to return. The subject can act normally on its next turn after this power ends.

If the space from which the subject departed is occupied upon his return to the time stream, he appears in the closest unoccupied space, still in his original orientation. Determine the closest space randomly if necessary.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, you can affect a creature of one size category larger, or double the weight of an object to be affected.

• For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Time Hop, Mass[]

Targets: All willing creatures in range

As time hop , except you can affect any number of willing subjects in range, including yourself. You can choose which creatures are affected by the power. The subjects hop forward in time a number of hours equal to your manifester level, or some shorter number of hours; you decide how many hours the mass time hop lasts when you manifest the power.

Augment: If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Psychoportation_Circle: {
    name: "Psychoportation Circle",
    discipline: "Psychoportation (Teleportation)",
    level: "Nomad 9",
    display: "Mental",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "You",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `Psychoport[]

Target or Targets: You and touched objects or other touched willing creatures

Resistance: No or Yes (object)

This power instantly transports you to a designated destination, which may be as distant as 100 miles per manifester level. Interplanar travel is not possible. You can bring along objects as long as their weight doesn't exceed your maximum load. You may also bring one additional willing Medium or smaller creature (carrying gear or objects up to its maximum load) or its equivalent per three manifester levels. A Large creature counts as two Medium creatures, a Huge creature counts as four Medium creatures, and so forth. All creatures to be transported must be in contact with one another, and at least one of those creatures must be in contact with you. As with all powers where the range is personal and the target is you, you need not make a saving throw, nor is power resistance applicable to you. Only objects held or in use (attended) by another person receive saving throws and power resistance.

You must have some clear idea of the location and layout of the destination. The clearer your mental image, the more likely the teleportation works. Areas of strong physical or psionic energy may make teleportation more hazardous or even impossible.

To see how well the teleportation works, roll d% and consult the table at the end of this power. Refer to the following information for definitions of the terms on the table.

Familiarity : “Very familiar” is a place where you have been very often and where you feel at home. “Studied carefully” is a place you know well, either because you can currently physically see it or you've been there often. “Seen casually” is a place that you have seen more than once but with which you are not very familiar. “Viewed once” is a place that you have seen once, possibly using powers such as remote viewing .

“False destination” is a place that does not truly exist or if you are teleporting to an otherwise familiar location that no longer exists as such or has been so completely altered as to no longer be familiar to you. When traveling to a false destination, roll 1d20+80 to obtain results on the table, rather than rolling d%, since there is no real destination for you to hope to arrive at or even be off target from.

On Target : You appear where you want to be.

Off Target : You appear safely a random distance away from the destination in a random direction. Distance off target is d% of the distance that was to be traveled. The direction off target is determined randomly.

Similar Area : You wind up in an area that's visually or thematically similar to the target area. Generally, you appear in the closest similar place within range. If no such area exists within the power's range, the power simply fails instead.

Mishap : You and anyone else teleporting with you have gotten “scrambled.” You each take 1d10 points of damage, and you reroll on the chart to see where you wind up. For these rerolls, roll 1d20+80. Each time “Mishap” comes up, the characters take more damage and must reroll.

Augment: For every 2 additional power points you spend, consider the familiarity of a location 1 step better, with the exception of a false destination, which is always considered a false destination.

Psychoport, Greater[]

As psychoport, except that there is no range limit and there is no chance you arrive off target. In addition, you need not have seen the destination, but in that case you must have at least a reliable description of the place to which you are teleporting. If you attempt to teleport with insufficient information (or with misleading information), you disappear and simply reappear in your original location. Interplanar travel is not possible.

Interplanetary Psychoport[]

This functions as greater psychorport , except there is truly no range limit and you do not need to have seen your destination, though you must have a solid grasp of which world you wish to travel to (“the third planet from the sun” is an acceptable destination, but “a habitable world near that bright star” is not). If you have a specific location on a planet in mind, you arrive there without a chance of failure; otherwise you arrive at a location that would not immediately be life-threatening. If no such safe landing zone exists on the world, such as someone attempting to travel into the sun without the proper precautions in place, the power simply fails.

Psychoport Trigger[]

You specify a situation that triggers your automatic manifestation of a psychoport, taking you to a predetermined location. You must know the psychoport power and have sufficient power points to manifest it when the specified situation occurs.

The psychoport trigger goes off on the initiative count immediately after the specified situation occurs, even if you are flat-footed or you have already taken your turn in the current round. The specified situation can be described in general terms or specific terms.

Psychoportation Circle[]

Effect: 5-ft.-radius circle that teleports those who activate it

You create a circle on the floor or other horizontal surface that teleports, as greater psychoport , any creature who stands on it to a designated spot. Once you designate the destination for the circle, you can't change it. The power fails if you attempt to set the circle to teleport creatures into a solid object, to a place with which you are not familiar and have no clear description, or to another plane.

The circle itself is subtle and nearly impossible to notice. If you intend to keep creatures from activating it accidentally, you need to mark the circle in some way.

Magic traps such as psychoportation circle are hard to detect and disable. A character with the trapfinding class feature can use the Disable Device to disarm magic traps. The DC in each case is 25 + spell level, or 34 in the case of psychoportation circle .`
  },
  Time_Regression: {
    name: "Time Regression",
    discipline: "Psychoportation",
    level: "Nomad 9",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "17",
    description: `You can regress apparent time 1 round into the past. In effect, you “replay” the previous round of activity. The power regresses time to the point along the time stream just prior to your previous turn, undoing the effects of everyone else's actions in the meantime. Once you have used time regression, only you retain knowledge of what happened during the round that is being replayed; however, you can communicate that knowledge verbally to your companions, if desired. During the round that you live through a second time, you can act on knowledge you previously gained by already living through the immediate future. In all likelihood, you'll probably not choose to manifest time regression during your second pass through the time stream, instead taking completely new actions.

Altering the time stream in such a fashion is mentally taxing and you suffer 2 points of ability damage to Charisma, Intelligence, and Wisdom. This damage cannot be ignored through any special effects or abilities, but can be healed as any other ability damage.`
  },
  Beckoning: {
    name: "Beckoning",
    discipline: "Clairsentience (Calling)",
    level: "Seer 1",
    display: "Mental",
    manifestingTime: "1 minute",
    range: "100 miles",
    target: "up to 20 entities of 6 HD or fewer; see text",
    area: "",
    duration: "instantaneous",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "1",
    description: `A psychic signal emanates to all creatures of specific type out to a 100-mile radius, which can be delivered to up to 20 such creatures, starting with the nearest creatures until the limit has been met. This power can't contact creatures with more than 6 Hit Dice. You can't send a specific message, but this power can be characterized as an open invitation to make contact and establish communication.

If there is an appropriate entity within range, the power succeeds automatically. You don't know whether the message was received, nor any specific details about what creatures received it or how many. Creatures that receive the message know the location and distance from where the power was manifested. Because this power doesn't call or summon the target, the target must have its own way to reach the place where the spell was cast.

How creatures respond to a beckoning power is circumstantial and it is possible the creatures will simply ignore the power. Creatures that come and investigate do so in their own time. They usually arrive cautiously, aware of the potential for ambush. Targets of the power might inform their organization or community if they have one. There are no restrictions on how the creatures react to being contacted, and they might respond with hostility, parley, entertain an alliance, or subjugate the manifester and their related community.

Using this power counts as mentally contacting the creature for the purpose of any of its special abilities (such as the star-spawn of Cthulhu's overwhelming mind). For the purpose of powers like remote viewing, the creature has firsthand knowledge of you and a connection similar to if it possessed a likeness of you.

Augment

• If you spend 2 additional power points, the range of this power increases to 200 miles. 4 points increases the range to 500 miles, while 6 points increases the range to infinite on the same plane. 8 points enables this power to work across planes

• If you spend 10 additional power points, you may choose to have this power act not only as a signal, but as a passage for creatures you contact. One creature that hears this ability may teleport immediately to the location of the manifester as an immediate action if it so chooses. This causes the power to gain the [teleportation] descriptor.

• For every 2 power points you spend beyond this, you may transport one additional creature

• If you spend 6 additional power points, you may manifest this power as an immediate action

• For every additional power point you spend augmenting this power (including as part of other augments), you may beckon creatures with 2 additional hit dice.`
  },
  Destiny_Dissonance: {
    name: "Destiny Dissonance",
    discipline: "Clairsentience",
    level: "Gambler 1, seer 1, sighted seeker 1, voyager 1",
    display: "Material and mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "1 round/level",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `Your mere touch grants your foe an imperfect, unfocused glimpse of the many possible futures in store. Unaccustomed to and unable to process the information, the subject becomes sickened for 1 round per level of the manifester if you succeed on a melee touch attack.

Mythic Destiny Dissonance[]

If you succeed on the melee touch attack, the target is dazed for the first round of the effect, and sickened for the remaining rounds. The duration increases to 2 rounds per manifester level.`
  },
  Precognition: {
    name: "Precognition",
    discipline: "Clairsentience",
    level: "Cryptic 1, gifted blade 1, highlord 1, psychic warrior 1, tactician 1, voyager 1",
    display: "Auditory, Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Precognition[]

Precognition allows your mind to glimpse fragments of potential future events—what you see will probably happen if no one takes action to change it. However, your vision is incomplete, and it makes no real sense until the actual events you glimpsed begin to unfold. That's when everything begins to come together, and you can act, if you act swiftly, on the information you previously received when you manifested this power.

In practice, manifesting this power grants you a “precognitive edge.” Normally, you can have only a single precognitive edge at one time. You must use your edge within a period of no more than 10 minutes per level, at which time your preknowledge fades and you lose your edge.

You can use your precognitive edge in a variety of ways. Essentially, the edge translates into a +2 insight bonus that you can apply at any time to either an attack roll, a damage roll, a saving throw, or a skill check. You can elect to apply the bonus to the roll after you determine that your unmodified roll is lower than desired.

Precognition, Defensive[]

Your awareness extends a fraction of a second into the future, allowing you to better evade an opponent's blows.

You gain a +1 insight bonus to AC and on all saving throws. If caught in a situation where your Dexterity bonus isn't applied to your Armor Class, this bonus to AC and saving throws does not apply.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Greater[]

As precognition, except as noted here. You gain a +4 insight bonus instead of a +2 bonus, and the effect is not discharged when used. You may only gain a number of precognitive edges per manifestation equal to your manifester level.

Precognition, Offensive[]

Your awareness extends a fraction of a second into the future, allowing you to better land blows against your opponent. You gain a +1 insight bonus on your attack rolls.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained on your attack rolls increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Tactical[]

Your awareness extends a fraction of a second into the future, allowing you to better perform a particular combat maneuver. Select one type of combat maneuver, such as bull rush or reposition, when you manifest this power. You gain a +2 enhancement bonus to combat maneuver checks of that type for the duration of the effect.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, the enhancement bonus increases by 1.

• For every 3 additional power points you spend, you can select an additional type of combat maneuver.

• If you spend 4 additional power points, using the combat maneuver selected does not provoke attacks of opportunity.

• If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Psychic_Tracking: {
    name: "Psychic Tracking",
    discipline: "Clairsentience",
    level: "Seer 1, sighted seeker 1, voyager 1",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `You can track creatures with an Intelligence score of 3 or greater by following the trails of mental energy they leave behind. Pass without trace and similar effects provide no protection from this power; however, creatures immune to mind-affecting effects leave no perceptible psychic tracks, and cannot be followed this way.

Finding psychic tracks or following them for 1 mile requires a DC 20 Spellcraft check. Every time the tracks become difficult to follow (such as when they intersect with other psychic tracks, enter an area of heavy traffic such as a market, or backtrack and diverge), you must make another check. If you fail a Spellcraft check, you can retry by meditating for 10 minutes (low traffic) 1 hour (high traffic) .

While tracking, you move at half your normal speed. You may move up to your normal speed by taking a -5 penalty on the Spellcraft check, or double your speed by taking a -20 penalty on the Spellcraft check.

Augment: For every additional power point you spend, you gain a +2 bonus on your Spellcraft checks to follow psychic tracks.`
  },
  Bore: {
    name: "Bore",
    discipline: "Clairsentience",
    level: "Cryptic 2, seer 2",
    display: "Material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One touched solid surface",
    area: "",
    duration: "Concentration up to 1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `The seemingly impenetrable solid surface before you frosts over with a sheet of ice crystals which upon deeper inspection can be seen to hold images of another place. You can manifest this power on a wall, door, or similar surface, creating a virtual pinhole through to the other side. This hole is up to one inch in diameter and is only visible from your side of the surface. You can see through this hole but not hear through it, nor can you pass items through the crystals.

This power does not provide illumination to the other side, but alternate means of vision such as darkvision function as expected. Also, the vision of the other side is tuned to your psyche, providing only a scrambled blur of color to anyone other than you who attempts to see through.

Bore is blocked by stone thicker than 1 foot, common metal thicker than one inch, a thin sheet of lead, or by wood or dirt thicker than 3 feet.

Augment: For each additional five power points you spend, the thickness of the materials bore can penetrate are doubled.

Mythic Bore

You may create a number of holes equal to your mythic tiers. All of these holes must be within 5 feet of the original but they now function for creatures other than you.`
  },
  Clairvoyant_Sense_Dyne_s: {
    name: "Clairvoyant Sense, Dyne's",
    discipline: "clairsentience (scrying)",
    level: "seer 7",
    display: "auditory and visual",
    manifestingTime: "1 standard action",
    range: "see text",
    target: "",
    area: "",
    duration: "1 hour/level",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "13",
    description: `Clairvoyant Sense, Dyne's[]

Effect: Psionic sensor

You can see and hear a distant location almost as if you were there. You don't need line of sight or line of effect, but the locale must be known—a place familiar to you or an obvious one, such as behind a door, around a corner, or in a grove of trees. Once you have selected the locale, the focus of your clairvoyant sense doesn't move, but you can rotate it in all directions to view the area as desired. Unlike other scrying powers, this power does not allow psionically or supernaturally enhanced senses to work through it.

If the chosen locale is magically or psionically dark, you see nothing. If it is naturally pitch black, you can see in a 10- foot radius around the center of the power's effect or out to the extent of your natural darkvision. The power does not work across planes.

Cosmic Perspective[]

Effect: psionic sensor

This power functions as clairvoyant sense , save that supernaturally enhanced senses operate through the psionic sensor and the sensor is capable of moving at a speed of 60 feet per round. In addition, the sensor gains the ability to fly at phenomenal speeds, able to move between two planets within a solar system in 1d4 minutes and beyond that in 1d4 hours. The locations the sensor moves to need not be familiar ones, and this power is often used to explore uncharted territory throughout the universe.

Augment: If you spend 4 additional power points, you may manifest powers through the Cosmic Perspective as if you were in the location.

Mythic Dyne's Clairvoyant Sense[]

When you scry into a naturally darkened area, increase the distance you can see by 5 feet times your mythic tier. You may also see half this distance within magical darkness, as long as the darkness was created by an effect of 3rd level or lower. You can scry into an area that is warded against scrying by a non-mythic effect by succeeding on a manifester level check with a bonus equal to your mythic tier against a DC of 11 plus the manifester level of the ward against scrying.`
  },
  False_Future: {
    name: "False Future",
    discipline: "Clairsentience",
    level: "Highlord 2, seer 2, sighted seeker 4, tactician 2, voyager 2",
    display: "Auditory, Material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "Highlord 3, seer 3, sighted seeker 7, tactician 3, voyager 3",
    description: `You show the targeted creature a vision of the future that is slightly incorrect. At any point in the target's turn, you can reposition them 5 ft. to reflect their reaction to the false insight. The target may react after the reposition has occurred. This might make an action the creature was about to take invalid, such as repositioning them when they are about to make an attack, in which case the action is wasted.

You cannot reposition the creature into a square which they could not occupy or where there is no ground (such as over a cliff, into a river, or a flow of lava). Repositions using this power do not provoke attacks of opportunity.

Augment: For every 2 additional power points spent, this power lasts an additional round and the save DC increases by 1. The target gets a save on every round this effect is used upon them at the same save DC.

Mythic False Future[]

If you reposition a creature as it is about to attack, you can reposition them so that their attack strikes a different creature instead of simply wasting the action. The new target of the attack must be within the target's reach. You can reposition non-mythic creatures into squares with no ground.

Augmented (3rd): If you expend one use of mythic power, you can target one additional creature per three tiers you possess.`
  },
  Improvise: {
    name: "Improvise",
    discipline: "Clairsentience",
    level: "Highlord 2, seer 2, tactician 2",
    display: "Mental",
    manifestingTime: "1 swift action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "3",
    description: `Your ability to form and implement a plan rapidly is improved. When you manifest this power, you can use the Readying An Action special initiative action without specifying the conditions that will trigger your readied action. You must still specify what action you will take as your readied action.

Augment: If you spend six additional power points, the duration increases to 1 round per level, but once you take the readied action, the power ends.

Mythic Improvise

You no longer need to specify what action you intend to take as your readied action.`
  },
  Object_Reading: {
    name: "Object Reading",
    discipline: "Clairsentience",
    level: "Seer 2, sighted seeker 2, voyager 2",
    display: "Auditory and material",
    manifestingTime: "1 minute",
    range: "Touch",
    target: "Object touched",
    area: "",
    duration: "Concentration, up to 10 min./level (D)",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You can learn details of an inanimate object's previous owner. Objects accumulate psychic impressions left by their previous owners, which can be read by use of this power. The amount of information revealed depends on how long you study a particular object.

• 1st Minute: Last owner's race.

• 2nd Minute: Last owner's gender.

• 3rd Minute: Last owner's age.

• 4th Minute: Last owner's alignment.

• 5th Minute: How last owner gained and lost the object.

• 6th+ Minute: Next-to-last owner's race, and so on.

The power always correctly identifies the last owner of the item, and the original owner (if you keep the power active long enough).

There is a 90% chance that this power will successfully identify all other former owners in sequence, but there is a 10% chance that one former owner will be skipped and thus not identified.

This power will not identify casual users as owners. (Anyone who uses an object to attack someone or something is not thereafter considered a casual user.)

An object without any previous owners reveals no information. You can continue to run through a list of previous owners and learn details about them as long as the power's duration lasts. If you use this power additional times on the same object, the information yielded is the same as if you were using the power on the object for the first time.

Augment: For every additional power point you spend, this power's maximum duration increases by 10 minutes.`
  },
  Sensitivity_to_Psychic_Impressions: {
    name: "Sensitivity to Psychic Impressions",
    discipline: "Clairsentience",
    level: "Seer 2, sighted seeker 2, voyager 2",
    display: "Auditory and material",
    manifestingTime: "1 hour",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "Spread with a radius of 25 ft. + 5 ft./2 levels, centered on you",
    duration: "Concentration, up to 10 min./level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You gain historical vision in a given location. Rooms, streets, tunnels, and other discrete locations accumulate psychic impressions left by powerful emotions experienced in a given area. These impressions offer you a picture of the location's past.

The types of events most likely to leave psychic impressions are those that elicited strong emotions: battles and betrayals, marriages and murders, births and great pain, or any other event where one emotion dominates. Everyday occurrences leave no residue for a manifester to detect.

The vision of the event is dreamlike and shadowy. You do not gain special knowledge of those involved in the vision, though you might be able to read large banners or other writing if they are in your language.

Beginning with the most recent significant event at a location and working backward in time, you can sense one distinct event for every 10 minutes you maintain concentration, if any such events exist to be sensed. Your sensitivity extends into the past a maximum number of years equal to 100 x your manifester level.`
  },
  True_Terror: {
    name: "True Terror",
    discipline: "Clairsentience [Fear, Mind-affecting]",
    level: "Dread 2, Seer 2, Thug 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One living creature with an Intelligence of 3 or more",
    area: "",
    duration: "1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You cause the target to see horrible visions of future possibilities, stunning the target unless it makes a successful Will save.

Augment: You can augment this power in any of the following ways.

• If you expend your psionic focus, the range increases to Long (400 ft. + 40 ft./level).

• For every additional power point you spend, you can target another creature.

• For every 2 additional power points you spend, the target becomes stunned for an additional round.

• If you spend 2 additional power points, you can target creatures with an Intelligence of 1 or more, as well as non-living creatures. You still cannot affect creature's that are immune to fear or mind-affecting effects.

• If you spend 5 additional power points, this becomes an Area-effect (20 feet radius) centered on you, affecting all targets within range.

In addition, for every 2 power points spent on the above augment options, the save DC increases by 1.`
  },
  Borrowed_Future_Self: {
    name: "Borrowed Future Self",
    discipline: "Psychoportation",
    level: "seer 3",
    display: "Visual, Mental, Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "",
    duration: "1 minute/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Effect: One future self

You reach out into all your possible futures and for a short while, you draw a fragment of your future self into this time.

Your duplicate has no actual substance, it only looks like you, and you cannot use it to alter its surroundings or to attack or otherwise harm creatures it encounters. You can use the duplicate to speak, and interact verbally with creatures using the Bluff Diplomacy, and Intimidate skills.

You can see, hear, taste, and smell your duplicate's surroundings as if you are actually present in its location using your Perception or Sense Motive skills. While you also remain aware of your own immediate surroundings when controlling your duplicate, controlling it does take a toll on your senses. You take a –4 penalty on Perception checks while you control your duplicate.

The duplicate moves under your mental command, and while you need not act out its movements, you must take a standard action to control your duplicate for 1 round (concentrating on the power) or it winks out of existence. You can maintain control of your duplicate even if you have no line of sight or line of effect to it.

The duplicate immediately winks out of existence if it is hit by an attack or in the area of a damaging effect, or if it moves beyond the maximum range of the power.

Augment: This power can be augmented in one or more of the following ways.

• If you spend 2 additional power points, you can define what your duplicate should do and general orders and it will do this by it's own volition, as if you were the duplicate. You can still use your senses through the duplicate if you manifest it like this, but cannot influence its actions once triggered.

• If you spend 2 additional power points, the duration increases to 10 minutes/level.`
  },
  Escape_Detection: {
    name: "Escape Detection",
    discipline: "Clairsentience",
    level: "Cryptic 3, gifted blade 3, highlord 3, marksman 3, psychic warrior 3, seer 3, sighted seeker 3, voyager 3",
    display: "None",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You (plus all your gear and any objects you carry) become difficult to detect by clairsentience powers such as clairvoyant sense , remote viewing , and psionic true seeing , and similar magical effects. If a clairsentience power or similar effect is attempted against you, the manifester of the power must succeed on a manifester level check (1d20 + manifester level, or caster level if the opponent is not a manifester) against a DC of 13 + your manifester level (maximum +10).

Mythic Escape Detection[]

Non-mythic clairsentience and divination effects to detect you are unable to detect you. You add your tier to the manifester level check and any saving throw against mythic clairsentience and divination effects used to try to detect you.`
  },
  Fate_Link: {
    name: "Fate Link",
    discipline: "Clairsentience",
    level: "Seer 3, sighted seeker 3",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Any two living creatures that are initially no more than 30 ft. apart.",
    area: "",
    duration: "10 min./level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You temporarily link the fates of any two creatures, if both fail their saving throws. If either linked creature experiences pain, both feel it. When one loses hit points, the other loses the same amount. If one takes nonlethal damage, so does the other. If one creature is subjected to an effect to which it is immune (such as a type of energy damage), the linked creature is not subjected to it either. If one dies, the other must immediately succeed on a Fortitude save against this power's save DC or gain two negative levels. No other effects are transferred by the fate link.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mythic Fate Link[]

The range increases to 100 feet + 10 feet per level.

Augmented: You can link one additional creature's fate per three mythic tiers you possess, or fraction thereof (one additional creature at 1st tier, 2 additional creatures at 4th tier, and so on.)`
  },
  Anchored_Navigation: {
    name: "Anchored Navigation",
    discipline: "Clairsentience",
    level: "Seer 4, sighted seeker 4",
    display: "Material and olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 hour/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "7",
    description: `You know where you are in relation to a fixed starting point, which is essential for setting up a mishap-free teleport beacon. While the duration lasts, you are aware of your exact distance and route (physical or psychoportive) back to a fixed starting point. The “anchored” starting point is your exact location when you manifest the power.

To designate other anchored starting points, you must manifest this power multiple times and be present at the desired locations when you do so.

You can also retrace your steps through a maze automatically while the power lasts, without resorting to a map.

Anchored navigation grants you a mindlink with one designated creature who remains within a 60-foot radius of the starting point, regardless of the distance between you and the creature. The use of anchored navigation is confined to the plane of existence where you manifest it.

Augment: If you spend 6 additional power points, the effect of this power extends across all planar boundaries.

Mythic Anchored Navigation[]

At any point during the power's duration, you can spend a standard action to reset the starting point for the mythic anchored navigation .

Augmented: If you expend one use of mythic power, you can have a number of beacons active equal to your mythic tier without having to manifest another instance of anchored navigation . You can set a new beacon as a standard action and can choose which beacon to deactivate if resetting the location of a beacon.`
  },
  Remote_Viewing: {
    name: "Remote Viewing",
    discipline: "Clairsentience (Scrying; see text)",
    level: "Seer 4, sighted seeker 4, voyager 4",
    display: "Mental",
    manifestingTime: "Time: 1 hour",
    range: "nge: See text",
    target: "",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Effect: Quasi-real viewpoint

You send your mind across space and dimensions, forming it into a quasi-real viewpoint from which you can see and hear some creature located at any distance from you, even if planar boundaries separate you. If the subject succeeds on a Will save, the remote viewing attempt fails, and you can't attempt to view that creature again for at least 24 hours. The difficulty of the save depends on how well you know the subject and what sort of physical connection (if any) you have to that creature. Furthermore, if the subject is on another plane, it gets a +5 bonus on its Will save.

*You must have some sort of connection to a creature you have no knowledge of.

If the subject fails its Will save, your mind coalesces a quasi-real viewpoint near enough to the subject to see and hear the subject and its immediate surroundings (up 30 feet in all directions away from the subject).

While the remote viewing lasts, your real body remains unmoving and unaware of your actual surroundings. On the other hand, your quasi-real viewpoint is treated in some ways as if it were an invisible ectoplasmic form of yourself, except as follows. This power is of the Scrying subdiscipline, but use the following information in place of the standard scrying sensor. As a quasi-real viewpoint, you can speak (though your voice is whispery).

You may potentially be sensed by the subject of your viewing (subjects who can see or sense invisible or hidden creatures automatically sense you; otherwise you make a Stealth check with a +40 bonus to escape detection if immobile, or a +20 bonus if moving). You could be attacked (although if you become subject to dispel psionics , the remote viewing simply ends). If the subject moves, you can attempt to follow it at a speed of 20 feet, though if it gets farther than 30 feet from you (or you move farther than 30 feet from it), the power ends.

You can attempt to manifest one power through your quasi-real viewpoint, but you must make a concentration check (DC 20 + level of the power you wish to manifest) to succeed. Manifesting (or attempting and failing to manifest) a power immediately ends the remote viewing.

Furthermore, all powers from your quasi-real viewpoint cost twice the usual number of power points (you can't exceed the power point limit set by your manifester level, so you are restricted to manifesting lower-level powers than you otherwise could). Power points you spend as a quasireal viewpoint are drained from your real body.

Augment: By spending 2 additional power points, the quasi-real viewpoint can move at a speed of 40 feet.`
  },
  Clairtangent_Hand: {
    name: "Clairtangent Hand",
    discipline: "Clairsentience (Scrying)",
    level: "Seer 5, voyager 5",
    display: "Auditory, mental, and visual",
    manifestingTime: "1 standard action",
    range: "See text",
    target: "A nonmagical, unattended object weighing up to 5 lb.",
    area: "See text",
    duration: "Up to 1 min./level; see text (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "9",
    description: `Far Hand[]

You can mentally lift and move an object at will from a distance. As a move action, you can propel the object as far as 15 feet in any direction, though the power ends if the distance between you and the object exceeds the power's range.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's range increases by 5 feet.

• For every additional power point you spend, the weight limit of the target increases by 2 pounds.

Librarian Note : The Psionics Unleashed version lists this power as a 1st-level psion/wilder power. Otherwise, it is identical.

Clairtangent Hand[]

You can emulate a far hand effect at any distance while simultaneously emulating clairvoyant sense to target your far hand; see the appropriate power descriptions. Clairtangent hand 's duration is up to 1 minute per level when used with a far hand effect.

Augment: If you spend 8 additional power points, you can emulate clairvoyant sense in conjunction with either telekinetic force or telekinetic maneuver , but this power's duration expires as soon as any of the noted telekinetic powers deals damage.

Mythic Clairtangent Hand[]

When you scry into a naturally darkened area, increase the distance you can see by 5 feet times your mythic tier. You may also see half this distance within magical darkness, as long as the darkness was created by an effect of 3rd level or lower. You can scry into an area that is warded against scrying by a non-mythic effect by succeeding on a manifester level check with a bonus equal to your mythic tier against a DC of 11 plus the manifester level of the ward against scrying.

The weight limit of the object you can affect is doubled.`
  },
  Second_Chance: {
    name: "Second Chance",
    discipline: "Clairsentience",
    level: "Seer 5, voyager 5",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level or until discharged",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "9",
    description: `You take a hand in influencing the probable outcomes of your immediate environment. You see the many alternative branches that reality could take in the next few seconds, and with this foreknowledge you gain the ability to reroll one attack roll, one saving throw, one ability check, or one skill check. You must take the result of the reroll, even if it's worse than the original roll. You do not have to make another roll if satisfied with your original roll.

Augment: For every 3 additional power points spend, you gain a +1 insight bonus on the reroll.`
  },
  Precognition_Greater: {
    name: "Precognition, Greater",
    discipline: "Clairsentience",
    level: "Cryptic 1, gifted blade 1, highlord 1, psychic warrior 1, tactician 1, voyager 1",
    display: "Auditory, Olfactory",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "1",
    description: `Precognition[]

Precognition allows your mind to glimpse fragments of potential future events—what you see will probably happen if no one takes action to change it. However, your vision is incomplete, and it makes no real sense until the actual events you glimpsed begin to unfold. That's when everything begins to come together, and you can act, if you act swiftly, on the information you previously received when you manifested this power.

In practice, manifesting this power grants you a “precognitive edge.” Normally, you can have only a single precognitive edge at one time. You must use your edge within a period of no more than 10 minutes per level, at which time your preknowledge fades and you lose your edge.

You can use your precognitive edge in a variety of ways. Essentially, the edge translates into a +2 insight bonus that you can apply at any time to either an attack roll, a damage roll, a saving throw, or a skill check. You can elect to apply the bonus to the roll after you determine that your unmodified roll is lower than desired.

Precognition, Defensive[]

Your awareness extends a fraction of a second into the future, allowing you to better evade an opponent's blows.

You gain a +1 insight bonus to AC and on all saving throws. If caught in a situation where your Dexterity bonus isn't applied to your Armor Class, this bonus to AC and saving throws does not apply.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Greater[]

As precognition, except as noted here. You gain a +4 insight bonus instead of a +2 bonus, and the effect is not discharged when used. You may only gain a number of precognitive edges per manifestation equal to your manifester level.

Precognition, Offensive[]

Your awareness extends a fraction of a second into the future, allowing you to better land blows against your opponent. You gain a +1 insight bonus on your attack rolls.

Augment: You can augment this power in one or both of the following ways.

• For every 3 additional power points you spend, the insight bonus gained on your attack rolls increases by 1.

• If you spend 6 additional power points, you can manifest this power as a swift action.

Precognition, Tactical[]

Your awareness extends a fraction of a second into the future, allowing you to better perform a particular combat maneuver. Select one type of combat maneuver, such as bull rush or reposition, when you manifest this power. You gain a +2 enhancement bonus to combat maneuver checks of that type for the duration of the effect.

Augment: This power may be augmented in one or both of the following ways.

• For every 2 additional power points you spend, the enhancement bonus increases by 1.

• For every 3 additional power points you spend, you can select an additional type of combat maneuver.

• If you spend 4 additional power points, using the combat maneuver selected does not provoke attacks of opportunity.

• If you spend 6 additional power points, you can manifest this power as an immediate action.`
  },
  Cosmic_Perspective: {
    name: "Cosmic Perspective",
    discipline: "clairsentience (scrying)",
    level: "seer 7",
    display: "auditory and visual",
    manifestingTime: "1 standard action",
    range: "see text",
    target: "",
    area: "",
    duration: "1 hour/level",
    savingThrow: "none",
    powerResistance: "no",
    powerPoints: "13",
    description: `Clairvoyant Sense, Dyne's[]

Effect: Psionic sensor

You can see and hear a distant location almost as if you were there. You don't need line of sight or line of effect, but the locale must be known—a place familiar to you or an obvious one, such as behind a door, around a corner, or in a grove of trees. Once you have selected the locale, the focus of your clairvoyant sense doesn't move, but you can rotate it in all directions to view the area as desired. Unlike other scrying powers, this power does not allow psionically or supernaturally enhanced senses to work through it.

If the chosen locale is magically or psionically dark, you see nothing. If it is naturally pitch black, you can see in a 10- foot radius around the center of the power's effect or out to the extent of your natural darkvision. The power does not work across planes.

Cosmic Perspective[]

Effect: psionic sensor

This power functions as clairvoyant sense , save that supernaturally enhanced senses operate through the psionic sensor and the sensor is capable of moving at a speed of 60 feet per round. In addition, the sensor gains the ability to fly at phenomenal speeds, able to move between two planets within a solar system in 1d4 minutes and beyond that in 1d4 hours. The locations the sensor moves to need not be familiar ones, and this power is often used to explore uncharted territory throughout the universe.

Augment: If you spend 4 additional power points, you may manifest powers through the Cosmic Perspective as if you were in the location.

Mythic Dyne's Clairvoyant Sense[]

When you scry into a naturally darkened area, increase the distance you can see by 5 feet times your mythic tier. You may also see half this distance within magical darkness, as long as the darkness was created by an effect of 3rd level or lower. You can scry into an area that is warded against scrying by a non-mythic effect by succeeding on a manifester level check with a bonus equal to your mythic tier against a DC of 11 plus the manifester level of the ward against scrying.`
  },
  Fate_of_One: {
    name: "Fate of One",
    discipline: "Clairsentience",
    level: "Seer 7",
    display: "Mental and visual",
    manifestingTime: "1 immediate action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `Your limited omniscience allows you to reroll a saving throw, attack roll, or skill check. Whatever the result of the reroll, you must use it even if it is worse than the original roll.

If you use the power to reroll a saving throw, you can manifest this power even when it is not your turn.

Mythic Fate of One[]

You do not have to take the result of the reroll if it's worse than the original roll. You add your tier to the reroll.

Augmented (2nd): If you expend one use of mythic power, you can reroll an additional number of times equal to half your tier.`
  },
  Hypercognition: {
    name: "Hypercognition",
    discipline: "Clairsentience",
    level: "Cryptic 6, seer 8, tactician 8, voyager 6",
    display: "Mental",
    manifestingTime: "1 standard action or 1 immediate action; see text",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Cryptic 11, seer 15, tactician 15, voyager 11",
    description: `You make lightning-fast deductions based on only the slightest clue, pattern, or scrap of memory resident in your mind. You can make reasonable statements about a person, place, or object, seemingly from very little knowledge. However, your knowledge is in fact the result of a rigorously logical process that you force your mind to undertake, digging up and correlating every possible piece of knowledge bearing on the topic (possibly even extracting echoes of knowledge from the Astral Plane).

The nature of the knowledge you gain concerning the subject of your analysis might include the answer to a riddle, the way out of a maze, stray bits of information about a person, legends about a place or an object, or even a conclusion concerning a dilemma that your conscious mind is unable to arrive at.

An Intelligence check may be required to obtain the desired information. If so, you can manifest hypercognition as an immediate action prior to making the check and receive a +20 bonus for doing so.

Mythic Hypercognition[]

You automatically succeed on any Intelligence check to obtain the desired information.

Augmented (3rd): If you expend one use of mythic power, the duration becomes one round per level. During this effect, you can gain the benefits of mythic hypercognition as a swift action.`
  },
  Metafaculty: {
    name: "Metafaculty",
    discipline: "Clairsentience",
    level: "Seer 9",
    display: "Mental, olfactory, and visual",
    manifestingTime: "1 hour",
    range: "Personal",
    target: "You",
    area: "",
    duration: "Instantaneous and 1 min./level (D); see text",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "17",
    description: `You elevate your mind to a near-universal consciousness, cogitating countless impressions and predictions involving any creature you have seen before, whether personally or by means of another power such as remote viewing .

This process gives you an uncannily accurate vision of the creature's nature, activities, and whereabouts. When you manifest the power, you learn the following facts about the creature.

• Its name, race, alignment, and character class.

• A general estimate of its level or Hit Dice: low (5 HD or lower), medium (6 to 11 HD), high (12 to 20 HD), very high (21 HD to 40 HD), or deific (41 HD or higher).

• Its location (including place of residence, town, country, world, and plane of existence).

• Significant items currently in its possession.

• Any significant activities or actions the creature has undertaken in the previous 8 hours, including details such as locales traveled through, the names or races of those the creature fought, spells or powers it has used, items it acquired, and items it left behind (including the location of those items).

• A current mental view of the creature, as described in the remote viewing power, which you can maintain for up to 1 minute per level.

Metafaculty can defeat spells, powers, and special abilities such as screen or mind blank (or even a wish spell) that normally obscure clairsentience powers. You can attempt a manifester level check (DC 6 + manifester or caster level of the creator of the obscuring effect, as appropriate) to defeat these sorts of otherwise impervious defenses.

Metafaculty is defeated by epic powers, epic spells, and epic special abilities that obscure divinations and clairsentience powers.

The amount of information gained from metafaculty is taxing on the mind. You suffer 2 points of ability burn to your key ability score when you manifest this power.

Mythic Metafaculty[]

Mythic metafaculty automatically bypasses non-mythic effects that bar clairsentience effects such as mind blank . You add your tier to any manifester level check against mythic effects. You know the creature's exact level or Hit Dice.

Augmented: If you expend one use of mythic power, you do not suffer ability burn for manifesting mythic metafaculty .`
  },
  Astral_Construct: {
    name: "Astral Construct",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 1",
    display: "Visual; see text",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "1",
    description: `Effect: One created astral construct

This power creates one 1st-level astral construct of solidified ectoplasm that attacks your enemies. It appears where you designate and acts immediately, on your turn. It attacks your opponents to the best of its ability. As a free action, you can mentally direct it not to attack, to attack particular enemies, or to perform other actions. The astral construct acts normally on the last round of the power's duration and dissipates at the end of its turn.

Astral constructs are not summoned; they are created on the plane you inhabit (using ectoplasm drawn from the Astral Plane). Thus, they are not subject to effects that hedge out or otherwise affect outsiders; they are constructs, not outsiders.

Augment: For every 2 additional power points you spend, the level of the astral construct increases by one.

Astral Construct (Mythic)[]

The astral constructs you summon are considered mythic creatures and gain one use of mythic powerand the surge ability, which they can use to add 1d6 to a single die roll. Astral constructs gain no other mythic abilities.

Augmented (6th): If you expend two uses of mythic power, you can add the agile, invincible, or savage mythic simple template to creatures you summon with this power. These templates are described in the Mythic Monster Advancement section of Chapter 6 in Pathfinder Roleplaying Game Mythic Adventures.`
  },
  Ectoplasmic_Creation: {
    name: "Ectoplasmic Creation",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 9",
    display: "Material",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "17",
    description: `Ectoplasmic Creation[]

Effect: Unattended, nonpsionic, nonmagical object of nonliving matter, up to 1 cu. ft./level

You shape raw ectoplasm into a nonmagical, unattended object of nonliving, organic matter. The volume of the item created cannot exceed 1 cubic foot per manifester level. You must succeed on an appropriate Craft skill check to make a complex item.

Attempting to use any created object as a material component for spells causes the spell to fail.

Ectoplasmic Creation, Major[]

This power functions like ectoplasmic creation, except that you can also create an object of mineral nature: stone, crystal, metal, or the like. The duration of the created item varies with its relative hardness and rarity, as indicated on the following table.

* Includes adamantine, alchemical silver, and mithral. You can't use major ectoplasmic creation to create a cold iron item. Additional rare items are possible at the GM's discretion, but should typically be limited to 1 round/level.

True Creation[]

As major ectoplasmic creation , except items created are enduring and cannot be negated by dispelling magic or negating powers. For all intents and purposes, these items are completely real.

You suffer one point of ability burn to your key ability score per 5,000 gp value of the item created. You suffer no ability burn if the value of the item created is under 50 gp.

Mythic Ectoplasmic Creation[]

You may choose to increase the duration of the items you create to 1 day/level or increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.

Mythic Major Ectoplasmic Creation[]

You may choose to increase the duration of the vegetable matter, stone, crystal, or base metal items you create to 1 day/level, precious metals or gems to 1 hour/level, or rare metals to 1 minute/level; or you may increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.`
  },
  Holographic_Projection: {
    name: "Holographic Projection",
    discipline: "metacreativity (figment)",
    level: "cryptic 2, dread 2, shaper 2",
    display: "auditory, material, visual",
    manifestingTime: "1 standard action",
    range: "long (400 feet + 40 feet/level)",
    target: "",
    area: "four 10-ft. cubes + one 10-ft. cube/level (S)",
    duration: "concentration",
    savingThrow: "Will negates, see text; Power",
    powerResistance: "",
    powerPoints: "3",
    description: `Resistance: no

You spread a wave of gaseous ectoplasm throughout an area, using it to conduct energy and thus project images and sound. You may use this ability to create any images, sounds, or thermal sensations that you wish within the area. Creatures that attempt to interact with these projections are allowed a will save to recognize that they are not real, but even upon recognizing their falsehood are not able to see through them. So long as you concentrate on this power, you may cause the figments created with this ability to move and change however you wish. These sensations cannot deal damage to creatures

Augment: This power can be augmented in the following ways:

• If you spend 2 additional power points, you may choose to extend the duration of this power to concentration + 1 round/level, rather than concentration. You may program the actions of the projection however you wish, including having it respond to certain stimuli. If you spend 2 points on top of this, the duration becomes concentration + 1 minute/level, and 2 more on top of this changes it to 1 hour/level).

• If you spend 8 additional power points, you may choose to make the effects of this power permanent.

• If you spend 4 additional power points, you may use this power to override the sense of all creatures in the area. All creatures inside are treated as blind and deaf while inside the area of this effect. Making a will save to recognize that this is a figment does not negate the blindness, or deafness.

• If you spend 8 additional power points, you may use this ability to selectively override existing sensations and interpretations within the area of effect. You may cause certain objects, effects, or creatures to become invisible to while they are within the area of this power. You may also treat creatures inside the area as deafened and/or blinded so long as they stay inside the area. Making a will save to recognize that this is a figment does not negate the invisibility, blindness, or deafness.

• If you spend 2 additional power points, you may use this ability to modify sensations of smell, taste, and touch within the area.

• If you spend 2 additional power points, the area increases to 1 30-ft cube/level.

• If you spend 4 additional power points, you may cause the holograms to be able to harm creatures within the area that you wish harmed, dealing 2d6 force damage +1 point of force damage per manifester level (Fortitude half).

• For every 2 power points you spend augmenting this power (including as part of other augmentations), the save DC increases by 1.`
  },
  Reconstruction: {
    name: "Reconstruction",
    discipline: "Metacreativity",
    level: "Shaper 2",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Construct touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (harmless)",
    powerResistance: "Yes (harmless)",
    powerPoints: "3",
    description: `When laying your hands upon a construct that has at least 1 hit point remaining, you reknit its structure to repair damage it has taken. The power repairs 3d8 points of damage +1 point per manifester level. Constructs that are immune to psionics or magic cannot be repaired in this fashion.

Augment: For every 2 additional power points you spend, this power repairs an additional 1d8 points of damage.`
  },
  Concealing_Amorpha_Greater: {
    name: "Concealing Amorpha, Greater",
    discipline: "Metacreativity (Creation)",
    level: "Cryptic 3, gifted blade 3, highlord 3, marksman 3, psychic warrior 3, shaper 3, voyager 3",
    display: "Material; see text",
    manifestingTime: "1 standard action",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `Concealing Amorpha[]

Effect: Quasi-real amorphous film centered on you

You weave a quasi-real membrane around yourself. You remain visible within the translucent, amorphous enclosure. This distortion grants you concealment (opponents have a 20% miss chance), thanks to the rippling membrane encasing your form. You can pick up or drop objects, easily reaching through the film. Anything you hold is enveloped by the amorpha. Likewise, you can engage in melee, make ranged attacks, and manifest powers without hindrance.

Augment: If you spend 4 additional power points, the membrane can spread and affect one creature adjacent to you. If the creature moves away from you, it loses the protection.

Concealing Amorpha, Greater[]

As concealing amorpha , except the quasi-real membrane so distorts your image and actual position that you gain total concealment (opponents have a 50% miss chance), but for a shorter period of time.

Mythic Concealing Amorpha[]

When a melee attack misses because of this power, there is a 50% chance that the weapon is coated in the membrane and deals only nonlethal damage unless the wielder spends  a  standard  action cleaning  off the membrane. Add your tier to Stealth checks while under the effect of mythic concealing amorpha .

Augmented: If you expend one use of mythic power, the amorpha absorbs damage from effects that deal damage of cold, fire, electricity, force, or sonic damage. When used  in  this  way,  you  reduce all damage of those energy types by your tier for one round and you shorten the duration of the effect by an additional round.

Mythic Greater Concealing Amorpha[]

When a melee attack misses because of this power, there is a 50% chance that the weapon is coated in the membrane and deals only nonlethal damage unless the wielder spends a standard action cleaning off the membrane.

Augmented: If you expend one use of mythic power, the duration of the effect is one minute per level.`
  },
  Ectoplasmic_Cocoon: {
    name: "Ectoplasmic Cocoon",
    discipline: "Metacreativity",
    level: "Shaper 7",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One Medium or smaller creature",
    area: "20-ft.-radius burst",
    duration: "1 hour/level (D)",
    savingThrow: "Reflex negates",
    powerResistance: "No",
    powerPoints: "13",
    description: `Ectoplasmic Cocoon[]

You draw writhing strands of ectoplasm from the Astral Plane that wrap up the subject like a mummy. The subject can still breathe but is otherwise helpless, unable to see outside the cocoon, speak, or take any physical actions. The subject's nostrils are clear (air passes through the cocoon normally). The subject can execute purely mental actions (such as manifesting powers or casting spells with no verbal, somatic, or material components).

Cutting or damaging the cocoon can free a victim. The cocoon has hardness 8 and 20 hit points. Teleportation and other forms of travel provide a means of escape, but the cocoon extends into the Ethereal Plane, blocking ethereal travel. An ectoplasmic cocoon can't be affected by dispel psionics , but it can be dismissed with dismiss ectoplasm, or otherwise destroyed by extreme measures or items.

The creature within the cocoon is visible only as a vague shape (substantial enough to interrupt line of sight) and cannot be directly harmed or interacted with unless the cocoon is destroyed. The cocooned creature can be moved normally (the weight of the cocoon is negligible).

A creature that is cocooned while aloft begins to fall immediately, and a creature that is cocooned while swimming or underwater may drown.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's save DC increases by 1.

• For every 2 additional power points you spend, this power can affect a target one size category larger.

Ectoplasmic Cocoon, Mass[]

As ectoplasmic cocoon , except you can cocoon several creatures (or a single big creature that fits in a 20-foot radius sphere or hemisphere) in a mass of writhing ectoplasm. Targets entirely within the area who fail their save are caught and cocooned. If a creature's body is only partially within the area, this power does not affect that creature.

Augment: For every 2 additional power points you spend, the radius of this power's area increases by 5 feet.

Mythic Ectoplasmic Cocoon[]

Add your tier to the hardness  of  the  cocoon  and the number of hit points the cocoon has are doubled. Creatures that make a successful Reflex save are instead entangled as if struck by entangling ectoplasm .

Mythic Mass Ectoplasmic Cocoon[]

Add your tier to the hardness  of  the  cocoon  and the number of hit points the cocoon has are doubled. Creatures that make a successful Reflex save are instead entangled as if struck by entangling ectoplasm .`
  },
  Crystalline_Bonds: {
    name: "Crystalline Bonds",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 4",
    display: "Mental and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One Medium or smaller creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Reflex negates",
    powerResistance: "No",
    powerPoints: "7",
    description: `You create rope-like coils of crystal that encircle your foe, gagging and immobilizing him, dealing 3d6 points of damage and 1d6 points of damage every round thereafter, as the crystal tightens against the target.

A creature caught by the crystal can attempt purely mental actions, but must make a concentration check (DC 20 + half the continuous damage dealt) to manifest powers. The creature can attempt to break free by spending 1 round and making a DC 20 Strength or Escape Artist check. The bond can alternatively be cut to break the target free. The crystal has AC 5, hardness 12, and 30 hit points.

Augment: This power can be augmented in one or more of the following ways.

• For every 2 additional power points spent, this power can affect a target of one size category larger.

• For every 2 additional power points spent, the continuous damage increases by 1d6 points of damage.

In addition, for every 2 additional power points spent on either of the above options, the power's save DC and the DCs to break free increase by 1.

Mythic Crystalline Bonds[]

Add your tier to the damage dealt by the coils and the DC to break free.

Augmented: If you expend one use of mythic power, you add your tier to the hardness and AC of the bonds.`
  },
  Modify_Matter: {
    name: "Modify Matter",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 6",
    display: "Material",
    manifestingTime: "See text",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Up to 100 cu. ft./level",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "11",
    description: `Modify Matter[]

You convert material of one sort into a product that is of the same material. Creatures or psionic items cannot be created or transmuted by this effect. The quality of items made by this power is commensurate with the quality of material used as the basis for the new fabrication. If you work with a mineral, the target is reduced to 1 cubic foot per level instead of 10 cubic feet.

You must make an appropriate Craft check to fabricate articles requiring a high degree of craftsmanship.

Manifesting requires 1 round per 10 cubic feet of material to be affected by the power. This power may not be used on attended items.

Modify Matter, Greater[]

As modify matter , except ten times as much material is affected by the power.`
  },
  Quintessence: {
    name: "Quintessence",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 4",
    display: "Material; see text",
    manifestingTime: "1 round",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "7",
    description: `Effect: 1-inch-diameter dollop of quintessence; see text

You collapse a bit of time from the continuum, forming a 1-ounce dollop of thick, gooey material called quintessence. This substance shimmers like a silver mirror when viewed from some angles but is transparent from other viewpoints. You can smooth a dollop of quintessence around any extremely small object.

Objects sealed within quintessence are protected from the effects of time; in practical terms, they enter a state of stasis. Living flesh with only partial contact with quintessence is also partially pulled out of the time stream (the manifester is immune to this effect). This disruption deals 1 point of damage per round beginning 10 rounds after partial contact occurs.

Quintessence can be manually scraped away from a protected object, freeing it to rejoin the time stream. When you do this, there is a 75% chance that the quintessence evaporates back into the continuum. Otherwise, it coalesces again into a 1-inch-diameter bead, available for later use.

Large quantities of quintessence could theoretically be gathered to preserve large items or structures (or even a complete living creature; if completely immersed, a living creature would not take the damage associated with partial contact). However, psionic characters and creatures are generally loath to do so because accumulations of quintessence weighing 1 pound or more hinder psionic activity within a 5-foot radius of the accumulation: Powers require twice as many power points to manifest, unless the manifester makes a successful Will save each time he or she attempts to manifest a power. Also in these circumstances, manifesting a psi-like ability that is usable at will is a full-round action rather than a standard action.`
  },
  Hail_of_Crystals_Anselm_s: {
    name: "Hail of Crystals, Anselm's",
    discipline: "Metacreativity (Creation)",
    level: "Gambler 5, shaper 5",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "",
    area: "20-ft.-radius burst",
    duration: "Instantaneous",
    savingThrow: "Reflex half",
    powerResistance: "No",
    powerPoints: "9",
    description: `A tiny ectoplasmic crystal emanates from your outstretched hand and rapidly expands to a 2-foot-diameter ball of crystal as it speeds toward the location you designate. You can choose to aim this crystal at a single target or at a specific point in space (a grid intersection).

If you aim the crystal at a single target, you must make a ranged touch attack to strike the target. Any creature or object struck by the ball of crystal takes 5d4 points of bludgeoning damage.

Whether the crystal hits its target, misses, or was aimed at a point in space, it explodes upon arrival at the location you designated. Anyone within 20 feet of the explosion takes 9d4 points of slashing damage from the thousands of crystal shards that spray forth, although the damage is halved on a successful Reflex save.

Augment: For every additional power point you spend, this power's damage from the explosion of the crystal increases by 1d4 points.

Mythic Anselm's Hail of Crystals[]

The radius of the burst increases to 40 feet and the damage dealt uses d8s instead of d4s.

Augmented (3rd): If you expend two uses of mythic power, you can exclude up to your tier in targets from the burst effect.`
  },
  Astral_Nanites: {
    name: "Astral Nanites",
    discipline: "metacreativity",
    level: "shaper 6",
    display: "visual",
    manifestingTime: "1 round",
    range: "close (25 ft + 5 ft./level)",
    target: "",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "11",
    description: `Effect: one created swarm

From the far reaches of the astral plane, you manifest an army of ectoplasmic nanites to serve you. These creatures function as an astral swarm , save that they have the robot subtype in addition to their normal abilities. Aside from the creature created, this power otherwise functions like astral construct .

Augment: This power can be augmented in the following ways:

• By spending 2 additional power points, the manifester may create an observer robot swarm in place of a astral swarm.

• By spending 6 additional power points, the manifester may create a gray goo in place of an astral swarm. If the manifester also expends his psionic focus, he may create the gray goo inside of a creature within Close range, affecting them as if it was subject to the gray goo's infest ability (no save).

• By expending psionic focus, the manifester may apply menu options to the created swarm as if it were a 6th-level astral construct.`
  },
  Crystallize_Ruelle_s: {
    name: "Crystallize, Ruelle's",
    discipline: "Metacreativity; Leve l: Gambler 6, shaper 6",
    level: "",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One living creature",
    area: "",
    duration: "Permanent",
    savingThrow: "Fortitude negates",
    powerResistance: "Yes",
    powerPoints: "11",
    description: `You seed the subject's flesh with supersaturated crystal. In the blink of an eye, the subject's form seems to freeze over, as its flesh and fluids are instantly crystallized. Following the application of this power, the subject appears lifeless. In fact, it is not dead (though no life can be detected with powers or spells that detect such).

This power has a chance of being dispelled only by a manifester of a higher level than you when you manifested this power. When the power is dispelled, crystal melts back into flesh, and the subject is in exactly the state he was prior to being affected by crystallize.

Mythic Ruelle's Crystallize[]

Non-mythic effects cannot negate the effect.  You can end the effect as a standard action.

Augmented (5th): If you expend two uses of mythic power, you can target non-living creatures.`
  },
  Genesis: {
    name: "Genesis",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 6",
    display: "Material",
    manifestingTime: "2 hours",
    range: "0 ft.; see text",
    target: "",
    area: "",
    duration: "1 day/level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "11",
    description: `Effect: Extradimensional demiplane, up to three 10-ft. cubes/level (S)

You create a small, finite demiplane. You must be on the Astral or Ethereal Plane or on a plane that has access to one of those planes (such as the Material Plane) to manifest this power. When you manifest the power, you decide whether the demiplane is within the Astral or the Ethereal Plane. It is filled with air or water (decided by you). The plane is generally flat and featureless, such as an earth, stone, water, or wood floor. The “walls” and “ceiling” of the plane may appear like solid earth, stone, wood, or water, or they may end in mist, a featureless void, or a similar unreal-looking border. The plane's environmental conditions are those of a temperate spring day on the Material Plane. You determine the plane's light level (bright, normal, dim, or darkness), which affects the entire plane.

There are no native creatures or plants on this plane, though you may bring some there (if the plane's light is bright or normal, it counts as sunlight for growing plants). The environment of the plane counts as normal terrain for the purpose of effects that target earth, stone, wood, and so on. For example, you could use foxhole to create a small trench or modify matter to create a stone building.

When you finish manifesting this power, you may bring yourself and up to seven other creatures to the plane automatically by joining hands in a circle. The demiplane is another plane of existence, and therefore is outside the range of any power or ability that cannot affect or reach other planes. Creatures can only enter the plane by the use of planar travel powers such as astral caravan or planar travel. You are considered “very familiar” with your entire demiplane.

As a standard action, you may eject a creature from your demiplane. The creature may resist with a Will saving throw. An ejected creature goes to the closest plane to your demiplane (usually the Astral Plane or the Ethereal Plane, but if you manifest this power on the Material Plane, the creature is sent to the Material Plane). When the power ends, the plane dissolves, and all creatures in the plane are ejected in this manner with no saving throw. The plane cannot be dispelled, but a creature on the plane can destroy it by using bend reality, reality revision, or unravel psionics and making a successful dispel check.

If you are within the demiplane, you can add to its area by manifesting the power again. Alternatively, you may manifest this power again to reset the duration of an existing area to that of your latest manifesting. If the duration on one area of the demiplane ends and other parts remain, creatures in the expiring area are shunted to remaining areas. If a collapsing portion of the demiplane would leave one section cut off from other sections of the demiplane (for example, if there were three areas connected in a straight line and the center part expired), the stranded sections count as separate demiplanes under your control. You may reconnect these stranded sections by manifesting the power again to create a linked area between the two.

Augments: This power may be augmented in one or more of the following ways.

• By spending 4 additional power points, instead of increasing the size of an existing demiplane, you may add or remove any planar trait available via the spell create demiplane to a demiplane you created via genesis. If you spend 6PP, you may choose any trait available via create demiplane, greater. Either of these augments changes this power's duration to Instantaneous.

• By spending two additional power points and doubling the manifestation time, the maximum size increases to 10 10-ft. cubes per level.

• By spending 4 additional power points and quadrupling the manifestation time, the maximum size increases to 20 10-ft. cubes per level.

• By spending 2 additional power points and channelling the power through specially-treated crystals similar to cognizance crystals that cost 20,000gp, the duration of this power becomes Permanent. These crystals are consumed during the manifestation process, becoming an infinitely fine lattice of psionic energy that roots the plane to the underlying fabric of its neighboring plane(s).

Mythic Genesis[]

You may choose to increase the duration of your demiplane to one week per level, or you may increase its size to a number of 20-foot cubes (rather than 10-foot cubes) as appropriate to any augmentation options you may have selected. Only a creature whose mythic rank or tier exceeds yours can dispel your demiplane.`
  },
  Modify_Matter_Greater: {
    name: "Modify Matter, Greater",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 6",
    display: "Material",
    manifestingTime: "See text",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "Up to 100 cu. ft./level",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "11",
    description: `Modify Matter[]

You convert material of one sort into a product that is of the same material. Creatures or psionic items cannot be created or transmuted by this effect. The quality of items made by this power is commensurate with the quality of material used as the basis for the new fabrication. If you work with a mineral, the target is reduced to 1 cubic foot per level instead of 10 cubic feet.

You must make an appropriate Craft check to fabricate articles requiring a high degree of craftsmanship.

Manifesting requires 1 round per 10 cubic feet of material to be affected by the power. This power may not be used on attended items.

Modify Matter, Greater[]

As modify matter , except ten times as much material is affected by the power.`
  },
  Ectoplasmic_Cocoon_Mass: {
    name: "Ectoplasmic Cocoon, Mass",
    discipline: "Metacreativity",
    level: "Shaper 7",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One Medium or smaller creature",
    area: "20-ft.-radius burst",
    duration: "1 hour/level (D)",
    savingThrow: "Reflex negates",
    powerResistance: "No",
    powerPoints: "13",
    description: `Ectoplasmic Cocoon[]

You draw writhing strands of ectoplasm from the Astral Plane that wrap up the subject like a mummy. The subject can still breathe but is otherwise helpless, unable to see outside the cocoon, speak, or take any physical actions. The subject's nostrils are clear (air passes through the cocoon normally). The subject can execute purely mental actions (such as manifesting powers or casting spells with no verbal, somatic, or material components).

Cutting or damaging the cocoon can free a victim. The cocoon has hardness 8 and 20 hit points. Teleportation and other forms of travel provide a means of escape, but the cocoon extends into the Ethereal Plane, blocking ethereal travel. An ectoplasmic cocoon can't be affected by dispel psionics , but it can be dismissed with dismiss ectoplasm, or otherwise destroyed by extreme measures or items.

The creature within the cocoon is visible only as a vague shape (substantial enough to interrupt line of sight) and cannot be directly harmed or interacted with unless the cocoon is destroyed. The cocooned creature can be moved normally (the weight of the cocoon is negligible).

A creature that is cocooned while aloft begins to fall immediately, and a creature that is cocooned while swimming or underwater may drown.

Augment: You can augment this power in one or both of the following ways.

• For every 2 additional power points you spend, this power's save DC increases by 1.

• For every 2 additional power points you spend, this power can affect a target one size category larger.

Ectoplasmic Cocoon, Mass[]

As ectoplasmic cocoon , except you can cocoon several creatures (or a single big creature that fits in a 20-foot radius sphere or hemisphere) in a mass of writhing ectoplasm. Targets entirely within the area who fail their save are caught and cocooned. If a creature's body is only partially within the area, this power does not affect that creature.

Augment: For every 2 additional power points you spend, the radius of this power's area increases by 5 feet.

Mythic Ectoplasmic Cocoon[]

Add your tier to the hardness  of  the  cocoon  and the number of hit points the cocoon has are doubled. Creatures that make a successful Reflex save are instead entangled as if struck by entangling ectoplasm .

Mythic Mass Ectoplasmic Cocoon[]

Add your tier to the hardness  of  the  cocoon  and the number of hit points the cocoon has are doubled. Creatures that make a successful Reflex save are instead entangled as if struck by entangling ectoplasm .`
  },
  Psionic_Effigy: {
    name: "Psionic Effigy",
    discipline: "Metacreativity (creation)",
    level: "Shaper 7",
    display: "Visual, Material",
    manifestingTime: "1 hour",
    range: "Close (25 feet + 5 feet/level)",
    target: "",
    area: "",
    duration: "Permanent until triggered (see text)",
    savingThrow: "see text",
    powerResistance: "see text",
    powerPoints: "13",
    description: `Effect: 1 effigy

: From ectoplasm, you create a receptacle of psionic power that possesses an infinite lifespan. The receptacle can be of any dimensions from Tiny to Huge size. As part of manifesting this power, you manifest a single power into the effigy. When certain conditions are met (as designated by the manifester), the effigy releases the power that was manifested into it, targeting a predesignated target. This target may be “whatever creature or creatures activated the effigy, the manifester, a selected creature present at the time of manifesting (either of which can be affected from anywhere in the multiverse), or even the effigy itself. The effigy possesses 80 hit points and hardness 25. The effigy cannot be moved from its location where it is created. Dispel psionics has no effect on the effigy, but dismiss e c toplasm can destroy it. Destruction of the effigy by any means automatically causes the power within to activate.

Augment

• For every 2 power points you spend, you may manifest an additional power into the effigy when you create it.

• If you spend 4 additional power points and 25,00 gp worth of components, you may choose to have the effigy reactivate after 1 minute. If the trigger conditions are met any additional times, the effigy activates again, and can activate an infinite number of times.

• If you spend 4 additional power points, you may designate the targets of this power as “all creatures within 60 feet of the effigy.” These targets may be those within 60 feet at the time of manifesting or those within 60 feet at the time of activation.`
  },
  Astral_Seed: {
    name: "Astral Seed",
    discipline: "Metacreativity",
    level: "Shaper 8",
    display: "Material; see text",
    manifestingTime: "10 minutes",
    range: "0 ft.",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "15",
    description: `Effect: One storage crystal

This power weaves strands of astral ectoplasm into a crystal containing the seed of your living mind (hardness 1 and 1 hit point). You can have only one astral seed in existence at any one time. Until such time as you perish, the astral seed (also called the storage crystal) is utterly inert. If you are slain at some later date, your soul transfers into the storage crystal, which begins to dimly glow.

Upon transference, your physical remains (should they still exist) become inert matter and cannot thereafter be restored to life. The transfer from the slain body to the astral seed works over any distance, physical or extradimensional.

Once your body's physical demise activates the storage crystal, you have the abilities of a psicrystal of the appropriate level, full hit points, plus all the powers you knew, the maximum power points you possessed when astral seed was manifested, and the current number of power points you had prior to the transfer into the crystal. Should this be higher than the maximum power points when the power was manifested, you have the lower of the two amounts. You also have a negative level that cannot be healed and that does not convert to real level loss in your current crystalline form. You have all the abilities you had in your original form, including the ability to manifest powers, so long as your storage crystal form has the physical ability to perform those actions. For example, you could not manifest Karak's bite of the wolf because your new form does not have a mouth. Nor could you wield a weapon, as your storage crystal does not have the arms to wield one.

You have thirty days to grow an organic body, after which time your sentience fades and your soul passes on if it hasn't entered a new body.

To grow a body, you (in the storage crystal) must spend ten days in uninterrupted solitude. The body's constituent parts are pulled as ectoplasm from the Astral Plane, then slowly molded and transformed into a living, breathing body that is an exact duplicate of your body at the time you manifested astral seed (the crystal itself breaks down and becomes a part of the new organic body). When the tenth day ends, you completely and totally inhabit the new body. You possess all the abilities you possessed when astral seed was manifested, but you have none of your equipment. You still suffer a negative level that does not fade unless removed by means such as restoration .

If the body is struck for any amount of damage during the ten-day period when it is growing, it is destroyed and your soul passes on.

Conceivably, you could manifest true mind switch to utilize a temporary body, but only an evil creature would smash his own temporarily empty storage crystal to permanently usurp a subject's organic body (unless the subject is itself irredeemably evil).

Astral Seed (Mythic)[]

The amount of time to reform your body is reduced to one day and do not suffer a negative level when you reform in your new body.

Augmented: If you expend one use of mythic power, you reform with all the abilities you possessed when killed, rather than when mythic astral seed was manifested.

Augmented (3rd): If you expend one use of mythic power, an ectoplasmic cocoon forms around your body as it is creating, protecting it from potential harm. Once the body is ready for you to inhabit, the cocoon dissipates.`
  },
  True_Creation: {
    name: "True Creation",
    discipline: "Metacreativity (Creation)",
    level: "Shaper 9",
    display: "Material",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "17",
    description: `Ectoplasmic Creation[]

Effect: Unattended, nonpsionic, nonmagical object of nonliving matter, up to 1 cu. ft./level

You shape raw ectoplasm into a nonmagical, unattended object of nonliving, organic matter. The volume of the item created cannot exceed 1 cubic foot per manifester level. You must succeed on an appropriate Craft skill check to make a complex item.

Attempting to use any created object as a material component for spells causes the spell to fail.

Ectoplasmic Creation, Major[]

This power functions like ectoplasmic creation, except that you can also create an object of mineral nature: stone, crystal, metal, or the like. The duration of the created item varies with its relative hardness and rarity, as indicated on the following table.

* Includes adamantine, alchemical silver, and mithral. You can't use major ectoplasmic creation to create a cold iron item. Additional rare items are possible at the GM's discretion, but should typically be limited to 1 round/level.

True Creation[]

As major ectoplasmic creation , except items created are enduring and cannot be negated by dispelling magic or negating powers. For all intents and purposes, these items are completely real.

You suffer one point of ability burn to your key ability score per 5,000 gp value of the item created. You suffer no ability burn if the value of the item created is under 50 gp.

Mythic Ectoplasmic Creation[]

You may choose to increase the duration of the items you create to 1 day/level or increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.

Mythic Major Ectoplasmic Creation[]

You may choose to increase the duration of the vegetable matter, stone, crystal, or base metal items you create to 1 day/level, precious metals or gems to 1 hour/level, or rare metals to 1 minute/level; or you may increase the volume of material created to 10 cubic feet per level. Add your mythic tier to Craft checks to make complex items.

Augmented: If you expend two uses of mythic power, you can increase the duration and the volume of material as described above.`
  },
  Empathic_Connection: {
    name: "Empathic Connection",
    discipline: "Telepathy (Charm) [Mind-Affecting]",
    level: "Telepath 1",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One humanoid",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You reach out with your mind, finding the emotional strings that most apply to your target. With delicate influences, you twist those emotional strings, making your target view you as a friend (treat the target's attitude as friendly).  If the creature is currently being threatened or attacked by you or your allies, however, it receives a +5 bonus on its saving throw.

This does not enable you to control the affected person as if it was an automaton, but it perceives your words and actions in the most favorable way. You can try to give the subject orders, but you must win an opposed Charisma check to convince it to do anything it wouldn't ordinarily do. (Retries are not allowed.) An affected creature never obeys suicidal or obviously harmful orders, but it might be convinced that something very dangerous is worth doing. Any act by you or your apparent allies that threatens the charmed person breaks the effect. You must speak the person's language to communicate your commands, be good at pantomiming, or have some other method to communicate, such as mindlink .

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, this power can also affect an animal, fey, magical beast, or monstrous humanoid.

• If you spend 4 additional power points, this power can also affect an aberration, dragon, elemental, or outsider in addition to the creature types mentioned above.

• If you spend 4 additional power points, this power's duration increases to one day per level.

In addition, for every 2 additional power points you spend to achieve any of these effects, this power's save DC increases by 1.

Mythic Empathic Connection[]

You add your mythic tier to Charisma checks to convince the target to act as you command, and the target can understand your commands or suggestions as if you shared a language, though you are not otherwise able to communicate. Add your mythic tier to the Sense Motive DC to discern that a creature is charmed.

Augmented: If you expend two uses of mythic power, the duration is increased to 1 day/level.`
  },
  Hallucinations: {
    name: "Hallucinations",
    discipline: "Telepathy",
    level: "telepath 1, dread 1",
    display: "Olfactory, Auditory",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "One target per manifester level",
    area: "",
    duration: "Concentration",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `You cause the targets to believe they hear any sound you imagine.

The sound can include intelligible speech. Instead of precisely imagining a sound, you can identify a sound the subjects know and they imagine it doing what you describe as you manifest the power. All targets hear the same sounds. You can change the sound as part of concentrating on the power.

Augment: This power can be augmented in any of the following ways:

• If you spend 2 additional power points, you can script whatever happens for 1 minute per level, instead of having to concentrate on the power. The power will play out as you defined it, including reacting to what the targets say or do, provided you defined that interaction when scripting it.

• If you spend 4 additional power points, you can include the image of any object, creature, or force you imagine or identify for the targets to imagine. You can move the image while you concentrate. The image fails and disappears when struck by an opponent unless you cause it to react appropriately while concentrating. Its AC is equal to 10 + ½ your manifester level.

• If you spend 6 additional power points, you can include an image as above, but also any olfactory, thermal and tactile elements, completing the mental hallucination.

• If you spend 5 additional power points, you can create a triggered mindtrick instead. This changes the duration to 1 week/level + 1 minute/level. You set the triggering condition (such as hearing a certain word or seeing a type of creature) when manifesting the power. The event that triggers the power can be as general or detailed as desired but must be based on an audible, tactile, olfactory, or visual trigger. The trigger can't be based on any quality not normally obvious to the senses, such as alignment. This power uses the target's senses to notice triggers. If this event happens during the first duration, the mindtrick plays out as if you had scripted it, for 1 minute per level and then ends.

• If you spend 8 additional power points, change the target to 1 target and the duration to permanent. You can make a general script for how the power interacts, when it activates and other general reactions, and the targets mind will actively work to make these scripts work.`
  },
  Mindlink: {
    name: "Mindlink",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Telepath 4",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels); see text",
    target: "",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Mindlink[]

Targets: You and one other willing creature within range that has an Intelligence score of 3 or higher

You forge a telepathic bond with your target. You can communicate telepathically through the bond even if you do not share a common language. No special power or influence is established as a result of the bond. Once the bond is formed, it works over any distance (although not from one plane to another).

Augment: You can augment this power in one or both of the following ways.

• If you spend 4 additional power points, you can attempt to create a telepathic bond with a creature that is not willing (Will save negates).

• For every additional power point you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Mindlink, Thieving[]

As mindlink , except that if the target is a psionic character or creature that knows powers, you can temporarily borrow a power of your choice (you are aware of what powers the subject knows, up to the highest level of power you can manifest).

Borrowing the subject's power is a separate standard action that provokes an attack of opportunity. If the attack to borrow a power succeeds, the mental communication provided by this power ends immediately. The borrowed power fades from the subject's awareness and appears within your own. You can now spend power points to manifest the borrowed power just as if it were one of your powers known. You maintain knowledge of the borrowed power until the duration of your thieving mindlink expires, at which time you lose knowledge of the power and the power reappears in the mind of the subject, no matter how far from you the subject is. Even if the subject is slain, you lose knowledge of the borrowed power when this power's duration expires.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Suppress_Compulsion: {
    name: "Suppress Compulsion",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Telepath 1, vitalist 1",
    display: "None",
    manifestingTime: "",
    range: "Close (25 feet + 5 feet/two levels)",
    target: "",
    area: "",
    duration: "1 round",
    savingThrow: "None",
    powerResistance: "Yes",
    powerPoints: "1",
    description: `Manifestation Time: One swift action

Target or Area: One dominated or controlled creature

You can attempt to suppress a compulsion or charm effect on another creature by overwhelming the creature with conflicting telepathic signals, temporarily canceling the domination. When you manifest this power, make a manifester level check against the ongoing controlling power currently in effect on the creature. The manifester level check is 1d20 + your manifester level against a Difficulty Class of 11 + the manifester level of the entity that originally manifested the controlling power. On a successful check, the control is suppressed for 1 full round. Even though suppressed, the compulsion or charm is still considered to be running off its duration.

Augment: You can augment this power in one or more of the following ways.

• If you spend 4 additional power points, you can attempt to permanently terminate a compulsion or charm effect on another creature, including mind control. When you manifest this power, make a manifester level check against the ongoing controlling power currently in effect on the creature against a Difficulty Class of 11 + the manifester level of the entity that originally manifested the controlling power. On a successful check, you terminate the effect.

• For every additional power point you spend, you increase your check result by +1 and extend the duration by 1 round.`
  },
  Aversion: {
    name: "Aversion",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Telepath 2",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 hour/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You plant a powerful aversion in the mind of the subject. If the object of the implanted aversion is an individual or a physical object, she will prefer not to approach within 30 feet of it. If it is a word, she will try not to utter it; if it is an action, she will not willingly attempt to perform it; and if it is an event, she will not willingly attend it. The subject will take reasonable steps to avoid the object of its aversion, but will not put herself in jeopardy by doing so.

If the subject is forced into taking an action she has an aversion to, she takes a –2 penalty on any attack rolls, ability checks, or skill checks involved.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1 and the duration increases by 1 hour.

Aversion (Mythic)[]

The range increases to 100 feet plus 10 feet per level and you can specify two aversions for the target.

Augmented: If you expend one use of mythic power, the penalty for doing averse things increases to -4.`
  },
  Brain_Lock: {
    name: "Brain Lock",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Telepath 2",
    display: "Material and visual",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One humanoid",
    area: "",
    duration: "Concentration + 1 round",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `The subject's higher mind is locked away. He stands dazed, unable to take any actions other than those identified below.

A brain locked subject is not stunned, so attackers get no special advantage against him.

A brain locked flyer must descend to the closest safe level area below it. An air-breathing swimmer must make for the surface.

Each round on its turn, the subject may attempt a new saving throw to end the effect. This is a full-round action that does not provoke attacks of opportunity.

Augment: You can augment this power in one or both of the following ways.

• If you spend 2 additional power points, this power can also affect an animal, fey, magical beast, or monstrous humanoid.

• If you spend 4 additional power points, this power can also affect an aberration, dragon, elemental, or outsider in addition to the creature types mentioned above.

In addition, for every 2 power points spent on either of the above options, the power's save DC is increased by 1.

Mythic Brain Lock[]

You can cease concentrating on the power without ending the effect and the duration becomes  one round per level. The target is no longer dazed when you are not concentrating on it, but you can resume and cease concentrating again to use its  effects  on the target any number of times within the power's duration.

Augmented: If you expend one use of mythic power, the duration becomes concentration plus one round per level.

Augmented (4th): If you expend two uses of mythic power, you add half your tier to the save each round on the subject's turn.`
  },
  Compelling_Voice: {
    name: "Compelling Voice, Naija's",
    discipline: "Telepathy (Compulsion) [Mind-Affecting, Language-Dependent];",
    level: "Telepath 2",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 hour/level or until completed",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "3",
    description: `You tune your voice to the empathic vibrations of your target, making the next words you speak seem very convincing (limited to a sentence or two). The suggestion must be worded in such a manner as to make the activity sound reasonable. Asking the creature to do some obviously harmful act automatically negates the effect of the power.

The suggested course of activity can continue for the entire duration. If the suggested activity can be completed in a shorter time, the power ends when the subject finishes what it was asked to do. You can instead specify conditions that will trigger a special activity during the duration. If the condition is not met before the power duration expires, the activity is not performed.

A very reasonable suggestion causes the save to be made with a penalty (such as –1 or –2).

Augment: For every 2 additional power points you spend, this power can affect an additional target and the power's save DC increases by 1. Any additional target cannot be more than 15 feet from another target of the power.

Mythic Naija's Compelling Voice[]

Mythic compelling voice loses the language-dependent descriptor, and can target one or more living creatures in a 10-foot-radius burst.`
  },
  Mindscape_Transcendence: {
    name: "Mindscape Transcendence",
    discipline: "Telepathy (network) (mind-affecting)",
    level: "Cryptic 3, Dread 3, Highlord 3, Psion/Wilder 3, Telepath 2, Tactician 3, Vitalist 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Personal, see text",
    target: "You",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates (see text)",
    powerResistance: "yes",
    powerPoints: "5, telepath 3",
    description: `Your conscious mind immediately leaps in or out of a mindscape. If you manifest this power outside of mindscape, you may enter a mindscape inhabited by a creature of your choice within close range (25 feet + 5 feet per 2 levels). The creature is allowed a Will save to prevent you from following it into the mindscape.

If you manifest this power inside of a mindscape, you may have your mind exit the mindscape and return to your body.

You may manifest this power while inside a binary mindscape in order to leave it. This power may be used to leave a binary mindscape but not to enter one.

Augment

• For every 2 additional power points you spend, you may affect an additional touched creature with this power.

• By spending 4 additional power points, you may exist simultaneously in and outside the mindscape. You may take a full round's worth of actions inside the mindscape as well as outside the mindscape, and do not take any penalties to AC outside of the mindscape while engaged in a psychic duel.

• If you spend 2 additional power points, you may use this power to enter a binary mindscape being used for a psychic duel. One creature of your choice inside is allowed a Will save, being shunted out of the mindscape on a failed save. You remain to resume the psychic duel with the remaining participant if they fail, but are yourself shunted out if they succeed.

• If you spend 4 additional power points, you may use this ability to enter or exit a creature's dreamscape much in the same way that you would do with a mindscape`
  },
  Numbed_Mind: {
    name: "Numbed Mind",
    discipline: "Telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, telepath 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round / level",
    savingThrow: "Will (see text)",
    powerResistance: "No",
    powerPoints: "3",
    description: `You numb the mind of the target, making their thoughts unfocused and imprecise. This makes the target harder to affect with any mind-affecting abilities, but if they are casters or manifesters, they can't use their mind to its fullest potential. The target gains a +4 bonus to saves against any mind-affecting abilities, spells or powers, but lose access to the highest level of spells, powers, spell-like abilities or psi-like abilities they possess. For example: Wayana, a 6th level sorcerer is targeted by numbed mind and fails her Will-save. For the duration of the power, she gains a +4 bonus to her saves against other mind-affecting abilities but cannot cast her 3rd level spells.

Augment: This power may be augmented in one or more of the following ways.

• 1. If you spend 4 additional power points, the duration becomes 1 minute / level.

• 2. For every additional power point you spend, you can target another creature.

• 3. If you spend 8 additional power points, the duration becomes permanent, but the target gets a new save (without the bonus) after having slept for at least 8 hours for as long as the power is in effect.`
  },
  Read_Thoughts: {
    name: "Read Thoughts",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 2, highlord 2, tactician 2, telepath 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "Cone-shaped emanation centered on you",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "Will negates; see text",
    powerResistance: "No",
    powerPoints: "3",
    description: `You know the surface thoughts of the mind of any creature in the area that fails a Will save. A target that succeeds on its save is not affected by this manifestation of the power, even if it leaves the area and then reenters the area before the duration expires.

Creatures of animal intelligence have simple, instinctual thoughts that you can pick up. If you read the thoughts of a creature with an Intelligence of 26 or higher (and at least 10 points higher than your own Intelligence score), you are stunned for 1 round and the power ends. This power does not let you pinpoint the location of an affected mind if you don't have line of sight to the subject.

Each round, you can turn to use this power in a new area. The power can penetrate barriers, but 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood or dirt blocks it.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Sense_Minds: {
    name: "Sense Minds",
    discipline: "Telepathy [Mind-affecting]",
    level: "Marksman 1, telepath 2",
    display: "Visual",
    manifestingTime: "1 standard action",
    range: "60 ft.",
    target: "",
    area: "cone-shaped emanation",
    duration: "Concentration, up to 1 min / level; (see text)",
    savingThrow: "Will negates",
    powerResistance: "no",
    powerPoints: "Marksman 1, telepath 3",
    description: `You can locate creatures. For the duration of the effect, you can detect any non-mindless creature in range, although the amount of information you learn depends on how long you concentrate on an area.

1st Round: Presence or absence of thoughts (from conscious creatures with Intelligence scores of 1 or higher).

2nd Round: Number of thinking minds and the Intelligence score of each. If the highest Intelligence is 26 or higher (and at least 10 points higher than your own Intelligence score), you are stunned for 1 round and the effect ends.

If you concentrate on a specific creature in the area of effect for one full round, you can pinpoint their exact location.`
  },
  Susceptible_Mind: {
    name: "Susceptible Mind",
    discipline: "Telepathy (mind-affecting)",
    level: "Cryptic 2, dread 2, telepath 2",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "One hour / level",
    savingThrow: "None",
    powerResistance: "No",
    powerPoints: "3",
    description: `You bend the mind of a creature so that it becomes less resistant to powers and spells that warp their loyalty. The target must roll twice to save against any charm or compulsion spells, powers or effects, and take the worst save.

Augment: This power may be augmented in one or more of the following ways.

• If you spend 2 additional power points, the duration of any failed charm or compulsion effect is doubled.

• If you spend 2 additional power points, you can affect another creature in range.`
  },
  Battlesense: {
    name: "Battlesense",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Highlord 3, tactician 3, telepath 3, vitalist 3",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "30 feet (see text)",
    target: "1 willing creature/level",
    area: "",
    duration: "1 round/level",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "5",
    description: `You link the minds of your allies, dramatically improving their coordination. When you manifest this power, a type of heads-up display appears in each target's mind, improving their coordination and group awareness. Each affected target can use the Aid Another action as an immediate action. Creatures that move out of the 30 foot range after the power is manifested are still affected by the power.

Additionally, all targets that are also willing members of your collective (if any) gain one special ability of your choice from this list. Your choice affects all members equally.

• +1 circumstance bonus to attack rolls

• +1 circumstance bonus to AC

• +2 circumstance bonus to weapon damage

• +5 circumstance bonus to speed

Augment: You may augment this power in one or both of the following ways.

• If you spend 2 additional power points, you can choose a second special ability from the collective bonus list. You may choose the same benefit again; if you do, it stacks with itself (up to +5 for attack rolls or AC, +10 for weapon damage, or +25 for bonus to speed).

• If you spend 2 additional power points, you can use this power as if you had the collective class feature, treating creatures with which you have established a mental link, such as the mindlink power, as members. Creatures that would not consider you an ally if not for the link do not count as willing members.`
  },
  Crisis_of_Breath_Kozak_s: {
    name: "Crisis of Breath, Kozak's",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]; Leve l : Telepath 3, vitalist 3",
    level: "",
    display: "Auditory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One breathing humanoid",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates, Fortitude partial; see text",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You compel the subject to purge its entire store of air in one explosive exhalation, and thereby disrupt the subject's autonomic breathing cycle. The subject's lungs do not automatically function again while the power's duration lasts.

If the target succeeds on a Will save when crisis of breath is manifested, it is unaffected by this power. If it fails its Will save, it can still continue to breathe by taking a standard action in each round to gasp for breath.

An affected creature can attempt to take actions normally (instead of consciously controlling its breathing), but each round it does so, beginning in the round when it failed its Will save, the subject risks blacking out from lack of oxygen. It must succeed on a Fortitude save at the end of any of its turns in which it did not consciously take a breath. The DC of this save increases by 1 in every consecutive round after the first one that goes by without a breath; the DC drops back to its original value if the subject spends an action to take a breath.

If a subject fails a Fortitude save, it is disabled (0 hp). In the following round, it drops to –1 hit points and is dying. Curing powers or spells can revive a dying subject normally, so long as this power's duration has expired; if the power is still in effect, a revived creature is still subject to Fortitude saves in each round when it does not consciously breathe.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, this power can also affect an animal, fey, magical beast, or monstrous humanoid.

• If you spend 4 additional power points, this power can also affect an aberration, dragon, elemental, or outsider in addition to the creature types mentioned above.

• If you spend 6 additional power points, this power can affect up to four creatures all within a 20-ft.-radius burst.

In addition, for every 2 additional power points you spend to achieve any of these effects, this power's save DC increases by 1.

Mythic Kozak's Crisis of Breath[]

Continuing to breathe requires a full-round action instead of a standard action.

Augmented (5th): If you expend three uses of mythic power, the target must make a successful save each round it attempts to continue to breathe. Failing the save means the attempt to breathe failed and the action is wasted.`
  },
  Empathic_Transfer_Hostile: {
    name: "Empathic Transfer, Hostile",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Gambler 3, highlord 3, psychic warrior 3, tactician 3, telepath 3, vitalist 3",
    display: "Auditory and material",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "Creature touched",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will half",
    powerResistance: "Yes",
    powerPoints: "5",
    description: `You transfer your hurt to another. When you manifest this power and then make a successful touch attack, you can transfer 50 points of damage (or less, if you choose) from yourself to the touched creature. The damage you transfer may not exceed the damage you currently have. You immediately regain hit points equal to the amount of damage you transfer.

You cannot use this power to gain hit points in excess of your full normal total. The transferred damage is empathic in nature, so powers and abilities the subject may have such as damage reduction and regeneration do not lessen or change this damage.

The damage transferred by this power has no type, so even if the subject has immunity to the type of damage you originally took, the transfer occurs normally and deals hit point damage to the subject.

Augment: You can augment this power in one or both of the following ways.

• For every additional power point you spend, you can transfer an additional 5 points of damage (maximum 70 points per manifestation), although you must still have that amount of actual damage to transfer.

• If you spend 6 additional power points, this power affects all creatures in a 20-foot-radius spread centered on you, transferring the full amount of damage to each creature, although no matter how many targets you affect, you only heal the highest amount transferred to any one target.

Mythic Hostile Empathic Transfer[]

The range of the effect, both the standard and the 6 power point augment, increases to 30 feet. You do not need to make a touch attack to target a creature.`
  },
  False_Sensory_Input: {
    name: "False Sensory Input",
    discipline: "Telepathy (mind-affecting)",
    level: "Telepath 5",
    display: "Mental",
    manifestingTime: "1 round",
    range: "Long (400 ft. + 40 ft./level)",
    target: "One creature",
    area: "",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `False Sensory Input[]

You have a limited ability to falsify one of the subject's senses. The subject thinks she sees, hears, smells, tastes, or feels something other than what her senses actually report. You can't create a sensation where none exists, nor make the subject completely oblivious to a sensation, but you can replace the specifics of one sensation with different specifics. For instance, you could make a human look like a dwarf (or one human look like another specific human), a closed door look like it is open, a vat of acid smell like rose water, a parrot look like a bookend, stale rations taste like fresh fruit, a light pat feel like a dagger thrust, a scream sound like the howling wind, and so on.

You can switch between senses you falsify round by round. You can't alter the size of an object by more than 50% by using this power. Thus, you couldn't make a castle look like a hovel, but you could make it look like a different castle, or a rough hillock of approximately the same size. If this power is used to distract an enemy manifester who is attempting to use his powers, the enemy must make a concentration check as if being grappling or pinned.

Because you override a victim's senses, you can fool a victim who is using true seeing or some other method of gathering information, assuming you know that the victim is actively using such an effect and you can maintain concentration.

Augment: For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

False Sensory Input, Complex[]

This power functions as false sensory input , save that the effects are more potent and can take more forms. Two senses rather than 1 are affected by this power, and it is possible to create sensations where none exist or alter the perceived size of an entity by more than 50%.

Augment

In addition to using the augments of false sensory input , this power can be augmented in the following ways

• For every 2 additional power points you spend, you may affect an additional sense with this power.

• If you spend 2 additional power points, you may use this power to interfere with clarifying abilities. Any creature affected by this power loses any insight bonuses they possess. If you spend 2 additional power points beyond this, any insight bonuses it possesses become penalties of equal amount.

• For every 2 additional power points you spend on this power (including as part of another augment), the save DC increases by 1.

Mythic False Sensory Input[]

You can completely define what the target perceives, including not seeing, hearing, or feeling certain things, creating phantom sounds, sights, or sensations of touch. The creature still feels pain, but otherwise its five senses are controlled by you.`
  },
  Mindscape_Genesis: {
    name: "Mindscape Genesis",
    discipline: "Telepathy (mind-affecting)",
    level: "Dread 3, Telepath 3",
    display: "Mental",
    manifestingTime: "1 full round",
    range: "See text",
    target: "",
    area: "",
    duration: "see text",
    savingThrow: "Will negates (see text)",
    powerResistance: "no",
    powerPoints: "5",
    description: `ffect: ffect 1 Illusory Creature

You infuse a mindscape with an illusory creature, which acts believably on all accounts. The creature may be created anywhere in the mindscape, and may take any form. You automatically sense anything that the creature senses, and may direct the creature to act in whatever manner you wish. The creature lasts as long as the mindscape does, but you may eliminate any creature you create as a free action. Individuals who interact with the creature are allowed a Will save to recognize the illusion.

If you manifest this power while outside of a mindscape, you may generate your creation inside of the mindscape of a creature within close range (25 ft + 5 ft/level). The creature is allowed a will save to prevent you from sending a creation into their mindscape.

Augment

• For every additional power point you spend, you may create an additional creature within the mindscape

• For every 2 power points you spend augmenting this power (including as part of other augments), the save DC increases by 1`
  },
  Alienation: {
    name: "Alienation",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Highlord 4, tactician 4, telepath 4",
    display: "Auditory, mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "1 living creature",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You close off the centers of the subject's mind that deal with communication and social interaction. The subject effectively loses knowledge of all languages (including telepathic and body language) and is treated as illiterate for the duration of the power. He may still “speak” and provide verbal components, and to him they sound completely normal, but to anyone else they appear as complete gibberish.

The subject is unable to understand anyone else on any level and is unable to determine friend from foe. This prevents things such as Sense Motive, the Aid Another action (or benefits from another's Aid Another), any skill check involving communication (including Linguistics), using teamwork feats, knowing if a magical effect used on him is harmless or not until it hits him (thus, he attempts a save against all effects he could) unless he makes a successful Spellcraft check to identify the effect, gaining the benefits from abilities such as bardic performance, or using any Charisma-based skill check (except Use Magic Device).

The target no longer counts as an ally for the purposes of determining flanking and all creatures who threaten the subject are considered allies for their own flanking purposes. In addition, the subject cannot make attacks of opportunity while under this effect.

The subject still understands if his attacks or powers are successful.

Augment: For every additional power point you spend, this power may affect an additional target. No two targets may be further than 15 feet apart. For every 2 power points spent this way, the power's save DC increases by 1.`
  },
  Fear_Cascade: {
    name: "Fear Cascade",
    discipline: "Telepathy [Fear, Mind-Affecting]",
    level: "Dread 4, gambler 4, telepath 4",
    display: "Mental, visual",
    manifestingTime: "1 standard action",
    range: "Long (400 ft. + 40 ft./level)",
    target: "One creature and any number within 20 ft.",
    area: "",
    duration: "1 round / level",
    savingThrow: "Will negates or no; see text; Power",
    powerResistance: "",
    powerPoints: "7",
    description: `Resistance: Yes

You overload the target creature's mental and physical faculties with fear, a fear so powerful that even creatures near the original target are affected by the residual energy. When you manifest this power, the target is cowering unless it makes a successful Will save.

In addition, all enemies within 20 feet of the target, including the target, are shaken for 1 round.

Augment: You can augment this power in one or more of the following ways.

• For every 2 additional power points you spend, the duration of the shaken condition increases by 1 round.

• For every 4 additional power points you spend, the radius for nearby affected creatures increases by 10 feet.

In addition, for every 2 power points you spend augmenting this power, the save DC increases by +1.`
  },
  Memory_Modification: {
    name: "Memory Modification",
    discipline: "Telepathy (Compulsion) [Mind-Affecting]",
    level: "Telepath 4",
    display: "Mental",
    manifestingTime: "1 round",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Permanent",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `You reach into the subject's mind and modify as many as 5 minutes of its memories in one of the following ways.

• Eliminate all memory of an event the subject actually experienced. This cannot negate charm, geas/quest, suggestion, or similar spells.

• Allow the subject to recall with perfect clarity an event it actually experienced.

• Change the details remembered of an event the subject actually experienced.

• Implant a memory of an event the subject never experienced.

Manifesting this power takes 1 round. If the subject fails to save, you proceed by spending as much as 5 minutes (a period of time equal to the amount of memory you want to modify) visualizing the memory you wish to modify in the subject. If your concentration is disturbed before the visualization is complete, or if the subject is ever beyond the power's range during this time, the power fails.

A modified memory does not necessarily affect the subject's actions, particularly if it contradicts the creature's natural inclinations. An illogical modified memory is dismissed by the creature as a bad dream, too much wine, or another similar excuse.

Mythic Memory Modification[]

It takes only one round to visualize the memory you are modifying and you may modify up to 10 minutes of memory.`
  },
  Mind_Control_Geth_s: {
    name: "Mind Control",
    discipline: "Telepathy",
    level: "Highlord 4, Psion/Wilder 4, Tactician 4",
    display: "Olfactory",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level); see text",
    target: "1 unintelligent creature or swarm of unintelligent creatures",
    area: "",
    duration: "1 day/level; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Mind Control

You can control the actions of any humanoid creature through a telepathic link that you establish with the subject's mind.

If you and the subject have a common language, you can generally force the subject to perform as you desire, within the limits of its abilities. If no common language exists, you can communicate only basic commands, such as “Come here,” “Go there,” “Fight,” and “Stand still.” You know what the subject is experiencing, but you do not receive direct sensory input from it, nor can it communicate with you telepathically.

Once you have given a controlled creature a command, it continues to attempt to carry out that command to the exclusion of all other activities except those necessary for day-to-day survival (such as sleeping, eating, and so forth). Because of this limited range of activity, a Sense Motive check against DC 15 (rather than DC 25) can determine that the subject's behavior is being influenced by an enchantment effect (see the Sense Motive skill description).

Changing your orders or giving a dominated creature a new command is a move action.

By concentrating fully on the power (a standard action), you can receive full sensory input as interpreted by the mind of the subject, though it still can't telepathically communicate with you. You can't actually see through the subject's eyes, so it's not as good as being there yourself, but you still get a good idea of what's going on.

Subjects resist this control, and any subject forced to take actions against its nature receives a new saving throw with a +2 bonus. Obviously self-destructive orders are not carried out. Once control is established, the range at which it can be exercised is unlimited, as long as you and the subject are on the same plane. You need not see the subject to control it.

If you don't spend at least 1 round concentrating on the power each day, the subject receives a new saving throw to throw off the mind control.

Protection from evil or a similar effect can prevent you from exercising control or using the telepathic link while the subject is so warded, but such an effect does not automatically dispel it.

Augment: You can augment this power in one or more of the following ways.

• If you spend 2 additional power points, this power can also affect an animal, fey, magical beast, or monstrous humanoid.

• If you spend 4 additional power points, this power can also affect an aberration, dragon, elemental, or outsider in addition to the creature types mentioned above.

• For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

In addition, for every 2 additional power points you spend to achieve any of these effects, this power's save DC increases by 1.

Hive Control[]

Your willpower seizes hold of a nearby entity of infinitesimal intellect, enabling you to usurp control over their actions. This ability functions as mind control , save that it does not affect a single creature. Rather, it takes control of a single creature or swarm of creatures with an intelligence score of -. Even if such creatures cannot understand your commands, they intuitively know your commands and obey them.

Augment

• For every 2 additional power points you spend, you may target one additional creature or swarm with this effect.

• If you spend 6 additional power points, you may use this power to control intelligent swarms or troops as if they were unintelligent swarms.

• For every 2 additional power points you spend (including as part of other augments), the save DC of this power increases by 1.

Mythic Mind Control[]

The Sense Motive DC to notice your target is dominated increases by double your tier. You can give orders to the target even if it's protected by non-mythic effects that block magical control, such as protection from evil . If the target is protected by a mythic effect, you can attempt to overcome this defense with a manifester level check (DC 15 plus the manifester level of the effect); add your tier to your roll and the opposing manifester's tier to the DC. If the target succeeds at its Will save to break your control, as an immediate action you can expend one use of mythic power to force it to reroll the save and use the lower result.`
  },
  Mindlink_Thieving: {
    name: "Mindlink, Thieving",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Telepath 4",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Close (25 ft. + 5 ft./2 levels); see text",
    target: "",
    area: "",
    duration: "10 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Mindlink[]

Targets: You and one other willing creature within range that has an Intelligence score of 3 or higher

You forge a telepathic bond with your target. You can communicate telepathically through the bond even if you do not share a common language. No special power or influence is established as a result of the bond. Once the bond is formed, it works over any distance (although not from one plane to another).

Augment: You can augment this power in one or both of the following ways.

• If you spend 4 additional power points, you can attempt to create a telepathic bond with a creature that is not willing (Will save negates).

• For every additional power point you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

Mindlink, Thieving[]

As mindlink , except that if the target is a psionic character or creature that knows powers, you can temporarily borrow a power of your choice (you are aware of what powers the subject knows, up to the highest level of power you can manifest).

Borrowing the subject's power is a separate standard action that provokes an attack of opportunity. If the attack to borrow a power succeeds, the mental communication provided by this power ends immediately. The borrowed power fades from the subject's awareness and appears within your own. You can now spend power points to manifest the borrowed power just as if it were one of your powers known. You maintain knowledge of the borrowed power until the duration of your thieving mindlink expires, at which time you lose knowledge of the power and the power reappears in the mind of the subject, no matter how far from you the subject is. Even if the subject is slain, you lose knowledge of the borrowed power when this power's duration expires.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.`
  },
  Schism: {
    name: "Schism",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Dread 5, telepath 4",
    display: "Auditory and visual",
    manifestingTime: "1 standard action",
    range: "Personal",
    target: "You",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "Dread 9, telepath 7",
    description: `Your mind splits into two independent parts. Each part functions in complete autonomy, like two characters in one body. Your new “second mind” does not control your body physically but is free to take one standard action in each round if the action is purely mental (such as manifesting a power) in the same round you take your normal actions. Your second mind can manifest powers using your power point reserve, but only as if your manifester level were six lower than it is. Your second mind doesn't provoke attacks of opportunity when manifesting a power, because doing so doesn't distract your primary mind.

Having a second mind is strenuous on your psyche, and your primary mind suffers a -2 manifester level penalty in any round in which the secondary mind has used its action. If your secondary mind does not do anything in a round, your primary mind does not suffer this penalty.

Your second mind takes its first action on your turn in the round after schism is manifested.

Both your minds communicate with each other telepathically. If you are subject to a compulsion or charm effect while you are of two minds, make a second saving throw if you fail the first. If you fail both, then the schism ends and you are affected normally by the power. If you fail just one, the schism ends immediately, but you are not subject to the compulsion or charm.

Your second mind does not gain any advantages if you are subject to a haste effect, although you gain the overall standard benefits.

Your second mind cannot access your psionic focus and does not benefit if you are maintaining psionic focus. Your second mind may gain psionic focus if you have the Psionic Meditation feat.`
  },
  Sensory_Cascade: {
    name: "Sensory Cascade",
    discipline: "Telepathy (Mind-Affecting)",
    level: "Dread 4, psion/wilder 4",
    display: "Visual",
    manifestingTime: "",
    range: "Medium (100 feet + 10 feet/level)",
    target: "All creatures in a 15-foot radius",
    area: "",
    duration: "1 round/level",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "7",
    description: `Manifestation Time: One standard action

You overload the target's sensory system. In effect, the cascade buries the senses of the target creatures (even those with blindsight, tremorsense, touchsight, or other esoteric methods of sensing the environment) with random sensations for the duration. The creatures are treated as if blinded. However, from round to round, an affected creature has a chance to sense normally. Each round on the creature's action, roll 1d4. On a roll of 1-3, the target does nothing for 1 round as it stands attempting to re-establish contact with its senses. Rolling a 4 frees the creature of the effect for 1 round.

Sense-blocked creatures that are attacked (and damaged) are shocked out of their sense deprivation for 1 round - they can attack or attempt to flee however they desire on their next action. The following round they are subject once again to the sensory cascade (unless they are continually attacked each round).

Augment: This power can be augmented in one of the following ways.

• If you spend an additional 4 power points, the condition lasts 24 hours.

• If you spend an additional 6 power points, the condition is permanent.`
  },
  False_Sensory_Input_Complex: {
    name: "False Sensory Input, Complex",
    discipline: "Telepathy (mind-affecting)",
    level: "Telepath 5",
    display: "Mental",
    manifestingTime: "1 round",
    range: "Long (400 ft. + 40 ft./level)",
    target: "One creature",
    area: "",
    duration: "Concentration, up to 1 min./level (D)",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `False Sensory Input[]

You have a limited ability to falsify one of the subject's senses. The subject thinks she sees, hears, smells, tastes, or feels something other than what her senses actually report. You can't create a sensation where none exists, nor make the subject completely oblivious to a sensation, but you can replace the specifics of one sensation with different specifics. For instance, you could make a human look like a dwarf (or one human look like another specific human), a closed door look like it is open, a vat of acid smell like rose water, a parrot look like a bookend, stale rations taste like fresh fruit, a light pat feel like a dagger thrust, a scream sound like the howling wind, and so on.

You can switch between senses you falsify round by round. You can't alter the size of an object by more than 50% by using this power. Thus, you couldn't make a castle look like a hovel, but you could make it look like a different castle, or a rough hillock of approximately the same size. If this power is used to distract an enemy manifester who is attempting to use his powers, the enemy must make a concentration check as if being grappling or pinned.

Because you override a victim's senses, you can fool a victim who is using true seeing or some other method of gathering information, assuming you know that the victim is actively using such an effect and you can maintain concentration.

Augment: For every 2 additional power points you spend, this power can affect an additional target. Any additional target cannot be more than 15 feet from another target of the power.

False Sensory Input, Complex[]

This power functions as false sensory input , save that the effects are more potent and can take more forms. Two senses rather than 1 are affected by this power, and it is possible to create sensations where none exist or alter the perceived size of an entity by more than 50%.

Augment

In addition to using the augments of false sensory input , this power can be augmented in the following ways

• For every 2 additional power points you spend, you may affect an additional sense with this power.

• If you spend 2 additional power points, you may use this power to interfere with clarifying abilities. Any creature affected by this power loses any insight bonuses they possess. If you spend 2 additional power points beyond this, any insight bonuses it possesses become penalties of equal amount.

• For every 2 additional power points you spend on this power (including as part of another augment), the save DC increases by 1.

Mythic False Sensory Input[]

You can completely define what the target perceives, including not seeing, hearing, or feeling certain things, creating phantom sounds, sights, or sensations of touch. The creature still feels pain, but otherwise its five senses are controlled by you.`
  },
  Metaconcert: {
    name: "Metaconcert",
    discipline: "Athanatism",
    level: "Conduit 7, Tactician 7, Vitalist 7",
    display: "Mental, Visual, see text",
    manifestingTime: "1 minute",
    range: "20 ft.",
    target: "You and up to five deceased psionic creatures in range; see text",
    area: "",
    duration: "1 min./level (D)",
    savingThrow: "",
    powerResistance: "",
    powerPoints: "13",
    description: `Metaconcert[]

You link your psychic might with other psionic creatures, creating a composite network more powerful than the sum of its parts. If there are no willing, psionic creatures in the area other than you when you use this power, it fails.

When you manifest this power, up to five willing, psionic creatures in the area connect with you into a metaconcert network (a “metanetwork”), a distributed, metaphysical analogue of a psionic manifester. Misty strands of glowing power link the brows of each member in a complex and shifting pattern, and a mental image of each other member appears in the minds of everyone so linked. A number of power points you designate flow from each member (including yourself) into a collective pool. If a member does not have enough power points to contribute, he drops out of the metaconcert (see below).

One individual is chosen as the metaconcert conductor by mutual consent of the other members (this is usually the manifester, but doesn't have to be). Until the power ends, this conductor directs the efforts of the network. Members of a metaconcert can continue to take actions of their own as normal without disrupting the metanetwork, provided they stay within the area (see below).

All the powers known of each member (except metaconcert) are available to the conductor through the metanetwork. While the conductor may still manifest his own powers as normal, he may instead choose to manifest a power from the metanetwork instead of from his own powers known. If he does so, he must use the power point pool of the metanetwork and may not use any of his feats or class features to modify the manifestation (although items are permitted), but he also gains numerous benefits. When manifesting a power from the metanetwork, his manifester level increases by one for each other metanetwork member (for instance, the normal maximum membership of five members besides the conductor increases the conductor's manifester level by five). It is obvious to an outsider when the conductor manifests from the metanetwork, as arcs of light pulse between the various members in a scintillating pattern, streaming to the conductor as his power manifests -- this display cannot be hidden.

The metanetwork also supports its members. Each member of the metanetwork gains a bonus on saving throws made against spells or powers equal to the number of other members, as the metanetwork distributes incoming magical energy about its nodes. If a spell or power would deal damage or ability damage to the conductor, he may choose to instead distribute it evenly between himself and all willing members. An individual member may decline receiving damage this way on a case-by-case basis (for example, if a metaconcert consists of the conductor and four other members, one of whom is not willing to receive damage at this time, the conductor may split the incoming damage between himself and the three willing members). Damage split to willing members this way is typeless and empathic in nature. This splitting takes place prior to the effects of other powers or abilities that lessen damage, such as energy resistance or the intellect fortress power. Spells and powers that are not subject to power resistance cannot have their damage or ability damage split this way, though the saving throw bonus still applies.

Once the metanetwork forms, the members must remain within the power's area, and as a group can move at half the slowest member's speed on the conductor's turn. This counts as a move action for each member (that is, if the group moves, each member is treated as having used a move action on their next turn). If a member moves outside the area (whether willingly or involuntarily), that individual drops out of the group, and the power point pool of the metanetwork is instantly recalculated.

All members who leave before a metaconcert ends or is dismissed reclaim a number of power points equal to the metanetwork's current power point pool divided by the number of members. That same number of points is removed from the metanetwork's power point pool. If the conductor drops out, the power ends. When a metaconcert ends normally or is dismissed, remaining power points in the pool are divided among all the members (the conductor receives the remainder if the points can't be divided evenly). No creature can leave a metaconcert with more power points than they had when they entered it -- surplus points dissipate as harmless light radiating from the creature's eyes.

Augment: For every additional power point you spend, this power's duration increases by 1 minute. For every 2 additional power points spent this way, the maximum number of members of the metanetwork increases by one, and the range and radius of the area of effect increase by 5 ft.

Soul Chorus[]

Drawing upon the powers of the fallen, you harness their latent psionic power for your own gain. This functions as metaconcert , save that instead of targeting willing allies, you instead target dead psionic creatures within range. The soul chorus draws all power points that the dead targets possessed at the time that they died, and the conductor may use any powers that were known to any of the creatures. Damage can be split evenly between the manifester and the dead targets as between creatures in a metanetwork (a corpse normally possesses 10 hp, plus 10 for each size it is above small), but any ability damage that would be transferred instead destroys any dead bodies that would take it.

Alternatively, this power can be used as a normal metaconcert power, save that it can target undead creatures as well as living creatures.

Augment

• For every additional power point you spend, this power's duration increases by 1 minute.

• For every 2 additional power points spent this way, the maximum number of members of the metanetwork increases by one, and the range and radius of the area of effect increase by 5 ft.

Mythic Metaconcert[]

The metaconcert conductor can manifest any mythic powers known by members of the metanetwork and gains an additional bonus to his manifester level equal to your tier. Members of the metanetwork gain a bonus on saving throws equal to your mythic tier. Hit point and ability damage is reduced by your tier before it is distributed.

Augmented: If you expend one use of mythic power, members of the metanetwork may spend a swift action to add more power points into the metanetwork's power point pool.`
  },
  Mind_Probe: {
    name: "Mind Probe",
    discipline: "Telepathy (Charm) [Mind-Affecting]",
    level: "Gambler 5, telepath 5",
    display: "Auditory, material, and visual",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "1 round/level (D)",
    savingThrow: "Will partial; see text",
    powerResistance: "Yes",
    powerPoints: "9",
    description: `All the subject's memories and knowledge are accessible to you, from memories deep below the surface to those still easily called to mind. You can learn the answer to one question per round, to the best of the subject's knowledge. If the subject succeeds on a Will save, it is not required to answer the question; however, making a save does not end the power. You can ask the subject a new question (or the same question) in subsequent rounds for as long as the power's duration persists.

You can probe a sleeping subject and automatically get an answer to your question. If the subject then succeeds on a Will save, it wakes after providing the answer and thereafter can resist answering by making Will saves as described above.

Subjects that do not wish to be probed can attempt to move beyond the power's range, unless they are somehow hindered. You pose the questions telepathically, and the answers to those questions are imparted directly to your mind. You and the subject do not need to speak the same language, though less intelligent creatures may yield up only appropriate visual images in answer to your questions.

Augment: This power may be augmented in one or both of the following ways.

• If you spend 2 additional power points, the power's range increases to Medium (100 ft. + 10 ft./level).

• For every 2 additional power points you spend, the power's save DC increases by 1.

Mythic Mind Probe[]

Creatures under the effect cannot move out of range of the effect once it has started. You add your tier to your manifester level to determine the duration and range of this power.

Augmented: If you expend one use of mythic power, the target is completely unaware when it makes a save and does not wake up if asleep even if it makes a successful save.`
  },
  Mindscape_Invitation: {
    name: "Mindscape Invitation",
    discipline: "Telepathy (network) (mind-affecting)",
    level: "Dread 5, Highlord 5, Telepath 5, Tactician 5",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Unlimited",
    target: "1 willing creature/manifester level",
    area: "",
    duration: "Instantaneous",
    savingThrow: "none (harmless)",
    powerResistance: "yes",
    powerPoints: "9",
    description: `You call together the minds of several willing creatures, pulling them into a mindscape that you currently reside in (or that you enter with the manifestation of this power). Regardless of their location, creatures are brought inside the mindscape (but can leave or be forced out as normal). From that point, creatures are allowed to interact or do whatever they wish in the mindscape.

Augment

• If you spend 4 additional power points, you may bring unwilling minds into the mindscape. Such creatures are allowed a Will save to avoid being pulled in.

• If you spend 4 additional power points, you may use this ability on creatures who are asleep. Their dreaming minds are pulled into the mindscape if they are willing (or they are allowed a saving throw if they are unwilling and the power is augmented in the first manner).`
  },
  Assign_Imperative: {
    name: "Assign Imperative",
    discipline: "Telepathy (curse, mind-affecting)",
    level: "Telepath 6",
    display: "Auditory and Mental",
    manifestingTime: "10 minutes",
    range: "close (25 feet + 5 feet/level)",
    target: "One creature",
    area: "",
    duration: "Permanent",
    savingThrow: "None",
    powerResistance: "yes",
    powerPoints: "11",
    description: `One of the most terrifying abilities of any telepath, this power distorts the ambitions of a target for a permanent duration. You command the target to perform or refrain from specific action, forcing the target to follow the given instructions until the job is completed, no matter how long it takes. If the instructions involve some open-ended task that the recipient cannot complete through his own actions, the power remains in effect for a maximum of 1 day per manifester level. A clever recipient can subvert some instructions. This power cannot be dispelled as normal, and only a cleanse spirit , bend reality , or similarly powerful instance of magic can end its effects. Even still, these effects require a successful manifester level check (DC 10 + your manifesting ability score modifier + the number of power points spent on this power) in order to dispel this power. However, a psychic chirurgery power is strong enough to end the effects of this power automatically.

AUGMENT

In addition to the ways that mind control can be augmented, this power can be augmented in the following ways.

• If you spend 4 additional power points, you may manifest this power as a standard action. If you do, the target is allowed a Will save.

• If you spend 4 additional power points, you may force a creature under the effects of this power to perform actions against its nature, including self-destructive actions. E creature is allowed a saving throw to break away from this effect if subjected to a flagrant command of this manner.

• If you spend 2 additional power points, you may deteriorate the mind and body of the targeted creature should their efforts prove insufficient. Once per day, you may cause a target to take a -3 penalty to all of its ability scores. These penalties are cumulative, but can never reduce an ability score below 1.`
  },
  Mind_Switch: {
    name: "Mind Switch",
    discipline: "telepathy",
    level: "cryptic 6, psion/wilder 7, vitalist 7",
    display: "material, mental",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "11 cryptic, 13 psion/wilder and vitalist",
    description: `Mind Switch[]

Targets: You and one other creature

You can attempt to take control of a nearby living creature, forcing your mind (and soul) into its body, and its mind into your body. You can target any creature whose Hit Dice are equal to or less than your manifester level.

You possess the target's body and force the creature's mind into your body unless it succeeds on a Will save. You can move your mind back into your own body whenever you desire, which returns the subject's mind to its own body and ends the power. If the manifestation succeeds, your life force occupies the host body, and the host's life force takes over yours.

You can call on rudimentary or instinctive knowledge of the subject creature, but not upon its acquired or learned knowledge (such as skills and feats it possesses). The same is true for the subject in your body. The mind switch brings about the following changes.

• You gain the type of your assumed body.

• You gain the Strength, Dexterity, and Constitution scores of your assumed body.

• You gain the natural armor, natural attacks, movement, and other simple physical characteristics of your assumed body.

• You gain the extraordinary special attacks and qualities of your assumed body, but you do not gain supernatural or spell-like abilities, nor do you gain any class abilities of the assumed body. Any racial trait which relies upon power points, such as the elan's resilience trait, is considered to be a supernatural ability.

• You gain the possessions and equipment of your assumed body.

• You retain your own hit points and saving throws (both possibly modified by new ability scores), class abilities, supernatural and spell-like abilities, spells and powers, and skills and feats (although skill checks use your new ability scores, and you may be temporarily unable to use feats whose requirements you do not meet in your new body). You retain any racial abilities, so long as they are not based upon your original form (for example, the dromite's chitin is based upon his physical body, so would not be retained).

• You suffer one negative level while in your assumed body. Supernatural abilities that require a certain body part may be unavailable in your new form.

If either body is killed while the power is in effect, the other participant also dies when the power ends. If one participant's body becomes petrified, imprisoned by temporal stasis or imprisonment, or incapacitated in some other way, the other participant will be incapacitated in that way when the power ends.

A targeted dispel psionics (or similar spells or effects) successfully manifested on either participant causes both minds to return to their original bodies.

If you successfully use mind switch while already under the effect of mind switch , the original target is returned to its original body, the new target occupies your original body, and you occupy the body of the new target.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mind Switch, True[]

As mind switch, except as noted here.

You permanently exchange bodies with the subject. Since this power's duration is instantaneous, you cannot be forced to return to your natural body by means of dispel psionics, an antimagic field, or a similar effect. If the subject's body dies while you are in it, you are dead. The subject immediately suffers one permanent negative level, but otherwise survives the experience in your natural body. If your natural body dies while the subject is in it, you immediately suffer two permanent negative levels, but you likewise survive the experience in your new body. Negative levels gained in this way may only be cured by powerful healing, such as greater restoration or restoration ; they do not fade over time.

Your “natural” body is always considered to be the last one you switched out of. If you exchange bodies with a chain of multiple subjects, you need worry only about the welfare of the last body you switched with. In other words, if your mind is expelled from your current body, your mind returns to the last body you switched with, not to your original body. Similarly, if your original body dies but you have since switched minds with a second subject, you take no penalty. You suffer permanent negative levels only if the body you inhabited immediately prior to your current body is killed.

You suffer two temporary negative levels upon manifesting this power, as your mind adjusts to controlling a new body. These negative levels cannot be cured, but fade at a rate of one every 24 hours.

If you successfully use true mind switch while under the effect of mind switch , the original target of mind switch is returned to its original body, the new target of true mind switch occupies your original body, and you occupy the body of the target of true mind switch .

Data Transfer[]

This ability functions as true mind switch , except as noted above and save that it instead transfers an AI between machines rather than a mind between creatures. As it is not a mind-affecting power, constructs are not immune to its effects.

Augment: This power can be augmented in the following ways:

• By expending six additional power points, you may use this power to transfer an Artificial Intelligence to a non-robot creature. If you do, this power gains the mind-affecting descriptor and the new target acquires the aggregate template even if they otherwise could not.`
  },
  Crisis_of_Life: {
    name: "Crisis of Life",
    discipline: "Telepathy [Mind-Affecting, Death]; Leve l : Telepath 7, vitalist 7",
    level: "",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Medium (100 ft. + 10 ft./level)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Fortitude partial; see text",
    powerResistance: "Yes",
    powerPoints: "13",
    description: `You interrupt the subject's autonomic heart rhythm, killing it instantly on a failed saving throw if it has 11 Hit Dice or less. If the target makes its saving throw or has more than 11 Hit Dice, it takes 7d6 points of damage.

Augment: For every additional power point you spend, this power can kill a subject that has Hit Dice equal to 11 + the number of additional points. For every two additional points spent, the power's save DC increases by 1.

Mythic Crisis of Life[]

Non-mythic creatures with Hit Dice less than half your manifester level do not get a Fortitude save.

Augmented: If you expend one use of mythic power, creatures suffer 7d10 points of damage on a successful save.`
  },
  Phrenic_Overload: {
    name: "Phrenic Overload",
    discipline: "Telepathy (mind-affecting)",
    level: "Dread 6, Telepath 7, Tactician 7",
    display: "Auditory, Mental",
    manifestingTime: "1 standard action",
    range: "personal",
    target: "",
    area: "40-ft.-radius emanation centered on you",
    duration: "1 minute/level",
    savingThrow: "Will partial (see text)",
    powerResistance: "Yes",
    powerPoints: "13 telepath and tactician, 11 dread",
    description: `Psychic signals bombard all those nearby as the erratic and complex thoughts of their fellows unrelentingly flood the minds of all inside the field. Creatures inside the area of this power (excluding the manifester) struggle to operate in the maelstrom, taking a -4 penalty on all attack rolls, saving throws, and skill checks. In addition, by making a concentration check as a move action (DC 10 + the number of power points spent on this power + your manifesting ability score modifier), a creature (including the manifester) can pick out the thoughts of a particular creature, as the read thoughts power with no saving throw allowed.

Augment

• If you expend psionic focus, you may omit a number of creatures within the area from the effects of this power equal to your intelligence modifier.

• If you spend 4 additional power points, creatures affected by this power must succeed on a Will save or be confused so long as they remain in the area and for 1 round after they leave.

• If you spend 2 additional power points, you may also impose a -4 penalty on the AC of all affected creatures as well as to the save DCs of all of their abilities.

• If you spend 2 additional power points, you automatically succeed on any concentration checks made to read the minds of creatures within the effects of this power, and may read thoughts as a swift action.

• For every 2 power points you spend augmenting this power (including as part of other augments), its range increases by 10 feet and the save DC increases by 1.`
  },
  Mind_Seed: {
    name: "Mind Seed",
    discipline: "Telepathy (Compulsion) [Evil, Mind-Affecting]",
    level: "Telepath 8",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "Touch",
    target: "One touched humanoid your size or smaller",
    area: "",
    duration: "Instantaneous; see text",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "15",
    description: `You impress the totality of your psyche into a subject's subconscious. If successfully implanted, the seed of your mind “germinates” over the period of one week. During this time, the subject begins to unconsciously take on your mannerisms.

When integration is complete (after one week), the subject becomes you in mind as you were when you manifested the power, but the subject's level is eight lower than your own. The subject does not have any of your physical ability scores or equipment, but does have the Intelligence, Wisdom, and Charisma scores you had when you were eight levels lower. The subject also knows the powers you knew when you were eight levels lower. If the subject's race is different from yours, its racial traits do not change.

While the subject is initially your mental duplicate, the two personalities diverge over time. Although the subject starts off with memories of your experiences, it possesses its original “soul” and physical body and is free to develop its own personality based on its own new experiences. Thus, the subject is not your slave or servant, but instead a nonplayer character in its own right that shares your earlier memories.

Protection from evil or a similar spell or power can prevent you from implanting mind seed, or prevent a seed from germinating while the protective power lasts. Otherwise, a germinating seed can be removed (prior to germination) only by psychic chirurgery, reality revision , or similarly high-level effects. Manifesting mind seed again during the germination period also cleanses the subject's mind and does not carry with it the restriction of a target of your size or smaller

The process of impressing your psyche into another is demanding and draining. You suffer one negative level that does not go away until cleansed by an effect such as restoration . Cleansing a mind seed does not bestow this penalty.

The target of this power must be your size or smaller. Effects active that modify your size do not modify this restriction; if you are normally Medium size, but under the effect of expansion , you may still only target a Medium or smaller humanoid.

This power does not have the evil descriptor when used to cleanse a mind seed .

Mythic Mind Seed[]

The subject's level is four lower than you instead of 8. Non-mythic effects cannot remove the seed once implanted.

Augmented (3rd): If you expend one use of mythic power, the range increases to 25 feet plus 5 feet per level instead of touch.

Augmented (8th): If you expend four uses of mythic power, the germination period reduces to one day instead of one week.`
  },
  Violate_Identity: {
    name: "Violate Identity",
    discipline: "Telepathy (mind-affecting)",
    level: "Telepath 8",
    display: "Mental",
    manifestingTime: "1 standard action",
    range: "close (25 feet + 5 feet/level)",
    target: "1 creature",
    area: "",
    duration: "permanent",
    savingThrow: "Will negates",
    powerResistance: "yes",
    powerPoints: "15",
    description: `You delve deep into the mind of your target, learning everything that they know and sculpting their worldview to your liking. When a creature fails a saving throw, you immediately understand all of their thoughts and memories and why they view the world as they do. You may rearrange, delete, or otherwise rewrite the creature's memories however you wish, altering their memories, teachings, ideas, and any other concepts that you desire to be changed. While this may be used to alter the targets opinions and knowledge, you may not directly cause an alignment shift by tinkering with the target's memories, nor may you alter the creature's class levels, feats, or other abilities in any way. This power's effects can be reversed only by a psychic chirurgery or reality revision power, or by similarly power magic. The target has no idea that its memory has been altered once the power has been manifested.

Augment

• For every 2 power points you spend, the save DC of this power increases by 1

• If you spend 2 additional power points, you may change the target's alignment with this power

• If you expend psionic focus, you may leave the target permanently insane, afflicting them with a single madness of your choice when the power is completed. You may choose the specifics of this madness, such as what the character incorrectly perceives when afflicted by a delusion or hallucination madness.`
  },
  Mind_Switch_True: {
    name: "Mind Switch, True",
    discipline: "telepathy",
    level: "cryptic 6, psion/wilder 7, vitalist 7",
    display: "material, mental",
    manifestingTime: "1 minute",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates; see text",
    powerResistance: "Yes",
    powerPoints: "11 cryptic, 13 psion/wilder and vitalist",
    description: `Mind Switch[]

Targets: You and one other creature

You can attempt to take control of a nearby living creature, forcing your mind (and soul) into its body, and its mind into your body. You can target any creature whose Hit Dice are equal to or less than your manifester level.

You possess the target's body and force the creature's mind into your body unless it succeeds on a Will save. You can move your mind back into your own body whenever you desire, which returns the subject's mind to its own body and ends the power. If the manifestation succeeds, your life force occupies the host body, and the host's life force takes over yours.

You can call on rudimentary or instinctive knowledge of the subject creature, but not upon its acquired or learned knowledge (such as skills and feats it possesses). The same is true for the subject in your body. The mind switch brings about the following changes.

• You gain the type of your assumed body.

• You gain the Strength, Dexterity, and Constitution scores of your assumed body.

• You gain the natural armor, natural attacks, movement, and other simple physical characteristics of your assumed body.

• You gain the extraordinary special attacks and qualities of your assumed body, but you do not gain supernatural or spell-like abilities, nor do you gain any class abilities of the assumed body. Any racial trait which relies upon power points, such as the elan's resilience trait, is considered to be a supernatural ability.

• You gain the possessions and equipment of your assumed body.

• You retain your own hit points and saving throws (both possibly modified by new ability scores), class abilities, supernatural and spell-like abilities, spells and powers, and skills and feats (although skill checks use your new ability scores, and you may be temporarily unable to use feats whose requirements you do not meet in your new body). You retain any racial abilities, so long as they are not based upon your original form (for example, the dromite's chitin is based upon his physical body, so would not be retained).

• You suffer one negative level while in your assumed body. Supernatural abilities that require a certain body part may be unavailable in your new form.

If either body is killed while the power is in effect, the other participant also dies when the power ends. If one participant's body becomes petrified, imprisoned by temporal stasis or imprisonment, or incapacitated in some other way, the other participant will be incapacitated in that way when the power ends.

A targeted dispel psionics (or similar spells or effects) successfully manifested on either participant causes both minds to return to their original bodies.

If you successfully use mind switch while already under the effect of mind switch , the original target is returned to its original body, the new target occupies your original body, and you occupy the body of the new target.

Augment: For every 2 additional power points you spend, this power's save DC increases by 1.

Mind Switch, True[]

As mind switch, except as noted here.

You permanently exchange bodies with the subject. Since this power's duration is instantaneous, you cannot be forced to return to your natural body by means of dispel psionics, an antimagic field, or a similar effect. If the subject's body dies while you are in it, you are dead. The subject immediately suffers one permanent negative level, but otherwise survives the experience in your natural body. If your natural body dies while the subject is in it, you immediately suffer two permanent negative levels, but you likewise survive the experience in your new body. Negative levels gained in this way may only be cured by powerful healing, such as greater restoration or restoration ; they do not fade over time.

Your “natural” body is always considered to be the last one you switched out of. If you exchange bodies with a chain of multiple subjects, you need worry only about the welfare of the last body you switched with. In other words, if your mind is expelled from your current body, your mind returns to the last body you switched with, not to your original body. Similarly, if your original body dies but you have since switched minds with a second subject, you take no penalty. You suffer permanent negative levels only if the body you inhabited immediately prior to your current body is killed.

You suffer two temporary negative levels upon manifesting this power, as your mind adjusts to controlling a new body. These negative levels cannot be cured, but fade at a rate of one every 24 hours.

If you successfully use true mind switch while under the effect of mind switch , the original target of mind switch is returned to its original body, the new target of true mind switch occupies your original body, and you occupy the body of the target of true mind switch .

Data Transfer[]

This ability functions as true mind switch , except as noted above and save that it instead transfers an AI between machines rather than a mind between creatures. As it is not a mind-affecting power, constructs are not immune to its effects.

Augment: This power can be augmented in the following ways:

• By expending six additional power points, you may use this power to transfer an Artificial Intelligence to a non-robot creature. If you do, this power gains the mind-affecting descriptor and the new target acquires the aggregate template even if they otherwise could not.`
  },
  Psychic_Chirurgery: {
    name: "Psychic Chirurgery",
    discipline: "Telepathy [Mind-Affecting]",
    level: "Telepath 9, vitalist 9",
    display: "Auditory, mental, and visual",
    manifestingTime: "10 minutes",
    range: "Close (25 ft. + 5 ft./2 levels)",
    target: "One creature",
    area: "",
    duration: "Instantaneous",
    savingThrow: "Will negates",
    powerResistance: "Yes",
    powerPoints: "17",
    description: `You can repair psychic damage or grant another creature knowledge of powers you know, depending on the version of this power you manifest.

Repair Psychic Damage: You can remove any compulsions and charms affecting the subject. In fact, you can remove any instantaneous or permanent effect caused by a mind-affecting power or spell with psychic chirurgery . Unlike with aura alteration , these effects end or are negated as soon as this power is manifested, with no need for another saving throw.

You can remove all negative levels (but see below) affecting the subject, regardless of how it received them, restoring it to the highest level it had previously attained. Permanent negative levels caused by energy drain or a similar effect, however, may only be cured if the effect occurred within a number of hours equal to your manifester level.

You can also remove all psionic effects penalizing the subject's ability scores, heal all ability damage, and remove any ability drain affecting the subject. Psychic chirurger y negates all forms of insanity, confusion, the effect of such powers as microcosm, and so on, but it does not restore permanent negative levels due to death.

Transfer Knowledge: If desired, you can use this power to directly transfer knowledge of a power you know to another psionic character. You can give a character knowledge of a power of any level that she can manifest, even if the power is not normally on the character's power list, but a character is limited to gaining a number of powers equal to her key ability modifier. Knowledge of powers gained through psychic chirurgery does not count toward the maximum number of powers a character can know per level.

Each time you use psychic chirurgery to implant knowledge of a power in another creature, you suffer ability burn to your key ability score equal to the level of the power implanted. If you and the subject are both willing to do so, you can split this damage evenly. You cannot manifest psychic chirurgery to bestow knowledge of a power if you are currently suffering ability burn to your key ability score, nor can psychic chirurgery be used to bestow knowledge of a power to a creature currently suffering from ability burn to their key ability score.`
  }
};


  export const psionPowers = Object.values(psionPowersObj);